
/* Vendors */
/*! jQuery UI - v1.10.3 - 2013-05-03
* http://jqueryui.com
* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.draggable.js, jquery.ui.droppable.js, jquery.ui.resizable.js, jquery.ui.selectable.js, jquery.ui.sortable.js, jquery.ui.effect.js, jquery.ui.accordion.js, jquery.ui.autocomplete.js, jquery.ui.button.js, jquery.ui.datepicker.js, jquery.ui.dialog.js, jquery.ui.effect-blind.js, jquery.ui.effect-bounce.js, jquery.ui.effect-clip.js, jquery.ui.effect-drop.js, jquery.ui.effect-explode.js, jquery.ui.effect-fade.js, jquery.ui.effect-fold.js, jquery.ui.effect-highlight.js, jquery.ui.effect-pulsate.js, jquery.ui.effect-scale.js, jquery.ui.effect-shake.js, jquery.ui.effect-slide.js, jquery.ui.effect-transfer.js, jquery.ui.menu.js, jquery.ui.position.js, jquery.ui.progressbar.js, jquery.ui.slider.js, jquery.ui.spinner.js, jquery.ui.tabs.js, jquery.ui.tooltip.js
* Copyright 2013 jQuery Foundation and other contributors; Licensed MIT */
(function(t,e){function i(e,i){var n,o,a,r=e.nodeName.toLowerCase();return"area"===r?(n=e.parentNode,o=n.name,e.href&&o&&"map"===n.nodeName.toLowerCase()?(a=t("img[usemap=#"+o+"]")[0],!!a&&s(a)):!1):(/input|select|textarea|button|object/.test(r)?!e.disabled:"a"===r?e.href||i:i)&&s(e)}function s(e){return t.expr.filters.visible(e)&&!t(e).parents().addBack().filter(function(){return"hidden"===t.css(this,"visibility")}).length}var n=0,o=/^ui-id-\d+$/;t.ui=t.ui||{},t.extend(t.ui,{version:"1.10.3",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,NUMPAD_ADD:107,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,NUMPAD_ENTER:108,NUMPAD_MULTIPLY:106,NUMPAD_SUBTRACT:109,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),t.fn.extend({focus:function(e){return function(i,s){return"number"==typeof i?this.each(function(){var e=this;setTimeout(function(){t(e).focus(),s&&s.call(e)},i)}):e.apply(this,arguments)}}(t.fn.focus),scrollParent:function(){var e;return e=t.ui.ie&&/(static|relative)/.test(this.css("position"))||/absolute/.test(this.css("position"))?this.parents().filter(function(){return/(relative|absolute|fixed)/.test(t.css(this,"position"))&&/(auto|scroll)/.test(t.css(this,"overflow")+t.css(this,"overflow-y")+t.css(this,"overflow-x"))}).eq(0):this.parents().filter(function(){return/(auto|scroll)/.test(t.css(this,"overflow")+t.css(this,"overflow-y")+t.css(this,"overflow-x"))}).eq(0),/fixed/.test(this.css("position"))||!e.length?t(document):e},zIndex:function(i){if(i!==e)return this.css("zIndex",i);if(this.length)for(var s,n,o=t(this[0]);o.length&&o[0]!==document;){if(s=o.css("position"),("absolute"===s||"relative"===s||"fixed"===s)&&(n=parseInt(o.css("zIndex"),10),!isNaN(n)&&0!==n))return n;o=o.parent()}return 0},uniqueId:function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++n)})},removeUniqueId:function(){return this.each(function(){o.test(this.id)&&t(this).removeAttr("id")})}}),t.extend(t.expr[":"],{data:t.expr.createPseudo?t.expr.createPseudo(function(e){return function(i){return!!t.data(i,e)}}):function(e,i,s){return!!t.data(e,s[3])},focusable:function(e){return i(e,!isNaN(t.attr(e,"tabindex")))},tabbable:function(e){var s=t.attr(e,"tabindex"),n=isNaN(s);return(n||s>=0)&&i(e,!n)}}),t("<a>").outerWidth(1).jquery||t.each(["Width","Height"],function(i,s){function n(e,i,s,n){return t.each(o,function(){i-=parseFloat(t.css(e,"padding"+this))||0,s&&(i-=parseFloat(t.css(e,"border"+this+"Width"))||0),n&&(i-=parseFloat(t.css(e,"margin"+this))||0)}),i}var o="Width"===s?["Left","Right"]:["Top","Bottom"],a=s.toLowerCase(),r={innerWidth:t.fn.innerWidth,innerHeight:t.fn.innerHeight,outerWidth:t.fn.outerWidth,outerHeight:t.fn.outerHeight};t.fn["inner"+s]=function(i){return i===e?r["inner"+s].call(this):this.each(function(){t(this).css(a,n(this,i)+"px")})},t.fn["outer"+s]=function(e,i){return"number"!=typeof e?r["outer"+s].call(this,e):this.each(function(){t(this).css(a,n(this,e,!0,i)+"px")})}}),t.fn.addBack||(t.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),t("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(t.fn.removeData=function(e){return function(i){return arguments.length?e.call(this,t.camelCase(i)):e.call(this)}}(t.fn.removeData)),t.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),t.support.selectstart="onselectstart"in document.createElement("div"),t.fn.extend({disableSelection:function(){return this.bind((t.support.selectstart?"selectstart":"mousedown")+".ui-disableSelection",function(t){t.preventDefault()})},enableSelection:function(){return this.unbind(".ui-disableSelection")}}),t.extend(t.ui,{plugin:{add:function(e,i,s){var n,o=t.ui[e].prototype;for(n in s)o.plugins[n]=o.plugins[n]||[],o.plugins[n].push([i,s[n]])},call:function(t,e,i){var s,n=t.plugins[e];if(n&&t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType)for(s=0;n.length>s;s++)t.options[n[s][0]]&&n[s][1].apply(t.element,i)}},hasScroll:function(e,i){if("hidden"===t(e).css("overflow"))return!1;var s=i&&"left"===i?"scrollLeft":"scrollTop",n=!1;return e[s]>0?!0:(e[s]=1,n=e[s]>0,e[s]=0,n)}})})(jQuery),function(t,e){var i=0,s=Array.prototype.slice,n=t.cleanData;t.cleanData=function(e){for(var i,s=0;null!=(i=e[s]);s++)try{t(i).triggerHandler("remove")}catch(o){}n(e)},t.widget=function(i,s,n){var o,a,r,h,l={},c=i.split(".")[0];i=i.split(".")[1],o=c+"-"+i,n||(n=s,s=t.Widget),t.expr[":"][o.toLowerCase()]=function(e){return!!t.data(e,o)},t[c]=t[c]||{},a=t[c][i],r=t[c][i]=function(t,i){return this._createWidget?(arguments.length&&this._createWidget(t,i),e):new r(t,i)},t.extend(r,a,{version:n.version,_proto:t.extend({},n),_childConstructors:[]}),h=new s,h.options=t.widget.extend({},h.options),t.each(n,function(i,n){return t.isFunction(n)?(l[i]=function(){var t=function(){return s.prototype[i].apply(this,arguments)},e=function(t){return s.prototype[i].apply(this,t)};return function(){var i,s=this._super,o=this._superApply;return this._super=t,this._superApply=e,i=n.apply(this,arguments),this._super=s,this._superApply=o,i}}(),e):(l[i]=n,e)}),r.prototype=t.widget.extend(h,{widgetEventPrefix:a?h.widgetEventPrefix:i},l,{constructor:r,namespace:c,widgetName:i,widgetFullName:o}),a?(t.each(a._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,r,i._proto)}),delete a._childConstructors):s._childConstructors.push(r),t.widget.bridge(i,r)},t.widget.extend=function(i){for(var n,o,a=s.call(arguments,1),r=0,h=a.length;h>r;r++)for(n in a[r])o=a[r][n],a[r].hasOwnProperty(n)&&o!==e&&(i[n]=t.isPlainObject(o)?t.isPlainObject(i[n])?t.widget.extend({},i[n],o):t.widget.extend({},o):o);return i},t.widget.bridge=function(i,n){var o=n.prototype.widgetFullName||i;t.fn[i]=function(a){var r="string"==typeof a,h=s.call(arguments,1),l=this;return a=!r&&h.length?t.widget.extend.apply(null,[a].concat(h)):a,r?this.each(function(){var s,n=t.data(this,o);return n?t.isFunction(n[a])&&"_"!==a.charAt(0)?(s=n[a].apply(n,h),s!==n&&s!==e?(l=s&&s.jquery?l.pushStack(s.get()):s,!1):e):t.error("no such method '"+a+"' for "+i+" widget instance"):t.error("cannot call methods on "+i+" prior to initialization; "+"attempted to call method '"+a+"'")}):this.each(function(){var e=t.data(this,o);e?e.option(a||{})._init():t.data(this,o,new n(a,this))}),l}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(e,s){s=t(s||this.defaultElement||this)[0],this.element=t(s),this.uuid=i++,this.eventNamespace="."+this.widgetName+this.uuid,this.options=t.widget.extend({},this.options,this._getCreateOptions(),e),this.bindings=t(),this.hoverable=t(),this.focusable=t(),s!==this&&(t.data(s,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===s&&this.destroy()}}),this.document=t(s.style?s.ownerDocument:s.document||s),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:t.noop,_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(t.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled "+"ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:t.noop,widget:function(){return this.element},option:function(i,s){var n,o,a,r=i;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof i)if(r={},n=i.split("."),i=n.shift(),n.length){for(o=r[i]=t.widget.extend({},this.options[i]),a=0;n.length-1>a;a++)o[n[a]]=o[n[a]]||{},o=o[n[a]];if(i=n.pop(),s===e)return o[i]===e?null:o[i];o[i]=s}else{if(s===e)return this.options[i]===e?null:this.options[i];r[i]=s}return this._setOptions(r),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return this.options[t]=e,"disabled"===t&&(this.widget().toggleClass(this.widgetFullName+"-disabled ui-state-disabled",!!e).attr("aria-disabled",e),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")),this},enable:function(){return this._setOption("disabled",!1)},disable:function(){return this._setOption("disabled",!0)},_on:function(i,s,n){var o,a=this;"boolean"!=typeof i&&(n=s,s=i,i=!1),n?(s=o=t(s),this.bindings=this.bindings.add(s)):(n=s,s=this.element,o=this.widget()),t.each(n,function(n,r){function h(){return i||a.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof r?a[r]:r).apply(a,arguments):e}"string"!=typeof r&&(h.guid=r.guid=r.guid||h.guid||t.guid++);var l=n.match(/^(\w+)\s*(.*)$/),c=l[1]+a.eventNamespace,u=l[2];u?o.delegate(u,c,h):s.bind(c,h)})},_off:function(t,e){e=(e||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,t.unbind(e).undelegate(e)},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){t(e.currentTarget).addClass("ui-state-hover")},mouseleave:function(e){t(e.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){t(e.currentTarget).addClass("ui-state-focus")},focusout:function(e){t(e.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(e,i,s){var n,o,a=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],o=i.originalEvent)for(n in o)n in i||(i[n]=o[n]);return this.element.trigger(i,s),!(t.isFunction(a)&&a.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,o){"string"==typeof n&&(n={effect:n});var a,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),a=!t.isEmptyObject(n),n.complete=o,n.delay&&s.delay(n.delay),a&&t.effects&&t.effects.effect[r]?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,o):s.queue(function(i){t(this)[e](),o&&o.call(s[0]),i()})}})}(jQuery),function(t){var e=!1;t(document).mouseup(function(){e=!1}),t.widget("ui.mouse",{version:"1.10.3",options:{cancel:"input,textarea,button,select,option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.bind("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).bind("click."+this.widgetName,function(i){return!0===t.data(i.target,e.widgetName+".preventClickEvent")?(t.removeData(i.target,e.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):undefined}),this.started=!1},_mouseDestroy:function(){this.element.unbind("."+this.widgetName),this._mouseMoveDelegate&&t(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(i){if(!e){this._mouseStarted&&this._mouseUp(i),this._mouseDownEvent=i;var s=this,n=1===i.which,o="string"==typeof this.options.cancel&&i.target.nodeName?t(i.target).closest(this.options.cancel).length:!1;return n&&!o&&this._mouseCapture(i)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){s.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(i)&&this._mouseDelayMet(i)&&(this._mouseStarted=this._mouseStart(i)!==!1,!this._mouseStarted)?(i.preventDefault(),!0):(!0===t.data(i.target,this.widgetName+".preventClickEvent")&&t.removeData(i.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return s._mouseMove(t)},this._mouseUpDelegate=function(t){return s._mouseUp(t)},t(document).bind("mousemove."+this.widgetName,this._mouseMoveDelegate).bind("mouseup."+this.widgetName,this._mouseUpDelegate),i.preventDefault(),e=!0,!0)):!0}},_mouseMove:function(e){return t.ui.ie&&(!document.documentMode||9>document.documentMode)&&!e.button?this._mouseUp(e):this._mouseStarted?(this._mouseDrag(e),e.preventDefault()):(this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,e)!==!1,this._mouseStarted?this._mouseDrag(e):this._mouseUp(e)),!this._mouseStarted)},_mouseUp:function(e){return t(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,e.target===this._mouseDownEvent.target&&t.data(e.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(e)),!1},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}})}(jQuery),function(t){t.widget("ui.draggable",t.ui.mouse,{version:"1.10.3",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"!==this.options.helper||/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative"),this.options.addClasses&&this.element.addClass("ui-draggable"),this.options.disabled&&this.element.addClass("ui-draggable-disabled"),this._mouseInit()},_destroy:function(){this.element.removeClass("ui-draggable ui-draggable-dragging ui-draggable-disabled"),this._mouseDestroy()},_mouseCapture:function(e){var i=this.options;return this.helper||i.disabled||t(e.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(e),this.handle?(t(i.iframeFix===!0?"iframe":i.iframeFix).each(function(){t("<div class='ui-draggable-iframeFix' style='background: #fff;'></div>").css({width:this.offsetWidth+"px",height:this.offsetHeight+"px",position:"absolute",opacity:"0.001",zIndex:1e3}).css(t(this).offset()).appendTo("body")}),!0):!1)},_mouseStart:function(e){var i=this.options;return this.helper=this._createHelper(e),this.helper.addClass("ui-draggable-dragging"),this._cacheHelperProportions(),t.ui.ddmanager&&(t.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(),this.offsetParent=this.helper.offsetParent(),this.offsetParentCssPosition=this.offsetParent.css("position"),this.offset=this.positionAbs=this.element.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},this.offset.scroll=!1,t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.originalPosition=this.position=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger("start",e)===!1?(this._clear(),!1):(this._cacheHelperProportions(),t.ui.ddmanager&&!i.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this._mouseDrag(e,!0),t.ui.ddmanager&&t.ui.ddmanager.dragStart(this,e),!0)},_mouseDrag:function(e,i){if("fixed"===this.offsetParentCssPosition&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),!i){var s=this._uiHash();if(this._trigger("drag",e,s)===!1)return this._mouseUp({}),!1;this.position=s.position}return this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),!1},_mouseStop:function(e){var i=this,s=!1;return t.ui.ddmanager&&!this.options.dropBehaviour&&(s=t.ui.ddmanager.drop(this,e)),this.dropped&&(s=this.dropped,this.dropped=!1),"original"!==this.options.helper||t.contains(this.element[0].ownerDocument,this.element[0])?("invalid"===this.options.revert&&!s||"valid"===this.options.revert&&s||this.options.revert===!0||t.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?t(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger("stop",e)!==!1&&i._clear()}):this._trigger("stop",e)!==!1&&this._clear(),!1):!1},_mouseUp:function(e){return t("div.ui-draggable-iframeFix").each(function(){this.parentNode.removeChild(this)}),t.ui.ddmanager&&t.ui.ddmanager.dragStop(this,e),t.ui.mouse.prototype._mouseUp.call(this,e)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp({}):this._clear(),this},_getHandle:function(e){return this.options.handle?!!t(e.target).closest(this.element.find(this.options.handle)).length:!0},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e])):"clone"===i.helper?this.element.clone().removeAttr("id"):this.element;return s.parents("body").length||s.appendTo("parent"===i.appendTo?this.element[0].parentNode:i.appendTo),s[0]===this.element[0]||/(fixed|absolute)/.test(s.css("position"))||s.css("position","absolute"),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===document.body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.element.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;return n.containment?"window"===n.containment?(this.containment=[t(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,t(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,t(window).scrollLeft()+t(window).width()-this.helperProportions.width-this.margins.left,t(window).scrollTop()+(t(window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],undefined):"document"===n.containment?(this.containment=[0,0,t(document).width()-this.helperProportions.width-this.margins.left,(t(document).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],undefined):n.containment.constructor===Array?(this.containment=n.containment,undefined):("parent"===n.containment&&(n.containment=this.helper[0].parentNode),i=t(n.containment),s=i[0],s&&(e="hidden"!==i.css("overflow"),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(e?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(e?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relative_container=i),undefined):(this.containment=null,undefined)},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent;return this.offset.scroll||(this.offset.scroll={top:n.scrollTop(),left:n.scrollLeft()}),{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():this.offset.scroll.top)*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():this.offset.scroll.left)*s}},_generatePosition:function(e){var i,s,n,o,a=this.options,r="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,h=e.pageX,l=e.pageY;return this.offset.scroll||(this.offset.scroll={top:r.scrollTop(),left:r.scrollLeft()}),this.originalPosition&&(this.containment&&(this.relative_container?(s=this.relative_container.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,e.pageX-this.offset.click.left<i[0]&&(h=i[0]+this.offset.click.left),e.pageY-this.offset.click.top<i[1]&&(l=i[1]+this.offset.click.top),e.pageX-this.offset.click.left>i[2]&&(h=i[2]+this.offset.click.left),e.pageY-this.offset.click.top>i[3]&&(l=i[3]+this.offset.click.top)),a.grid&&(n=a.grid[1]?this.originalPageY+Math.round((l-this.originalPageY)/a.grid[1])*a.grid[1]:this.originalPageY,l=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-a.grid[1]:n+a.grid[1]:n,o=a.grid[0]?this.originalPageX+Math.round((h-this.originalPageX)/a.grid[0])*a.grid[0]:this.originalPageX,h=i?o-this.offset.click.left>=i[0]||o-this.offset.click.left>i[2]?o:o-this.offset.click.left>=i[0]?o-a.grid[0]:o+a.grid[0]:o)),{top:l-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():this.offset.scroll.top),left:h-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():this.offset.scroll.left)}},_clear:function(){this.helper.removeClass("ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1},_trigger:function(e,i,s){return s=s||this._uiHash(),t.ui.plugin.call(this,e,[i,s]),"drag"===e&&(this.positionAbs=this._convertPositionTo("absolute")),t.Widget.prototype._trigger.call(this,e,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),t.ui.plugin.add("draggable","connectToSortable",{start:function(e,i){var s=t(this).data("ui-draggable"),n=s.options,o=t.extend({},i,{item:s.element});s.sortables=[],t(n.connectToSortable).each(function(){var i=t.data(this,"ui-sortable");i&&!i.options.disabled&&(s.sortables.push({instance:i,shouldRevert:i.options.revert}),i.refreshPositions(),i._trigger("activate",e,o))})},stop:function(e,i){var s=t(this).data("ui-draggable"),n=t.extend({},i,{item:s.element});t.each(s.sortables,function(){this.instance.isOver?(this.instance.isOver=0,s.cancelHelperRemoval=!0,this.instance.cancelHelperRemoval=!1,this.shouldRevert&&(this.instance.options.revert=this.shouldRevert),this.instance._mouseStop(e),this.instance.options.helper=this.instance.options._helper,"original"===s.options.helper&&this.instance.currentItem.css({top:"auto",left:"auto"})):(this.instance.cancelHelperRemoval=!1,this.instance._trigger("deactivate",e,n))})},drag:function(e,i){var s=t(this).data("ui-draggable"),n=this;t.each(s.sortables,function(){var o=!1,a=this;this.instance.positionAbs=s.positionAbs,this.instance.helperProportions=s.helperProportions,this.instance.offset.click=s.offset.click,this.instance._intersectsWith(this.instance.containerCache)&&(o=!0,t.each(s.sortables,function(){return this.instance.positionAbs=s.positionAbs,this.instance.helperProportions=s.helperProportions,this.instance.offset.click=s.offset.click,this!==a&&this.instance._intersectsWith(this.instance.containerCache)&&t.contains(a.instance.element[0],this.instance.element[0])&&(o=!1),o})),o?(this.instance.isOver||(this.instance.isOver=1,this.instance.currentItem=t(n).clone().removeAttr("id").appendTo(this.instance.element).data("ui-sortable-item",!0),this.instance.options._helper=this.instance.options.helper,this.instance.options.helper=function(){return i.helper[0]},e.target=this.instance.currentItem[0],this.instance._mouseCapture(e,!0),this.instance._mouseStart(e,!0,!0),this.instance.offset.click.top=s.offset.click.top,this.instance.offset.click.left=s.offset.click.left,this.instance.offset.parent.left-=s.offset.parent.left-this.instance.offset.parent.left,this.instance.offset.parent.top-=s.offset.parent.top-this.instance.offset.parent.top,s._trigger("toSortable",e),s.dropped=this.instance.element,s.currentItem=s.element,this.instance.fromOutside=s),this.instance.currentItem&&this.instance._mouseDrag(e)):this.instance.isOver&&(this.instance.isOver=0,this.instance.cancelHelperRemoval=!0,this.instance.options.revert=!1,this.instance._trigger("out",e,this.instance._uiHash(this.instance)),this.instance._mouseStop(e,!0),this.instance.options.helper=this.instance.options._helper,this.instance.currentItem.remove(),this.instance.placeholder&&this.instance.placeholder.remove(),s._trigger("fromSortable",e),s.dropped=!1)})}}),t.ui.plugin.add("draggable","cursor",{start:function(){var e=t("body"),i=t(this).data("ui-draggable").options;e.css("cursor")&&(i._cursor=e.css("cursor")),e.css("cursor",i.cursor)},stop:function(){var e=t(this).data("ui-draggable").options;e._cursor&&t("body").css("cursor",e._cursor)}}),t.ui.plugin.add("draggable","opacity",{start:function(e,i){var s=t(i.helper),n=t(this).data("ui-draggable").options;s.css("opacity")&&(n._opacity=s.css("opacity")),s.css("opacity",n.opacity)},stop:function(e,i){var s=t(this).data("ui-draggable").options;s._opacity&&t(i.helper).css("opacity",s._opacity)}}),t.ui.plugin.add("draggable","scroll",{start:function(){var e=t(this).data("ui-draggable");e.scrollParent[0]!==document&&"HTML"!==e.scrollParent[0].tagName&&(e.overflowOffset=e.scrollParent.offset())},drag:function(e){var i=t(this).data("ui-draggable"),s=i.options,n=!1;i.scrollParent[0]!==document&&"HTML"!==i.scrollParent[0].tagName?(s.axis&&"x"===s.axis||(i.overflowOffset.top+i.scrollParent[0].offsetHeight-e.pageY<s.scrollSensitivity?i.scrollParent[0].scrollTop=n=i.scrollParent[0].scrollTop+s.scrollSpeed:e.pageY-i.overflowOffset.top<s.scrollSensitivity&&(i.scrollParent[0].scrollTop=n=i.scrollParent[0].scrollTop-s.scrollSpeed)),s.axis&&"y"===s.axis||(i.overflowOffset.left+i.scrollParent[0].offsetWidth-e.pageX<s.scrollSensitivity?i.scrollParent[0].scrollLeft=n=i.scrollParent[0].scrollLeft+s.scrollSpeed:e.pageX-i.overflowOffset.left<s.scrollSensitivity&&(i.scrollParent[0].scrollLeft=n=i.scrollParent[0].scrollLeft-s.scrollSpeed))):(s.axis&&"x"===s.axis||(e.pageY-t(document).scrollTop()<s.scrollSensitivity?n=t(document).scrollTop(t(document).scrollTop()-s.scrollSpeed):t(window).height()-(e.pageY-t(document).scrollTop())<s.scrollSensitivity&&(n=t(document).scrollTop(t(document).scrollTop()+s.scrollSpeed))),s.axis&&"y"===s.axis||(e.pageX-t(document).scrollLeft()<s.scrollSensitivity?n=t(document).scrollLeft(t(document).scrollLeft()-s.scrollSpeed):t(window).width()-(e.pageX-t(document).scrollLeft())<s.scrollSensitivity&&(n=t(document).scrollLeft(t(document).scrollLeft()+s.scrollSpeed)))),n!==!1&&t.ui.ddmanager&&!s.dropBehaviour&&t.ui.ddmanager.prepareOffsets(i,e)}}),t.ui.plugin.add("draggable","snap",{start:function(){var e=t(this).data("ui-draggable"),i=e.options;e.snapElements=[],t(i.snap.constructor!==String?i.snap.items||":data(ui-draggable)":i.snap).each(function(){var i=t(this),s=i.offset();this!==e.element[0]&&e.snapElements.push({item:this,width:i.outerWidth(),height:i.outerHeight(),top:s.top,left:s.left})})},drag:function(e,i){var s,n,o,a,r,h,l,c,u,d,p=t(this).data("ui-draggable"),f=p.options,g=f.snapTolerance,m=i.offset.left,v=m+p.helperProportions.width,_=i.offset.top,b=_+p.helperProportions.height;for(u=p.snapElements.length-1;u>=0;u--)r=p.snapElements[u].left,h=r+p.snapElements[u].width,l=p.snapElements[u].top,c=l+p.snapElements[u].height,r-g>v||m>h+g||l-g>b||_>c+g||!t.contains(p.snapElements[u].item.ownerDocument,p.snapElements[u].item)?(p.snapElements[u].snapping&&p.options.snap.release&&p.options.snap.release.call(p.element,e,t.extend(p._uiHash(),{snapItem:p.snapElements[u].item})),p.snapElements[u].snapping=!1):("inner"!==f.snapMode&&(s=g>=Math.abs(l-b),n=g>=Math.abs(c-_),o=g>=Math.abs(r-v),a=g>=Math.abs(h-m),s&&(i.position.top=p._convertPositionTo("relative",{top:l-p.helperProportions.height,left:0}).top-p.margins.top),n&&(i.position.top=p._convertPositionTo("relative",{top:c,left:0}).top-p.margins.top),o&&(i.position.left=p._convertPositionTo("relative",{top:0,left:r-p.helperProportions.width}).left-p.margins.left),a&&(i.position.left=p._convertPositionTo("relative",{top:0,left:h}).left-p.margins.left)),d=s||n||o||a,"outer"!==f.snapMode&&(s=g>=Math.abs(l-_),n=g>=Math.abs(c-b),o=g>=Math.abs(r-m),a=g>=Math.abs(h-v),s&&(i.position.top=p._convertPositionTo("relative",{top:l,left:0}).top-p.margins.top),n&&(i.position.top=p._convertPositionTo("relative",{top:c-p.helperProportions.height,left:0}).top-p.margins.top),o&&(i.position.left=p._convertPositionTo("relative",{top:0,left:r}).left-p.margins.left),a&&(i.position.left=p._convertPositionTo("relative",{top:0,left:h-p.helperProportions.width}).left-p.margins.left)),!p.snapElements[u].snapping&&(s||n||o||a||d)&&p.options.snap.snap&&p.options.snap.snap.call(p.element,e,t.extend(p._uiHash(),{snapItem:p.snapElements[u].item})),p.snapElements[u].snapping=s||n||o||a||d)}}),t.ui.plugin.add("draggable","stack",{start:function(){var e,i=this.data("ui-draggable").options,s=t.makeArray(t(i.stack)).sort(function(e,i){return(parseInt(t(e).css("zIndex"),10)||0)-(parseInt(t(i).css("zIndex"),10)||0)});s.length&&(e=parseInt(t(s[0]).css("zIndex"),10)||0,t(s).each(function(i){t(this).css("zIndex",e+i)}),this.css("zIndex",e+s.length))}}),t.ui.plugin.add("draggable","zIndex",{start:function(e,i){var s=t(i.helper),n=t(this).data("ui-draggable").options;s.css("zIndex")&&(n._zIndex=s.css("zIndex")),s.css("zIndex",n.zIndex)},stop:function(e,i){var s=t(this).data("ui-draggable").options;s._zIndex&&t(i.helper).css("zIndex",s._zIndex)}})}(jQuery),function(t){function e(t,e,i){return t>e&&e+i>t}t.widget("ui.droppable",{version:"1.10.3",widgetEventPrefix:"drop",options:{accept:"*",activeClass:!1,addClasses:!0,greedy:!1,hoverClass:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var e=this.options,i=e.accept;this.isover=!1,this.isout=!0,this.accept=t.isFunction(i)?i:function(t){return t.is(i)
},this.proportions={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight},t.ui.ddmanager.droppables[e.scope]=t.ui.ddmanager.droppables[e.scope]||[],t.ui.ddmanager.droppables[e.scope].push(this),e.addClasses&&this.element.addClass("ui-droppable")},_destroy:function(){for(var e=0,i=t.ui.ddmanager.droppables[this.options.scope];i.length>e;e++)i[e]===this&&i.splice(e,1);this.element.removeClass("ui-droppable ui-droppable-disabled")},_setOption:function(e,i){"accept"===e&&(this.accept=t.isFunction(i)?i:function(t){return t.is(i)}),t.Widget.prototype._setOption.apply(this,arguments)},_activate:function(e){var i=t.ui.ddmanager.current;this.options.activeClass&&this.element.addClass(this.options.activeClass),i&&this._trigger("activate",e,this.ui(i))},_deactivate:function(e){var i=t.ui.ddmanager.current;this.options.activeClass&&this.element.removeClass(this.options.activeClass),i&&this._trigger("deactivate",e,this.ui(i))},_over:function(e){var i=t.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.addClass(this.options.hoverClass),this._trigger("over",e,this.ui(i)))},_out:function(e){var i=t.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("out",e,this.ui(i)))},_drop:function(e,i){var s=i||t.ui.ddmanager.current,n=!1;return s&&(s.currentItem||s.element)[0]!==this.element[0]?(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var e=t.data(this,"ui-droppable");return e.options.greedy&&!e.options.disabled&&e.options.scope===s.options.scope&&e.accept.call(e.element[0],s.currentItem||s.element)&&t.ui.intersect(s,t.extend(e,{offset:e.element.offset()}),e.options.tolerance)?(n=!0,!1):undefined}),n?!1:this.accept.call(this.element[0],s.currentItem||s.element)?(this.options.activeClass&&this.element.removeClass(this.options.activeClass),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("drop",e,this.ui(s)),this.element):!1):!1},ui:function(t){return{draggable:t.currentItem||t.element,helper:t.helper,position:t.position,offset:t.positionAbs}}}),t.ui.intersect=function(t,i,s){if(!i.offset)return!1;var n,o,a=(t.positionAbs||t.position.absolute).left,r=a+t.helperProportions.width,h=(t.positionAbs||t.position.absolute).top,l=h+t.helperProportions.height,c=i.offset.left,u=c+i.proportions.width,d=i.offset.top,p=d+i.proportions.height;switch(s){case"fit":return a>=c&&u>=r&&h>=d&&p>=l;case"intersect":return a+t.helperProportions.width/2>c&&u>r-t.helperProportions.width/2&&h+t.helperProportions.height/2>d&&p>l-t.helperProportions.height/2;case"pointer":return n=(t.positionAbs||t.position.absolute).left+(t.clickOffset||t.offset.click).left,o=(t.positionAbs||t.position.absolute).top+(t.clickOffset||t.offset.click).top,e(o,d,i.proportions.height)&&e(n,c,i.proportions.width);case"touch":return(h>=d&&p>=h||l>=d&&p>=l||d>h&&l>p)&&(a>=c&&u>=a||r>=c&&u>=r||c>a&&r>u);default:return!1}},t.ui.ddmanager={current:null,droppables:{"default":[]},prepareOffsets:function(e,i){var s,n,o=t.ui.ddmanager.droppables[e.options.scope]||[],a=i?i.type:null,r=(e.currentItem||e.element).find(":data(ui-droppable)").addBack();t:for(s=0;o.length>s;s++)if(!(o[s].options.disabled||e&&!o[s].accept.call(o[s].element[0],e.currentItem||e.element))){for(n=0;r.length>n;n++)if(r[n]===o[s].element[0]){o[s].proportions.height=0;continue t}o[s].visible="none"!==o[s].element.css("display"),o[s].visible&&("mousedown"===a&&o[s]._activate.call(o[s],i),o[s].offset=o[s].element.offset(),o[s].proportions={width:o[s].element[0].offsetWidth,height:o[s].element[0].offsetHeight})}},drop:function(e,i){var s=!1;return t.each((t.ui.ddmanager.droppables[e.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&t.ui.intersect(e,this,this.options.tolerance)&&(s=this._drop.call(this,i)||s),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,i)))}),s},dragStart:function(e,i){e.element.parentsUntil("body").bind("scroll.droppable",function(){e.options.refreshPositions||t.ui.ddmanager.prepareOffsets(e,i)})},drag:function(e,i){e.options.refreshPositions&&t.ui.ddmanager.prepareOffsets(e,i),t.each(t.ui.ddmanager.droppables[e.options.scope]||[],function(){if(!this.options.disabled&&!this.greedyChild&&this.visible){var s,n,o,a=t.ui.intersect(e,this,this.options.tolerance),r=!a&&this.isover?"isout":a&&!this.isover?"isover":null;r&&(this.options.greedy&&(n=this.options.scope,o=this.element.parents(":data(ui-droppable)").filter(function(){return t.data(this,"ui-droppable").options.scope===n}),o.length&&(s=t.data(o[0],"ui-droppable"),s.greedyChild="isover"===r)),s&&"isover"===r&&(s.isover=!1,s.isout=!0,s._out.call(s,i)),this[r]=!0,this["isout"===r?"isover":"isout"]=!1,this["isover"===r?"_over":"_out"].call(this,i),s&&"isout"===r&&(s.isout=!1,s.isover=!0,s._over.call(s,i)))}})},dragStop:function(e,i){e.element.parentsUntil("body").unbind("scroll.droppable"),e.options.refreshPositions||t.ui.ddmanager.prepareOffsets(e,i)}}}(jQuery),function(t){function e(t){return parseInt(t,10)||0}function i(t){return!isNaN(parseInt(t,10))}t.widget("ui.resizable",t.ui.mouse,{version:"1.10.3",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_create:function(){var e,i,s,n,o,a=this,r=this.options;if(this.element.addClass("ui-resizable"),t.extend(this,{_aspectRatio:!!r.aspectRatio,aspectRatio:r.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:r.helper||r.ghost||r.animate?r.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i)&&(this.element.wrap(t("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.data("ui-resizable")),this.elementIsWrapper=!0,this.element.css({marginLeft:this.originalElement.css("marginLeft"),marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom")}),this.originalElement.css({marginLeft:0,marginTop:0,marginRight:0,marginBottom:0}),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css({margin:this.originalElement.css("margin")}),this._proportionallyResize()),this.handles=r.handles||(t(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),e=this.handles.split(","),this.handles={},i=0;e.length>i;i++)s=t.trim(e[i]),o="ui-resizable-"+s,n=t("<div class='ui-resizable-handle "+o+"'></div>"),n.css({zIndex:r.zIndex}),"se"===s&&n.addClass("ui-icon ui-icon-gripsmall-diagonal-se"),this.handles[s]=".ui-resizable-"+s,this.element.append(n);this._renderAxis=function(e){var i,s,n,o;e=e||this.element;for(i in this.handles)this.handles[i].constructor===String&&(this.handles[i]=t(this.handles[i],this.element).show()),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/textarea|input|select|button/i)&&(s=t(this.handles[i],this.element),o=/sw|ne|nw|se|n|s/.test(i)?s.outerHeight():s.outerWidth(),n=["padding",/ne|nw|n/.test(i)?"Top":/se|sw|s/.test(i)?"Bottom":/^e$/.test(i)?"Right":"Left"].join(""),e.css(n,o),this._proportionallyResize()),t(this.handles[i]).length},this._renderAxis(this.element),this._handles=t(".ui-resizable-handle",this.element).disableSelection(),this._handles.mouseover(function(){a.resizing||(this.className&&(n=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),a.axis=n&&n[1]?n[1]:"se")}),r.autoHide&&(this._handles.hide(),t(this.element).addClass("ui-resizable-autohide").mouseenter(function(){r.disabled||(t(this).removeClass("ui-resizable-autohide"),a._handles.show())}).mouseleave(function(){r.disabled||a.resizing||(t(this).addClass("ui-resizable-autohide"),a._handles.hide())})),this._mouseInit()},_destroy:function(){this._mouseDestroy();var e,i=function(e){t(e).removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing").removeData("resizable").removeData("ui-resizable").unbind(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(i(this.element),e=this.element,this.originalElement.css({position:e.css("position"),width:e.outerWidth(),height:e.outerHeight(),top:e.css("top"),left:e.css("left")}).insertAfter(e),e.remove()),this.originalElement.css("resize",this.originalResizeStyle),i(this.originalElement),this},_mouseCapture:function(e){var i,s,n=!1;for(i in this.handles)s=t(this.handles[i])[0],(s===e.target||t.contains(s,e.target))&&(n=!0);return!this.options.disabled&&n},_mouseStart:function(i){var s,n,o,a=this.options,r=this.element.position(),h=this.element;return this.resizing=!0,/absolute/.test(h.css("position"))?h.css({position:"absolute",top:h.css("top"),left:h.css("left")}):h.is(".ui-draggable")&&h.css({position:"absolute",top:r.top,left:r.left}),this._renderProxy(),s=e(this.helper.css("left")),n=e(this.helper.css("top")),a.containment&&(s+=t(a.containment).scrollLeft()||0,n+=t(a.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:s,top:n},this.size=this._helper?{width:h.outerWidth(),height:h.outerHeight()}:{width:h.width(),height:h.height()},this.originalSize=this._helper?{width:h.outerWidth(),height:h.outerHeight()}:{width:h.width(),height:h.height()},this.originalPosition={left:s,top:n},this.sizeDiff={width:h.outerWidth()-h.width(),height:h.outerHeight()-h.height()},this.originalMousePosition={left:i.pageX,top:i.pageY},this.aspectRatio="number"==typeof a.aspectRatio?a.aspectRatio:this.originalSize.width/this.originalSize.height||1,o=t(".ui-resizable-"+this.axis).css("cursor"),t("body").css("cursor","auto"===o?this.axis+"-resize":o),h.addClass("ui-resizable-resizing"),this._propagate("start",i),!0},_mouseDrag:function(e){var i,s=this.helper,n={},o=this.originalMousePosition,a=this.axis,r=this.position.top,h=this.position.left,l=this.size.width,c=this.size.height,u=e.pageX-o.left||0,d=e.pageY-o.top||0,p=this._change[a];return p?(i=p.apply(this,[e,u,d]),this._updateVirtualBoundaries(e.shiftKey),(this._aspectRatio||e.shiftKey)&&(i=this._updateRatio(i,e)),i=this._respectSize(i,e),this._updateCache(i),this._propagate("resize",e),this.position.top!==r&&(n.top=this.position.top+"px"),this.position.left!==h&&(n.left=this.position.left+"px"),this.size.width!==l&&(n.width=this.size.width+"px"),this.size.height!==c&&(n.height=this.size.height+"px"),s.css(n),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),t.isEmptyObject(n)||this._trigger("resize",e,this.ui()),!1):!1},_mouseStop:function(e){this.resizing=!1;var i,s,n,o,a,r,h,l=this.options,c=this;return this._helper&&(i=this._proportionallyResizeElements,s=i.length&&/textarea/i.test(i[0].nodeName),n=s&&t.ui.hasScroll(i[0],"left")?0:c.sizeDiff.height,o=s?0:c.sizeDiff.width,a={width:c.helper.width()-o,height:c.helper.height()-n},r=parseInt(c.element.css("left"),10)+(c.position.left-c.originalPosition.left)||null,h=parseInt(c.element.css("top"),10)+(c.position.top-c.originalPosition.top)||null,l.animate||this.element.css(t.extend(a,{top:h,left:r})),c.helper.height(c.size.height),c.helper.width(c.size.width),this._helper&&!l.animate&&this._proportionallyResize()),t("body").css("cursor","auto"),this.element.removeClass("ui-resizable-resizing"),this._propagate("stop",e),this._helper&&this.helper.remove(),!1},_updateVirtualBoundaries:function(t){var e,s,n,o,a,r=this.options;a={minWidth:i(r.minWidth)?r.minWidth:0,maxWidth:i(r.maxWidth)?r.maxWidth:1/0,minHeight:i(r.minHeight)?r.minHeight:0,maxHeight:i(r.maxHeight)?r.maxHeight:1/0},(this._aspectRatio||t)&&(e=a.minHeight*this.aspectRatio,n=a.minWidth/this.aspectRatio,s=a.maxHeight*this.aspectRatio,o=a.maxWidth/this.aspectRatio,e>a.minWidth&&(a.minWidth=e),n>a.minHeight&&(a.minHeight=n),a.maxWidth>s&&(a.maxWidth=s),a.maxHeight>o&&(a.maxHeight=o)),this._vBoundaries=a},_updateCache:function(t){this.offset=this.helper.offset(),i(t.left)&&(this.position.left=t.left),i(t.top)&&(this.position.top=t.top),i(t.height)&&(this.size.height=t.height),i(t.width)&&(this.size.width=t.width)},_updateRatio:function(t){var e=this.position,s=this.size,n=this.axis;return i(t.height)?t.width=t.height*this.aspectRatio:i(t.width)&&(t.height=t.width/this.aspectRatio),"sw"===n&&(t.left=e.left+(s.width-t.width),t.top=null),"nw"===n&&(t.top=e.top+(s.height-t.height),t.left=e.left+(s.width-t.width)),t},_respectSize:function(t){var e=this._vBoundaries,s=this.axis,n=i(t.width)&&e.maxWidth&&e.maxWidth<t.width,o=i(t.height)&&e.maxHeight&&e.maxHeight<t.height,a=i(t.width)&&e.minWidth&&e.minWidth>t.width,r=i(t.height)&&e.minHeight&&e.minHeight>t.height,h=this.originalPosition.left+this.originalSize.width,l=this.position.top+this.size.height,c=/sw|nw|w/.test(s),u=/nw|ne|n/.test(s);return a&&(t.width=e.minWidth),r&&(t.height=e.minHeight),n&&(t.width=e.maxWidth),o&&(t.height=e.maxHeight),a&&c&&(t.left=h-e.minWidth),n&&c&&(t.left=h-e.maxWidth),r&&u&&(t.top=l-e.minHeight),o&&u&&(t.top=l-e.maxHeight),t.width||t.height||t.left||!t.top?t.width||t.height||t.top||!t.left||(t.left=null):t.top=null,t},_proportionallyResize:function(){if(this._proportionallyResizeElements.length){var t,e,i,s,n,o=this.helper||this.element;for(t=0;this._proportionallyResizeElements.length>t;t++){if(n=this._proportionallyResizeElements[t],!this.borderDif)for(this.borderDif=[],i=[n.css("borderTopWidth"),n.css("borderRightWidth"),n.css("borderBottomWidth"),n.css("borderLeftWidth")],s=[n.css("paddingTop"),n.css("paddingRight"),n.css("paddingBottom"),n.css("paddingLeft")],e=0;i.length>e;e++)this.borderDif[e]=(parseInt(i[e],10)||0)+(parseInt(s[e],10)||0);n.css({height:o.height()-this.borderDif[0]-this.borderDif[2]||0,width:o.width()-this.borderDif[1]-this.borderDif[3]||0})}}},_renderProxy:function(){var e=this.element,i=this.options;this.elementOffset=e.offset(),this._helper?(this.helper=this.helper||t("<div style='overflow:hidden;'></div>"),this.helper.addClass(this._helper).css({width:this.element.outerWidth()-1,height:this.element.outerHeight()-1,position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++i.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(t,e){return{width:this.originalSize.width+e}},w:function(t,e){var i=this.originalSize,s=this.originalPosition;return{left:s.left+e,width:i.width-e}},n:function(t,e,i){var s=this.originalSize,n=this.originalPosition;return{top:n.top+i,height:s.height-i}},s:function(t,e,i){return{height:this.originalSize.height+i}},se:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},sw:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[e,i,s]))},ne:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},nw:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[e,i,s]))}},_propagate:function(e,i){t.ui.plugin.call(this,e,[i,this.ui()]),"resize"!==e&&this._trigger(e,i,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),t.ui.plugin.add("resizable","animate",{stop:function(e){var i=t(this).data("ui-resizable"),s=i.options,n=i._proportionallyResizeElements,o=n.length&&/textarea/i.test(n[0].nodeName),a=o&&t.ui.hasScroll(n[0],"left")?0:i.sizeDiff.height,r=o?0:i.sizeDiff.width,h={width:i.size.width-r,height:i.size.height-a},l=parseInt(i.element.css("left"),10)+(i.position.left-i.originalPosition.left)||null,c=parseInt(i.element.css("top"),10)+(i.position.top-i.originalPosition.top)||null;i.element.animate(t.extend(h,c&&l?{top:c,left:l}:{}),{duration:s.animateDuration,easing:s.animateEasing,step:function(){var s={width:parseInt(i.element.css("width"),10),height:parseInt(i.element.css("height"),10),top:parseInt(i.element.css("top"),10),left:parseInt(i.element.css("left"),10)};n&&n.length&&t(n[0]).css({width:s.width,height:s.height}),i._updateCache(s),i._propagate("resize",e)}})}}),t.ui.plugin.add("resizable","containment",{start:function(){var i,s,n,o,a,r,h,l=t(this).data("ui-resizable"),c=l.options,u=l.element,d=c.containment,p=d instanceof t?d.get(0):/parent/.test(d)?u.parent().get(0):d;p&&(l.containerElement=t(p),/document/.test(d)||d===document?(l.containerOffset={left:0,top:0},l.containerPosition={left:0,top:0},l.parentData={element:t(document),left:0,top:0,width:t(document).width(),height:t(document).height()||document.body.parentNode.scrollHeight}):(i=t(p),s=[],t(["Top","Right","Left","Bottom"]).each(function(t,n){s[t]=e(i.css("padding"+n))}),l.containerOffset=i.offset(),l.containerPosition=i.position(),l.containerSize={height:i.innerHeight()-s[3],width:i.innerWidth()-s[1]},n=l.containerOffset,o=l.containerSize.height,a=l.containerSize.width,r=t.ui.hasScroll(p,"left")?p.scrollWidth:a,h=t.ui.hasScroll(p)?p.scrollHeight:o,l.parentData={element:p,left:n.left,top:n.top,width:r,height:h}))},resize:function(e){var i,s,n,o,a=t(this).data("ui-resizable"),r=a.options,h=a.containerOffset,l=a.position,c=a._aspectRatio||e.shiftKey,u={top:0,left:0},d=a.containerElement;d[0]!==document&&/static/.test(d.css("position"))&&(u=h),l.left<(a._helper?h.left:0)&&(a.size.width=a.size.width+(a._helper?a.position.left-h.left:a.position.left-u.left),c&&(a.size.height=a.size.width/a.aspectRatio),a.position.left=r.helper?h.left:0),l.top<(a._helper?h.top:0)&&(a.size.height=a.size.height+(a._helper?a.position.top-h.top:a.position.top),c&&(a.size.width=a.size.height*a.aspectRatio),a.position.top=a._helper?h.top:0),a.offset.left=a.parentData.left+a.position.left,a.offset.top=a.parentData.top+a.position.top,i=Math.abs((a._helper?a.offset.left-u.left:a.offset.left-u.left)+a.sizeDiff.width),s=Math.abs((a._helper?a.offset.top-u.top:a.offset.top-h.top)+a.sizeDiff.height),n=a.containerElement.get(0)===a.element.parent().get(0),o=/relative|absolute/.test(a.containerElement.css("position")),n&&o&&(i-=a.parentData.left),i+a.size.width>=a.parentData.width&&(a.size.width=a.parentData.width-i,c&&(a.size.height=a.size.width/a.aspectRatio)),s+a.size.height>=a.parentData.height&&(a.size.height=a.parentData.height-s,c&&(a.size.width=a.size.height*a.aspectRatio))},stop:function(){var e=t(this).data("ui-resizable"),i=e.options,s=e.containerOffset,n=e.containerPosition,o=e.containerElement,a=t(e.helper),r=a.offset(),h=a.outerWidth()-e.sizeDiff.width,l=a.outerHeight()-e.sizeDiff.height;e._helper&&!i.animate&&/relative/.test(o.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:h,height:l}),e._helper&&!i.animate&&/static/.test(o.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:h,height:l})}}),t.ui.plugin.add("resizable","alsoResize",{start:function(){var e=t(this).data("ui-resizable"),i=e.options,s=function(e){t(e).each(function(){var e=t(this);e.data("ui-resizable-alsoresize",{width:parseInt(e.width(),10),height:parseInt(e.height(),10),left:parseInt(e.css("left"),10),top:parseInt(e.css("top"),10)})})};"object"!=typeof i.alsoResize||i.alsoResize.parentNode?s(i.alsoResize):i.alsoResize.length?(i.alsoResize=i.alsoResize[0],s(i.alsoResize)):t.each(i.alsoResize,function(t){s(t)})},resize:function(e,i){var s=t(this).data("ui-resizable"),n=s.options,o=s.originalSize,a=s.originalPosition,r={height:s.size.height-o.height||0,width:s.size.width-o.width||0,top:s.position.top-a.top||0,left:s.position.left-a.left||0},h=function(e,s){t(e).each(function(){var e=t(this),n=t(this).data("ui-resizable-alsoresize"),o={},a=s&&s.length?s:e.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];t.each(a,function(t,e){var i=(n[e]||0)+(r[e]||0);i&&i>=0&&(o[e]=i||null)}),e.css(o)})};"object"!=typeof n.alsoResize||n.alsoResize.nodeType?h(n.alsoResize):t.each(n.alsoResize,function(t,e){h(t,e)})},stop:function(){t(this).removeData("resizable-alsoresize")}}),t.ui.plugin.add("resizable","ghost",{start:function(){var e=t(this).data("ui-resizable"),i=e.options,s=e.size;e.ghost=e.originalElement.clone(),e.ghost.css({opacity:.25,display:"block",position:"relative",height:s.height,width:s.width,margin:0,left:0,top:0}).addClass("ui-resizable-ghost").addClass("string"==typeof i.ghost?i.ghost:""),e.ghost.appendTo(e.helper)},resize:function(){var e=t(this).data("ui-resizable");e.ghost&&e.ghost.css({position:"relative",height:e.size.height,width:e.size.width})},stop:function(){var e=t(this).data("ui-resizable");e.ghost&&e.helper&&e.helper.get(0).removeChild(e.ghost.get(0))}}),t.ui.plugin.add("resizable","grid",{resize:function(){var e=t(this).data("ui-resizable"),i=e.options,s=e.size,n=e.originalSize,o=e.originalPosition,a=e.axis,r="number"==typeof i.grid?[i.grid,i.grid]:i.grid,h=r[0]||1,l=r[1]||1,c=Math.round((s.width-n.width)/h)*h,u=Math.round((s.height-n.height)/l)*l,d=n.width+c,p=n.height+u,f=i.maxWidth&&d>i.maxWidth,g=i.maxHeight&&p>i.maxHeight,m=i.minWidth&&i.minWidth>d,v=i.minHeight&&i.minHeight>p;i.grid=r,m&&(d+=h),v&&(p+=l),f&&(d-=h),g&&(p-=l),/^(se|s|e)$/.test(a)?(e.size.width=d,e.size.height=p):/^(ne)$/.test(a)?(e.size.width=d,e.size.height=p,e.position.top=o.top-u):/^(sw)$/.test(a)?(e.size.width=d,e.size.height=p,e.position.left=o.left-c):(e.size.width=d,e.size.height=p,e.position.top=o.top-u,e.position.left=o.left-c)}})}(jQuery),function(t){t.widget("ui.selectable",t.ui.mouse,{version:"1.10.3",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var e,i=this;this.element.addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){e=t(i.options.filter,i.element[0]),e.addClass("ui-selectee"),e.each(function(){var e=t(this),i=e.offset();t.data(this,"selectable-item",{element:this,$element:e,left:i.left,top:i.top,right:i.left+e.outerWidth(),bottom:i.top+e.outerHeight(),startselected:!1,selected:e.hasClass("ui-selected"),selecting:e.hasClass("ui-selecting"),unselecting:e.hasClass("ui-unselecting")})})},this.refresh(),this.selectees=e.addClass("ui-selectee"),this._mouseInit(),this.helper=t("<div class='ui-selectable-helper'></div>")},_destroy:function(){this.selectees.removeClass("ui-selectee").removeData("selectable-item"),this.element.removeClass("ui-selectable ui-selectable-disabled"),this._mouseDestroy()},_mouseStart:function(e){var i=this,s=this.options;this.opos=[e.pageX,e.pageY],this.options.disabled||(this.selectees=t(s.filter,this.element[0]),this._trigger("start",e),t(s.appendTo).append(this.helper),this.helper.css({left:e.pageX,top:e.pageY,width:0,height:0}),s.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var s=t.data(this,"selectable-item");s.startselected=!0,e.metaKey||e.ctrlKey||(s.$element.removeClass("ui-selected"),s.selected=!1,s.$element.addClass("ui-unselecting"),s.unselecting=!0,i._trigger("unselecting",e,{unselecting:s.element}))}),t(e.target).parents().addBack().each(function(){var s,n=t.data(this,"selectable-item");return n?(s=!e.metaKey&&!e.ctrlKey||!n.$element.hasClass("ui-selected"),n.$element.removeClass(s?"ui-unselecting":"ui-selected").addClass(s?"ui-selecting":"ui-unselecting"),n.unselecting=!s,n.selecting=s,n.selected=s,s?i._trigger("selecting",e,{selecting:n.element}):i._trigger("unselecting",e,{unselecting:n.element}),!1):undefined}))},_mouseDrag:function(e){if(this.dragged=!0,!this.options.disabled){var i,s=this,n=this.options,o=this.opos[0],a=this.opos[1],r=e.pageX,h=e.pageY;return o>r&&(i=r,r=o,o=i),a>h&&(i=h,h=a,a=i),this.helper.css({left:o,top:a,width:r-o,height:h-a}),this.selectees.each(function(){var i=t.data(this,"selectable-item"),l=!1;i&&i.element!==s.element[0]&&("touch"===n.tolerance?l=!(i.left>r||o>i.right||i.top>h||a>i.bottom):"fit"===n.tolerance&&(l=i.left>o&&r>i.right&&i.top>a&&h>i.bottom),l?(i.selected&&(i.$element.removeClass("ui-selected"),i.selected=!1),i.unselecting&&(i.$element.removeClass("ui-unselecting"),i.unselecting=!1),i.selecting||(i.$element.addClass("ui-selecting"),i.selecting=!0,s._trigger("selecting",e,{selecting:i.element}))):(i.selecting&&((e.metaKey||e.ctrlKey)&&i.startselected?(i.$element.removeClass("ui-selecting"),i.selecting=!1,i.$element.addClass("ui-selected"),i.selected=!0):(i.$element.removeClass("ui-selecting"),i.selecting=!1,i.startselected&&(i.$element.addClass("ui-unselecting"),i.unselecting=!0),s._trigger("unselecting",e,{unselecting:i.element}))),i.selected&&(e.metaKey||e.ctrlKey||i.startselected||(i.$element.removeClass("ui-selected"),i.selected=!1,i.$element.addClass("ui-unselecting"),i.unselecting=!0,s._trigger("unselecting",e,{unselecting:i.element})))))}),!1}},_mouseStop:function(e){var i=this;return this.dragged=!1,t(".ui-unselecting",this.element[0]).each(function(){var s=t.data(this,"selectable-item");s.$element.removeClass("ui-unselecting"),s.unselecting=!1,s.startselected=!1,i._trigger("unselected",e,{unselected:s.element})}),t(".ui-selecting",this.element[0]).each(function(){var s=t.data(this,"selectable-item");s.$element.removeClass("ui-selecting").addClass("ui-selected"),s.selecting=!1,s.selected=!0,s.startselected=!0,i._trigger("selected",e,{selected:s.element})}),this._trigger("stop",e),this.helper.remove(),!1}})}(jQuery),function(t){function e(t,e,i){return t>e&&e+i>t}function i(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))}t.widget("ui.sortable",t.ui.mouse,{version:"1.10.3",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_create:function(){var t=this.options;this.containerCache={},this.element.addClass("ui-sortable"),this.refresh(),this.floating=this.items.length?"x"===t.axis||i(this.items[0].item):!1,this.offset=this.element.offset(),this._mouseInit(),this.ready=!0},_destroy:function(){this.element.removeClass("ui-sortable ui-sortable-disabled"),this._mouseDestroy();for(var t=this.items.length-1;t>=0;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_setOption:function(e,i){"disabled"===e?(this.options[e]=i,this.widget().toggleClass("ui-sortable-disabled",!!i)):t.Widget.prototype._setOption.apply(this,arguments)},_mouseCapture:function(e,i){var s=null,n=!1,o=this;return this.reverting?!1:this.options.disabled||"static"===this.options.type?!1:(this._refreshItems(e),t(e.target).parents().each(function(){return t.data(this,o.widgetName+"-item")===o?(s=t(this),!1):undefined}),t.data(e.target,o.widgetName+"-item")===o&&(s=t(e.target)),s?!this.options.handle||i||(t(this.options.handle,s).find("*").addBack().each(function(){this===e.target&&(n=!0)}),n)?(this.currentItem=s,this._removeCurrentsFromItems(),!0):!1:!1)},_mouseStart:function(e,i,s){var n,o,a=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(e),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,a.cursorAt&&this._adjustOffsetFromHelper(a.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),a.containment&&this._setContainment(),a.cursor&&"auto"!==a.cursor&&(o=this.document.find("body"),this.storedCursor=o.css("cursor"),o.css("cursor",a.cursor),this.storedStylesheet=t("<style>*{ cursor: "+a.cursor+" !important; }</style>").appendTo(o)),a.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",a.opacity)),a.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",a.zIndex)),this.scrollParent[0]!==document&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",e,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!s)for(n=this.containers.length-1;n>=0;n--)this.containers[n]._trigger("activate",e,this._uiHash(this));return t.ui.ddmanager&&(t.ui.ddmanager.current=this),t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this.dragging=!0,this.helper.addClass("ui-sortable-helper"),this._mouseDrag(e),!0},_mouseDrag:function(e){var i,s,n,o,a=this.options,r=!1;for(this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==document&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-e.pageY<a.scrollSensitivity?this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop+a.scrollSpeed:e.pageY-this.overflowOffset.top<a.scrollSensitivity&&(this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop-a.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-e.pageX<a.scrollSensitivity?this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft+a.scrollSpeed:e.pageX-this.overflowOffset.left<a.scrollSensitivity&&(this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft-a.scrollSpeed)):(e.pageY-t(document).scrollTop()<a.scrollSensitivity?r=t(document).scrollTop(t(document).scrollTop()-a.scrollSpeed):t(window).height()-(e.pageY-t(document).scrollTop())<a.scrollSensitivity&&(r=t(document).scrollTop(t(document).scrollTop()+a.scrollSpeed)),e.pageX-t(document).scrollLeft()<a.scrollSensitivity?r=t(document).scrollLeft(t(document).scrollLeft()-a.scrollSpeed):t(window).width()-(e.pageX-t(document).scrollLeft())<a.scrollSensitivity&&(r=t(document).scrollLeft(t(document).scrollLeft()+a.scrollSpeed))),r!==!1&&t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),i=this.items.length-1;i>=0;i--)if(s=this.items[i],n=s.item[0],o=this._intersectsWithPointer(s),o&&s.instance===this.currentContainer&&n!==this.currentItem[0]&&this.placeholder[1===o?"next":"prev"]()[0]!==n&&!t.contains(this.placeholder[0],n)&&("semi-dynamic"===this.options.type?!t.contains(this.element[0],n):!0)){if(this.direction=1===o?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(s))break;
this._rearrange(e,s),this._trigger("change",e,this._uiHash());break}return this._contactContainers(e),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),this._trigger("sort",e,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(e,i){if(e){if(t.ui.ddmanager&&!this.options.dropBehaviour&&t.ui.ddmanager.drop(this,e),this.options.revert){var s=this,n=this.placeholder.offset(),o=this.options.axis,a={};o&&"x"!==o||(a.left=n.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===document.body?0:this.offsetParent[0].scrollLeft)),o&&"y"!==o||(a.top=n.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===document.body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,t(this.helper).animate(a,parseInt(this.options.revert,10)||500,function(){s._clear(e)})}else this._clear(e,i);return!1}},cancel:function(){if(this.dragging){this._mouseUp({target:null}),"original"===this.options.helper?this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper"):this.currentItem.show();for(var e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("deactivate",null,this._uiHash(this)),this.containers[e].containerCache.over&&(this.containers[e]._trigger("out",null,this._uiHash(this)),this.containers[e].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),t.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?t(this.domPosition.prev).after(this.currentItem):t(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},t(i).each(function(){var i=(t(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);i&&s.push((e.key||i[1]+"[]")+"="+(e.key&&e.expression?i[1]:i[2]))}),!s.length&&e.key&&s.push(e.key+"="),s.join("&")},toArray:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},i.each(function(){s.push(t(e.item||this).attr(e.attribute||"id")||"")}),s},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,h=r+t.height,l=this.offset.click.top,c=this.offset.click.left,u="x"===this.options.axis||s+l>r&&h>s+l,d="y"===this.options.axis||e+c>o&&a>e+c,p=u&&d;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?p:e+this.helperProportions.width/2>o&&a>i-this.helperProportions.width/2&&s+this.helperProportions.height/2>r&&h>n-this.helperProportions.height/2},_intersectsWithPointer:function(t){var i="x"===this.options.axis||e(this.positionAbs.top+this.offset.click.top,t.top,t.height),s="y"===this.options.axis||e(this.positionAbs.left+this.offset.click.left,t.left,t.width),n=i&&s,o=this._getDragVerticalDirection(),a=this._getDragHorizontalDirection();return n?this.floating?a&&"right"===a||"down"===o?2:1:o&&("down"===o?2:1):!1},_intersectsWithSides:function(t){var i=e(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),s=e(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),n=this._getDragVerticalDirection(),o=this._getDragHorizontalDirection();return this.floating&&o?"right"===o&&s||"left"===o&&!s:n&&("down"===n&&i||"up"===n&&!i)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!==t&&(t>0?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!==t&&(t>0?"right":"left")},refresh:function(t){return this._refreshItems(t),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(e){var i,s,n,o,a=[],r=[],h=this._connectWith();if(h&&e)for(i=h.length-1;i>=0;i--)for(n=t(h[i]),s=n.length-1;s>=0;s--)o=t.data(n[s],this.widgetFullName),o&&o!==this&&!o.options.disabled&&r.push([t.isFunction(o.options.items)?o.options.items.call(o.element):t(o.options.items,o.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),o]);for(r.push([t.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):t(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),i=r.length-1;i>=0;i--)r[i][0].each(function(){a.push(this)});return t(a)},_removeCurrentsFromItems:function(){var e=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=t.grep(this.items,function(t){for(var i=0;e.length>i;i++)if(e[i]===t.item[0])return!1;return!0})},_refreshItems:function(e){this.items=[],this.containers=[this];var i,s,n,o,a,r,h,l,c=this.items,u=[[t.isFunction(this.options.items)?this.options.items.call(this.element[0],e,{item:this.currentItem}):t(this.options.items,this.element),this]],d=this._connectWith();if(d&&this.ready)for(i=d.length-1;i>=0;i--)for(n=t(d[i]),s=n.length-1;s>=0;s--)o=t.data(n[s],this.widgetFullName),o&&o!==this&&!o.options.disabled&&(u.push([t.isFunction(o.options.items)?o.options.items.call(o.element[0],e,{item:this.currentItem}):t(o.options.items,o.element),o]),this.containers.push(o));for(i=u.length-1;i>=0;i--)for(a=u[i][1],r=u[i][0],s=0,l=r.length;l>s;s++)h=t(r[s]),h.data(this.widgetName+"-item",a),c.push({item:h,instance:a,width:0,height:0,left:0,top:0})},refreshPositions:function(e){this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var i,s,n,o;for(i=this.items.length-1;i>=0;i--)s=this.items[i],s.instance!==this.currentContainer&&this.currentContainer&&s.item[0]!==this.currentItem[0]||(n=this.options.toleranceElement?t(this.options.toleranceElement,s.item):s.item,e||(s.width=n.outerWidth(),s.height=n.outerHeight()),o=n.offset(),s.left=o.left,s.top=o.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(i=this.containers.length-1;i>=0;i--)o=this.containers[i].element.offset(),this.containers[i].containerCache.left=o.left,this.containers[i].containerCache.top=o.top,this.containers[i].containerCache.width=this.containers[i].element.outerWidth(),this.containers[i].containerCache.height=this.containers[i].element.outerHeight();return this},_createPlaceholder:function(e){e=e||this;var i,s=e.options;s.placeholder&&s.placeholder.constructor!==String||(i=s.placeholder,s.placeholder={element:function(){var s=e.currentItem[0].nodeName.toLowerCase(),n=t("<"+s+">",e.document[0]).addClass(i||e.currentItem[0].className+" ui-sortable-placeholder").removeClass("ui-sortable-helper");return"tr"===s?e.currentItem.children().each(function(){t("<td>&#160;</td>",e.document[0]).attr("colspan",t(this).attr("colspan")||1).appendTo(n)}):"img"===s&&n.attr("src",e.currentItem.attr("src")),i||n.css("visibility","hidden"),n},update:function(t,n){(!i||s.forcePlaceholderSize)&&(n.height()||n.height(e.currentItem.innerHeight()-parseInt(e.currentItem.css("paddingTop")||0,10)-parseInt(e.currentItem.css("paddingBottom")||0,10)),n.width()||n.width(e.currentItem.innerWidth()-parseInt(e.currentItem.css("paddingLeft")||0,10)-parseInt(e.currentItem.css("paddingRight")||0,10)))}}),e.placeholder=t(s.placeholder.element.call(e.element,e.currentItem)),e.currentItem.after(e.placeholder),s.placeholder.update(e,e.placeholder)},_contactContainers:function(s){var n,o,a,r,h,l,c,u,d,p,f=null,g=null;for(n=this.containers.length-1;n>=0;n--)if(!t.contains(this.currentItem[0],this.containers[n].element[0]))if(this._intersectsWith(this.containers[n].containerCache)){if(f&&t.contains(this.containers[n].element[0],f.element[0]))continue;f=this.containers[n],g=n}else this.containers[n].containerCache.over&&(this.containers[n]._trigger("out",s,this._uiHash(this)),this.containers[n].containerCache.over=0);if(f)if(1===this.containers.length)this.containers[g].containerCache.over||(this.containers[g]._trigger("over",s,this._uiHash(this)),this.containers[g].containerCache.over=1);else{for(a=1e4,r=null,p=f.floating||i(this.currentItem),h=p?"left":"top",l=p?"width":"height",c=this.positionAbs[h]+this.offset.click[h],o=this.items.length-1;o>=0;o--)t.contains(this.containers[g].element[0],this.items[o].item[0])&&this.items[o].item[0]!==this.currentItem[0]&&(!p||e(this.positionAbs.top+this.offset.click.top,this.items[o].top,this.items[o].height))&&(u=this.items[o].item.offset()[h],d=!1,Math.abs(u-c)>Math.abs(u+this.items[o][l]-c)&&(d=!0,u+=this.items[o][l]),a>Math.abs(u-c)&&(a=Math.abs(u-c),r=this.items[o],this.direction=d?"up":"down"));if(!r&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[g])return;r?this._rearrange(s,r,null,!0):this._rearrange(s,null,this.containers[g].element,!0),this._trigger("change",s,this._uiHash()),this.containers[g]._trigger("change",s,this._uiHash(this)),this.currentContainer=this.containers[g],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[g]._trigger("over",s,this._uiHash(this)),this.containers[g].containerCache.over=1}},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e,this.currentItem])):"clone"===i.helper?this.currentItem.clone():this.currentItem;return s.parents("body").length||t("parent"!==i.appendTo?i.appendTo:this.currentItem[0].parentNode)[0].appendChild(s[0]),s[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),(!s[0].style.width||i.forceHelperSize)&&s.width(this.currentItem.width()),(!s[0].style.height||i.forceHelperSize)&&s.height(this.currentItem.height()),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===document.body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.currentItem.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;"parent"===n.containment&&(n.containment=this.helper[0].parentNode),("document"===n.containment||"window"===n.containment)&&(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,t("document"===n.containment?document:window).width()-this.helperProportions.width-this.margins.left,(t("document"===n.containment?document:window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(n.containment)||(e=t(n.containment)[0],i=t(n.containment).offset(),s="hidden"!==t(e).css("overflow"),this.containment=[i.left+(parseInt(t(e).css("borderLeftWidth"),10)||0)+(parseInt(t(e).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(t(e).css("borderTopWidth"),10)||0)+(parseInt(t(e).css("paddingTop"),10)||0)-this.margins.top,i.left+(s?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(t(e).css("borderLeftWidth"),10)||0)-(parseInt(t(e).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(s?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(t(e).css("borderTopWidth"),10)||0)-(parseInt(t(e).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop())*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())*s}},_generatePosition:function(e){var i,s,n=this.options,o=e.pageX,a=e.pageY,r="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,h=/(html|body)/i.test(r[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==document&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(e.pageX-this.offset.click.left<this.containment[0]&&(o=this.containment[0]+this.offset.click.left),e.pageY-this.offset.click.top<this.containment[1]&&(a=this.containment[1]+this.offset.click.top),e.pageX-this.offset.click.left>this.containment[2]&&(o=this.containment[2]+this.offset.click.left),e.pageY-this.offset.click.top>this.containment[3]&&(a=this.containment[3]+this.offset.click.top)),n.grid&&(i=this.originalPageY+Math.round((a-this.originalPageY)/n.grid[1])*n.grid[1],a=this.containment?i-this.offset.click.top>=this.containment[1]&&i-this.offset.click.top<=this.containment[3]?i:i-this.offset.click.top>=this.containment[1]?i-n.grid[1]:i+n.grid[1]:i,s=this.originalPageX+Math.round((o-this.originalPageX)/n.grid[0])*n.grid[0],o=this.containment?s-this.offset.click.left>=this.containment[0]&&s-this.offset.click.left<=this.containment[2]?s:s-this.offset.click.left>=this.containment[0]?s-n.grid[0]:s+n.grid[0]:s)),{top:a-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():h?0:r.scrollTop()),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():h?0:r.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){this.reverting=!1;var i,s=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(i in this._storedCSS)("auto"===this._storedCSS[i]||"static"===this._storedCSS[i])&&(this._storedCSS[i]="");this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper")}else this.currentItem.show();for(this.fromOutside&&!e&&s.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||s.push(function(t){this._trigger("update",t,this._uiHash())}),this!==this.currentContainer&&(e||(s.push(function(t){this._trigger("remove",t,this._uiHash())}),s.push(function(t){return function(e){t._trigger("receive",e,this._uiHash(this))}}.call(this,this.currentContainer)),s.push(function(t){return function(e){t._trigger("update",e,this._uiHash(this))}}.call(this,this.currentContainer)))),i=this.containers.length-1;i>=0;i--)e||s.push(function(t){return function(e){t._trigger("deactivate",e,this._uiHash(this))}}.call(this,this.containers[i])),this.containers[i].containerCache.over&&(s.push(function(t){return function(e){t._trigger("out",e,this._uiHash(this))}}.call(this,this.containers[i])),this.containers[i].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,this.cancelHelperRemoval){if(!e){for(this._trigger("beforeStop",t,this._uiHash()),i=0;s.length>i;i++)s[i].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!1}if(e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null,!e){for(i=0;s.length>i;i++)s[i].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!0},_trigger:function(){t.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(e){var i=e||this;return{helper:i.helper,placeholder:i.placeholder||t([]),position:i.position,originalPosition:i.originalPosition,offset:i.positionAbs,item:i.currentItem,sender:e?e.element:null}}})}(jQuery),function(t,e){var i="ui-effects-";t.effects={effect:{}},function(t,e){function i(t,e,i){var s=u[e.type]||{};return null==t?i||!e.def?null:e.def:(t=s.floor?~~t:parseFloat(t),isNaN(t)?e.def:s.mod?(t+s.mod)%s.mod:0>t?0:t>s.max?s.max:t)}function s(i){var s=l(),n=s._rgba=[];return i=i.toLowerCase(),f(h,function(t,o){var a,r=o.re.exec(i),h=r&&o.parse(r),l=o.space||"rgba";return h?(a=s[l](h),s[c[l].cache]=a[c[l].cache],n=s._rgba=a._rgba,!1):e}),n.length?("0,0,0,0"===n.join()&&t.extend(n,o.transparent),s):o[i]}function n(t,e,i){return i=(i+1)%1,1>6*i?t+6*(e-t)*i:1>2*i?e:2>3*i?t+6*(e-t)*(2/3-i):t}var o,a="backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",r=/^([\-+])=\s*(\d+\.?\d*)/,h=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[t[1],t[2],t[3],t[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[2.55*t[1],2.55*t[2],2.55*t[3],t[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(t){return[t[1],t[2]/100,t[3]/100,t[4]]}}],l=t.Color=function(e,i,s,n){return new t.Color.fn.parse(e,i,s,n)},c={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},u={"byte":{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},d=l.support={},p=t("<p>")[0],f=t.each;p.style.cssText="background-color:rgba(1,1,1,.5)",d.rgba=p.style.backgroundColor.indexOf("rgba")>-1,f(c,function(t,e){e.cache="_"+t,e.props.alpha={idx:3,type:"percent",def:1}}),l.fn=t.extend(l.prototype,{parse:function(n,a,r,h){if(n===e)return this._rgba=[null,null,null,null],this;(n.jquery||n.nodeType)&&(n=t(n).css(a),a=e);var u=this,d=t.type(n),p=this._rgba=[];return a!==e&&(n=[n,a,r,h],d="array"),"string"===d?this.parse(s(n)||o._default):"array"===d?(f(c.rgba.props,function(t,e){p[e.idx]=i(n[e.idx],e)}),this):"object"===d?(n instanceof l?f(c,function(t,e){n[e.cache]&&(u[e.cache]=n[e.cache].slice())}):f(c,function(e,s){var o=s.cache;f(s.props,function(t,e){if(!u[o]&&s.to){if("alpha"===t||null==n[t])return;u[o]=s.to(u._rgba)}u[o][e.idx]=i(n[t],e,!0)}),u[o]&&0>t.inArray(null,u[o].slice(0,3))&&(u[o][3]=1,s.from&&(u._rgba=s.from(u[o])))}),this):e},is:function(t){var i=l(t),s=!0,n=this;return f(c,function(t,o){var a,r=i[o.cache];return r&&(a=n[o.cache]||o.to&&o.to(n._rgba)||[],f(o.props,function(t,i){return null!=r[i.idx]?s=r[i.idx]===a[i.idx]:e})),s}),s},_space:function(){var t=[],e=this;return f(c,function(i,s){e[s.cache]&&t.push(i)}),t.pop()},transition:function(t,e){var s=l(t),n=s._space(),o=c[n],a=0===this.alpha()?l("transparent"):this,r=a[o.cache]||o.to(a._rgba),h=r.slice();return s=s[o.cache],f(o.props,function(t,n){var o=n.idx,a=r[o],l=s[o],c=u[n.type]||{};null!==l&&(null===a?h[o]=l:(c.mod&&(l-a>c.mod/2?a+=c.mod:a-l>c.mod/2&&(a-=c.mod)),h[o]=i((l-a)*e+a,n)))}),this[n](h)},blend:function(e){if(1===this._rgba[3])return this;var i=this._rgba.slice(),s=i.pop(),n=l(e)._rgba;return l(t.map(i,function(t,e){return(1-s)*n[e]+s*t}))},toRgbaString:function(){var e="rgba(",i=t.map(this._rgba,function(t,e){return null==t?e>2?1:0:t});return 1===i[3]&&(i.pop(),e="rgb("),e+i.join()+")"},toHslaString:function(){var e="hsla(",i=t.map(this.hsla(),function(t,e){return null==t&&(t=e>2?1:0),e&&3>e&&(t=Math.round(100*t)+"%"),t});return 1===i[3]&&(i.pop(),e="hsl("),e+i.join()+")"},toHexString:function(e){var i=this._rgba.slice(),s=i.pop();return e&&i.push(~~(255*s)),"#"+t.map(i,function(t){return t=(t||0).toString(16),1===t.length?"0"+t:t}).join("")},toString:function(){return 0===this._rgba[3]?"transparent":this.toRgbaString()}}),l.fn.parse.prototype=l.fn,c.hsla.to=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e,i,s=t[0]/255,n=t[1]/255,o=t[2]/255,a=t[3],r=Math.max(s,n,o),h=Math.min(s,n,o),l=r-h,c=r+h,u=.5*c;return e=h===r?0:s===r?60*(n-o)/l+360:n===r?60*(o-s)/l+120:60*(s-n)/l+240,i=0===l?0:.5>=u?l/c:l/(2-c),[Math.round(e)%360,i,u,null==a?1:a]},c.hsla.from=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e=t[0]/360,i=t[1],s=t[2],o=t[3],a=.5>=s?s*(1+i):s+i-s*i,r=2*s-a;return[Math.round(255*n(r,a,e+1/3)),Math.round(255*n(r,a,e)),Math.round(255*n(r,a,e-1/3)),o]},f(c,function(s,n){var o=n.props,a=n.cache,h=n.to,c=n.from;l.fn[s]=function(s){if(h&&!this[a]&&(this[a]=h(this._rgba)),s===e)return this[a].slice();var n,r=t.type(s),u="array"===r||"object"===r?s:arguments,d=this[a].slice();return f(o,function(t,e){var s=u["object"===r?t:e.idx];null==s&&(s=d[e.idx]),d[e.idx]=i(s,e)}),c?(n=l(c(d)),n[a]=d,n):l(d)},f(o,function(e,i){l.fn[e]||(l.fn[e]=function(n){var o,a=t.type(n),h="alpha"===e?this._hsla?"hsla":"rgba":s,l=this[h](),c=l[i.idx];return"undefined"===a?c:("function"===a&&(n=n.call(this,c),a=t.type(n)),null==n&&i.empty?this:("string"===a&&(o=r.exec(n),o&&(n=c+parseFloat(o[2])*("+"===o[1]?1:-1))),l[i.idx]=n,this[h](l)))})})}),l.hook=function(e){var i=e.split(" ");f(i,function(e,i){t.cssHooks[i]={set:function(e,n){var o,a,r="";if("transparent"!==n&&("string"!==t.type(n)||(o=s(n)))){if(n=l(o||n),!d.rgba&&1!==n._rgba[3]){for(a="backgroundColor"===i?e.parentNode:e;(""===r||"transparent"===r)&&a&&a.style;)try{r=t.css(a,"backgroundColor"),a=a.parentNode}catch(h){}n=n.blend(r&&"transparent"!==r?r:"_default")}n=n.toRgbaString()}try{e.style[i]=n}catch(h){}}},t.fx.step[i]=function(e){e.colorInit||(e.start=l(e.elem,i),e.end=l(e.end),e.colorInit=!0),t.cssHooks[i].set(e.elem,e.start.transition(e.end,e.pos))}})},l.hook(a),t.cssHooks.borderColor={expand:function(t){var e={};return f(["Top","Right","Bottom","Left"],function(i,s){e["border"+s+"Color"]=t}),e}},o=t.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"}}(jQuery),function(){function i(e){var i,s,n=e.ownerDocument.defaultView?e.ownerDocument.defaultView.getComputedStyle(e,null):e.currentStyle,o={};if(n&&n.length&&n[0]&&n[n[0]])for(s=n.length;s--;)i=n[s],"string"==typeof n[i]&&(o[t.camelCase(i)]=n[i]);else for(i in n)"string"==typeof n[i]&&(o[i]=n[i]);return o}function s(e,i){var s,n,a={};for(s in i)n=i[s],e[s]!==n&&(o[s]||(t.fx.step[s]||!isNaN(parseFloat(n)))&&(a[s]=n));return a}var n=["add","remove","toggle"],o={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};t.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(e,i){t.fx.step[i]=function(t){("none"!==t.end&&!t.setAttr||1===t.pos&&!t.setAttr)&&(jQuery.style(t.elem,i,t.end),t.setAttr=!0)}}),t.fn.addBack||(t.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),t.effects.animateClass=function(e,o,a,r){var h=t.speed(o,a,r);return this.queue(function(){var o,a=t(this),r=a.attr("class")||"",l=h.children?a.find("*").addBack():a;l=l.map(function(){var e=t(this);return{el:e,start:i(this)}}),o=function(){t.each(n,function(t,i){e[i]&&a[i+"Class"](e[i])})},o(),l=l.map(function(){return this.end=i(this.el[0]),this.diff=s(this.start,this.end),this}),a.attr("class",r),l=l.map(function(){var e=this,i=t.Deferred(),s=t.extend({},h,{queue:!1,complete:function(){i.resolve(e)}});return this.el.animate(this.diff,s),i.promise()}),t.when.apply(t,l.get()).done(function(){o(),t.each(arguments,function(){var e=this.el;t.each(this.diff,function(t){e.css(t,"")})}),h.complete.call(a[0])})})},t.fn.extend({addClass:function(e){return function(i,s,n,o){return s?t.effects.animateClass.call(this,{add:i},s,n,o):e.apply(this,arguments)}}(t.fn.addClass),removeClass:function(e){return function(i,s,n,o){return arguments.length>1?t.effects.animateClass.call(this,{remove:i},s,n,o):e.apply(this,arguments)}}(t.fn.removeClass),toggleClass:function(i){return function(s,n,o,a,r){return"boolean"==typeof n||n===e?o?t.effects.animateClass.call(this,n?{add:s}:{remove:s},o,a,r):i.apply(this,arguments):t.effects.animateClass.call(this,{toggle:s},n,o,a)}}(t.fn.toggleClass),switchClass:function(e,i,s,n,o){return t.effects.animateClass.call(this,{add:i,remove:e},s,n,o)}})}(),function(){function s(e,i,s,n){return t.isPlainObject(e)&&(i=e,e=e.effect),e={effect:e},null==i&&(i={}),t.isFunction(i)&&(n=i,s=null,i={}),("number"==typeof i||t.fx.speeds[i])&&(n=s,s=i,i={}),t.isFunction(s)&&(n=s,s=null),i&&t.extend(e,i),s=s||i.duration,e.duration=t.fx.off?0:"number"==typeof s?s:s in t.fx.speeds?t.fx.speeds[s]:t.fx.speeds._default,e.complete=n||i.complete,e}function n(e){return!e||"number"==typeof e||t.fx.speeds[e]?!0:"string"!=typeof e||t.effects.effect[e]?t.isFunction(e)?!0:"object"!=typeof e||e.effect?!1:!0:!0}t.extend(t.effects,{version:"1.10.3",save:function(t,e){for(var s=0;e.length>s;s++)null!==e[s]&&t.data(i+e[s],t[0].style[e[s]])},restore:function(t,s){var n,o;for(o=0;s.length>o;o++)null!==s[o]&&(n=t.data(i+s[o]),n===e&&(n=""),t.css(s[o],n))},setMode:function(t,e){return"toggle"===e&&(e=t.is(":hidden")?"show":"hide"),e},getBaseline:function(t,e){var i,s;switch(t[0]){case"top":i=0;break;case"middle":i=.5;break;case"bottom":i=1;break;default:i=t[0]/e.height}switch(t[1]){case"left":s=0;break;case"center":s=.5;break;case"right":s=1;break;default:s=t[1]/e.width}return{x:s,y:i}},createWrapper:function(e){if(e.parent().is(".ui-effects-wrapper"))return e.parent();var i={width:e.outerWidth(!0),height:e.outerHeight(!0),"float":e.css("float")},s=t("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),n={width:e.width(),height:e.height()},o=document.activeElement;try{o.id}catch(a){o=document.body}return e.wrap(s),(e[0]===o||t.contains(e[0],o))&&t(o).focus(),s=e.parent(),"static"===e.css("position")?(s.css({position:"relative"}),e.css({position:"relative"})):(t.extend(i,{position:e.css("position"),zIndex:e.css("z-index")}),t.each(["top","left","bottom","right"],function(t,s){i[s]=e.css(s),isNaN(parseInt(i[s],10))&&(i[s]="auto")}),e.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),e.css(n),s.css(i).show()},removeWrapper:function(e){var i=document.activeElement;return e.parent().is(".ui-effects-wrapper")&&(e.parent().replaceWith(e),(e[0]===i||t.contains(e[0],i))&&t(i).focus()),e},setTransition:function(e,i,s,n){return n=n||{},t.each(i,function(t,i){var o=e.cssUnit(i);o[0]>0&&(n[i]=o[0]*s+o[1])}),n}}),t.fn.extend({effect:function(){function e(e){function s(){t.isFunction(o)&&o.call(n[0]),t.isFunction(e)&&e()}var n=t(this),o=i.complete,r=i.mode;(n.is(":hidden")?"hide"===r:"show"===r)?(n[r](),s()):a.call(n[0],i,s)}var i=s.apply(this,arguments),n=i.mode,o=i.queue,a=t.effects.effect[i.effect];return t.fx.off||!a?n?this[n](i.duration,i.complete):this.each(function(){i.complete&&i.complete.call(this)}):o===!1?this.each(e):this.queue(o||"fx",e)},show:function(t){return function(e){if(n(e))return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="show",this.effect.call(this,i)}}(t.fn.show),hide:function(t){return function(e){if(n(e))return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="hide",this.effect.call(this,i)}}(t.fn.hide),toggle:function(t){return function(e){if(n(e)||"boolean"==typeof e)return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="toggle",this.effect.call(this,i)}}(t.fn.toggle),cssUnit:function(e){var i=this.css(e),s=[];return t.each(["em","px","%","pt"],function(t,e){i.indexOf(e)>0&&(s=[parseFloat(i),e])}),s}})}(),function(){var e={};t.each(["Quad","Cubic","Quart","Quint","Expo"],function(t,i){e[i]=function(e){return Math.pow(e,t+2)}}),t.extend(e,{Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t){return 0===t||1===t?t:-Math.pow(2,8*(t-1))*Math.sin((80*(t-1)-7.5)*Math.PI/15)},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,i=4;((e=Math.pow(2,--i))-1)/11>t;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*e-2)/22-t,2)}}),t.each(e,function(e,i){t.easing["easeIn"+e]=i,t.easing["easeOut"+e]=function(t){return 1-i(1-t)},t.easing["easeInOut"+e]=function(t){return.5>t?i(2*t)/2:1-i(-2*t+2)/2}})}()}(jQuery),function(t){var e=0,i={},s={};i.height=i.paddingTop=i.paddingBottom=i.borderTopWidth=i.borderBottomWidth="hide",s.height=s.paddingTop=s.paddingBottom=s.borderTopWidth=s.borderBottomWidth="show",t.widget("ui.accordion",{version:"1.10.3",options:{active:0,animate:{},collapsible:!1,event:"click",header:"> li > :first-child,> :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},_create:function(){var e=this.options;this.prevShow=this.prevHide=t(),this.element.addClass("ui-accordion ui-widget ui-helper-reset").attr("role","tablist"),e.collapsible||e.active!==!1&&null!=e.active||(e.active=0),this._processPanels(),0>e.active&&(e.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():t(),content:this.active.length?this.active.next():t()}},_createIcons:function(){var e=this.options.icons;e&&(t("<span>").addClass("ui-accordion-header-icon ui-icon "+e.header).prependTo(this.headers),this.active.children(".ui-accordion-header-icon").removeClass(e.header).addClass(e.activeHeader),this.headers.addClass("ui-accordion-icons"))
},_destroyIcons:function(){this.headers.removeClass("ui-accordion-icons").children(".ui-accordion-header-icon").remove()},_destroy:function(){var t;this.element.removeClass("ui-accordion ui-widget ui-helper-reset").removeAttr("role"),this.headers.removeClass("ui-accordion-header ui-accordion-header-active ui-helper-reset ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top").removeAttr("role").removeAttr("aria-selected").removeAttr("aria-controls").removeAttr("tabIndex").each(function(){/^ui-accordion/.test(this.id)&&this.removeAttribute("id")}),this._destroyIcons(),t=this.headers.next().css("display","").removeAttr("role").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-labelledby").removeClass("ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-state-disabled").each(function(){/^ui-accordion/.test(this.id)&&this.removeAttribute("id")}),"content"!==this.options.heightStyle&&t.css("height","")},_setOption:function(t,e){return"active"===t?(this._activate(e),undefined):("event"===t&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(e)),this._super(t,e),"collapsible"!==t||e||this.options.active!==!1||this._activate(0),"icons"===t&&(this._destroyIcons(),e&&this._createIcons()),"disabled"===t&&this.headers.add(this.headers.next()).toggleClass("ui-state-disabled",!!e),undefined)},_keydown:function(e){if(!e.altKey&&!e.ctrlKey){var i=t.ui.keyCode,s=this.headers.length,n=this.headers.index(e.target),o=!1;switch(e.keyCode){case i.RIGHT:case i.DOWN:o=this.headers[(n+1)%s];break;case i.LEFT:case i.UP:o=this.headers[(n-1+s)%s];break;case i.SPACE:case i.ENTER:this._eventHandler(e);break;case i.HOME:o=this.headers[0];break;case i.END:o=this.headers[s-1]}o&&(t(e.target).attr("tabIndex",-1),t(o).attr("tabIndex",0),o.focus(),e.preventDefault())}},_panelKeyDown:function(e){e.keyCode===t.ui.keyCode.UP&&e.ctrlKey&&t(e.currentTarget).prev().focus()},refresh:function(){var e=this.options;this._processPanels(),e.active===!1&&e.collapsible===!0||!this.headers.length?(e.active=!1,this.active=t()):e.active===!1?this._activate(0):this.active.length&&!t.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(e.active=!1,this.active=t()):this._activate(Math.max(0,e.active-1)):e.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){this.headers=this.element.find(this.options.header).addClass("ui-accordion-header ui-helper-reset ui-state-default ui-corner-all"),this.headers.next().addClass("ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom").filter(":not(.ui-accordion-content-active)").hide()},_refresh:function(){var i,s=this.options,n=s.heightStyle,o=this.element.parent(),a=this.accordionId="ui-accordion-"+(this.element.attr("id")||++e);this.active=this._findActive(s.active).addClass("ui-accordion-header-active ui-state-active ui-corner-top").removeClass("ui-corner-all"),this.active.next().addClass("ui-accordion-content-active").show(),this.headers.attr("role","tab").each(function(e){var i=t(this),s=i.attr("id"),n=i.next(),o=n.attr("id");s||(s=a+"-header-"+e,i.attr("id",s)),o||(o=a+"-panel-"+e,n.attr("id",o)),i.attr("aria-controls",o),n.attr("aria-labelledby",s)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false",tabIndex:-1}).next().attr({"aria-expanded":"false","aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true",tabIndex:0}).next().attr({"aria-expanded":"true","aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(s.event),"fill"===n?(i=o.height(),this.element.siblings(":visible").each(function(){var e=t(this),s=e.css("position");"absolute"!==s&&"fixed"!==s&&(i-=e.outerHeight(!0))}),this.headers.each(function(){i-=t(this).outerHeight(!0)}),this.headers.next().each(function(){t(this).height(Math.max(0,i-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===n&&(i=0,this.headers.next().each(function(){i=Math.max(i,t(this).css("height","").height())}).height(i))},_activate:function(e){var i=this._findActive(e)[0];i!==this.active[0]&&(i=i||this.active[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return"number"==typeof e?this.headers.eq(e):t()},_setupEvents:function(e){var i={keydown:"_keydown"};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(e){var i=this.options,s=this.active,n=t(e.currentTarget),o=n[0]===s[0],a=o&&i.collapsible,r=a?t():n.next(),h=s.next(),l={oldHeader:s,oldPanel:h,newHeader:a?t():n,newPanel:r};e.preventDefault(),o&&!i.collapsible||this._trigger("beforeActivate",e,l)===!1||(i.active=a?!1:this.headers.index(n),this.active=o?t():n,this._toggle(l),s.removeClass("ui-accordion-header-active ui-state-active"),i.icons&&s.children(".ui-accordion-header-icon").removeClass(i.icons.activeHeader).addClass(i.icons.header),o||(n.removeClass("ui-corner-all").addClass("ui-accordion-header-active ui-state-active ui-corner-top"),i.icons&&n.children(".ui-accordion-header-icon").removeClass(i.icons.header).addClass(i.icons.activeHeader),n.next().addClass("ui-accordion-content-active")))},_toggle:function(e){var i=e.newPanel,s=this.prevShow.length?this.prevShow:e.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=i,this.prevHide=s,this.options.animate?this._animate(i,s,e):(s.hide(),i.show(),this._toggleComplete(e)),s.attr({"aria-expanded":"false","aria-hidden":"true"}),s.prev().attr("aria-selected","false"),i.length&&s.length?s.prev().attr("tabIndex",-1):i.length&&this.headers.filter(function(){return 0===t(this).attr("tabIndex")}).attr("tabIndex",-1),i.attr({"aria-expanded":"true","aria-hidden":"false"}).prev().attr({"aria-selected":"true",tabIndex:0})},_animate:function(t,e,n){var o,a,r,h=this,l=0,c=t.length&&(!e.length||t.index()<e.index()),u=this.options.animate||{},d=c&&u.down||u,p=function(){h._toggleComplete(n)};return"number"==typeof d&&(r=d),"string"==typeof d&&(a=d),a=a||d.easing||u.easing,r=r||d.duration||u.duration,e.length?t.length?(o=t.show().outerHeight(),e.animate(i,{duration:r,easing:a,step:function(t,e){e.now=Math.round(t)}}),t.hide().animate(s,{duration:r,easing:a,complete:p,step:function(t,i){i.now=Math.round(t),"height"!==i.prop?l+=i.now:"content"!==h.options.heightStyle&&(i.now=Math.round(o-e.outerHeight()-l),l=0)}}),undefined):e.animate(i,r,a,p):t.animate(s,r,a,p)},_toggleComplete:function(t){var e=t.oldPanel;e.removeClass("ui-accordion-content-active").prev().removeClass("ui-corner-top").addClass("ui-corner-all"),e.length&&(e.parent()[0].className=e.parent()[0].className),this._trigger("activate",null,t)}})}(jQuery),function(t){var e=0;t.widget("ui.autocomplete",{version:"1.10.3",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},pending:0,_create:function(){var e,i,s,n=this.element[0].nodeName.toLowerCase(),o="textarea"===n,a="input"===n;this.isMultiLine=o?!0:a?!1:this.element.prop("isContentEditable"),this.valueMethod=this.element[o||a?"val":"text"],this.isNewMenu=!0,this.element.addClass("ui-autocomplete-input").attr("autocomplete","off"),this._on(this.element,{keydown:function(n){if(this.element.prop("readOnly"))return e=!0,s=!0,i=!0,undefined;e=!1,s=!1,i=!1;var o=t.ui.keyCode;switch(n.keyCode){case o.PAGE_UP:e=!0,this._move("previousPage",n);break;case o.PAGE_DOWN:e=!0,this._move("nextPage",n);break;case o.UP:e=!0,this._keyEvent("previous",n);break;case o.DOWN:e=!0,this._keyEvent("next",n);break;case o.ENTER:case o.NUMPAD_ENTER:this.menu.active&&(e=!0,n.preventDefault(),this.menu.select(n));break;case o.TAB:this.menu.active&&this.menu.select(n);break;case o.ESCAPE:this.menu.element.is(":visible")&&(this._value(this.term),this.close(n),n.preventDefault());break;default:i=!0,this._searchTimeout(n)}},keypress:function(s){if(e)return e=!1,(!this.isMultiLine||this.menu.element.is(":visible"))&&s.preventDefault(),undefined;if(!i){var n=t.ui.keyCode;switch(s.keyCode){case n.PAGE_UP:this._move("previousPage",s);break;case n.PAGE_DOWN:this._move("nextPage",s);break;case n.UP:this._keyEvent("previous",s);break;case n.DOWN:this._keyEvent("next",s)}}},input:function(t){return s?(s=!1,t.preventDefault(),undefined):(this._searchTimeout(t),undefined)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(t){return this.cancelBlur?(delete this.cancelBlur,undefined):(clearTimeout(this.searching),this.close(t),this._change(t),undefined)}}),this._initSource(),this.menu=t("<ul>").addClass("ui-autocomplete ui-front").appendTo(this._appendTo()).menu({role:null}).hide().data("ui-menu"),this._on(this.menu.element,{mousedown:function(e){e.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur});var i=this.menu.element[0];t(e.target).closest(".ui-menu-item").length||this._delay(function(){var e=this;this.document.one("mousedown",function(s){s.target===e.element[0]||s.target===i||t.contains(i,s.target)||e.close()})})},menufocus:function(e,i){if(this.isNewMenu&&(this.isNewMenu=!1,e.originalEvent&&/^mouse/.test(e.originalEvent.type)))return this.menu.blur(),this.document.one("mousemove",function(){t(e.target).trigger(e.originalEvent)}),undefined;var s=i.item.data("ui-autocomplete-item");!1!==this._trigger("focus",e,{item:s})?e.originalEvent&&/^key/.test(e.originalEvent.type)&&this._value(s.value):this.liveRegion.text(s.value)},menuselect:function(t,e){var i=e.item.data("ui-autocomplete-item"),s=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.focus(),this.previous=s,this._delay(function(){this.previous=s,this.selectedItem=i})),!1!==this._trigger("select",t,{item:i})&&this._value(i.value),this.term=this._value(),this.close(t),this.selectedItem=i}}),this.liveRegion=t("<span>",{role:"status","aria-live":"polite"}).addClass("ui-helper-hidden-accessible").insertBefore(this.element),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(t,e){this._super(t,e),"source"===t&&this._initSource(),"appendTo"===t&&this.menu.element.appendTo(this._appendTo()),"disabled"===t&&e&&this.xhr&&this.xhr.abort()},_appendTo:function(){var e=this.options.appendTo;return e&&(e=e.jquery||e.nodeType?t(e):this.document.find(e).eq(0)),e||(e=this.element.closest(".ui-front")),e.length||(e=this.document[0].body),e},_initSource:function(){var e,i,s=this;t.isArray(this.options.source)?(e=this.options.source,this.source=function(i,s){s(t.ui.autocomplete.filter(e,i.term))}):"string"==typeof this.options.source?(i=this.options.source,this.source=function(e,n){s.xhr&&s.xhr.abort(),s.xhr=t.ajax({url:i,data:e,dataType:"json",success:function(t){n(t)},error:function(){n([])}})}):this.source=this.options.source},_searchTimeout:function(t){clearTimeout(this.searching),this.searching=this._delay(function(){this.term!==this._value()&&(this.selectedItem=null,this.search(null,t))},this.options.delay)},search:function(t,e){return t=null!=t?t:this._value(),this.term=this._value(),t.length<this.options.minLength?this.close(e):this._trigger("search",e)!==!1?this._search(t):undefined},_search:function(t){this.pending++,this.element.addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:t},this._response())},_response:function(){var t=this,i=++e;return function(s){i===e&&t.__response(s),t.pending--,t.pending||t.element.removeClass("ui-autocomplete-loading")}},__response:function(t){t&&(t=this._normalize(t)),this._trigger("response",null,{content:t}),!this.options.disabled&&t&&t.length&&!this.cancelSearch?(this._suggest(t),this._trigger("open")):this._close()},close:function(t){this.cancelSearch=!0,this._close(t)},_close:function(t){this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",t))},_change:function(t){this.previous!==this._value()&&this._trigger("change",t,{item:this.selectedItem})},_normalize:function(e){return e.length&&e[0].label&&e[0].value?e:t.map(e,function(e){return"string"==typeof e?{label:e,value:e}:t.extend({label:e.label||e.value,value:e.value||e.label},e)})},_suggest:function(e){var i=this.menu.element.empty();this._renderMenu(i,e),this.isNewMenu=!0,this.menu.refresh(),i.show(),this._resizeMenu(),i.position(t.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next()},_resizeMenu:function(){var t=this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(e,i){var s=this;t.each(i,function(t,i){s._renderItemData(e,i)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-autocomplete-item",e)},_renderItem:function(e,i){return t("<li>").append(t("<a>").text(i.label)).appendTo(e)},_move:function(t,e){return this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(t)||this.menu.isLastItem()&&/^next/.test(t)?(this._value(this.term),this.menu.blur(),undefined):(this.menu[t](e),undefined):(this.search(null,e),undefined)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(t,e){(!this.isMultiLine||this.menu.element.is(":visible"))&&(this._move(t,e),e.preventDefault())}}),t.extend(t.ui.autocomplete,{escapeRegex:function(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(e,i){var s=RegExp(t.ui.autocomplete.escapeRegex(i),"i");return t.grep(e,function(t){return s.test(t.label||t.value||t)})}}),t.widget("ui.autocomplete",t.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(t){return t+(t>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(t){var e;this._superApply(arguments),this.options.disabled||this.cancelSearch||(e=t&&t.length?this.options.messages.results(t.length):this.options.messages.noResults,this.liveRegion.text(e))}})}(jQuery),function(t){var e,i,s,n,o="ui-button ui-widget ui-state-default ui-corner-all",a="ui-state-hover ui-state-active ",r="ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",h=function(){var e=t(this);setTimeout(function(){e.find(":ui-button").button("refresh")},1)},l=function(e){var i=e.name,s=e.form,n=t([]);return i&&(i=i.replace(/'/g,"\\'"),n=s?t(s).find("[name='"+i+"']"):t("[name='"+i+"']",e.ownerDocument).filter(function(){return!this.form})),n};t.widget("ui.button",{version:"1.10.3",defaultElement:"<button>",options:{disabled:null,text:!0,label:null,icons:{primary:null,secondary:null}},_create:function(){this.element.closest("form").unbind("reset"+this.eventNamespace).bind("reset"+this.eventNamespace,h),"boolean"!=typeof this.options.disabled?this.options.disabled=!!this.element.prop("disabled"):this.element.prop("disabled",this.options.disabled),this._determineButtonType(),this.hasTitle=!!this.buttonElement.attr("title");var a=this,r=this.options,c="checkbox"===this.type||"radio"===this.type,u=c?"":"ui-state-active",d="ui-state-focus";null===r.label&&(r.label="input"===this.type?this.buttonElement.val():this.buttonElement.html()),this._hoverable(this.buttonElement),this.buttonElement.addClass(o).attr("role","button").bind("mouseenter"+this.eventNamespace,function(){r.disabled||this===e&&t(this).addClass("ui-state-active")}).bind("mouseleave"+this.eventNamespace,function(){r.disabled||t(this).removeClass(u)}).bind("click"+this.eventNamespace,function(t){r.disabled&&(t.preventDefault(),t.stopImmediatePropagation())}),this.element.bind("focus"+this.eventNamespace,function(){a.buttonElement.addClass(d)}).bind("blur"+this.eventNamespace,function(){a.buttonElement.removeClass(d)}),c&&(this.element.bind("change"+this.eventNamespace,function(){n||a.refresh()}),this.buttonElement.bind("mousedown"+this.eventNamespace,function(t){r.disabled||(n=!1,i=t.pageX,s=t.pageY)}).bind("mouseup"+this.eventNamespace,function(t){r.disabled||(i!==t.pageX||s!==t.pageY)&&(n=!0)})),"checkbox"===this.type?this.buttonElement.bind("click"+this.eventNamespace,function(){return r.disabled||n?!1:undefined}):"radio"===this.type?this.buttonElement.bind("click"+this.eventNamespace,function(){if(r.disabled||n)return!1;t(this).addClass("ui-state-active"),a.buttonElement.attr("aria-pressed","true");var e=a.element[0];l(e).not(e).map(function(){return t(this).button("widget")[0]}).removeClass("ui-state-active").attr("aria-pressed","false")}):(this.buttonElement.bind("mousedown"+this.eventNamespace,function(){return r.disabled?!1:(t(this).addClass("ui-state-active"),e=this,a.document.one("mouseup",function(){e=null}),undefined)}).bind("mouseup"+this.eventNamespace,function(){return r.disabled?!1:(t(this).removeClass("ui-state-active"),undefined)}).bind("keydown"+this.eventNamespace,function(e){return r.disabled?!1:((e.keyCode===t.ui.keyCode.SPACE||e.keyCode===t.ui.keyCode.ENTER)&&t(this).addClass("ui-state-active"),undefined)}).bind("keyup"+this.eventNamespace+" blur"+this.eventNamespace,function(){t(this).removeClass("ui-state-active")}),this.buttonElement.is("a")&&this.buttonElement.keyup(function(e){e.keyCode===t.ui.keyCode.SPACE&&t(this).click()})),this._setOption("disabled",r.disabled),this._resetButton()},_determineButtonType:function(){var t,e,i;this.type=this.element.is("[type=checkbox]")?"checkbox":this.element.is("[type=radio]")?"radio":this.element.is("input")?"input":"button","checkbox"===this.type||"radio"===this.type?(t=this.element.parents().last(),e="label[for='"+this.element.attr("id")+"']",this.buttonElement=t.find(e),this.buttonElement.length||(t=t.length?t.siblings():this.element.siblings(),this.buttonElement=t.filter(e),this.buttonElement.length||(this.buttonElement=t.find(e))),this.element.addClass("ui-helper-hidden-accessible"),i=this.element.is(":checked"),i&&this.buttonElement.addClass("ui-state-active"),this.buttonElement.prop("aria-pressed",i)):this.buttonElement=this.element},widget:function(){return this.buttonElement},_destroy:function(){this.element.removeClass("ui-helper-hidden-accessible"),this.buttonElement.removeClass(o+" "+a+" "+r).removeAttr("role").removeAttr("aria-pressed").html(this.buttonElement.find(".ui-button-text").html()),this.hasTitle||this.buttonElement.removeAttr("title")},_setOption:function(t,e){return this._super(t,e),"disabled"===t?(e?this.element.prop("disabled",!0):this.element.prop("disabled",!1),undefined):(this._resetButton(),undefined)},refresh:function(){var e=this.element.is("input, button")?this.element.is(":disabled"):this.element.hasClass("ui-button-disabled");e!==this.options.disabled&&this._setOption("disabled",e),"radio"===this.type?l(this.element[0]).each(function(){t(this).is(":checked")?t(this).button("widget").addClass("ui-state-active").attr("aria-pressed","true"):t(this).button("widget").removeClass("ui-state-active").attr("aria-pressed","false")}):"checkbox"===this.type&&(this.element.is(":checked")?this.buttonElement.addClass("ui-state-active").attr("aria-pressed","true"):this.buttonElement.removeClass("ui-state-active").attr("aria-pressed","false"))},_resetButton:function(){if("input"===this.type)return this.options.label&&this.element.val(this.options.label),undefined;var e=this.buttonElement.removeClass(r),i=t("<span></span>",this.document[0]).addClass("ui-button-text").html(this.options.label).appendTo(e.empty()).text(),s=this.options.icons,n=s.primary&&s.secondary,o=[];s.primary||s.secondary?(this.options.text&&o.push("ui-button-text-icon"+(n?"s":s.primary?"-primary":"-secondary")),s.primary&&e.prepend("<span class='ui-button-icon-primary ui-icon "+s.primary+"'></span>"),s.secondary&&e.append("<span class='ui-button-icon-secondary ui-icon "+s.secondary+"'></span>"),this.options.text||(o.push(n?"ui-button-icons-only":"ui-button-icon-only"),this.hasTitle||e.attr("title",t.trim(i)))):o.push("ui-button-text-only"),e.addClass(o.join(" "))}}),t.widget("ui.buttonset",{version:"1.10.3",options:{items:"button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"},_create:function(){this.element.addClass("ui-buttonset")},_init:function(){this.refresh()},_setOption:function(t,e){"disabled"===t&&this.buttons.button("option",t,e),this._super(t,e)},refresh:function(){var e="rtl"===this.element.css("direction");this.buttons=this.element.find(this.options.items).filter(":ui-button").button("refresh").end().not(":ui-button").button().end().map(function(){return t(this).button("widget")[0]}).removeClass("ui-corner-all ui-corner-left ui-corner-right").filter(":first").addClass(e?"ui-corner-right":"ui-corner-left").end().filter(":last").addClass(e?"ui-corner-left":"ui-corner-right").end().end()},_destroy:function(){this.element.removeClass("ui-buttonset"),this.buttons.map(function(){return t(this).button("widget")[0]}).removeClass("ui-corner-left ui-corner-right").end().button("destroy")}})}(jQuery),function(t,e){function i(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},t.extend(this._defaults,this.regional[""]),this.dpDiv=s(t("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function s(e){var i="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return e.delegate(i,"mouseout",function(){t(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&t(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&t(this).removeClass("ui-datepicker-next-hover")}).delegate(i,"mouseover",function(){t.datepicker._isDisabledDatepicker(o.inline?e.parent()[0]:o.input[0])||(t(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),t(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&t(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&t(this).addClass("ui-datepicker-next-hover"))})}function n(e,i){t.extend(e,i);for(var s in i)null==i[s]&&(e[s]=i[s]);return e}t.extend(t.ui,{datepicker:{version:"1.10.3"}});var o,a="datepicker";t.extend(i.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(t){return n(this._defaults,t||{}),this},_attachDatepicker:function(e,i){var s,n,o;s=e.nodeName.toLowerCase(),n="div"===s||"span"===s,e.id||(this.uuid+=1,e.id="dp"+this.uuid),o=this._newInst(t(e),n),o.settings=t.extend({},i||{}),"input"===s?this._connectDatepicker(e,o):n&&this._inlineDatepicker(e,o)},_newInst:function(e,i){var n=e[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:n,input:e,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:i,dpDiv:i?s(t("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(e,i){var s=t(e);i.append=t([]),i.trigger=t([]),s.hasClass(this.markerClassName)||(this._attachments(s,i),s.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp),this._autoSize(i),t.data(e,a,i),i.settings.disabled&&this._disableDatepicker(e))},_attachments:function(e,i){var s,n,o,a=this._get(i,"appendText"),r=this._get(i,"isRTL");i.append&&i.append.remove(),a&&(i.append=t("<span class='"+this._appendClass+"'>"+a+"</span>"),e[r?"before":"after"](i.append)),e.unbind("focus",this._showDatepicker),i.trigger&&i.trigger.remove(),s=this._get(i,"showOn"),("focus"===s||"both"===s)&&e.focus(this._showDatepicker),("button"===s||"both"===s)&&(n=this._get(i,"buttonText"),o=this._get(i,"buttonImage"),i.trigger=t(this._get(i,"buttonImageOnly")?t("<img/>").addClass(this._triggerClass).attr({src:o,alt:n,title:n}):t("<button type='button'></button>").addClass(this._triggerClass).html(o?t("<img/>").attr({src:o,alt:n,title:n}):n)),e[r?"before":"after"](i.trigger),i.trigger.click(function(){return t.datepicker._datepickerShowing&&t.datepicker._lastInput===e[0]?t.datepicker._hideDatepicker():t.datepicker._datepickerShowing&&t.datepicker._lastInput!==e[0]?(t.datepicker._hideDatepicker(),t.datepicker._showDatepicker(e[0])):t.datepicker._showDatepicker(e[0]),!1}))},_autoSize:function(t){if(this._get(t,"autoSize")&&!t.inline){var e,i,s,n,o=new Date(2009,11,20),a=this._get(t,"dateFormat");a.match(/[DM]/)&&(e=function(t){for(i=0,s=0,n=0;t.length>n;n++)t[n].length>i&&(i=t[n].length,s=n);return s},o.setMonth(e(this._get(t,a.match(/MM/)?"monthNames":"monthNamesShort"))),o.setDate(e(this._get(t,a.match(/DD/)?"dayNames":"dayNamesShort"))+20-o.getDay())),t.input.attr("size",this._formatDate(t,o).length)}},_inlineDatepicker:function(e,i){var s=t(e);s.hasClass(this.markerClassName)||(s.addClass(this.markerClassName).append(i.dpDiv),t.data(e,a,i),this._setDate(i,this._getDefaultDate(i),!0),this._updateDatepicker(i),this._updateAlternate(i),i.settings.disabled&&this._disableDatepicker(e),i.dpDiv.css("display","block"))},_dialogDatepicker:function(e,i,s,o,r){var h,l,c,u,d,p=this._dialogInst;return p||(this.uuid+=1,h="dp"+this.uuid,this._dialogInput=t("<input type='text' id='"+h+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.keydown(this._doKeyDown),t("body").append(this._dialogInput),p=this._dialogInst=this._newInst(this._dialogInput,!1),p.settings={},t.data(this._dialogInput[0],a,p)),n(p.settings,o||{}),i=i&&i.constructor===Date?this._formatDate(p,i):i,this._dialogInput.val(i),this._pos=r?r.length?r:[r.pageX,r.pageY]:null,this._pos||(l=document.documentElement.clientWidth,c=document.documentElement.clientHeight,u=document.documentElement.scrollLeft||document.body.scrollLeft,d=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[l/2-100+u,c/2-150+d]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),p.settings.onSelect=s,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),t.blockUI&&t.blockUI(this.dpDiv),t.data(this._dialogInput[0],a,p),this},_destroyDatepicker:function(e){var i,s=t(e),n=t.data(e,a);s.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),t.removeData(e,a),"input"===i?(n.append.remove(),n.trigger.remove(),s.removeClass(this.markerClassName).unbind("focus",this._showDatepicker).unbind("keydown",this._doKeyDown).unbind("keypress",this._doKeyPress).unbind("keyup",this._doKeyUp)):("div"===i||"span"===i)&&s.removeClass(this.markerClassName).empty())},_enableDatepicker:function(e){var i,s,n=t(e),o=t.data(e,a);n.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),"input"===i?(e.disabled=!1,o.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):("div"===i||"span"===i)&&(s=n.children("."+this._inlineClass),s.children().removeClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=t.map(this._disabledInputs,function(t){return t===e?null:t}))},_disableDatepicker:function(e){var i,s,n=t(e),o=t.data(e,a);n.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),"input"===i?(e.disabled=!0,o.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):("div"===i||"span"===i)&&(s=n.children("."+this._inlineClass),s.children().addClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=t.map(this._disabledInputs,function(t){return t===e?null:t}),this._disabledInputs[this._disabledInputs.length]=e)},_isDisabledDatepicker:function(t){if(!t)return!1;for(var e=0;this._disabledInputs.length>e;e++)if(this._disabledInputs[e]===t)return!0;return!1},_getInst:function(e){try{return t.data(e,a)}catch(i){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(i,s,o){var a,r,h,l,c=this._getInst(i);return 2===arguments.length&&"string"==typeof s?"defaults"===s?t.extend({},t.datepicker._defaults):c?"all"===s?t.extend({},c.settings):this._get(c,s):null:(a=s||{},"string"==typeof s&&(a={},a[s]=o),c&&(this._curInst===c&&this._hideDatepicker(),r=this._getDateDatepicker(i,!0),h=this._getMinMaxDate(c,"min"),l=this._getMinMaxDate(c,"max"),n(c.settings,a),null!==h&&a.dateFormat!==e&&a.minDate===e&&(c.settings.minDate=this._formatDate(c,h)),null!==l&&a.dateFormat!==e&&a.maxDate===e&&(c.settings.maxDate=this._formatDate(c,l)),"disabled"in a&&(a.disabled?this._disableDatepicker(i):this._enableDatepicker(i)),this._attachments(t(i),c),this._autoSize(c),this._setDate(c,r),this._updateAlternate(c),this._updateDatepicker(c)),e)},_changeDatepicker:function(t,e,i){this._optionDatepicker(t,e,i)},_refreshDatepicker:function(t){var e=this._getInst(t);e&&this._updateDatepicker(e)},_setDateDatepicker:function(t,e){var i=this._getInst(t);i&&(this._setDate(i,e),this._updateDatepicker(i),this._updateAlternate(i))},_getDateDatepicker:function(t,e){var i=this._getInst(t);return i&&!i.inline&&this._setDateFromField(i,e),i?this._getDate(i):null},_doKeyDown:function(e){var i,s,n,o=t.datepicker._getInst(e.target),a=!0,r=o.dpDiv.is(".ui-datepicker-rtl");if(o._keyEvent=!0,t.datepicker._datepickerShowing)switch(e.keyCode){case 9:t.datepicker._hideDatepicker(),a=!1;break;case 13:return n=t("td."+t.datepicker._dayOverClass+":not(."+t.datepicker._currentClass+")",o.dpDiv),n[0]&&t.datepicker._selectDay(e.target,o.selectedMonth,o.selectedYear,n[0]),i=t.datepicker._get(o,"onSelect"),i?(s=t.datepicker._formatDate(o),i.apply(o.input?o.input[0]:null,[s,o])):t.datepicker._hideDatepicker(),!1;
case 27:t.datepicker._hideDatepicker();break;case 33:t.datepicker._adjustDate(e.target,e.ctrlKey?-t.datepicker._get(o,"stepBigMonths"):-t.datepicker._get(o,"stepMonths"),"M");break;case 34:t.datepicker._adjustDate(e.target,e.ctrlKey?+t.datepicker._get(o,"stepBigMonths"):+t.datepicker._get(o,"stepMonths"),"M");break;case 35:(e.ctrlKey||e.metaKey)&&t.datepicker._clearDate(e.target),a=e.ctrlKey||e.metaKey;break;case 36:(e.ctrlKey||e.metaKey)&&t.datepicker._gotoToday(e.target),a=e.ctrlKey||e.metaKey;break;case 37:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,r?1:-1,"D"),a=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&t.datepicker._adjustDate(e.target,e.ctrlKey?-t.datepicker._get(o,"stepBigMonths"):-t.datepicker._get(o,"stepMonths"),"M");break;case 38:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,-7,"D"),a=e.ctrlKey||e.metaKey;break;case 39:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,r?-1:1,"D"),a=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&t.datepicker._adjustDate(e.target,e.ctrlKey?+t.datepicker._get(o,"stepBigMonths"):+t.datepicker._get(o,"stepMonths"),"M");break;case 40:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,7,"D"),a=e.ctrlKey||e.metaKey;break;default:a=!1}else 36===e.keyCode&&e.ctrlKey?t.datepicker._showDatepicker(this):a=!1;a&&(e.preventDefault(),e.stopPropagation())},_doKeyPress:function(i){var s,n,o=t.datepicker._getInst(i.target);return t.datepicker._get(o,"constrainInput")?(s=t.datepicker._possibleChars(t.datepicker._get(o,"dateFormat")),n=String.fromCharCode(null==i.charCode?i.keyCode:i.charCode),i.ctrlKey||i.metaKey||" ">n||!s||s.indexOf(n)>-1):e},_doKeyUp:function(e){var i,s=t.datepicker._getInst(e.target);if(s.input.val()!==s.lastVal)try{i=t.datepicker.parseDate(t.datepicker._get(s,"dateFormat"),s.input?s.input.val():null,t.datepicker._getFormatConfig(s)),i&&(t.datepicker._setDateFromField(s),t.datepicker._updateAlternate(s),t.datepicker._updateDatepicker(s))}catch(n){}return!0},_showDatepicker:function(e){if(e=e.target||e,"input"!==e.nodeName.toLowerCase()&&(e=t("input",e.parentNode)[0]),!t.datepicker._isDisabledDatepicker(e)&&t.datepicker._lastInput!==e){var i,s,o,a,r,h,l;i=t.datepicker._getInst(e),t.datepicker._curInst&&t.datepicker._curInst!==i&&(t.datepicker._curInst.dpDiv.stop(!0,!0),i&&t.datepicker._datepickerShowing&&t.datepicker._hideDatepicker(t.datepicker._curInst.input[0])),s=t.datepicker._get(i,"beforeShow"),o=s?s.apply(e,[e,i]):{},o!==!1&&(n(i.settings,o),i.lastVal=null,t.datepicker._lastInput=e,t.datepicker._setDateFromField(i),t.datepicker._inDialog&&(e.value=""),t.datepicker._pos||(t.datepicker._pos=t.datepicker._findPos(e),t.datepicker._pos[1]+=e.offsetHeight),a=!1,t(e).parents().each(function(){return a|="fixed"===t(this).css("position"),!a}),r={left:t.datepicker._pos[0],top:t.datepicker._pos[1]},t.datepicker._pos=null,i.dpDiv.empty(),i.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),t.datepicker._updateDatepicker(i),r=t.datepicker._checkOffset(i,r,a),i.dpDiv.css({position:t.datepicker._inDialog&&t.blockUI?"static":a?"fixed":"absolute",display:"none",left:r.left+"px",top:r.top+"px"}),i.inline||(h=t.datepicker._get(i,"showAnim"),l=t.datepicker._get(i,"duration"),i.dpDiv.zIndex(t(e).zIndex()+1),t.datepicker._datepickerShowing=!0,t.effects&&t.effects.effect[h]?i.dpDiv.show(h,t.datepicker._get(i,"showOptions"),l):i.dpDiv[h||"show"](h?l:null),t.datepicker._shouldFocusInput(i)&&i.input.focus(),t.datepicker._curInst=i))}},_updateDatepicker:function(e){this.maxRows=4,o=e,e.dpDiv.empty().append(this._generateHTML(e)),this._attachHandlers(e),e.dpDiv.find("."+this._dayOverClass+" a").mouseover();var i,s=this._getNumberOfMonths(e),n=s[1],a=17;e.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),n>1&&e.dpDiv.addClass("ui-datepicker-multi-"+n).css("width",a*n+"em"),e.dpDiv[(1!==s[0]||1!==s[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),e.dpDiv[(this._get(e,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),e===t.datepicker._curInst&&t.datepicker._datepickerShowing&&t.datepicker._shouldFocusInput(e)&&e.input.focus(),e.yearshtml&&(i=e.yearshtml,setTimeout(function(){i===e.yearshtml&&e.yearshtml&&e.dpDiv.find("select.ui-datepicker-year:first").replaceWith(e.yearshtml),i=e.yearshtml=null},0))},_shouldFocusInput:function(t){return t.input&&t.input.is(":visible")&&!t.input.is(":disabled")&&!t.input.is(":focus")},_checkOffset:function(e,i,s){var n=e.dpDiv.outerWidth(),o=e.dpDiv.outerHeight(),a=e.input?e.input.outerWidth():0,r=e.input?e.input.outerHeight():0,h=document.documentElement.clientWidth+(s?0:t(document).scrollLeft()),l=document.documentElement.clientHeight+(s?0:t(document).scrollTop());return i.left-=this._get(e,"isRTL")?n-a:0,i.left-=s&&i.left===e.input.offset().left?t(document).scrollLeft():0,i.top-=s&&i.top===e.input.offset().top+r?t(document).scrollTop():0,i.left-=Math.min(i.left,i.left+n>h&&h>n?Math.abs(i.left+n-h):0),i.top-=Math.min(i.top,i.top+o>l&&l>o?Math.abs(o+r):0),i},_findPos:function(e){for(var i,s=this._getInst(e),n=this._get(s,"isRTL");e&&("hidden"===e.type||1!==e.nodeType||t.expr.filters.hidden(e));)e=e[n?"previousSibling":"nextSibling"];return i=t(e).offset(),[i.left,i.top]},_hideDatepicker:function(e){var i,s,n,o,r=this._curInst;!r||e&&r!==t.data(e,a)||this._datepickerShowing&&(i=this._get(r,"showAnim"),s=this._get(r,"duration"),n=function(){t.datepicker._tidyDialog(r)},t.effects&&(t.effects.effect[i]||t.effects[i])?r.dpDiv.hide(i,t.datepicker._get(r,"showOptions"),s,n):r.dpDiv["slideDown"===i?"slideUp":"fadeIn"===i?"fadeOut":"hide"](i?s:null,n),i||n(),this._datepickerShowing=!1,o=this._get(r,"onClose"),o&&o.apply(r.input?r.input[0]:null,[r.input?r.input.val():"",r]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),t.blockUI&&(t.unblockUI(),t("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(t){t.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")},_checkExternalClick:function(e){if(t.datepicker._curInst){var i=t(e.target),s=t.datepicker._getInst(i[0]);(i[0].id!==t.datepicker._mainDivId&&0===i.parents("#"+t.datepicker._mainDivId).length&&!i.hasClass(t.datepicker.markerClassName)&&!i.closest("."+t.datepicker._triggerClass).length&&t.datepicker._datepickerShowing&&(!t.datepicker._inDialog||!t.blockUI)||i.hasClass(t.datepicker.markerClassName)&&t.datepicker._curInst!==s)&&t.datepicker._hideDatepicker()}},_adjustDate:function(e,i,s){var n=t(e),o=this._getInst(n[0]);this._isDisabledDatepicker(n[0])||(this._adjustInstDate(o,i+("M"===s?this._get(o,"showCurrentAtPos"):0),s),this._updateDatepicker(o))},_gotoToday:function(e){var i,s=t(e),n=this._getInst(s[0]);this._get(n,"gotoCurrent")&&n.currentDay?(n.selectedDay=n.currentDay,n.drawMonth=n.selectedMonth=n.currentMonth,n.drawYear=n.selectedYear=n.currentYear):(i=new Date,n.selectedDay=i.getDate(),n.drawMonth=n.selectedMonth=i.getMonth(),n.drawYear=n.selectedYear=i.getFullYear()),this._notifyChange(n),this._adjustDate(s)},_selectMonthYear:function(e,i,s){var n=t(e),o=this._getInst(n[0]);o["selected"+("M"===s?"Month":"Year")]=o["draw"+("M"===s?"Month":"Year")]=parseInt(i.options[i.selectedIndex].value,10),this._notifyChange(o),this._adjustDate(n)},_selectDay:function(e,i,s,n){var o,a=t(e);t(n).hasClass(this._unselectableClass)||this._isDisabledDatepicker(a[0])||(o=this._getInst(a[0]),o.selectedDay=o.currentDay=t("a",n).html(),o.selectedMonth=o.currentMonth=i,o.selectedYear=o.currentYear=s,this._selectDate(e,this._formatDate(o,o.currentDay,o.currentMonth,o.currentYear)))},_clearDate:function(e){var i=t(e);this._selectDate(i,"")},_selectDate:function(e,i){var s,n=t(e),o=this._getInst(n[0]);i=null!=i?i:this._formatDate(o),o.input&&o.input.val(i),this._updateAlternate(o),s=this._get(o,"onSelect"),s?s.apply(o.input?o.input[0]:null,[i,o]):o.input&&o.input.trigger("change"),o.inline?this._updateDatepicker(o):(this._hideDatepicker(),this._lastInput=o.input[0],"object"!=typeof o.input[0]&&o.input.focus(),this._lastInput=null)},_updateAlternate:function(e){var i,s,n,o=this._get(e,"altField");o&&(i=this._get(e,"altFormat")||this._get(e,"dateFormat"),s=this._getDate(e),n=this.formatDate(i,s,this._getFormatConfig(e)),t(o).each(function(){t(this).val(n)}))},noWeekends:function(t){var e=t.getDay();return[e>0&&6>e,""]},iso8601Week:function(t){var e,i=new Date(t.getTime());return i.setDate(i.getDate()+4-(i.getDay()||7)),e=i.getTime(),i.setMonth(0),i.setDate(1),Math.floor(Math.round((e-i)/864e5)/7)+1},parseDate:function(i,s,n){if(null==i||null==s)throw"Invalid arguments";if(s="object"==typeof s?""+s:s+"",""===s)return null;var o,a,r,h,l=0,c=(n?n.shortYearCutoff:null)||this._defaults.shortYearCutoff,u="string"!=typeof c?c:(new Date).getFullYear()%100+parseInt(c,10),d=(n?n.dayNamesShort:null)||this._defaults.dayNamesShort,p=(n?n.dayNames:null)||this._defaults.dayNames,f=(n?n.monthNamesShort:null)||this._defaults.monthNamesShort,g=(n?n.monthNames:null)||this._defaults.monthNames,m=-1,v=-1,_=-1,b=-1,y=!1,w=function(t){var e=i.length>o+1&&i.charAt(o+1)===t;return e&&o++,e},k=function(t){var e=w(t),i="@"===t?14:"!"===t?20:"y"===t&&e?4:"o"===t?3:2,n=RegExp("^\\d{1,"+i+"}"),o=s.substring(l).match(n);if(!o)throw"Missing number at position "+l;return l+=o[0].length,parseInt(o[0],10)},x=function(i,n,o){var a=-1,r=t.map(w(i)?o:n,function(t,e){return[[e,t]]}).sort(function(t,e){return-(t[1].length-e[1].length)});if(t.each(r,function(t,i){var n=i[1];return s.substr(l,n.length).toLowerCase()===n.toLowerCase()?(a=i[0],l+=n.length,!1):e}),-1!==a)return a+1;throw"Unknown name at position "+l},D=function(){if(s.charAt(l)!==i.charAt(o))throw"Unexpected literal at position "+l;l++};for(o=0;i.length>o;o++)if(y)"'"!==i.charAt(o)||w("'")?D():y=!1;else switch(i.charAt(o)){case"d":_=k("d");break;case"D":x("D",d,p);break;case"o":b=k("o");break;case"m":v=k("m");break;case"M":v=x("M",f,g);break;case"y":m=k("y");break;case"@":h=new Date(k("@")),m=h.getFullYear(),v=h.getMonth()+1,_=h.getDate();break;case"!":h=new Date((k("!")-this._ticksTo1970)/1e4),m=h.getFullYear(),v=h.getMonth()+1,_=h.getDate();break;case"'":w("'")?D():y=!0;break;default:D()}if(s.length>l&&(r=s.substr(l),!/^\s+/.test(r)))throw"Extra/unparsed characters found in date: "+r;if(-1===m?m=(new Date).getFullYear():100>m&&(m+=(new Date).getFullYear()-(new Date).getFullYear()%100+(u>=m?0:-100)),b>-1)for(v=1,_=b;;){if(a=this._getDaysInMonth(m,v-1),a>=_)break;v++,_-=a}if(h=this._daylightSavingAdjust(new Date(m,v-1,_)),h.getFullYear()!==m||h.getMonth()+1!==v||h.getDate()!==_)throw"Invalid date";return h},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:1e7*60*60*24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925)),formatDate:function(t,e,i){if(!e)return"";var s,n=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,o=(i?i.dayNames:null)||this._defaults.dayNames,a=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,r=(i?i.monthNames:null)||this._defaults.monthNames,h=function(e){var i=t.length>s+1&&t.charAt(s+1)===e;return i&&s++,i},l=function(t,e,i){var s=""+e;if(h(t))for(;i>s.length;)s="0"+s;return s},c=function(t,e,i,s){return h(t)?s[e]:i[e]},u="",d=!1;if(e)for(s=0;t.length>s;s++)if(d)"'"!==t.charAt(s)||h("'")?u+=t.charAt(s):d=!1;else switch(t.charAt(s)){case"d":u+=l("d",e.getDate(),2);break;case"D":u+=c("D",e.getDay(),n,o);break;case"o":u+=l("o",Math.round((new Date(e.getFullYear(),e.getMonth(),e.getDate()).getTime()-new Date(e.getFullYear(),0,0).getTime())/864e5),3);break;case"m":u+=l("m",e.getMonth()+1,2);break;case"M":u+=c("M",e.getMonth(),a,r);break;case"y":u+=h("y")?e.getFullYear():(10>e.getYear()%100?"0":"")+e.getYear()%100;break;case"@":u+=e.getTime();break;case"!":u+=1e4*e.getTime()+this._ticksTo1970;break;case"'":h("'")?u+="'":d=!0;break;default:u+=t.charAt(s)}return u},_possibleChars:function(t){var e,i="",s=!1,n=function(i){var s=t.length>e+1&&t.charAt(e+1)===i;return s&&e++,s};for(e=0;t.length>e;e++)if(s)"'"!==t.charAt(e)||n("'")?i+=t.charAt(e):s=!1;else switch(t.charAt(e)){case"d":case"m":case"y":case"@":i+="0123456789";break;case"D":case"M":return null;case"'":n("'")?i+="'":s=!0;break;default:i+=t.charAt(e)}return i},_get:function(t,i){return t.settings[i]!==e?t.settings[i]:this._defaults[i]},_setDateFromField:function(t,e){if(t.input.val()!==t.lastVal){var i=this._get(t,"dateFormat"),s=t.lastVal=t.input?t.input.val():null,n=this._getDefaultDate(t),o=n,a=this._getFormatConfig(t);try{o=this.parseDate(i,s,a)||n}catch(r){s=e?"":s}t.selectedDay=o.getDate(),t.drawMonth=t.selectedMonth=o.getMonth(),t.drawYear=t.selectedYear=o.getFullYear(),t.currentDay=s?o.getDate():0,t.currentMonth=s?o.getMonth():0,t.currentYear=s?o.getFullYear():0,this._adjustInstDate(t)}},_getDefaultDate:function(t){return this._restrictMinMax(t,this._determineDate(t,this._get(t,"defaultDate"),new Date))},_determineDate:function(e,i,s){var n=function(t){var e=new Date;return e.setDate(e.getDate()+t),e},o=function(i){try{return t.datepicker.parseDate(t.datepicker._get(e,"dateFormat"),i,t.datepicker._getFormatConfig(e))}catch(s){}for(var n=(i.toLowerCase().match(/^c/)?t.datepicker._getDate(e):null)||new Date,o=n.getFullYear(),a=n.getMonth(),r=n.getDate(),h=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,l=h.exec(i);l;){switch(l[2]||"d"){case"d":case"D":r+=parseInt(l[1],10);break;case"w":case"W":r+=7*parseInt(l[1],10);break;case"m":case"M":a+=parseInt(l[1],10),r=Math.min(r,t.datepicker._getDaysInMonth(o,a));break;case"y":case"Y":o+=parseInt(l[1],10),r=Math.min(r,t.datepicker._getDaysInMonth(o,a))}l=h.exec(i)}return new Date(o,a,r)},a=null==i||""===i?s:"string"==typeof i?o(i):"number"==typeof i?isNaN(i)?s:n(i):new Date(i.getTime());return a=a&&"Invalid Date"==""+a?s:a,a&&(a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)),this._daylightSavingAdjust(a)},_daylightSavingAdjust:function(t){return t?(t.setHours(t.getHours()>12?t.getHours()+2:0),t):null},_setDate:function(t,e,i){var s=!e,n=t.selectedMonth,o=t.selectedYear,a=this._restrictMinMax(t,this._determineDate(t,e,new Date));t.selectedDay=t.currentDay=a.getDate(),t.drawMonth=t.selectedMonth=t.currentMonth=a.getMonth(),t.drawYear=t.selectedYear=t.currentYear=a.getFullYear(),n===t.selectedMonth&&o===t.selectedYear||i||this._notifyChange(t),this._adjustInstDate(t),t.input&&t.input.val(s?"":this._formatDate(t))},_getDate:function(t){var e=!t.currentYear||t.input&&""===t.input.val()?null:this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return e},_attachHandlers:function(e){var i=this._get(e,"stepMonths"),s="#"+e.id.replace(/\\\\/g,"\\");e.dpDiv.find("[data-handler]").map(function(){var e={prev:function(){t.datepicker._adjustDate(s,-i,"M")},next:function(){t.datepicker._adjustDate(s,+i,"M")},hide:function(){t.datepicker._hideDatepicker()},today:function(){t.datepicker._gotoToday(s)},selectDay:function(){return t.datepicker._selectDay(s,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return t.datepicker._selectMonthYear(s,this,"M"),!1},selectYear:function(){return t.datepicker._selectMonthYear(s,this,"Y"),!1}};t(this).bind(this.getAttribute("data-event"),e[this.getAttribute("data-handler")])})},_generateHTML:function(t){var e,i,s,n,o,a,r,h,l,c,u,d,p,f,g,m,v,_,b,y,w,k,x,D,C,I,P,T,M,S,z,A,H,E,N,W,O,F,R,L=new Date,j=this._daylightSavingAdjust(new Date(L.getFullYear(),L.getMonth(),L.getDate())),Y=this._get(t,"isRTL"),B=this._get(t,"showButtonPanel"),V=this._get(t,"hideIfNoPrevNext"),K=this._get(t,"navigationAsDateFormat"),U=this._getNumberOfMonths(t),q=this._get(t,"showCurrentAtPos"),Q=this._get(t,"stepMonths"),X=1!==U[0]||1!==U[1],$=this._daylightSavingAdjust(t.currentDay?new Date(t.currentYear,t.currentMonth,t.currentDay):new Date(9999,9,9)),G=this._getMinMaxDate(t,"min"),J=this._getMinMaxDate(t,"max"),Z=t.drawMonth-q,te=t.drawYear;if(0>Z&&(Z+=12,te--),J)for(e=this._daylightSavingAdjust(new Date(J.getFullYear(),J.getMonth()-U[0]*U[1]+1,J.getDate())),e=G&&G>e?G:e;this._daylightSavingAdjust(new Date(te,Z,1))>e;)Z--,0>Z&&(Z=11,te--);for(t.drawMonth=Z,t.drawYear=te,i=this._get(t,"prevText"),i=K?this.formatDate(i,this._daylightSavingAdjust(new Date(te,Z-Q,1)),this._getFormatConfig(t)):i,s=this._canAdjustMonth(t,-1,te,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(Y?"e":"w")+"'>"+i+"</span></a>":V?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(Y?"e":"w")+"'>"+i+"</span></a>",n=this._get(t,"nextText"),n=K?this.formatDate(n,this._daylightSavingAdjust(new Date(te,Z+Q,1)),this._getFormatConfig(t)):n,o=this._canAdjustMonth(t,1,te,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(Y?"w":"e")+"'>"+n+"</span></a>":V?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(Y?"w":"e")+"'>"+n+"</span></a>",a=this._get(t,"currentText"),r=this._get(t,"gotoCurrent")&&t.currentDay?$:j,a=K?this.formatDate(a,r,this._getFormatConfig(t)):a,h=t.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(t,"closeText")+"</button>",l=B?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(Y?h:"")+(this._isInRange(t,r)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+a+"</button>":"")+(Y?"":h)+"</div>":"",c=parseInt(this._get(t,"firstDay"),10),c=isNaN(c)?0:c,u=this._get(t,"showWeek"),d=this._get(t,"dayNames"),p=this._get(t,"dayNamesMin"),f=this._get(t,"monthNames"),g=this._get(t,"monthNamesShort"),m=this._get(t,"beforeShowDay"),v=this._get(t,"showOtherMonths"),_=this._get(t,"selectOtherMonths"),b=this._getDefaultDate(t),y="",k=0;U[0]>k;k++){for(x="",this.maxRows=4,D=0;U[1]>D;D++){if(C=this._daylightSavingAdjust(new Date(te,Z,t.selectedDay)),I=" ui-corner-all",P="",X){if(P+="<div class='ui-datepicker-group",U[1]>1)switch(D){case 0:P+=" ui-datepicker-group-first",I=" ui-corner-"+(Y?"right":"left");break;case U[1]-1:P+=" ui-datepicker-group-last",I=" ui-corner-"+(Y?"left":"right");break;default:P+=" ui-datepicker-group-middle",I=""}P+="'>"}for(P+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+I+"'>"+(/all|left/.test(I)&&0===k?Y?o:s:"")+(/all|right/.test(I)&&0===k?Y?s:o:"")+this._generateMonthYearHeader(t,Z,te,G,J,k>0||D>0,f,g)+"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>",T=u?"<th class='ui-datepicker-week-col'>"+this._get(t,"weekHeader")+"</th>":"",w=0;7>w;w++)M=(w+c)%7,T+="<th"+((w+c+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+d[M]+"'>"+p[M]+"</span></th>";for(P+=T+"</tr></thead><tbody>",S=this._getDaysInMonth(te,Z),te===t.selectedYear&&Z===t.selectedMonth&&(t.selectedDay=Math.min(t.selectedDay,S)),z=(this._getFirstDayOfMonth(te,Z)-c+7)%7,A=Math.ceil((z+S)/7),H=X?this.maxRows>A?this.maxRows:A:A,this.maxRows=H,E=this._daylightSavingAdjust(new Date(te,Z,1-z)),N=0;H>N;N++){for(P+="<tr>",W=u?"<td class='ui-datepicker-week-col'>"+this._get(t,"calculateWeek")(E)+"</td>":"",w=0;7>w;w++)O=m?m.apply(t.input?t.input[0]:null,[E]):[!0,""],F=E.getMonth()!==Z,R=F&&!_||!O[0]||G&&G>E||J&&E>J,W+="<td class='"+((w+c+6)%7>=5?" ui-datepicker-week-end":"")+(F?" ui-datepicker-other-month":"")+(E.getTime()===C.getTime()&&Z===t.selectedMonth&&t._keyEvent||b.getTime()===E.getTime()&&b.getTime()===C.getTime()?" "+this._dayOverClass:"")+(R?" "+this._unselectableClass+" ui-state-disabled":"")+(F&&!v?"":" "+O[1]+(E.getTime()===$.getTime()?" "+this._currentClass:"")+(E.getTime()===j.getTime()?" ui-datepicker-today":""))+"'"+(F&&!v||!O[2]?"":" title='"+O[2].replace(/'/g,"&#39;")+"'")+(R?"":" data-handler='selectDay' data-event='click' data-month='"+E.getMonth()+"' data-year='"+E.getFullYear()+"'")+">"+(F&&!v?"&#xa0;":R?"<span class='ui-state-default'>"+E.getDate()+"</span>":"<a class='ui-state-default"+(E.getTime()===j.getTime()?" ui-state-highlight":"")+(E.getTime()===$.getTime()?" ui-state-active":"")+(F?" ui-priority-secondary":"")+"' href='#'>"+E.getDate()+"</a>")+"</td>",E.setDate(E.getDate()+1),E=this._daylightSavingAdjust(E);P+=W+"</tr>"}Z++,Z>11&&(Z=0,te++),P+="</tbody></table>"+(X?"</div>"+(U[0]>0&&D===U[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),x+=P}y+=x}return y+=l,t._keyEvent=!1,y},_generateMonthYearHeader:function(t,e,i,s,n,o,a,r){var h,l,c,u,d,p,f,g,m=this._get(t,"changeMonth"),v=this._get(t,"changeYear"),_=this._get(t,"showMonthAfterYear"),b="<div class='ui-datepicker-title'>",y="";if(o||!m)y+="<span class='ui-datepicker-month'>"+a[e]+"</span>";else{for(h=s&&s.getFullYear()===i,l=n&&n.getFullYear()===i,y+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",c=0;12>c;c++)(!h||c>=s.getMonth())&&(!l||n.getMonth()>=c)&&(y+="<option value='"+c+"'"+(c===e?" selected='selected'":"")+">"+r[c]+"</option>");y+="</select>"}if(_||(b+=y+(!o&&m&&v?"":"&#xa0;")),!t.yearshtml)if(t.yearshtml="",o||!v)b+="<span class='ui-datepicker-year'>"+i+"</span>";else{for(u=this._get(t,"yearRange").split(":"),d=(new Date).getFullYear(),p=function(t){var e=t.match(/c[+\-].*/)?i+parseInt(t.substring(1),10):t.match(/[+\-].*/)?d+parseInt(t,10):parseInt(t,10);return isNaN(e)?d:e},f=p(u[0]),g=Math.max(f,p(u[1]||"")),f=s?Math.max(f,s.getFullYear()):f,g=n?Math.min(g,n.getFullYear()):g,t.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";g>=f;f++)t.yearshtml+="<option value='"+f+"'"+(f===i?" selected='selected'":"")+">"+f+"</option>";t.yearshtml+="</select>",b+=t.yearshtml,t.yearshtml=null}return b+=this._get(t,"yearSuffix"),_&&(b+=(!o&&m&&v?"":"&#xa0;")+y),b+="</div>"},_adjustInstDate:function(t,e,i){var s=t.drawYear+("Y"===i?e:0),n=t.drawMonth+("M"===i?e:0),o=Math.min(t.selectedDay,this._getDaysInMonth(s,n))+("D"===i?e:0),a=this._restrictMinMax(t,this._daylightSavingAdjust(new Date(s,n,o)));t.selectedDay=a.getDate(),t.drawMonth=t.selectedMonth=a.getMonth(),t.drawYear=t.selectedYear=a.getFullYear(),("M"===i||"Y"===i)&&this._notifyChange(t)},_restrictMinMax:function(t,e){var i=this._getMinMaxDate(t,"min"),s=this._getMinMaxDate(t,"max"),n=i&&i>e?i:e;return s&&n>s?s:n},_notifyChange:function(t){var e=this._get(t,"onChangeMonthYear");e&&e.apply(t.input?t.input[0]:null,[t.selectedYear,t.selectedMonth+1,t])},_getNumberOfMonths:function(t){var e=this._get(t,"numberOfMonths");return null==e?[1,1]:"number"==typeof e?[1,e]:e},_getMinMaxDate:function(t,e){return this._determineDate(t,this._get(t,e+"Date"),null)},_getDaysInMonth:function(t,e){return 32-this._daylightSavingAdjust(new Date(t,e,32)).getDate()},_getFirstDayOfMonth:function(t,e){return new Date(t,e,1).getDay()},_canAdjustMonth:function(t,e,i,s){var n=this._getNumberOfMonths(t),o=this._daylightSavingAdjust(new Date(i,s+(0>e?e:n[0]*n[1]),1));return 0>e&&o.setDate(this._getDaysInMonth(o.getFullYear(),o.getMonth())),this._isInRange(t,o)},_isInRange:function(t,e){var i,s,n=this._getMinMaxDate(t,"min"),o=this._getMinMaxDate(t,"max"),a=null,r=null,h=this._get(t,"yearRange");return h&&(i=h.split(":"),s=(new Date).getFullYear(),a=parseInt(i[0],10),r=parseInt(i[1],10),i[0].match(/[+\-].*/)&&(a+=s),i[1].match(/[+\-].*/)&&(r+=s)),(!n||e.getTime()>=n.getTime())&&(!o||e.getTime()<=o.getTime())&&(!a||e.getFullYear()>=a)&&(!r||r>=e.getFullYear())},_getFormatConfig:function(t){var e=this._get(t,"shortYearCutoff");return e="string"!=typeof e?e:(new Date).getFullYear()%100+parseInt(e,10),{shortYearCutoff:e,dayNamesShort:this._get(t,"dayNamesShort"),dayNames:this._get(t,"dayNames"),monthNamesShort:this._get(t,"monthNamesShort"),monthNames:this._get(t,"monthNames")}},_formatDate:function(t,e,i,s){e||(t.currentDay=t.selectedDay,t.currentMonth=t.selectedMonth,t.currentYear=t.selectedYear);var n=e?"object"==typeof e?e:this._daylightSavingAdjust(new Date(s,i,e)):this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return this.formatDate(this._get(t,"dateFormat"),n,this._getFormatConfig(t))}}),t.fn.datepicker=function(e){if(!this.length)return this;t.datepicker.initialized||(t(document).mousedown(t.datepicker._checkExternalClick),t.datepicker.initialized=!0),0===t("#"+t.datepicker._mainDivId).length&&t("body").append(t.datepicker.dpDiv);var i=Array.prototype.slice.call(arguments,1);return"string"!=typeof e||"isDisabled"!==e&&"getDate"!==e&&"widget"!==e?"option"===e&&2===arguments.length&&"string"==typeof arguments[1]?t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this[0]].concat(i)):this.each(function(){"string"==typeof e?t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this].concat(i)):t.datepicker._attachDatepicker(this,e)}):t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this[0]].concat(i))},t.datepicker=new i,t.datepicker.initialized=!1,t.datepicker.uuid=(new Date).getTime(),t.datepicker.version="1.10.3"}(jQuery),function(t){var e={buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},i={maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0};t.widget("ui.dialog",{version:"1.10.3",options:{appendTo:"body",autoOpen:!0,buttons:[],closeOnEscape:!0,closeText:"close",dialogClass:"",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(e){var i=t(this).css(e).offset().top;0>i&&t(this).css("top",e.top-i)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),this.options.title=this.options.title||this.originalTitle,this._createWrapper(),this.element.show().removeAttr("title").addClass("ui-dialog-content ui-widget-content").appendTo(this.uiDialog),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&t.fn.draggable&&this._makeDraggable(),this.options.resizable&&t.fn.resizable&&this._makeResizable(),this._isOpen=!1},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var e=this.options.appendTo;return e&&(e.jquery||e.nodeType)?t(e):this.document.find(e||"body").eq(0)},_destroy:function(){var t,e=this.originalPosition;this._destroyOverlay(),this.element.removeUniqueId().removeClass("ui-dialog-content ui-widget-content").css(this.originalCss).detach(),this.uiDialog.stop(!0,!0).remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),t=e.parent.children().eq(e.index),t.length&&t[0]!==this.element[0]?t.before(this.element):e.parent.append(this.element)},widget:function(){return this.uiDialog},disable:t.noop,enable:t.noop,close:function(e){var i=this;this._isOpen&&this._trigger("beforeClose",e)!==!1&&(this._isOpen=!1,this._destroyOverlay(),this.opener.filter(":focusable").focus().length||t(this.document[0].activeElement).blur(),this._hide(this.uiDialog,this.options.hide,function(){i._trigger("close",e)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(t,e){var i=!!this.uiDialog.nextAll(":visible").insertBefore(this.uiDialog).length;return i&&!e&&this._trigger("focus",t),i},open:function(){var e=this;return this._isOpen?(this._moveToTop()&&this._focusTabbable(),undefined):(this._isOpen=!0,this.opener=t(this.document[0].activeElement),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this._show(this.uiDialog,this.options.show,function(){e._focusTabbable(),e._trigger("focus")}),this._trigger("open"),undefined)},_focusTabbable:function(){var t=this.element.find("[autofocus]");t.length||(t=this.element.find(":tabbable")),t.length||(t=this.uiDialogButtonPane.find(":tabbable")),t.length||(t=this.uiDialogTitlebarClose.filter(":tabbable")),t.length||(t=this.uiDialog),t.eq(0).focus()},_keepFocus:function(e){function i(){var e=this.document[0].activeElement,i=this.uiDialog[0]===e||t.contains(this.uiDialog[0],e);i||this._focusTabbable()}e.preventDefault(),i.call(this),this._delay(i)},_createWrapper:function(){this.uiDialog=t("<div>").addClass("ui-dialog ui-widget ui-widget-content ui-corner-all ui-front "+this.options.dialogClass).hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._on(this.uiDialog,{keydown:function(e){if(this.options.closeOnEscape&&!e.isDefaultPrevented()&&e.keyCode&&e.keyCode===t.ui.keyCode.ESCAPE)return e.preventDefault(),this.close(e),undefined;if(e.keyCode===t.ui.keyCode.TAB){var i=this.uiDialog.find(":tabbable"),s=i.filter(":first"),n=i.filter(":last");e.target!==n[0]&&e.target!==this.uiDialog[0]||e.shiftKey?e.target!==s[0]&&e.target!==this.uiDialog[0]||!e.shiftKey||(n.focus(1),e.preventDefault()):(s.focus(1),e.preventDefault())}},mousedown:function(t){this._moveToTop(t)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var e;this.uiDialogTitlebar=t("<div>").addClass("ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix").prependTo(this.uiDialog),this._on(this.uiDialogTitlebar,{mousedown:function(e){t(e.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.focus()}}),this.uiDialogTitlebarClose=t("<button></button>").button({label:this.options.closeText,icons:{primary:"ui-icon-closethick"},text:!1}).addClass("ui-dialog-titlebar-close").appendTo(this.uiDialogTitlebar),this._on(this.uiDialogTitlebarClose,{click:function(t){t.preventDefault(),this.close(t)}}),e=t("<span>").uniqueId().addClass("ui-dialog-title").prependTo(this.uiDialogTitlebar),this._title(e),this.uiDialog.attr({"aria-labelledby":e.attr("id")})},_title:function(t){this.options.title||t.html("&#160;"),t.text(this.options.title)},_createButtonPane:function(){this.uiDialogButtonPane=t("<div>").addClass("ui-dialog-buttonpane ui-widget-content ui-helper-clearfix"),this.uiButtonSet=t("<div>").addClass("ui-dialog-buttonset").appendTo(this.uiDialogButtonPane),this._createButtons()},_createButtons:function(){var e=this,i=this.options.buttons;return this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),t.isEmptyObject(i)||t.isArray(i)&&!i.length?(this.uiDialog.removeClass("ui-dialog-buttons"),undefined):(t.each(i,function(i,s){var n,o;s=t.isFunction(s)?{click:s,text:i}:s,s=t.extend({type:"button"},s),n=s.click,s.click=function(){n.apply(e.element[0],arguments)},o={icons:s.icons,text:s.showText},delete s.icons,delete s.showText,t("<button></button>",s).button(o).appendTo(e.uiButtonSet)}),this.uiDialog.addClass("ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog),undefined)},_makeDraggable:function(){function e(t){return{position:t.position,offset:t.offset}}var i=this,s=this.options;this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(s,n){t(this).addClass("ui-dialog-dragging"),i._blockFrames(),i._trigger("dragStart",s,e(n))},drag:function(t,s){i._trigger("drag",t,e(s))},stop:function(n,o){s.position=[o.position.left-i.document.scrollLeft(),o.position.top-i.document.scrollTop()],t(this).removeClass("ui-dialog-dragging"),i._unblockFrames(),i._trigger("dragStop",n,e(o))}})},_makeResizable:function(){function e(t){return{originalPosition:t.originalPosition,originalSize:t.originalSize,position:t.position,size:t.size}
}var i=this,s=this.options,n=s.resizable,o=this.uiDialog.css("position"),a="string"==typeof n?n:"n,e,s,w,se,sw,ne,nw";this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:s.maxWidth,maxHeight:s.maxHeight,minWidth:s.minWidth,minHeight:this._minHeight(),handles:a,start:function(s,n){t(this).addClass("ui-dialog-resizing"),i._blockFrames(),i._trigger("resizeStart",s,e(n))},resize:function(t,s){i._trigger("resize",t,e(s))},stop:function(n,o){s.height=t(this).height(),s.width=t(this).width(),t(this).removeClass("ui-dialog-resizing"),i._unblockFrames(),i._trigger("resizeStop",n,e(o))}}).css("position",o)},_minHeight:function(){var t=this.options;return"auto"===t.height?t.minHeight:Math.min(t.minHeight,t.height)},_position:function(){var t=this.uiDialog.is(":visible");t||this.uiDialog.show(),this.uiDialog.position(this.options.position),t||this.uiDialog.hide()},_setOptions:function(s){var n=this,o=!1,a={};t.each(s,function(t,s){n._setOption(t,s),t in e&&(o=!0),t in i&&(a[t]=s)}),o&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",a)},_setOption:function(t,e){var i,s,n=this.uiDialog;"dialogClass"===t&&n.removeClass(this.options.dialogClass).addClass(e),"disabled"!==t&&(this._super(t,e),"appendTo"===t&&this.uiDialog.appendTo(this._appendTo()),"buttons"===t&&this._createButtons(),"closeText"===t&&this.uiDialogTitlebarClose.button({label:""+e}),"draggable"===t&&(i=n.is(":data(ui-draggable)"),i&&!e&&n.draggable("destroy"),!i&&e&&this._makeDraggable()),"position"===t&&this._position(),"resizable"===t&&(s=n.is(":data(ui-resizable)"),s&&!e&&n.resizable("destroy"),s&&"string"==typeof e&&n.resizable("option","handles",e),s||e===!1||this._makeResizable()),"title"===t&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))},_size:function(){var t,e,i,s=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),s.minWidth>s.width&&(s.width=s.minWidth),t=this.uiDialog.css({height:"auto",width:s.width}).outerHeight(),e=Math.max(0,s.minHeight-t),i="number"==typeof s.maxHeight?Math.max(0,s.maxHeight-t):"none","auto"===s.height?this.element.css({minHeight:e,maxHeight:i,height:"auto"}):this.element.height(Math.max(0,s.height-t)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var e=t(this);return t("<div>").css({position:"absolute",width:e.outerWidth(),height:e.outerHeight()}).appendTo(e.parent()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(e){return t(e.target).closest(".ui-dialog").length?!0:!!t(e.target).closest(".ui-datepicker").length},_createOverlay:function(){if(this.options.modal){var e=this,i=this.widgetFullName;t.ui.dialog.overlayInstances||this._delay(function(){t.ui.dialog.overlayInstances&&this.document.bind("focusin.dialog",function(s){e._allowInteraction(s)||(s.preventDefault(),t(".ui-dialog:visible:last .ui-dialog-content").data(i)._focusTabbable())})}),this.overlay=t("<div>").addClass("ui-widget-overlay ui-front").appendTo(this._appendTo()),this._on(this.overlay,{mousedown:"_keepFocus"}),t.ui.dialog.overlayInstances++}},_destroyOverlay:function(){this.options.modal&&this.overlay&&(t.ui.dialog.overlayInstances--,t.ui.dialog.overlayInstances||this.document.unbind("focusin.dialog"),this.overlay.remove(),this.overlay=null)}}),t.ui.dialog.overlayInstances=0,t.uiBackCompat!==!1&&t.widget("ui.dialog",t.ui.dialog,{_position:function(){var e,i=this.options.position,s=[],n=[0,0];i?(("string"==typeof i||"object"==typeof i&&"0"in i)&&(s=i.split?i.split(" "):[i[0],i[1]],1===s.length&&(s[1]=s[0]),t.each(["left","top"],function(t,e){+s[t]===s[t]&&(n[t]=s[t],s[t]=e)}),i={my:s[0]+(0>n[0]?n[0]:"+"+n[0])+" "+s[1]+(0>n[1]?n[1]:"+"+n[1]),at:s.join(" ")}),i=t.extend({},t.ui.dialog.prototype.options.position,i)):i=t.ui.dialog.prototype.options.position,e=this.uiDialog.is(":visible"),e||this.uiDialog.show(),this.uiDialog.position(i),e||this.uiDialog.hide()}})}(jQuery),function(t){var e=/up|down|vertical/,i=/up|left|vertical|horizontal/;t.effects.effect.blind=function(s,n){var o,a,r,h=t(this),l=["position","top","bottom","left","right","height","width"],c=t.effects.setMode(h,s.mode||"hide"),u=s.direction||"up",d=e.test(u),p=d?"height":"width",f=d?"top":"left",g=i.test(u),m={},v="show"===c;h.parent().is(".ui-effects-wrapper")?t.effects.save(h.parent(),l):t.effects.save(h,l),h.show(),o=t.effects.createWrapper(h).css({overflow:"hidden"}),a=o[p](),r=parseFloat(o.css(f))||0,m[p]=v?a:0,g||(h.css(d?"bottom":"right",0).css(d?"top":"left","auto").css({position:"absolute"}),m[f]=v?r:a+r),v&&(o.css(p,0),g||o.css(f,r+a)),o.animate(m,{duration:s.duration,easing:s.easing,queue:!1,complete:function(){"hide"===c&&h.hide(),t.effects.restore(h,l),t.effects.removeWrapper(h),n()}})}}(jQuery),function(t){t.effects.effect.bounce=function(e,i){var s,n,o,a=t(this),r=["position","top","bottom","left","right","height","width"],h=t.effects.setMode(a,e.mode||"effect"),l="hide"===h,c="show"===h,u=e.direction||"up",d=e.distance,p=e.times||5,f=2*p+(c||l?1:0),g=e.duration/f,m=e.easing,v="up"===u||"down"===u?"top":"left",_="up"===u||"left"===u,b=a.queue(),y=b.length;for((c||l)&&r.push("opacity"),t.effects.save(a,r),a.show(),t.effects.createWrapper(a),d||(d=a["top"===v?"outerHeight":"outerWidth"]()/3),c&&(o={opacity:1},o[v]=0,a.css("opacity",0).css(v,_?2*-d:2*d).animate(o,g,m)),l&&(d/=Math.pow(2,p-1)),o={},o[v]=0,s=0;p>s;s++)n={},n[v]=(_?"-=":"+=")+d,a.animate(n,g,m).animate(o,g,m),d=l?2*d:d/2;l&&(n={opacity:0},n[v]=(_?"-=":"+=")+d,a.animate(n,g,m)),a.queue(function(){l&&a.hide(),t.effects.restore(a,r),t.effects.removeWrapper(a),i()}),y>1&&b.splice.apply(b,[1,0].concat(b.splice(y,f+1))),a.dequeue()}}(jQuery),function(t){t.effects.effect.clip=function(e,i){var s,n,o,a=t(this),r=["position","top","bottom","left","right","height","width"],h=t.effects.setMode(a,e.mode||"hide"),l="show"===h,c=e.direction||"vertical",u="vertical"===c,d=u?"height":"width",p=u?"top":"left",f={};t.effects.save(a,r),a.show(),s=t.effects.createWrapper(a).css({overflow:"hidden"}),n="IMG"===a[0].tagName?s:a,o=n[d](),l&&(n.css(d,0),n.css(p,o/2)),f[d]=l?o:0,f[p]=l?0:o/2,n.animate(f,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){l||a.hide(),t.effects.restore(a,r),t.effects.removeWrapper(a),i()}})}}(jQuery),function(t){t.effects.effect.drop=function(e,i){var s,n=t(this),o=["position","top","bottom","left","right","opacity","height","width"],a=t.effects.setMode(n,e.mode||"hide"),r="show"===a,h=e.direction||"left",l="up"===h||"down"===h?"top":"left",c="up"===h||"left"===h?"pos":"neg",u={opacity:r?1:0};t.effects.save(n,o),n.show(),t.effects.createWrapper(n),s=e.distance||n["top"===l?"outerHeight":"outerWidth"](!0)/2,r&&n.css("opacity",0).css(l,"pos"===c?-s:s),u[l]=(r?"pos"===c?"+=":"-=":"pos"===c?"-=":"+=")+s,n.animate(u,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===a&&n.hide(),t.effects.restore(n,o),t.effects.removeWrapper(n),i()}})}}(jQuery),function(t){t.effects.effect.explode=function(e,i){function s(){b.push(this),b.length===u*d&&n()}function n(){p.css({visibility:"visible"}),t(b).remove(),g||p.hide(),i()}var o,a,r,h,l,c,u=e.pieces?Math.round(Math.sqrt(e.pieces)):3,d=u,p=t(this),f=t.effects.setMode(p,e.mode||"hide"),g="show"===f,m=p.show().css("visibility","hidden").offset(),v=Math.ceil(p.outerWidth()/d),_=Math.ceil(p.outerHeight()/u),b=[];for(o=0;u>o;o++)for(h=m.top+o*_,c=o-(u-1)/2,a=0;d>a;a++)r=m.left+a*v,l=a-(d-1)/2,p.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-a*v,top:-o*_}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:v,height:_,left:r+(g?l*v:0),top:h+(g?c*_:0),opacity:g?0:1}).animate({left:r+(g?0:l*v),top:h+(g?0:c*_),opacity:g?1:0},e.duration||500,e.easing,s)}}(jQuery),function(t){t.effects.effect.fade=function(e,i){var s=t(this),n=t.effects.setMode(s,e.mode||"toggle");s.animate({opacity:n},{queue:!1,duration:e.duration,easing:e.easing,complete:i})}}(jQuery),function(t){t.effects.effect.fold=function(e,i){var s,n,o=t(this),a=["position","top","bottom","left","right","height","width"],r=t.effects.setMode(o,e.mode||"hide"),h="show"===r,l="hide"===r,c=e.size||15,u=/([0-9]+)%/.exec(c),d=!!e.horizFirst,p=h!==d,f=p?["width","height"]:["height","width"],g=e.duration/2,m={},v={};t.effects.save(o,a),o.show(),s=t.effects.createWrapper(o).css({overflow:"hidden"}),n=p?[s.width(),s.height()]:[s.height(),s.width()],u&&(c=parseInt(u[1],10)/100*n[l?0:1]),h&&s.css(d?{height:0,width:c}:{height:c,width:0}),m[f[0]]=h?n[0]:c,v[f[1]]=h?n[1]:0,s.animate(m,g,e.easing).animate(v,g,e.easing,function(){l&&o.hide(),t.effects.restore(o,a),t.effects.removeWrapper(o),i()})}}(jQuery),function(t){t.effects.effect.highlight=function(e,i){var s=t(this),n=["backgroundImage","backgroundColor","opacity"],o=t.effects.setMode(s,e.mode||"show"),a={backgroundColor:s.css("backgroundColor")};"hide"===o&&(a.opacity=0),t.effects.save(s,n),s.show().css({backgroundImage:"none",backgroundColor:e.color||"#ffff99"}).animate(a,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===o&&s.hide(),t.effects.restore(s,n),i()}})}}(jQuery),function(t){t.effects.effect.pulsate=function(e,i){var s,n=t(this),o=t.effects.setMode(n,e.mode||"show"),a="show"===o,r="hide"===o,h=a||"hide"===o,l=2*(e.times||5)+(h?1:0),c=e.duration/l,u=0,d=n.queue(),p=d.length;for((a||!n.is(":visible"))&&(n.css("opacity",0).show(),u=1),s=1;l>s;s++)n.animate({opacity:u},c,e.easing),u=1-u;n.animate({opacity:u},c,e.easing),n.queue(function(){r&&n.hide(),i()}),p>1&&d.splice.apply(d,[1,0].concat(d.splice(p,l+1))),n.dequeue()}}(jQuery),function(t){t.effects.effect.puff=function(e,i){var s=t(this),n=t.effects.setMode(s,e.mode||"hide"),o="hide"===n,a=parseInt(e.percent,10)||150,r=a/100,h={height:s.height(),width:s.width(),outerHeight:s.outerHeight(),outerWidth:s.outerWidth()};t.extend(e,{effect:"scale",queue:!1,fade:!0,mode:n,complete:i,percent:o?a:100,from:o?h:{height:h.height*r,width:h.width*r,outerHeight:h.outerHeight*r,outerWidth:h.outerWidth*r}}),s.effect(e)},t.effects.effect.scale=function(e,i){var s=t(this),n=t.extend(!0,{},e),o=t.effects.setMode(s,e.mode||"effect"),a=parseInt(e.percent,10)||(0===parseInt(e.percent,10)?0:"hide"===o?0:100),r=e.direction||"both",h=e.origin,l={height:s.height(),width:s.width(),outerHeight:s.outerHeight(),outerWidth:s.outerWidth()},c={y:"horizontal"!==r?a/100:1,x:"vertical"!==r?a/100:1};n.effect="size",n.queue=!1,n.complete=i,"effect"!==o&&(n.origin=h||["middle","center"],n.restore=!0),n.from=e.from||("show"===o?{height:0,width:0,outerHeight:0,outerWidth:0}:l),n.to={height:l.height*c.y,width:l.width*c.x,outerHeight:l.outerHeight*c.y,outerWidth:l.outerWidth*c.x},n.fade&&("show"===o&&(n.from.opacity=0,n.to.opacity=1),"hide"===o&&(n.from.opacity=1,n.to.opacity=0)),s.effect(n)},t.effects.effect.size=function(e,i){var s,n,o,a=t(this),r=["position","top","bottom","left","right","width","height","overflow","opacity"],h=["position","top","bottom","left","right","overflow","opacity"],l=["width","height","overflow"],c=["fontSize"],u=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],d=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],p=t.effects.setMode(a,e.mode||"effect"),f=e.restore||"effect"!==p,g=e.scale||"both",m=e.origin||["middle","center"],v=a.css("position"),_=f?r:h,b={height:0,width:0,outerHeight:0,outerWidth:0};"show"===p&&a.show(),s={height:a.height(),width:a.width(),outerHeight:a.outerHeight(),outerWidth:a.outerWidth()},"toggle"===e.mode&&"show"===p?(a.from=e.to||b,a.to=e.from||s):(a.from=e.from||("show"===p?b:s),a.to=e.to||("hide"===p?b:s)),o={from:{y:a.from.height/s.height,x:a.from.width/s.width},to:{y:a.to.height/s.height,x:a.to.width/s.width}},("box"===g||"both"===g)&&(o.from.y!==o.to.y&&(_=_.concat(u),a.from=t.effects.setTransition(a,u,o.from.y,a.from),a.to=t.effects.setTransition(a,u,o.to.y,a.to)),o.from.x!==o.to.x&&(_=_.concat(d),a.from=t.effects.setTransition(a,d,o.from.x,a.from),a.to=t.effects.setTransition(a,d,o.to.x,a.to))),("content"===g||"both"===g)&&o.from.y!==o.to.y&&(_=_.concat(c).concat(l),a.from=t.effects.setTransition(a,c,o.from.y,a.from),a.to=t.effects.setTransition(a,c,o.to.y,a.to)),t.effects.save(a,_),a.show(),t.effects.createWrapper(a),a.css("overflow","hidden").css(a.from),m&&(n=t.effects.getBaseline(m,s),a.from.top=(s.outerHeight-a.outerHeight())*n.y,a.from.left=(s.outerWidth-a.outerWidth())*n.x,a.to.top=(s.outerHeight-a.to.outerHeight)*n.y,a.to.left=(s.outerWidth-a.to.outerWidth)*n.x),a.css(a.from),("content"===g||"both"===g)&&(u=u.concat(["marginTop","marginBottom"]).concat(c),d=d.concat(["marginLeft","marginRight"]),l=r.concat(u).concat(d),a.find("*[width]").each(function(){var i=t(this),s={height:i.height(),width:i.width(),outerHeight:i.outerHeight(),outerWidth:i.outerWidth()};f&&t.effects.save(i,l),i.from={height:s.height*o.from.y,width:s.width*o.from.x,outerHeight:s.outerHeight*o.from.y,outerWidth:s.outerWidth*o.from.x},i.to={height:s.height*o.to.y,width:s.width*o.to.x,outerHeight:s.height*o.to.y,outerWidth:s.width*o.to.x},o.from.y!==o.to.y&&(i.from=t.effects.setTransition(i,u,o.from.y,i.from),i.to=t.effects.setTransition(i,u,o.to.y,i.to)),o.from.x!==o.to.x&&(i.from=t.effects.setTransition(i,d,o.from.x,i.from),i.to=t.effects.setTransition(i,d,o.to.x,i.to)),i.css(i.from),i.animate(i.to,e.duration,e.easing,function(){f&&t.effects.restore(i,l)})})),a.animate(a.to,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){0===a.to.opacity&&a.css("opacity",a.from.opacity),"hide"===p&&a.hide(),t.effects.restore(a,_),f||("static"===v?a.css({position:"relative",top:a.to.top,left:a.to.left}):t.each(["top","left"],function(t,e){a.css(e,function(e,i){var s=parseInt(i,10),n=t?a.to.left:a.to.top;return"auto"===i?n+"px":s+n+"px"})})),t.effects.removeWrapper(a),i()}})}}(jQuery),function(t){t.effects.effect.shake=function(e,i){var s,n=t(this),o=["position","top","bottom","left","right","height","width"],a=t.effects.setMode(n,e.mode||"effect"),r=e.direction||"left",h=e.distance||20,l=e.times||3,c=2*l+1,u=Math.round(e.duration/c),d="up"===r||"down"===r?"top":"left",p="up"===r||"left"===r,f={},g={},m={},v=n.queue(),_=v.length;for(t.effects.save(n,o),n.show(),t.effects.createWrapper(n),f[d]=(p?"-=":"+=")+h,g[d]=(p?"+=":"-=")+2*h,m[d]=(p?"-=":"+=")+2*h,n.animate(f,u,e.easing),s=1;l>s;s++)n.animate(g,u,e.easing).animate(m,u,e.easing);n.animate(g,u,e.easing).animate(f,u/2,e.easing).queue(function(){"hide"===a&&n.hide(),t.effects.restore(n,o),t.effects.removeWrapper(n),i()}),_>1&&v.splice.apply(v,[1,0].concat(v.splice(_,c+1))),n.dequeue()}}(jQuery),function(t){t.effects.effect.slide=function(e,i){var s,n=t(this),o=["position","top","bottom","left","right","width","height"],a=t.effects.setMode(n,e.mode||"show"),r="show"===a,h=e.direction||"left",l="up"===h||"down"===h?"top":"left",c="up"===h||"left"===h,u={};t.effects.save(n,o),n.show(),s=e.distance||n["top"===l?"outerHeight":"outerWidth"](!0),t.effects.createWrapper(n).css({overflow:"hidden"}),r&&n.css(l,c?isNaN(s)?"-"+s:-s:s),u[l]=(r?c?"+=":"-=":c?"-=":"+=")+s,n.animate(u,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===a&&n.hide(),t.effects.restore(n,o),t.effects.removeWrapper(n),i()}})}}(jQuery),function(t){t.effects.effect.transfer=function(e,i){var s=t(this),n=t(e.to),o="fixed"===n.css("position"),a=t("body"),r=o?a.scrollTop():0,h=o?a.scrollLeft():0,l=n.offset(),c={top:l.top-r,left:l.left-h,height:n.innerHeight(),width:n.innerWidth()},u=s.offset(),d=t("<div class='ui-effects-transfer'></div>").appendTo(document.body).addClass(e.className).css({top:u.top-r,left:u.left-h,height:s.innerHeight(),width:s.innerWidth(),position:o?"fixed":"absolute"}).animate(c,e.duration,e.easing,function(){d.remove(),i()})}}(jQuery),function(t){t.widget("ui.menu",{version:"1.10.3",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-carat-1-e"},menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content ui-corner-all").toggleClass("ui-menu-icons",!!this.element.find(".ui-icon").length).attr({role:this.options.role,tabIndex:0}).bind("click"+this.eventNamespace,t.proxy(function(t){this.options.disabled&&t.preventDefault()},this)),this.options.disabled&&this.element.addClass("ui-state-disabled").attr("aria-disabled","true"),this._on({"mousedown .ui-menu-item > a":function(t){t.preventDefault()},"click .ui-state-disabled > a":function(t){t.preventDefault()},"click .ui-menu-item:has(a)":function(e){var i=t(e.target).closest(".ui-menu-item");!this.mouseHandled&&i.not(".ui-state-disabled").length&&(this.mouseHandled=!0,this.select(e),i.has(".ui-menu").length?this.expand(e):this.element.is(":focus")||(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(e){var i=t(e.currentTarget);i.siblings().children(".ui-state-active").removeClass("ui-state-active"),this.focus(e,i)},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(t,e){var i=this.active||this.element.children(".ui-menu-item").eq(0);e||this.focus(t,i)},blur:function(e){this._delay(function(){t.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(e)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(e){t(e.target).closest(".ui-menu").length||this.collapseAll(e),this.mouseHandled=!1}})},_destroy:function(){this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeClass("ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show(),this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").children("a").removeUniqueId().removeClass("ui-corner-all ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function(){var e=t(this);e.data("ui-menu-submenu-carat")&&e.remove()}),this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content")},_keydown:function(e){function i(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}var s,n,o,a,r,h=!0;switch(e.keyCode){case t.ui.keyCode.PAGE_UP:this.previousPage(e);break;case t.ui.keyCode.PAGE_DOWN:this.nextPage(e);break;case t.ui.keyCode.HOME:this._move("first","first",e);break;case t.ui.keyCode.END:this._move("last","last",e);break;case t.ui.keyCode.UP:this.previous(e);break;case t.ui.keyCode.DOWN:this.next(e);break;case t.ui.keyCode.LEFT:this.collapse(e);break;case t.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(e);break;case t.ui.keyCode.ENTER:case t.ui.keyCode.SPACE:this._activate(e);break;case t.ui.keyCode.ESCAPE:this.collapse(e);break;default:h=!1,n=this.previousFilter||"",o=String.fromCharCode(e.keyCode),a=!1,clearTimeout(this.filterTimer),o===n?a=!0:o=n+o,r=RegExp("^"+i(o),"i"),s=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(t(this).children("a").text())}),s=a&&-1!==s.index(this.active.next())?this.active.nextAll(".ui-menu-item"):s,s.length||(o=String.fromCharCode(e.keyCode),r=RegExp("^"+i(o),"i"),s=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(t(this).children("a").text())})),s.length?(this.focus(e,s),s.length>1?(this.previousFilter=o,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter):delete this.previousFilter}h&&e.preventDefault()},_activate:function(t){this.active.is(".ui-state-disabled")||(this.active.children("a[aria-haspopup='true']").length?this.expand(t):this.select(t))},refresh:function(){var e,i=this.options.icons.submenu,s=this.element.find(this.options.menus);s.filter(":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-corner-all").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var e=t(this),s=e.prev("a"),n=t("<span>").addClass("ui-menu-icon ui-icon "+i).data("ui-menu-submenu-carat",!0);s.attr("aria-haspopup","true").prepend(n),e.attr("aria-labelledby",s.attr("id"))}),e=s.add(this.element),e.children(":not(.ui-menu-item):has(a)").addClass("ui-menu-item").attr("role","presentation").children("a").uniqueId().addClass("ui-corner-all").attr({tabIndex:-1,role:this._itemRole()}),e.children(":not(.ui-menu-item)").each(function(){var e=t(this);/[^\-\u2014\u2013\s]/.test(e.text())||e.addClass("ui-widget-content ui-menu-divider")}),e.children(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!t.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(t,e){"icons"===t&&this.element.find(".ui-menu-icon").removeClass(this.options.icons.submenu).addClass(e.submenu),this._super(t,e)},focus:function(t,e){var i,s;this.blur(t,t&&"focus"===t.type),this._scrollIntoView(e),this.active=e.first(),s=this.active.children("a").addClass("ui-state-focus"),this.options.role&&this.element.attr("aria-activedescendant",s.attr("id")),this.active.parent().closest(".ui-menu-item").children("a:first").addClass("ui-state-active"),t&&"keydown"===t.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),i=e.children(".ui-menu"),i.length&&/^mouse/.test(t.type)&&this._startOpening(i),this.activeMenu=e.parent(),this._trigger("focus",t,{item:e})},_scrollIntoView:function(e){var i,s,n,o,a,r;this._hasScroll()&&(i=parseFloat(t.css(this.activeMenu[0],"borderTopWidth"))||0,s=parseFloat(t.css(this.activeMenu[0],"paddingTop"))||0,n=e.offset().top-this.activeMenu.offset().top-i-s,o=this.activeMenu.scrollTop(),a=this.activeMenu.height(),r=e.height(),0>n?this.activeMenu.scrollTop(o+n):n+r>a&&this.activeMenu.scrollTop(o+n-a+r))},blur:function(t,e){e||clearTimeout(this.timer),this.active&&(this.active.children("a").removeClass("ui-state-focus"),this.active=null,this._trigger("blur",t,{item:this.active}))},_startOpening:function(t){clearTimeout(this.timer),"true"===t.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(t)},this.delay))},_open:function(e){var i=t.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(e.parents(".ui-menu")).hide().attr("aria-hidden","true"),e.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(i)},collapseAll:function(e,i){clearTimeout(this.timer),this.timer=this._delay(function(){var s=i?this.element:t(e&&e.target).closest(this.element.find(".ui-menu"));s.length||(s=this.element),this._close(s),this.blur(e),this.activeMenu=s},this.delay)},_close:function(t){t||(t=this.active?this.active.parent():this.element),t.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false").end().find("a.ui-state-active").removeClass("ui-state-active")},collapse:function(t){var e=this.active&&this.active.parent().closest(".ui-menu-item",this.element);e&&e.length&&(this._close(),this.focus(t,e))},expand:function(t){var e=this.active&&this.active.children(".ui-menu ").children(".ui-menu-item").first();e&&e.length&&(this._open(e.parent()),this._delay(function(){this.focus(t,e)}))},next:function(t){this._move("next","first",t)},previous:function(t){this._move("prev","last",t)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(t,e,i){var s;this.active&&(s="first"===t||"last"===t?this.active["first"===t?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[t+"All"](".ui-menu-item").eq(0)),s&&s.length&&this.active||(s=this.activeMenu.children(".ui-menu-item")[e]()),this.focus(i,s)},nextPage:function(e){var i,s,n;return this.active?(this.isLastItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return i=t(this),0>i.offset().top-s-n}),this.focus(e,i)):this.focus(e,this.activeMenu.children(".ui-menu-item")[this.active?"last":"first"]())),undefined):(this.next(e),undefined)},previousPage:function(e){var i,s,n;return this.active?(this.isFirstItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return i=t(this),i.offset().top-s+n>0}),this.focus(e,i)):this.focus(e,this.activeMenu.children(".ui-menu-item").first())),undefined):(this.next(e),undefined)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(e){this.active=this.active||t(e.target).closest(".ui-menu-item");var i={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(e,!0),this._trigger("select",e,i)}})}(jQuery),function(t,e){function i(t,e,i){return[parseFloat(t[0])*(p.test(t[0])?e/100:1),parseFloat(t[1])*(p.test(t[1])?i/100:1)]}function s(e,i){return parseInt(t.css(e,i),10)||0}function n(e){var i=e[0];return 9===i.nodeType?{width:e.width(),height:e.height(),offset:{top:0,left:0}}:t.isWindow(i)?{width:e.width(),height:e.height(),offset:{top:e.scrollTop(),left:e.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:e.outerWidth(),height:e.outerHeight(),offset:e.offset()}}t.ui=t.ui||{};var o,a=Math.max,r=Math.abs,h=Math.round,l=/left|center|right/,c=/top|center|bottom/,u=/[\+\-]\d+(\.[\d]+)?%?/,d=/^\w+/,p=/%$/,f=t.fn.position;t.position={scrollbarWidth:function(){if(o!==e)return o;var i,s,n=t("<div style='display:block;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),a=n.children()[0];return t("body").append(n),i=a.offsetWidth,n.css("overflow","scroll"),s=a.offsetWidth,i===s&&(s=n[0].clientWidth),n.remove(),o=i-s},getScrollInfo:function(e){var i=e.isWindow?"":e.element.css("overflow-x"),s=e.isWindow?"":e.element.css("overflow-y"),n="scroll"===i||"auto"===i&&e.width<e.element[0].scrollWidth,o="scroll"===s||"auto"===s&&e.height<e.element[0].scrollHeight;return{width:o?t.position.scrollbarWidth():0,height:n?t.position.scrollbarWidth():0}},getWithinInfo:function(e){var i=t(e||window),s=t.isWindow(i[0]);return{element:i,isWindow:s,offset:i.offset()||{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:s?i.width():i.outerWidth(),height:s?i.height():i.outerHeight()}}},t.fn.position=function(e){if(!e||!e.of)return f.apply(this,arguments);e=t.extend({},e);var o,p,g,m,v,_,b=t(e.of),y=t.position.getWithinInfo(e.within),w=t.position.getScrollInfo(y),k=(e.collision||"flip").split(" "),x={};return _=n(b),b[0].preventDefault&&(e.at="left top"),p=_.width,g=_.height,m=_.offset,v=t.extend({},m),t.each(["my","at"],function(){var t,i,s=(e[this]||"").split(" ");1===s.length&&(s=l.test(s[0])?s.concat(["center"]):c.test(s[0])?["center"].concat(s):["center","center"]),s[0]=l.test(s[0])?s[0]:"center",s[1]=c.test(s[1])?s[1]:"center",t=u.exec(s[0]),i=u.exec(s[1]),x[this]=[t?t[0]:0,i?i[0]:0],e[this]=[d.exec(s[0])[0],d.exec(s[1])[0]]}),1===k.length&&(k[1]=k[0]),"right"===e.at[0]?v.left+=p:"center"===e.at[0]&&(v.left+=p/2),"bottom"===e.at[1]?v.top+=g:"center"===e.at[1]&&(v.top+=g/2),o=i(x.at,p,g),v.left+=o[0],v.top+=o[1],this.each(function(){var n,l,c=t(this),u=c.outerWidth(),d=c.outerHeight(),f=s(this,"marginLeft"),_=s(this,"marginTop"),D=u+f+s(this,"marginRight")+w.width,C=d+_+s(this,"marginBottom")+w.height,I=t.extend({},v),P=i(x.my,c.outerWidth(),c.outerHeight());"right"===e.my[0]?I.left-=u:"center"===e.my[0]&&(I.left-=u/2),"bottom"===e.my[1]?I.top-=d:"center"===e.my[1]&&(I.top-=d/2),I.left+=P[0],I.top+=P[1],t.support.offsetFractions||(I.left=h(I.left),I.top=h(I.top)),n={marginLeft:f,marginTop:_},t.each(["left","top"],function(i,s){t.ui.position[k[i]]&&t.ui.position[k[i]][s](I,{targetWidth:p,targetHeight:g,elemWidth:u,elemHeight:d,collisionPosition:n,collisionWidth:D,collisionHeight:C,offset:[o[0]+P[0],o[1]+P[1]],my:e.my,at:e.at,within:y,elem:c})}),e.using&&(l=function(t){var i=m.left-I.left,s=i+p-u,n=m.top-I.top,o=n+g-d,h={target:{element:b,left:m.left,top:m.top,width:p,height:g},element:{element:c,left:I.left,top:I.top,width:u,height:d},horizontal:0>s?"left":i>0?"right":"center",vertical:0>o?"top":n>0?"bottom":"middle"};u>p&&p>r(i+s)&&(h.horizontal="center"),d>g&&g>r(n+o)&&(h.vertical="middle"),h.important=a(r(i),r(s))>a(r(n),r(o))?"horizontal":"vertical",e.using.call(this,t,h)}),c.offset(t.extend(I,{using:l}))})},t.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,o=s.width,r=t.left-e.collisionPosition.marginLeft,h=n-r,l=r+e.collisionWidth-o-n;e.collisionWidth>o?h>0&&0>=l?(i=t.left+h+e.collisionWidth-o-n,t.left+=h-i):t.left=l>0&&0>=h?n:h>l?n+o-e.collisionWidth:n:h>0?t.left+=h:l>0?t.left-=l:t.left=a(t.left-r,t.left)},top:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollTop:s.offset.top,o=e.within.height,r=t.top-e.collisionPosition.marginTop,h=n-r,l=r+e.collisionHeight-o-n;e.collisionHeight>o?h>0&&0>=l?(i=t.top+h+e.collisionHeight-o-n,t.top+=h-i):t.top=l>0&&0>=h?n:h>l?n+o-e.collisionHeight:n:h>0?t.top+=h:l>0?t.top-=l:t.top=a(t.top-r,t.top)}},flip:{left:function(t,e){var i,s,n=e.within,o=n.offset.left+n.scrollLeft,a=n.width,h=n.isWindow?n.scrollLeft:n.offset.left,l=t.left-e.collisionPosition.marginLeft,c=l-h,u=l+e.collisionWidth-a-h,d="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,p="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,f=-2*e.offset[0];0>c?(i=t.left+d+p+f+e.collisionWidth-a-o,(0>i||r(c)>i)&&(t.left+=d+p+f)):u>0&&(s=t.left-e.collisionPosition.marginLeft+d+p+f-h,(s>0||u>r(s))&&(t.left+=d+p+f))},top:function(t,e){var i,s,n=e.within,o=n.offset.top+n.scrollTop,a=n.height,h=n.isWindow?n.scrollTop:n.offset.top,l=t.top-e.collisionPosition.marginTop,c=l-h,u=l+e.collisionHeight-a-h,d="top"===e.my[1],p=d?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,f="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,g=-2*e.offset[1];0>c?(s=t.top+p+f+g+e.collisionHeight-a-o,t.top+p+f+g>c&&(0>s||r(c)>s)&&(t.top+=p+f+g)):u>0&&(i=t.top-e.collisionPosition.marginTop+p+f+g-h,t.top+p+f+g>u&&(i>0||u>r(i))&&(t.top+=p+f+g))}},flipfit:{left:function(){t.ui.position.flip.left.apply(this,arguments),t.ui.position.fit.left.apply(this,arguments)},top:function(){t.ui.position.flip.top.apply(this,arguments),t.ui.position.fit.top.apply(this,arguments)}}},function(){var e,i,s,n,o,a=document.getElementsByTagName("body")[0],r=document.createElement("div");e=document.createElement(a?"div":"body"),s={visibility:"hidden",width:0,height:0,border:0,margin:0,background:"none"},a&&t.extend(s,{position:"absolute",left:"-1000px",top:"-1000px"});for(o in s)e.style[o]=s[o];e.appendChild(r),i=a||document.documentElement,i.insertBefore(e,i.firstChild),r.style.cssText="position: absolute; left: 10.7432222px;",n=t(r).offset().left,t.support.offsetFractions=n>10&&11>n,e.innerHTML="",i.removeChild(e)}()}(jQuery),function(t,e){t.widget("ui.progressbar",{version:"1.10.3",options:{max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.addClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").attr({role:"progressbar","aria-valuemin":this.min}),this.valueDiv=t("<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>").appendTo(this.element),this._refreshValue()},_destroy:function(){this.element.removeClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow"),this.valueDiv.remove()
},value:function(t){return t===e?this.options.value:(this.options.value=this._constrainedValue(t),this._refreshValue(),e)},_constrainedValue:function(t){return t===e&&(t=this.options.value),this.indeterminate=t===!1,"number"!=typeof t&&(t=0),this.indeterminate?!1:Math.min(this.options.max,Math.max(this.min,t))},_setOptions:function(t){var e=t.value;delete t.value,this._super(t),this.options.value=this._constrainedValue(e),this._refreshValue()},_setOption:function(t,e){"max"===t&&(e=Math.max(this.min,e)),this._super(t,e)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var e=this.options.value,i=this._percentage();this.valueDiv.toggle(this.indeterminate||e>this.min).toggleClass("ui-corner-right",e===this.options.max).width(i.toFixed(0)+"%"),this.element.toggleClass("ui-progressbar-indeterminate",this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=t("<div class='ui-progressbar-overlay'></div>").appendTo(this.valueDiv))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":e}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==e&&(this.oldValue=e,this._trigger("change")),e===this.options.max&&this._trigger("complete")}})}(jQuery),function(t){var e=5;t.widget("ui.slider",t.ui.mouse,{version:"1.10.3",widgetEventPrefix:"slide",options:{animate:!1,distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this.element.addClass("ui-slider ui-slider-"+this.orientation+" ui-widget"+" ui-widget-content"+" ui-corner-all"),this._refresh(),this._setOption("disabled",this.options.disabled),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var e,i,s=this.options,n=this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"),o="<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",a=[];for(i=s.values&&s.values.length||1,n.length>i&&(n.slice(i).remove(),n=n.slice(0,i)),e=n.length;i>e;e++)a.push(o);this.handles=n.add(t(a.join("")).appendTo(this.element)),this.handle=this.handles.eq(0),this.handles.each(function(e){t(this).data("ui-slider-handle-index",e)})},_createRange:function(){var e=this.options,i="";e.range?(e.range===!0&&(e.values?e.values.length&&2!==e.values.length?e.values=[e.values[0],e.values[0]]:t.isArray(e.values)&&(e.values=e.values.slice(0)):e.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?this.range.removeClass("ui-slider-range-min ui-slider-range-max").css({left:"",bottom:""}):(this.range=t("<div></div>").appendTo(this.element),i="ui-slider-range ui-widget-header ui-corner-all"),this.range.addClass(i+("min"===e.range||"max"===e.range?" ui-slider-range-"+e.range:""))):this.range=t([])},_setupEvents:function(){var t=this.handles.add(this.range).filter("a");this._off(t),this._on(t,this._handleEvents),this._hoverable(t),this._focusable(t)},_destroy:function(){this.handles.remove(),this.range.remove(),this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all"),this._mouseDestroy()},_mouseCapture:function(e){var i,s,n,o,a,r,h,l,c=this,u=this.options;return u.disabled?!1:(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),i={x:e.pageX,y:e.pageY},s=this._normValueFromMouse(i),n=this._valueMax()-this._valueMin()+1,this.handles.each(function(e){var i=Math.abs(s-c.values(e));(n>i||n===i&&(e===c._lastChangedValue||c.values(e)===u.min))&&(n=i,o=t(this),a=e)}),r=this._start(e,a),r===!1?!1:(this._mouseSliding=!0,this._handleIndex=a,o.addClass("ui-state-active").focus(),h=o.offset(),l=!t(e.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=l?{left:0,top:0}:{left:e.pageX-h.left-o.width()/2,top:e.pageY-h.top-o.height()/2-(parseInt(o.css("borderTopWidth"),10)||0)-(parseInt(o.css("borderBottomWidth"),10)||0)+(parseInt(o.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(e,a,s),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(t){var e={x:t.pageX,y:t.pageY},i=this._normValueFromMouse(e);return this._slide(t,this._handleIndex,i),!1},_mouseStop:function(t){return this.handles.removeClass("ui-state-active"),this._mouseSliding=!1,this._stop(t,this._handleIndex),this._change(t,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(t){var e,i,s,n,o;return"horizontal"===this.orientation?(e=this.elementSize.width,i=t.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(e=this.elementSize.height,i=t.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),s=i/e,s>1&&(s=1),0>s&&(s=0),"vertical"===this.orientation&&(s=1-s),n=this._valueMax()-this._valueMin(),o=this._valueMin()+s*n,this._trimAlignValue(o)},_start:function(t,e){var i={handle:this.handles[e],value:this.value()};return this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._trigger("start",t,i)},_slide:function(t,e,i){var s,n,o;this.options.values&&this.options.values.length?(s=this.values(e?0:1),2===this.options.values.length&&this.options.range===!0&&(0===e&&i>s||1===e&&s>i)&&(i=s),i!==this.values(e)&&(n=this.values(),n[e]=i,o=this._trigger("slide",t,{handle:this.handles[e],value:i,values:n}),s=this.values(e?0:1),o!==!1&&this.values(e,i,!0))):i!==this.value()&&(o=this._trigger("slide",t,{handle:this.handles[e],value:i}),o!==!1&&this.value(i))},_stop:function(t,e){var i={handle:this.handles[e],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._trigger("stop",t,i)},_change:function(t,e){if(!this._keySliding&&!this._mouseSliding){var i={handle:this.handles[e],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._lastChangedValue=e,this._trigger("change",t,i)}},value:function(t){return arguments.length?(this.options.value=this._trimAlignValue(t),this._refreshValue(),this._change(null,0),undefined):this._value()},values:function(e,i){var s,n,o;if(arguments.length>1)return this.options.values[e]=this._trimAlignValue(i),this._refreshValue(),this._change(null,e),undefined;if(!arguments.length)return this._values();if(!t.isArray(arguments[0]))return this.options.values&&this.options.values.length?this._values(e):this.value();for(s=this.options.values,n=arguments[0],o=0;s.length>o;o+=1)s[o]=this._trimAlignValue(n[o]),this._change(null,o);this._refreshValue()},_setOption:function(e,i){var s,n=0;switch("range"===e&&this.options.range===!0&&("min"===i?(this.options.value=this._values(0),this.options.values=null):"max"===i&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),t.isArray(this.options.values)&&(n=this.options.values.length),t.Widget.prototype._setOption.apply(this,arguments),e){case"orientation":this._detectOrientation(),this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-"+this.orientation),this._refreshValue();break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),s=0;n>s;s+=1)this._change(null,s);this._animateOff=!1;break;case"min":case"max":this._animateOff=!0,this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_value:function(){var t=this.options.value;return t=this._trimAlignValue(t)},_values:function(t){var e,i,s;if(arguments.length)return e=this.options.values[t],e=this._trimAlignValue(e);if(this.options.values&&this.options.values.length){for(i=this.options.values.slice(),s=0;i.length>s;s+=1)i[s]=this._trimAlignValue(i[s]);return i}return[]},_trimAlignValue:function(t){if(this._valueMin()>=t)return this._valueMin();if(t>=this._valueMax())return this._valueMax();var e=this.options.step>0?this.options.step:1,i=(t-this._valueMin())%e,s=t-i;return 2*Math.abs(i)>=e&&(s+=i>0?e:-e),parseFloat(s.toFixed(5))},_valueMin:function(){return this.options.min},_valueMax:function(){return this.options.max},_refreshValue:function(){var e,i,s,n,o,a=this.options.range,r=this.options,h=this,l=this._animateOff?!1:r.animate,c={};this.options.values&&this.options.values.length?this.handles.each(function(s){i=100*((h.values(s)-h._valueMin())/(h._valueMax()-h._valueMin())),c["horizontal"===h.orientation?"left":"bottom"]=i+"%",t(this).stop(1,1)[l?"animate":"css"](c,r.animate),h.options.range===!0&&("horizontal"===h.orientation?(0===s&&h.range.stop(1,1)[l?"animate":"css"]({left:i+"%"},r.animate),1===s&&h.range[l?"animate":"css"]({width:i-e+"%"},{queue:!1,duration:r.animate})):(0===s&&h.range.stop(1,1)[l?"animate":"css"]({bottom:i+"%"},r.animate),1===s&&h.range[l?"animate":"css"]({height:i-e+"%"},{queue:!1,duration:r.animate}))),e=i}):(s=this.value(),n=this._valueMin(),o=this._valueMax(),i=o!==n?100*((s-n)/(o-n)):0,c["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[l?"animate":"css"](c,r.animate),"min"===a&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:i+"%"},r.animate),"max"===a&&"horizontal"===this.orientation&&this.range[l?"animate":"css"]({width:100-i+"%"},{queue:!1,duration:r.animate}),"min"===a&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:i+"%"},r.animate),"max"===a&&"vertical"===this.orientation&&this.range[l?"animate":"css"]({height:100-i+"%"},{queue:!1,duration:r.animate}))},_handleEvents:{keydown:function(i){var s,n,o,a,r=t(i.target).data("ui-slider-handle-index");switch(i.keyCode){case t.ui.keyCode.HOME:case t.ui.keyCode.END:case t.ui.keyCode.PAGE_UP:case t.ui.keyCode.PAGE_DOWN:case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(i.preventDefault(),!this._keySliding&&(this._keySliding=!0,t(i.target).addClass("ui-state-active"),s=this._start(i,r),s===!1))return}switch(a=this.options.step,n=o=this.options.values&&this.options.values.length?this.values(r):this.value(),i.keyCode){case t.ui.keyCode.HOME:o=this._valueMin();break;case t.ui.keyCode.END:o=this._valueMax();break;case t.ui.keyCode.PAGE_UP:o=this._trimAlignValue(n+(this._valueMax()-this._valueMin())/e);break;case t.ui.keyCode.PAGE_DOWN:o=this._trimAlignValue(n-(this._valueMax()-this._valueMin())/e);break;case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:if(n===this._valueMax())return;o=this._trimAlignValue(n+a);break;case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(n===this._valueMin())return;o=this._trimAlignValue(n-a)}this._slide(i,r,o)},click:function(t){t.preventDefault()},keyup:function(e){var i=t(e.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(e,i),this._change(e,i),t(e.target).removeClass("ui-state-active"))}}})}(jQuery),function(t){function e(t){return function(){var e=this.element.val();t.apply(this,arguments),this._refresh(),e!==this.element.val()&&this._trigger("change")}}t.widget("ui.spinner",{version:"1.10.3",defaultElement:"<input>",widgetEventPrefix:"spin",options:{culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var e={},i=this.element;return t.each(["min","max","step"],function(t,s){var n=i.attr(s);void 0!==n&&n.length&&(e[s]=n)}),e},_events:{keydown:function(t){this._start(t)&&this._keydown(t)&&t.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(t){return this.cancelBlur?(delete this.cancelBlur,void 0):(this._stop(),this._refresh(),this.previous!==this.element.val()&&this._trigger("change",t),void 0)},mousewheel:function(t,e){if(e){if(!this.spinning&&!this._start(t))return!1;this._spin((e>0?1:-1)*this.options.step,t),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(t)},100),t.preventDefault()}},"mousedown .ui-spinner-button":function(e){function i(){var t=this.element[0]===this.document[0].activeElement;t||(this.element.focus(),this.previous=s,this._delay(function(){this.previous=s}))}var s;s=this.element[0]===this.document[0].activeElement?this.previous:this.element.val(),e.preventDefault(),i.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,i.call(this)}),this._start(e)!==!1&&this._repeat(null,t(e.currentTarget).hasClass("ui-spinner-up")?1:-1,e)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(e){return t(e.currentTarget).hasClass("ui-state-active")?this._start(e)===!1?!1:(this._repeat(null,t(e.currentTarget).hasClass("ui-spinner-up")?1:-1,e),void 0):void 0},"mouseleave .ui-spinner-button":"_stop"},_draw:function(){var t=this.uiSpinner=this.element.addClass("ui-spinner-input").attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());this.element.attr("role","spinbutton"),this.buttons=t.find(".ui-spinner-button").attr("tabIndex",-1).button().removeClass("ui-corner-all"),this.buttons.height()>Math.ceil(.5*t.height())&&t.height()>0&&t.height(t.height()),this.options.disabled&&this.disable()},_keydown:function(e){var i=this.options,s=t.ui.keyCode;switch(e.keyCode){case s.UP:return this._repeat(null,1,e),!0;case s.DOWN:return this._repeat(null,-1,e),!0;case s.PAGE_UP:return this._repeat(null,i.page,e),!0;case s.PAGE_DOWN:return this._repeat(null,-i.page,e),!0}return!1},_uiSpinnerHtml:function(){return"<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>"},_buttonHtml:function(){return"<a class='ui-spinner-button ui-spinner-up ui-corner-tr'><span class='ui-icon "+this.options.icons.up+"'>&#9650;</span>"+"</a>"+"<a class='ui-spinner-button ui-spinner-down ui-corner-br'>"+"<span class='ui-icon "+this.options.icons.down+"'>&#9660;</span>"+"</a>"},_start:function(t){return this.spinning||this._trigger("start",t)!==!1?(this.counter||(this.counter=1),this.spinning=!0,!0):!1},_repeat:function(t,e,i){t=t||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,e,i)},t),this._spin(e*this.options.step,i)},_spin:function(t,e){var i=this.value()||0;this.counter||(this.counter=1),i=this._adjustValue(i+t*this._increment(this.counter)),this.spinning&&this._trigger("spin",e,{value:i})===!1||(this._value(i),this.counter++)},_increment:function(e){var i=this.options.incremental;return i?t.isFunction(i)?i(e):Math.floor(e*e*e/5e4-e*e/500+17*e/200+1):1},_precision:function(){var t=this._precisionOf(this.options.step);return null!==this.options.min&&(t=Math.max(t,this._precisionOf(this.options.min))),t},_precisionOf:function(t){var e=""+t,i=e.indexOf(".");return-1===i?0:e.length-i-1},_adjustValue:function(t){var e,i,s=this.options;return e=null!==s.min?s.min:0,i=t-e,i=Math.round(i/s.step)*s.step,t=e+i,t=parseFloat(t.toFixed(this._precision())),null!==s.max&&t>s.max?s.max:null!==s.min&&s.min>t?s.min:t},_stop:function(t){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",t))},_setOption:function(t,e){if("culture"===t||"numberFormat"===t){var i=this._parse(this.element.val());return this.options[t]=e,this.element.val(this._format(i)),void 0}("max"===t||"min"===t||"step"===t)&&"string"==typeof e&&(e=this._parse(e)),"icons"===t&&(this.buttons.first().find(".ui-icon").removeClass(this.options.icons.up).addClass(e.up),this.buttons.last().find(".ui-icon").removeClass(this.options.icons.down).addClass(e.down)),this._super(t,e),"disabled"===t&&(e?(this.element.prop("disabled",!0),this.buttons.button("disable")):(this.element.prop("disabled",!1),this.buttons.button("enable")))},_setOptions:e(function(t){this._super(t),this._value(this.element.val())}),_parse:function(t){return"string"==typeof t&&""!==t&&(t=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(t,10,this.options.culture):+t),""===t||isNaN(t)?null:t},_format:function(t){return""===t?"":window.Globalize&&this.options.numberFormat?Globalize.format(t,this.options.numberFormat,this.options.culture):t},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},_value:function(t,e){var i;""!==t&&(i=this._parse(t),null!==i&&(e||(i=this._adjustValue(i)),t=this._format(i))),this.element.val(t),this._refresh()},_destroy:function(){this.element.removeClass("ui-spinner-input").prop("disabled",!1).removeAttr("autocomplete").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:e(function(t){this._stepUp(t)}),_stepUp:function(t){this._start()&&(this._spin((t||1)*this.options.step),this._stop())},stepDown:e(function(t){this._stepDown(t)}),_stepDown:function(t){this._start()&&(this._spin((t||1)*-this.options.step),this._stop())},pageUp:e(function(t){this._stepUp((t||1)*this.options.page)}),pageDown:e(function(t){this._stepDown((t||1)*this.options.page)}),value:function(t){return arguments.length?(e(this._value).call(this,t),void 0):this._parse(this.element.val())},widget:function(){return this.uiSpinner}})}(jQuery),function(t,e){function i(){return++n}function s(t){return t.hash.length>1&&decodeURIComponent(t.href.replace(o,""))===decodeURIComponent(location.href.replace(o,""))}var n=0,o=/#.*$/;t.widget("ui.tabs",{version:"1.10.3",delay:300,options:{active:null,collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_create:function(){var e=this,i=this.options;this.running=!1,this.element.addClass("ui-tabs ui-widget ui-widget-content ui-corner-all").toggleClass("ui-tabs-collapsible",i.collapsible).delegate(".ui-tabs-nav > li","mousedown"+this.eventNamespace,function(e){t(this).is(".ui-state-disabled")&&e.preventDefault()}).delegate(".ui-tabs-anchor","focus"+this.eventNamespace,function(){t(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this._processTabs(),i.active=this._initialActive(),t.isArray(i.disabled)&&(i.disabled=t.unique(i.disabled.concat(t.map(this.tabs.filter(".ui-state-disabled"),function(t){return e.tabs.index(t)}))).sort()),this.active=this.options.active!==!1&&this.anchors.length?this._findActive(i.active):t(),this._refresh(),this.active.length&&this.load(i.active)},_initialActive:function(){var i=this.options.active,s=this.options.collapsible,n=location.hash.substring(1);return null===i&&(n&&this.tabs.each(function(s,o){return t(o).attr("aria-controls")===n?(i=s,!1):e}),null===i&&(i=this.tabs.index(this.tabs.filter(".ui-tabs-active"))),(null===i||-1===i)&&(i=this.tabs.length?0:!1)),i!==!1&&(i=this.tabs.index(this.tabs.eq(i)),-1===i&&(i=s?!1:0)),!s&&i===!1&&this.anchors.length&&(i=0),i},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):t()}},_tabKeydown:function(i){var s=t(this.document[0].activeElement).closest("li"),n=this.tabs.index(s),o=!0;if(!this._handlePageNav(i)){switch(i.keyCode){case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:n++;break;case t.ui.keyCode.UP:case t.ui.keyCode.LEFT:o=!1,n--;break;case t.ui.keyCode.END:n=this.anchors.length-1;break;case t.ui.keyCode.HOME:n=0;break;case t.ui.keyCode.SPACE:return i.preventDefault(),clearTimeout(this.activating),this._activate(n),e;case t.ui.keyCode.ENTER:return i.preventDefault(),clearTimeout(this.activating),this._activate(n===this.options.active?!1:n),e;default:return}i.preventDefault(),clearTimeout(this.activating),n=this._focusNextTab(n,o),i.ctrlKey||(s.attr("aria-selected","false"),this.tabs.eq(n).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",n)},this.delay))}},_panelKeydown:function(e){this._handlePageNav(e)||e.ctrlKey&&e.keyCode===t.ui.keyCode.UP&&(e.preventDefault(),this.active.focus())},_handlePageNav:function(i){return i.altKey&&i.keyCode===t.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):i.altKey&&i.keyCode===t.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):e},_findNextTab:function(e,i){function s(){return e>n&&(e=0),0>e&&(e=n),e}for(var n=this.tabs.length-1;-1!==t.inArray(s(),this.options.disabled);)e=i?e+1:e-1;return e},_focusNextTab:function(t,e){return t=this._findNextTab(t,e),this.tabs.eq(t).focus(),t},_setOption:function(t,i){return"active"===t?(this._activate(i),e):"disabled"===t?(this._setupDisabled(i),e):(this._super(t,i),"collapsible"===t&&(this.element.toggleClass("ui-tabs-collapsible",i),i||this.options.active!==!1||this._activate(0)),"event"===t&&this._setupEvents(i),"heightStyle"===t&&this._setupHeightStyle(i),e)},_tabId:function(t){return t.attr("aria-controls")||"ui-tabs-"+i()},_sanitizeSelector:function(t){return t?t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var e=this.options,i=this.tablist.children(":has(a[href])");e.disabled=t.map(i.filter(".ui-state-disabled"),function(t){return i.index(t)}),this._processTabs(),e.active!==!1&&this.anchors.length?this.active.length&&!t.contains(this.tablist[0],this.active[0])?this.tabs.length===e.disabled.length?(e.active=!1,this.active=t()):this._activate(this._findNextTab(Math.max(0,e.active-1),!1)):e.active=this.tabs.index(this.active):(e.active=!1,this.active=t()),this._refresh()},_refresh:function(){this._setupDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-expanded":"false","aria-hidden":"true"}),this.active.length?(this.active.addClass("ui-tabs-active ui-state-active").attr({"aria-selected":"true",tabIndex:0}),this._getPanelForTab(this.active).show().attr({"aria-expanded":"true","aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var e=this;this.tablist=this._getList().addClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").attr("role","tablist"),this.tabs=this.tablist.find("> li:has(a[href])").addClass("ui-state-default ui-corner-top").attr({role:"tab",tabIndex:-1}),this.anchors=this.tabs.map(function(){return t("a",this)[0]}).addClass("ui-tabs-anchor").attr({role:"presentation",tabIndex:-1}),this.panels=t(),this.anchors.each(function(i,n){var o,a,r,h=t(n).uniqueId().attr("id"),l=t(n).closest("li"),c=l.attr("aria-controls");s(n)?(o=n.hash,a=e.element.find(e._sanitizeSelector(o))):(r=e._tabId(l),o="#"+r,a=e.element.find(o),a.length||(a=e._createPanel(r),a.insertAfter(e.panels[i-1]||e.tablist)),a.attr("aria-live","polite")),a.length&&(e.panels=e.panels.add(a)),c&&l.data("ui-tabs-aria-controls",c),l.attr({"aria-controls":o.substring(1),"aria-labelledby":h}),a.attr("aria-labelledby",h)}),this.panels.addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").attr("role","tabpanel")},_getList:function(){return this.element.find("ol,ul").eq(0)},_createPanel:function(e){return t("<div>").attr("id",e).addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").data("ui-tabs-destroy",!0)},_setupDisabled:function(e){t.isArray(e)&&(e.length?e.length===this.anchors.length&&(e=!0):e=!1);for(var i,s=0;i=this.tabs[s];s++)e===!0||-1!==t.inArray(s,e)?t(i).addClass("ui-state-disabled").attr("aria-disabled","true"):t(i).removeClass("ui-state-disabled").removeAttr("aria-disabled");this.options.disabled=e},_setupEvents:function(e){var i={click:function(t){t.preventDefault()}};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(e){var i,s=this.element.parent();"fill"===e?(i=s.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var e=t(this),s=e.css("position");"absolute"!==s&&"fixed"!==s&&(i-=e.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=t(this).outerHeight(!0)}),this.panels.each(function(){t(this).height(Math.max(0,i-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===e&&(i=0,this.panels.each(function(){i=Math.max(i,t(this).height("").height())}).height(i))},_eventHandler:function(e){var i=this.options,s=this.active,n=t(e.currentTarget),o=n.closest("li"),a=o[0]===s[0],r=a&&i.collapsible,h=r?t():this._getPanelForTab(o),l=s.length?this._getPanelForTab(s):t(),c={oldTab:s,oldPanel:l,newTab:r?t():o,newPanel:h};e.preventDefault(),o.hasClass("ui-state-disabled")||o.hasClass("ui-tabs-loading")||this.running||a&&!i.collapsible||this._trigger("beforeActivate",e,c)===!1||(i.active=r?!1:this.tabs.index(o),this.active=a?t():o,this.xhr&&this.xhr.abort(),l.length||h.length||t.error("jQuery UI Tabs: Mismatching fragment identifier."),h.length&&this.load(this.tabs.index(o),e),this._toggle(e,c))},_toggle:function(e,i){function s(){o.running=!1,o._trigger("activate",e,i)}function n(){i.newTab.closest("li").addClass("ui-tabs-active ui-state-active"),a.length&&o.options.show?o._show(a,o.options.show,s):(a.show(),s())}var o=this,a=i.newPanel,r=i.oldPanel;this.running=!0,r.length&&this.options.hide?this._hide(r,this.options.hide,function(){i.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),n()}):(i.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),r.hide(),n()),r.attr({"aria-expanded":"false","aria-hidden":"true"}),i.oldTab.attr("aria-selected","false"),a.length&&r.length?i.oldTab.attr("tabIndex",-1):a.length&&this.tabs.filter(function(){return 0===t(this).attr("tabIndex")}).attr("tabIndex",-1),a.attr({"aria-expanded":"true","aria-hidden":"false"}),i.newTab.attr({"aria-selected":"true",tabIndex:0})},_activate:function(e){var i,s=this._findActive(e);s[0]!==this.active[0]&&(s.length||(s=this.active),i=s.find(".ui-tabs-anchor")[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return e===!1?t():this.tabs.eq(e)},_getIndex:function(t){return"string"==typeof t&&(t=this.anchors.index(this.anchors.filter("[href$='"+t+"']"))),t},_destroy:function(){this.xhr&&this.xhr.abort(),this.element.removeClass("ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible"),this.tablist.removeClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").removeAttr("role"),this.anchors.removeClass("ui-tabs-anchor").removeAttr("role").removeAttr("tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){t.data(this,"ui-tabs-destroy")?t(this).remove():t(this).removeClass("ui-state-default ui-state-active ui-state-disabled ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel").removeAttr("tabIndex").removeAttr("aria-live").removeAttr("aria-busy").removeAttr("aria-selected").removeAttr("aria-labelledby").removeAttr("aria-hidden").removeAttr("aria-expanded").removeAttr("role")}),this.tabs.each(function(){var e=t(this),i=e.data("ui-tabs-aria-controls");i?e.attr("aria-controls",i).removeData("ui-tabs-aria-controls"):e.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(i){var s=this.options.disabled;s!==!1&&(i===e?s=!1:(i=this._getIndex(i),s=t.isArray(s)?t.map(s,function(t){return t!==i?t:null}):t.map(this.tabs,function(t,e){return e!==i?e:null})),this._setupDisabled(s))},disable:function(i){var s=this.options.disabled;if(s!==!0){if(i===e)s=!0;else{if(i=this._getIndex(i),-1!==t.inArray(i,s))return;s=t.isArray(s)?t.merge([i],s).sort():[i]}this._setupDisabled(s)}},load:function(e,i){e=this._getIndex(e);var n=this,o=this.tabs.eq(e),a=o.find(".ui-tabs-anchor"),r=this._getPanelForTab(o),h={tab:o,panel:r};s(a[0])||(this.xhr=t.ajax(this._ajaxSettings(a,i,h)),this.xhr&&"canceled"!==this.xhr.statusText&&(o.addClass("ui-tabs-loading"),r.attr("aria-busy","true"),this.xhr.success(function(t){setTimeout(function(){r.html(t),n._trigger("load",i,h)},1)}).complete(function(t,e){setTimeout(function(){"abort"===e&&n.panels.stop(!1,!0),o.removeClass("ui-tabs-loading"),r.removeAttr("aria-busy"),t===n.xhr&&delete n.xhr},1)})))},_ajaxSettings:function(e,i,s){var n=this;return{url:e.attr("href"),beforeSend:function(e,o){return n._trigger("beforeLoad",i,t.extend({jqXHR:e,ajaxSettings:o},s))}}},_getPanelForTab:function(e){var i=t(e).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+i))}})}(jQuery),function(t){function e(e,i){var s=(e.attr("aria-describedby")||"").split(/\s+/);s.push(i),e.data("ui-tooltip-id",i).attr("aria-describedby",t.trim(s.join(" ")))}function i(e){var i=e.data("ui-tooltip-id"),s=(e.attr("aria-describedby")||"").split(/\s+/),n=t.inArray(i,s);-1!==n&&s.splice(n,1),e.removeData("ui-tooltip-id"),s=t.trim(s.join(" ")),s?e.attr("aria-describedby",s):e.removeAttr("aria-describedby")}var s=0;t.widget("ui.tooltip",{version:"1.10.3",options:{content:function(){var e=t(this).attr("title")||"";return t("<a>").text(e).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,tooltipClass:null,track:!1,close:null,open:null},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.options.disabled&&this._disable()},_setOption:function(e,i){var s=this;return"disabled"===e?(this[i?"_disable":"_enable"](),this.options[e]=i,void 0):(this._super(e,i),"content"===e&&t.each(this.tooltips,function(t,e){s._updateContent(e)}),void 0)},_disable:function(){var e=this;t.each(this.tooltips,function(i,s){var n=t.Event("blur");n.target=n.currentTarget=s[0],e.close(n,!0)}),this.element.find(this.options.items).addBack().each(function(){var e=t(this);e.is("[title]")&&e.data("ui-tooltip-title",e.attr("title")).attr("title","")})},_enable:function(){this.element.find(this.options.items).addBack().each(function(){var e=t(this);e.data("ui-tooltip-title")&&e.attr("title",e.data("ui-tooltip-title"))})},open:function(e){var i=this,s=t(e?e.target:this.element).closest(this.options.items);s.length&&!s.data("ui-tooltip-id")&&(s.attr("title")&&s.data("ui-tooltip-title",s.attr("title")),s.data("ui-tooltip-open",!0),e&&"mouseover"===e.type&&s.parents().each(function(){var e,s=t(this);s.data("ui-tooltip-open")&&(e=t.Event("blur"),e.target=e.currentTarget=this,i.close(e,!0)),s.attr("title")&&(s.uniqueId(),i.parents[this.id]={element:this,title:s.attr("title")},s.attr("title",""))}),this._updateContent(s,e))},_updateContent:function(t,e){var i,s=this.options.content,n=this,o=e?e.type:null;return"string"==typeof s?this._open(e,t,s):(i=s.call(t[0],function(i){t.data("ui-tooltip-open")&&n._delay(function(){e&&(e.type=o),this._open(e,t,i)})}),i&&this._open(e,t,i),void 0)},_open:function(i,s,n){function o(t){l.of=t,a.is(":hidden")||a.position(l)}var a,r,h,l=t.extend({},this.options.position);
if(n){if(a=this._find(s),a.length)return a.find(".ui-tooltip-content").html(n),void 0;s.is("[title]")&&(i&&"mouseover"===i.type?s.attr("title",""):s.removeAttr("title")),a=this._tooltip(s),e(s,a.attr("id")),a.find(".ui-tooltip-content").html(n),this.options.track&&i&&/^mouse/.test(i.type)?(this._on(this.document,{mousemove:o}),o(i)):a.position(t.extend({of:s},this.options.position)),a.hide(),this._show(a,this.options.show),this.options.show&&this.options.show.delay&&(h=this.delayedShow=setInterval(function(){a.is(":visible")&&(o(l.of),clearInterval(h))},t.fx.interval)),this._trigger("open",i,{tooltip:a}),r={keyup:function(e){if(e.keyCode===t.ui.keyCode.ESCAPE){var i=t.Event(e);i.currentTarget=s[0],this.close(i,!0)}},remove:function(){this._removeTooltip(a)}},i&&"mouseover"!==i.type||(r.mouseleave="close"),i&&"focusin"!==i.type||(r.focusout="close"),this._on(!0,s,r)}},close:function(e){var s=this,n=t(e?e.currentTarget:this.element),o=this._find(n);this.closing||(clearInterval(this.delayedShow),n.data("ui-tooltip-title")&&n.attr("title",n.data("ui-tooltip-title")),i(n),o.stop(!0),this._hide(o,this.options.hide,function(){s._removeTooltip(t(this))}),n.removeData("ui-tooltip-open"),this._off(n,"mouseleave focusout keyup"),n[0]!==this.element[0]&&this._off(n,"remove"),this._off(this.document,"mousemove"),e&&"mouseleave"===e.type&&t.each(this.parents,function(e,i){t(i.element).attr("title",i.title),delete s.parents[e]}),this.closing=!0,this._trigger("close",e,{tooltip:o}),this.closing=!1)},_tooltip:function(e){var i="ui-tooltip-"+s++,n=t("<div>").attr({id:i,role:"tooltip"}).addClass("ui-tooltip ui-widget ui-corner-all ui-widget-content "+(this.options.tooltipClass||""));return t("<div>").addClass("ui-tooltip-content").appendTo(n),n.appendTo(this.document[0].body),this.tooltips[i]=e,n},_find:function(e){var i=e.data("ui-tooltip-id");return i?t("#"+i):t()},_removeTooltip:function(t){t.remove(),delete this.tooltips[t.attr("id")]},_destroy:function(){var e=this;t.each(this.tooltips,function(i,s){var n=t.Event("blur");n.target=n.currentTarget=s[0],e.close(n,!0),t("#"+i).remove(),s.data("ui-tooltip-title")&&(s.attr("title",s.data("ui-tooltip-title")),s.removeData("ui-tooltip-title"))})}})}(jQuery);
function floatToString(t,r){var e=t.toFixed(r).toString();return e.match(/^\.\d+/)?"0"+e:e}function attributeToString(t){return"string"!=typeof t&&"undefined"===(t+="")&&(t=""),jQuery.trim(t)}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.money_format="${{amount}}",Shopify.onError=function(t,r){var e=eval("("+t.responseText+")");e.message?alert(e.message+"("+e.status+"): "+e.description):alert("Error : "+Shopify.fullMessagesFromErrors(e).join("; ")+".")},Shopify.fullMessagesFromErrors=function(t){var o=[];return jQuery.each(t,function(e,t){jQuery.each(t,function(t,r){o.push(e+" "+r)})}),o},Shopify.onCartUpdate=function(t){/*alert("There are now "+t.item_count+" items in the cart.")*/},Shopify.onCartShippingRatesUpdate=function(t,r){var e="";r.zip&&(e+=r.zip+", "),r.province&&(e+=r.province+", "),e+=r.country,alert("There are "+t.length+" shipping rates available for "+e+", starting at "+Shopify.formatMoney(t[0].price)+".")},Shopify.onItemAdded=function(t){alert(t.title+" was added to your shopping cart.")},Shopify.onProduct=function(t){alert("Received everything we ever wanted to know about "+t.title)},Shopify.formatMoney=function(t,r){function n(t,r){return void 0===t?r:t}function e(t,r,e,o){if(r=n(r,2),e=n(e,","),o=n(o,"."),isNaN(t)||null==t)return 0;var a=(t=(t/100).toFixed(r)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?o+a[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",a=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(a)[1]){case"amount":o=e(t,2);break;case"amount_no_decimals":o=e(t,0);break;case"amount_with_comma_separator":o=e(t,2,".",",");break;case"amount_with_space_separator":o=e(t,2," ",",");break;case"amount_with_period_and_space_separator":o=e(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=e(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=e(t,0,".","");break;case"amount_with_space_separator":o=e(t,2,",","");break;case"amount_with_apostrophe_separator":o=e(t,2,"'",".")}return i.replace(a,o)},Shopify.resizeImage=function(t,r){try{if("original"==r)return t;var e=t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);return e[1]+"_"+r+"."+e[2]}catch(o){return t}},Shopify.addItem=function(t,r,e){var o={type:"POST",url:"/cart/add.js",data:"quantity="+(r=r||1)+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.addItemFromForm=function(t,r){var e={type:"POST",url:"/cart/add.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.getCart=function(r){jQuery.getJSON("/cart.js",function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)})},Shopify.pollForCartShippingRatesForDestination=function(o,a,t){t=t||Shopify.onError;var n=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(t,r,e){200===e.status?"function"==typeof a?a(t.shipping_rates,o):Shopify.onCartShippingRatesUpdate(t.shipping_rates,o):setTimeout(n,500)},error:t})};return n},Shopify.getCartShippingRatesForDestination=function(t,r,e){e=e||Shopify.onError;var o={type:"POST",url:"/cart/prepare_shipping_rates",data:Shopify.param({shipping_address:t}),success:Shopify.pollForCartShippingRatesForDestination(t,r,e),error:e};jQuery.ajax(o)},Shopify.getProduct=function(t,r){jQuery.getJSON("/products/"+t+".js",function(t){"function"==typeof r?r(t):Shopify.onProduct(t)})},Shopify.changeItem=function(t,r,e){var o={type:"POST",url:"/cart/change.js",data:"quantity="+r+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.removeItem=function(t,r){var e={type:"POST",url:"/cart/change.js",data:"quantity=0&id="+t,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.clear=function(r){var t={type:"POST",url:"/cart/clear.js",data:"",dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(t)},Shopify.updateCartFromForm=function(t,r){var e={type:"POST",url:"/cart/update.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartAttributes=function(t,r){var o="";jQuery.isArray(t)?jQuery.each(t,function(t,r){var e=attributeToString(r.key);""!==e&&(o+="attributes["+e+"]="+attributeToString(r.value)+"&")}):"object"==typeof t&&null!==t&&jQuery.each(t,function(t,r){o+="attributes["+attributeToString(t)+"]="+attributeToString(r)+"&"});var e={type:"POST",url:"/cart/update.js",data:o,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartNote=function(t,r){var e={type:"POST",url:"/cart/update.js",data:"note="+attributeToString(t),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},"1.4"<=jQuery.fn.jquery?Shopify.param=jQuery.param:(Shopify.param=function(t){var e=[],r=function(t,r){r=jQuery.isFunction(r)?r():r,e[e.length]=encodeURIComponent(t)+"="+encodeURIComponent(r)};if(jQuery.isArray(t)||t.jquery)jQuery.each(t,function(){r(this.name,this.value)});else for(var o in t)Shopify.buildParams(o,t[o],r);return e.join("&").replace(/%20/g,"+")},Shopify.buildParams=function(e,t,o){jQuery.isArray(t)&&t.length?jQuery.each(t,function(t,r){rbracket.test(e)?o(e,r):Shopify.buildParams(e+"["+("object"==typeof r||jQuery.isArray(r)?t:"")+"]",r,o)}):null!=t&&"object"==typeof t?Shopify.isEmptyObject(t)?o(e,""):jQuery.each(t,function(t,r){Shopify.buildParams(e+"["+t+"]",r,o)}):o(e,t)},Shopify.isEmptyObject=function(t){for(var r in t)return!1;return!0});
function floatToString(t, e) {
    var o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? "0" + o : o;
}
"undefined" == typeof window.Shopify && (window.Shopify = {}),
    (Shopify.each = function (t, e) {
        for (var o = 0; o < t.length; o++) e(t[o], o);
    }),
    (Shopify.map = function (t, e) {
        for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
        return o;
    }),
    (Shopify.arrayIncludes = function (t, e) {
        for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
        return !1;
    }),
    (Shopify.uniq = function (t) {
        for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
        return e;
    }),
    (Shopify.isDefined = function (t) {
        return void 0 !== t;
    }),
    (Shopify.getClass = function (t) {
        return Object.prototype.toString.call(t).slice(8, -1);
    }),
    (Shopify.extend = function (t, e) {
        function o() {}
        (o.prototype = e.prototype), (t.prototype = new o()), ((t.prototype.constructor = t).baseConstructor = e), (t.superClass = e.prototype);
    }),
    (Shopify.locationSearch = function () {
        return window.location.search;
    }),
    (Shopify.locationHash = function () {
        return window.location.hash;
    }),
    (Shopify.replaceState = function (t) {
        window.history.replaceState({}, document.title, t);
    }),
    (Shopify.urlParam = function (t) {
        var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
        return e && decodeURIComponent(e[1].replace(/\+/g, " "));
    }),
    (Shopify.newState = function (t, e) {
        return (Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e) + Shopify.locationHash();
    }),
    (Shopify.setParam = function (t, e) {
        Shopify.replaceState(Shopify.newState(t, e));
    }),
    (Shopify.Product = function (t) {
        Shopify.isDefined(t) && this.update(t);
    }),
    (Shopify.Product.prototype.update = function (t) {
        for (property in t) this[property] = t[property];
    }),
    (Shopify.Product.prototype.optionNames = function () {
        return "Array" == Shopify.getClass(this.options) ? this.options : [];
    }),
    (Shopify.Product.prototype.optionValues = function (o) {
        if (!Shopify.isDefined(this.variants)) return null;
        var t = Shopify.map(this.variants, function (t) {
            var e = "option" + (o + 1);
            return t[e] == undefined ? null : t[e];
        });
        return null == t[0] ? null : Shopify.uniq(t);
    }),
    (Shopify.Product.prototype.getVariant = function (i) {
        var r = null;
        return (
            i.length != this.options.length ||
                Shopify.each(this.variants, function (t) {
                    for (var e = !0, o = 0; o < i.length; o++) {
                        t["option" + (o + 1)] != i[o] && (e = !1);
                    }
                    1 != e || (r = t);
                }),
            r
        );
    }),
    (Shopify.Product.prototype.getVariantById = function (t) {
        for (var e = 0; e < this.variants.length; e++) {
            var o = this.variants[e];
            if (t == o.id) return o;
        }
        return null;
    }),
    (Shopify.money_format = "${{amount}}"),
    (Shopify.formatMoney = function (t, e) {
        function n(t, e) {
            return void 0 === t ? e : t;
        }
        function o(t, e, o, i) {
            if (((e = n(e, 2)), (o = n(o, ",")), (i = n(i, ".")), isNaN(t) || null == t)) return 0;
            var r = (t = (t / 100).toFixed(e)).split(".");
            return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? i + r[1] : "");
        }
        "string" == typeof t && (t = t.replace(".", ""));
        var i = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            a = e || this.money_format;
        switch (a.match(r)[1]) {
            case "amount":
                i = o(t, 2);
                break;
            case "amount_no_decimals":
                i = o(t, 0);
                break;
            case "amount_with_comma_separator":
                i = o(t, 2, ".", ",");
                break;
            case "amount_with_space_separator":
                i = o(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                i = o(t, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = o(t, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                i = o(t, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                i = o(t, 2, "'", ".");
        }
        return a.replace(r, i);
    }),
    (Shopify.OptionSelectors = function (t, e) {
        return (
            (this.selectorDivClass = "selector-wrapper"),
            (this.selectorClass = "single-option-selector"),
            (this.variantIdFieldIdSuffix = "-variant-id"),
            (this.variantIdField = null),
            (this.historyState = null),
            (this.selectors = []),
            (this.domIdPrefix = t),
            (this.product = new Shopify.Product(e.product)),
            (this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}),
            this.replaceSelector(t),
            this.initDropdown(),
            e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
            !0
        );
    }),
    (Shopify.OptionSelectors.prototype.initDropdown = function () {
        var t = { initialLoad: !0 };
        if (!this.selectVariantFromDropdown(t)) {
            var e = this;
            setTimeout(function () {
                e.selectVariantFromParams(t) || e.fireOnChangeForFirstDropdown.call(e, t);
            });
        }
    }),
    (Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) {
        this.selectors[0].element.onchange(t);
    }),
    (Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) {
        this.selectVariantFromParams(t) || this.selectVariantFromDropdown(t);
    }),
    (Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
        var e = document.getElementById(t),
            o = e.parentNode;
        Shopify.each(this.buildSelectors(), function (t) {
            o.insertBefore(t, e);
        }),
            (e.style.display = "none"),
            (this.variantIdField = e);
    }),
    (Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) {
        var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
        if ((e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e)) return !1;
        var o = e.value;
        return this.selectVariant(o, t);
    }),
    (Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) {
        var e = Shopify.urlParam("variant");
        return this.selectVariant(e, t);
    }),
    (Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
        var o = this.product.getVariantById(t);
        if (null == o) return !1;
        for (var i = 0; i < this.selectors.length; i++) {
            var r = this.selectors[i].element,
                n = o[r.getAttribute("data-option")];
            null != n && this.optionExistInSelect(r, n) && (r.value = n);
        }
        return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0;
    }),
    (Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) {
        for (var o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0;
    }),
    (Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
        Shopify.isDefined(e) && this.setMessageElement(e), (this.domIdPrefix = "product-" + this.product.id + "-variant-selector");
        var o = document.getElementById(t);
        Shopify.each(this.buildSelectors(), function (t) {
            o.appendChild(t);
        });
    }),
    (Shopify.OptionSelectors.prototype.buildSelectors = function () {
        for (var t = 0; t < this.product.optionNames().length; t++) {
            var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
            (e.element.disabled = !1), this.selectors.push(e);
        }
        var i = this.selectorDivClass,
            r = this.product.optionNames();
        return Shopify.map(this.selectors, function (t) {
            var e = document.createElement("div");
            if ((e.setAttribute("class", i), 1 < r.length)) {
                var o = document.createElement("label");
                (o.htmlFor = t.element.id), (o.innerHTML = t.name), e.appendChild(o);
            }
            return e.appendChild(t.element), e;
        });
    }),
    (Shopify.OptionSelectors.prototype.selectedValues = function () {
        for (var t = [], e = 0; e < this.selectors.length; e++) {
            var o = this.selectors[e].element.value;
            t.push(o);
        }
        return t;
    }),
    (Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
        var o = this.selectedValues(),
            i = this.product.getVariant(o);
        i ? ((this.variantIdField.disabled = !1), (this.variantIdField.value = i.id)) : (this.variantIdField.disabled = !0), this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e);
    }),
    (Shopify.OptionSelectorsFromDOM = function (t, e) {
        var o = e.optionNames || [],
            i = e.priceFieldExists || !0,
            r = e.delimiter || "/",
            n = this.createProductFromSelector(t, o, i, r);
        (e.product = n), Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
    }),
    Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
    (Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, n, a, s) {
        if (!Shopify.isDefined(a)) a = !0;
        if (!Shopify.isDefined(s)) s = "/";
        var e = document.getElementById(t),
            o = e.childNodes,
            p = (e.parentNode, n.length),
            l = [];
        Shopify.each(o, function (t) {
            if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
                var e = t.innerHTML.split(new RegExp("\\s*\\" + s + "\\s*"));
                0 == n.length && (p = e.length - (a ? 1 : 0));
                var o = e.slice(0, p),
                    i = a ? e[p] : "",
                    r = (t.getAttribute("value"), { available: !t.disabled, id: parseFloat(t.value), price: i, option1: o[0], option2: o[1], option3: o[2] });
                l.push(r);
            }
        });
        var i = { variants: l };
        if (0 == n.length) {
            i.options = [];
            for (var r = 0; r < p; r++) i.options[r] = "option " + (r + 1);
        } else i.options = n;
        return i;
    }),
    (Shopify.SingleOptionSelector = function (o, i, t, e) {
        (this.multiSelector = o), (this.values = e), (this.index = i), (this.name = t), (this.element = document.createElement("select"));
        for (var r = 0; r < e.length; r++) {
            var n = document.createElement("option");
            (n.value = e[r]), (n.innerHTML = e[r]), this.element.appendChild(n);
        }
        return (
            this.element.setAttribute("class", this.multiSelector.selectorClass),
            this.element.setAttribute("data-option", "option" + (i + 1)),
            (this.element.id = o.domIdPrefix + "-option-" + i),
            (this.element.onchange = function (t, e) {
                (e = e || {}), o.updateSelectors(i, e);
            }),
            !0
        );
    }),
    (Shopify.Image = {
        preload: function (t, e) {
            for (var o = 0; o < t.length; o++) {
                var i = t[o];
                this.loadImage(this.getSizedImageUrl(i, e));
            }
        },
        loadImage: function (t) {
            new Image().src = t;
        },
        switchImage: function (t, e, o) {
            if (t && e) {
                var i = this.imageSize(e.src),
                    r = this.getSizedImageUrl(t.src, i);
                o ? o(r, t, e) : (e.src = r);
            }
        },
        imageSize: function (t) {
            var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            return null !== e ? e[1] : null;
        },
        getSizedImageUrl: function (t, e) {
            if (null == e) return t;
            if ("master" == e) return this.removeProtocol(t);
            var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null == o) return null;
            var i = t.split(o[0]),
                r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r);
        },
        removeProtocol: function (t) {
            return t.replace(/http(s)?:/, "");
        },
    }),
    (Shopify.OptionSelectors.HistoryState = function (t) {
        this.browserSupports() && this.register(t);
    }),
    (Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
        window.addEventListener("popstate", function () {
            t.selectVariantFromParamsOrDropdown({ popStateCall: !0 });
        });
    }),
    (Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) {
        this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id));
    }),
    (Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
        return window.history && window.history.replaceState;
    });

/*! lazysizes - v4.0.1 */
!function(a,b){var c=b(a,a.document);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}(window,function(a,b){"use strict";if(b.getElementsByClassName){var c,d,e=b.documentElement,f=a.Date,g=a.HTMLPictureElement,h="addEventListener",i="getAttribute",j=a[h],k=a.setTimeout,l=a.requestAnimationFrame||k,m=a.requestIdleCallback,n=/^picture$/i,o=["load","error","lazyincluded","_lazyloaded"],p={},q=Array.prototype.forEach,r=function(a,b){return p[b]||(p[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),p[b].test(a[i]("class")||"")&&p[b]},s=function(a,b){r(a,b)||a.setAttribute("class",(a[i]("class")||"").trim()+" "+b)},t=function(a,b){var c;(c=r(a,b))&&a.setAttribute("class",(a[i]("class")||"").replace(c," "))},u=function(a,b,c){var d=c?h:"removeEventListener";c&&u(a,b),o.forEach(function(c){a[d](c,b)})},v=function(a,d,e,f,g){var h=b.createEvent("CustomEvent");return e||(e={}),e.instance=c,h.initCustomEvent(d,!f,!g,e),a.dispatchEvent(h),h},w=function(b,c){var e;!g&&(e=a.picturefill||d.pf)?e({reevaluate:!0,elements:[b]}):c&&c.src&&(b.src=c.src)},x=function(a,b){return(getComputedStyle(a,null)||{})[b]},y=function(a,b,c){for(c=c||a.offsetWidth;c<d.minSize&&b&&!a._lazysizesWidth;)c=b.offsetWidth,b=b.parentNode;return c},z=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?k:l)(g)))};return h._lsFlush=g,h}(),A=function(a,b){return b?function(){z(a)}:function(){var b=this,c=arguments;z(function(){a.apply(b,c)})}},B=function(a){var b,c=0,e=125,g=d.ricTimeout,h=function(){b=!1,c=f.now(),a()},i=m&&d.ricTimeout?function(){m(h,{timeout:g}),g!==d.ricTimeout&&(g=d.ricTimeout)}:A(function(){k(h)},!0);return function(a){var d;(a=a===!0)&&(g=33),b||(b=!0,d=e-(f.now()-c),0>d&&(d=0),a||9>d&&m?i():k(i,d))}},C=function(a){var b,c,d=99,e=function(){b=null,a()},g=function(){var a=f.now()-c;d>a?k(g,d-a):(m||e)(e)};return function(){c=f.now(),b||(b=k(g,d))}};!function(){var b,c={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:300};d=a.lazySizesConfig||a.lazysizesConfig||{};for(b in c)b in d||(d[b]=c[b]);a.lazySizesConfig=d,k(function(){d.init&&F()})}();var D=function(){var g,l,m,o,p,y,D,F,G,H,I,J,K,L,M=/^img$/i,N=/^iframe$/i,O="onscroll"in a&&!/glebot/.test(navigator.userAgent),P=0,Q=0,R=0,S=-1,T=function(a){R--,a&&a.target&&u(a.target,T),(!a||0>R||!a.target)&&(R=0)},U=function(a,c){var d,f=a,g="hidden"==x(b.body,"visibility")||"hidden"!=x(a,"visibility");for(F-=c,I+=c,G-=c,H+=c;g&&(f=f.offsetParent)&&f!=b.body&&f!=e;)g=(x(f,"opacity")||1)>0,g&&"visible"!=x(f,"overflow")&&(d=f.getBoundingClientRect(),g=H>d.left&&G<d.right&&I>d.top-1&&F<d.bottom+1);return g},V=function(){var a,f,h,j,k,m,n,p,q,r=c.elements;if((o=d.loadMode)&&8>R&&(a=r.length)){f=0,S++,null==K&&("expand"in d||(d.expand=e.clientHeight>500&&e.clientWidth>500?500:370),J=d.expand,K=J*d.expFactor),K>Q&&1>R&&S>2&&o>2&&!b.hidden?(Q=K,S=0):Q=o>1&&S>1&&6>R?J:P;for(;a>f;f++)if(r[f]&&!r[f]._lazyRace)if(O)if((p=r[f][i]("data-expand"))&&(m=1*p)||(m=Q),q!==m&&(y=innerWidth+m*L,D=innerHeight+m,n=-1*m,q=m),h=r[f].getBoundingClientRect(),(I=h.bottom)>=n&&(F=h.top)<=D&&(H=h.right)>=n*L&&(G=h.left)<=y&&(I||H||G||F)&&(d.loadHidden||"hidden"!=x(r[f],"visibility"))&&(l&&3>R&&!p&&(3>o||4>S)||U(r[f],m))){if(ba(r[f]),k=!0,R>9)break}else!k&&l&&!j&&4>R&&4>S&&o>2&&(g[0]||d.preloadAfterLoad)&&(g[0]||!p&&(I||H||G||F||"auto"!=r[f][i](d.sizesAttr)))&&(j=g[0]||r[f]);else ba(r[f]);j&&!k&&ba(j)}},W=B(V),X=function(a){s(a.target,d.loadedClass),t(a.target,d.loadingClass),u(a.target,Z),v(a.target,"lazyloaded")},Y=A(X),Z=function(a){Y({target:a.target})},$=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},_=function(a){var b,c=a[i](d.srcsetAttr);(b=d.customMedia[a[i]("data-media")||a[i]("media")])&&a.setAttribute("media",b),c&&a.setAttribute("srcset",c)},aa=A(function(a,b,c,e,f){var g,h,j,l,o,p;(o=v(a,"lazybeforeunveil",b)).defaultPrevented||(e&&(c?s(a,d.autosizesClass):a.setAttribute("sizes",e)),h=a[i](d.srcsetAttr),g=a[i](d.srcAttr),f&&(j=a.parentNode,l=j&&n.test(j.nodeName||"")),p=b.firesLoad||"src"in a&&(h||g||l),o={target:a},p&&(u(a,T,!0),clearTimeout(m),m=k(T,2500),s(a,d.loadingClass),u(a,Z,!0)),l&&q.call(j.getElementsByTagName("source"),_),h?a.setAttribute("srcset",h):g&&!l&&(N.test(a.nodeName)?$(a,g):a.src=g),f&&(h||l)&&w(a,{src:g})),a._lazyRace&&delete a._lazyRace,t(a,d.lazyClass),z(function(){(!p||a.complete&&a.naturalWidth>1)&&(p?T(o):R--,X(o))},!0)}),ba=function(a){var b,c=M.test(a.nodeName),e=c&&(a[i](d.sizesAttr)||a[i]("sizes")),f="auto"==e;(!f&&l||!c||!a[i]("src")&&!a.srcset||a.complete||r(a,d.errorClass)||!r(a,d.lazyClass))&&(b=v(a,"lazyunveilread").detail,f&&E.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,R++,aa(a,b,f,e,c))},ca=function(){if(!l){if(f.now()-p<999)return void k(ca,999);var a=C(function(){d.loadMode=3,W()});l=!0,d.loadMode=3,W(),j("scroll",function(){3==d.loadMode&&(d.loadMode=2),a()},!0)}};return{_:function(){p=f.now(),c.elements=b.getElementsByClassName(d.lazyClass),g=b.getElementsByClassName(d.lazyClass+" "+d.preloadClass),L=d.hFac,j("scroll",W,!0),j("resize",W,!0),a.MutationObserver?new MutationObserver(W).observe(e,{childList:!0,subtree:!0,attributes:!0}):(e[h]("DOMNodeInserted",W,!0),e[h]("DOMAttrModified",W,!0),setInterval(W,999)),j("hashchange",W,!0),["focus","mouseover","click","load","transitionend","animationend","webkitAnimationEnd"].forEach(function(a){b[h](a,W,!0)}),/d$|^c/.test(b.readyState)?ca():(j("load",ca),b[h]("DOMContentLoaded",W),k(ca,2e4)),c.elements.length?(V(),z._lsFlush()):W()},checkElems:W,unveil:ba}}(),E=function(){var a,c=A(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),n.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;g>f;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||w(a,c.detail)}),e=function(a,b,d){var e,f=a.parentNode;f&&(d=y(a,f,d),e=v(a,"lazybeforesizes",{width:d,dataAttr:!!b}),e.defaultPrevented||(d=e.detail.width,d&&d!==a._lazysizesWidth&&c(a,f,e,d)))},f=function(){var b,c=a.length;if(c)for(b=0;c>b;b++)e(a[b])},g=C(f);return{_:function(){a=b.getElementsByClassName(d.autosizesClass),j("resize",g)},checkElems:g,updateElem:e}}(),F=function(){F.i||(F.i=!0,E._(),D._())};return c={cfg:d,autoSizer:E,loader:D,init:F,uP:w,aC:s,rC:t,hC:r,fire:v,gW:y,rAF:z}}});
/*! Plugin - ls.rias.min.js */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";function d(b,c){var d,e,f,g,h=a.getComputedStyle(b);e=b.parentNode,g={isPicture:!(!e||!m.test(e.nodeName||""))},f=function(a,c){var d=b.getAttribute("data-"+a);if(!d){var e=h.getPropertyValue("--ls-"+a);e&&(d=e.trim())}if(d){if("true"==d)d=!0;else if("false"==d)d=!1;else if(l.test(d))d=parseFloat(d);else if("function"==typeof j[a])d=j[a](b,d);else if(q.test(d))try{d=JSON.parse(d)}catch(f){}g[a]=d}else a in j&&"function"!=typeof j[a]?g[a]=j[a]:c&&"function"==typeof j[a]&&(g[a]=j[a](b,d))};for(d in j)f(d);return c.replace(p,function(a,b){b in g||f(b,!0)}),g}function e(a,b){var c=[],d=function(a,c){return k[typeof b[c]]?b[c]:a};return c.srcset=[],b.absUrl&&(s.setAttribute("href",a),a=s.href),a=((b.prefix||"")+a+(b.postfix||"")).replace(p,d),b.widths.forEach(function(d){var e=b.widthmap[d]||d,f={u:a.replace(n,e).replace(o,b.ratio?Math.round(d*b.ratio):""),w:d};c.push(f),c.srcset.push(f.c=f.u+" "+d+"w")}),c}function f(a,c,d){var f=0,g=0,h=d;if(a){if("container"===c.ratio){for(f=h.scrollWidth,g=h.scrollHeight;!(f&&g||h===b);)h=h.parentNode,f=h.scrollWidth,g=h.scrollHeight;f&&g&&(c.ratio=g/f)}a=e(a,c),a.isPicture=c.isPicture,u&&"IMG"==d.nodeName.toUpperCase()?d.removeAttribute(i.srcsetAttr):d.setAttribute(i.srcsetAttr,a.srcset.join(", ")),Object.defineProperty(d,"_lazyrias",{value:a,writable:!0})}}function g(a,b){var e=d(a,b);return j.modifyOptions.call(a,{target:a,details:e,detail:e}),c.fire(a,"lazyriasmodifyoptions",e),e}function h(a){return a.getAttribute(a.getAttribute("data-srcattr")||j.srcAttr)||a.getAttribute(i.srcsetAttr)||a.getAttribute(i.srcAttr)||a.getAttribute("data-pfsrcset")||""}var i,j,k={string:1,number:1},l=/^\-*\+*\d+\.*\d*$/,m=/^picture$/i,n=/\s*\{\s*width\s*\}\s*/i,o=/\s*\{\s*height\s*\}\s*/i,p=/\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,q=/^\[.*\]|\{.*\}$/,r=/^(?:auto|\d+(px)?)$/,s=b.createElement("a"),t=b.createElement("img"),u="srcset"in t&&!("sizes"in t),v=!!a.HTMLPictureElement&&!u;!function(){var b,d=function(){},e={prefix:"",postfix:"",srcAttr:"data-src",absUrl:!1,modifyOptions:d,widthmap:{},ratio:!1};i=c&&c.cfg||a.lazySizesConfig,i||(i={},a.lazySizesConfig=i),i.supportsType||(i.supportsType=function(a){return!a}),i.rias||(i.rias={}),j=i.rias,"widths"in j||(j.widths=[],function(a){for(var b,c=0;!b||3e3>b;)c+=5,c>30&&(c+=1),b=36*c,a.push(b)}(j.widths));for(b in e)b in j||(j[b]=e[b])}(),addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c){var b,d,e,k,l,m,o,p,q,s,t,u,x;if(b=a.target,a.detail.dataAttr&&!a.defaultPrevented&&!j.disabled&&(q=b.getAttribute(i.sizesAttr)||b.getAttribute("sizes"))&&r.test(q)){if(d=h(b),e=g(b,d),t=n.test(e.prefix)||n.test(e.postfix),e.isPicture&&(k=b.parentNode))for(l=k.getElementsByTagName("source"),m=0,o=l.length;o>m;m++)(t||n.test(p=h(l[m])))&&(f(p,e,l[m]),u=!0);t||n.test(d)?(f(d,e,b),u=!0):u&&(x=[],x.srcset=[],x.isPicture=!0,Object.defineProperty(b,"_lazyrias",{value:x,writable:!0})),u&&(v?b.removeAttribute(i.srcAttr):"auto"!=q&&(s={width:parseInt(q,10)},w({target:b,detail:s})))}}},!0);var w=function(){var d=function(a,b){return a.w-b.w},e=function(a){var b,c,d=a.length,e=a[d-1],f=0;for(f;d>f;f++)if(e=a[f],e.d=e.w/a.w,e.d>=a.d){!e.cached&&(b=a[f-1])&&b.d>a.d-.13*Math.pow(a.d,2.2)&&(c=Math.pow(b.d-.6,1.6),b.cached&&(b.d+=.15*c),b.d+(e.d-a.d)*c>a.d&&(e=b));break}return e},f=function(a,b){var d;return!a._lazyrias&&c.pWS&&(d=c.pWS(a.getAttribute(i.srcsetAttr||""))).length&&(Object.defineProperty(a,"_lazyrias",{value:d,writable:!0}),b&&a.parentNode&&(d.isPicture="PICTURE"==a.parentNode.nodeName.toUpperCase())),a._lazyrias},g=function(b){var d=a.devicePixelRatio||1,e=c.getX&&c.getX(b);return Math.min(e||d,2.4,d)},h=function(b,c){var h,i,j,k,l,m;if(l=b._lazyrias,l.isPicture&&a.matchMedia)for(i=0,h=b.parentNode.getElementsByTagName("source"),j=h.length;j>i;i++)if(f(h[i])&&!h[i].getAttribute("type")&&(!(k=h[i].getAttribute("media"))||(matchMedia(k)||{}).matches)){l=h[i]._lazyrias;break}return(!l.w||l.w<c)&&(l.w=c,l.d=g(b),m=e(l.sort(d))),m},j=function(d){if(d.detail.instance==c){var e,g=d.target;return!u&&(a.respimage||a.picturefill||lazySizesConfig.pf)?void b.removeEventListener("lazybeforesizes",j):void(("_lazyrias"in g||d.detail.dataAttr&&f(g,!0))&&(e=h(g,d.detail.width),e&&e.u&&g._lazyrias.cur!=e.u&&(g._lazyrias.cur=e.u,e.cached=!0,c.rAF(function(){g.setAttribute(i.srcAttr,e.u),g.setAttribute("src",e.u)}))))}};return v?j=function(){}:addEventListener("lazybeforesizes",j),j}()});
/**
 * Accordion, jQuery Plugin
 *
 * This plugin provides an accordion with cookie support.
 *
 * Copyright (c) 2011 John Snyder (snyderplace.com)
 * @license http://www.snyderplace.com/accordion/license.txt New BSD
 * @version 1.1
 */
(function($) {
    $.fn.accordion = function(options) {

        //firewalling
        if (!this || this.length < 1) {
            return this;
        }

        initialize(this, options);

    };

    //create the initial accordion
    function initialize(obj, options) {

        //build main options before element iteration
        var opts = $.extend({}, $.fn.accordion.defaults, options);

        //store any opened default values to set cookie later
        var opened = '';

        //iterate each matched object, bind, and open/close
        obj.each(function() {
            var $this = $(this);
            saveOpts($this, opts);

            //bind it to the event
            if (opts.bind == 'mouseenter') {
                $this.bind('mouseenter', function(e) {
                    e.preventDefault();
                    toggle($this, opts);
                });
            }

            //bind it to the event
            if (opts.bind == 'mouseover') {
                $this.bind('mouseover',function(e) {
                    e.preventDefault();
                    toggle($this, opts);
                });
            }

            //bind it to the event
            if (opts.bind == 'click') {
                $this.bind('click', function(e) {
                    e.preventDefault();
                    toggle($this, opts);
                });
            }

            //bind it to the event
            if (opts.bind == 'dblclick') {
                $this.bind('dblclick', function(e) {
                    e.preventDefault();
                    toggle($this, opts);
                });
            }

            //initialize the panels
            //get the id for this element
            id = $this.attr('id');

            //if not using cookies, open defaults
            if (!useCookies(opts)) {
                //close it if not defaulted to open
                if (id != opts.defaultOpen) {
                    $this.addClass(opts.cssClose);
                    opts.loadClose($this, opts);
                } else { //its a default open, open it
                    $this.addClass(opts.cssOpen);
                    opts.loadOpen($this, opts);
                    opened = id;
                }
            } else { //can use cookies, use them now
                //has a cookie been set, this overrides default open
                if (issetCookie(opts)) {
                    if (inCookie(id, opts) === false) {
                        $this.addClass(opts.cssClose);
                        opts.loadClose($this, opts);
                    } else {
                        $this.addClass(opts.cssOpen);
                        opts.loadOpen($this, opts);
                        opened = id;
                    }
                } else { //a cookie hasn't been set open defaults
                    if (id != opts.defaultOpen) {
                        $this.addClass(opts.cssClose);
                        opts.loadClose($this, opts);
                    } else { //its a default open, open it
                        $this.addClass(opts.cssOpen);
                        opts.loadOpen($this, opts);
                        opened = id;
                    }
                }
            }
        });

        //now that the loop is done, set the cookie
        if (opened.length > 0 && useCookies(opts)) {
            setCookie(opened, opts);
        } else { //there are none open, set cookie
            setCookie('', opts);
        }

        return obj;
    };

    //load opts from object
    function loadOpts($this) {
        return $this.data('accordion-opts');
    }

    //save opts into object
    function saveOpts($this, opts) {
        return $this.data('accordion-opts', opts);
    }

    //hides a accordion panel
    function close(opts) {
        opened = $(document).find('.' + opts.cssOpen);
        $.each(opened, function() {
            //give the proper class to the linked element
            $(this).addClass(opts.cssClose).removeClass(opts.cssOpen);
            opts.animateClose($(this), opts);
        });
    }

    //opens a accordion panel
    function open($this, opts) {
        close(opts);
        //give the proper class to the linked element
        $this.removeClass(opts.cssClose).addClass(opts.cssOpen);

        //open the element
        opts.animateOpen($this, opts);

        //do cookies if plugin available
        if (useCookies(opts)) {
            // split the cookieOpen string by ","
            id = $this.attr('id');
            setCookie(id, opts);
        }
    }

    //toggle a accordion on an event
    function toggle($this, opts) {
        // close the only open item
        if ($this.hasClass(opts.cssOpen))
        {
            close(opts);
            //do cookies if plugin available
            if (useCookies(opts)) {
                // split the cookieOpen string by ","
                setCookie('', opts);
            }
            return false;
        }
        close(opts);
        //open a closed element
        open($this, opts);
        return false;
    }

    //use cookies?
    function useCookies(opts) {
        //return false if cookie plugin not present or if a cookie name is not provided
        if (!$.cookie || opts.cookieName == '') {
            return false;
        }

        //we can use cookies
        return true;
    }

    //set a cookie
    function setCookie(value, opts)
    {
        //can use the cookie plugin
        if (!useCookies(opts)) { //no, quit here
            return false;
        }

        //cookie plugin is available, lets set the cookie
        $.cookie(opts.cookieName, value, opts.cookieOptions);
    }

    //check if a accordion is in the cookie
    function inCookie(value, opts)
    {
        //can use the cookie plugin
        if (!useCookies(opts)) {
            return false;
        }

        //if its not there we don't need to remove from it
        if (!issetCookie(opts)) { //quit here, don't have a cookie
            return false;
        }

        //unescape it
        cookie = unescape($.cookie(opts.cookieName));

        //is this value in the cookie arrray
        if (cookie != value) { //no, quit here
            return false;
        }

        return true;
    }

    //check if a cookie is set
    function issetCookie(opts)
    {
        //can we use the cookie plugin
        if (!useCookies(opts)) { //no, quit here
            return false;
        }

        //is the cookie set
        if ($.cookie(opts.cookieName) == null) { //no, quit here
            return false;
        }

        return true;
    }

    // settings
    $.fn.accordion.defaults = {
        cssClose: 'accordion-close', //class you want to assign to a closed accordion header
        cssOpen: 'accordion-open', //class you want to assign an opened accordion header
        cookieName: 'accordion', //name of the cookie you want to set for this accordion
        cookieOptions: { //cookie options, see cookie plugin for details
            path: '/',
            expires: 7,
            domain: '',
            secure: ''
        },
        defaultOpen: '', //id that you want opened by default
        speed: 'slow', //speed of the slide effect
        bind: 'click', //event to bind to, supports click, dblclick, mouseover and mouseenter
        animateOpen: function (elem, opts) { //replace the standard slideDown with custom function
            elem.next().stop(true, true).slideDown(opts.speed);
        },
        animateClose: function (elem, opts) { //replace the standard slideUp with custom function
            elem.next().stop(true, true).slideUp(opts.speed);
        },
        loadOpen: function (elem, opts) { //replace the default open state with custom function
            elem.next().show();
        },
        loadClose: function (elem, opts) { //replace the default close state with custom function
            elem.next().hide();
        }
    };
})(jQuery);
/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */ 


if(typeof Currency==="undefined"){var Currency={}}Currency.cookie={configuration:{expires:365,path:"/",domain:window.location.hostname},name:"currency",write:function(a){jQuery.cookie(this.name,a,this.configuration)},read:function(){return jQuery.cookie(this.name)},destroy:function(){jQuery.cookie(this.name,null,this.configuration)}};Currency.moneyFormats={USD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} USD"},EUR:{money_format:"&euro;{{amount}}",money_with_currency_format:"&euro;{{amount}} EUR"},GBP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} GBP"},CAD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} CAD"},ALL:{money_format:"Lek {{amount}}",money_with_currency_format:"Lek {{amount}} ALL"},DZD:{money_format:"DA {{amount}}",money_with_currency_format:"DA {{amount}} DZD"},AOA:{money_format:"Kz{{amount}}",money_with_currency_format:"Kz{{amount}} AOA"},ARS:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} ARS"},AMD:{money_format:"{{amount}} AMD",money_with_currency_format:"{{amount}} AMD"},AWG:{money_format:"Afl{{amount}}",money_with_currency_format:"Afl{{amount}} AWG"},AUD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} AUD"},BBD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} Bds"},AZN:{money_format:"m.{{amount}}",money_with_currency_format:"m.{{amount}} AZN"},BDT:{money_format:"Tk {{amount}}",money_with_currency_format:"Tk {{amount}} BDT"},BSD:{money_format:"BS${{amount}}",money_with_currency_format:"BS${{amount}} BSD"},BHD:{money_format:"{{amount}}0 BD",money_with_currency_format:"{{amount}}0 BHD"},BYR:{money_format:"Br {{amount}}",money_with_currency_format:"Br {{amount}} BYR"},BZD:{money_format:"BZ${{amount}}",money_with_currency_format:"BZ${{amount}} BZD"},BTN:{money_format:"Nu {{amount}}",money_with_currency_format:"Nu {{amount}} BTN"},BAM:{money_format:"KM {{amount_with_comma_separator}}",money_with_currency_format:"KM {{amount_with_comma_separator}} BAM"},BRL:{money_format:"R$ {{amount_with_comma_separator}}",money_with_currency_format:"R$ {{amount_with_comma_separator}} BRL"},BOB:{money_format:"Bs{{amount_with_comma_separator}}",money_with_currency_format:"Bs{{amount_with_comma_separator}} BOB"},BWP:{money_format:"P{{amount}}",money_with_currency_format:"P{{amount}} BWP"},BND:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} BND"},BGN:{money_format:"{{amount}} лв",money_with_currency_format:"{{amount}} лв BGN"},MMK:{money_format:"K{{amount}}",money_with_currency_format:"K{{amount}} MMK"},KHR:{money_format:"KHR{{amount}}",money_with_currency_format:"KHR{{amount}}"},KYD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} KYD"},XAF:{money_format:"FCFA{{amount}}",money_with_currency_format:"FCFA{{amount}} XAF"},CLP:{money_format:"${{amount_no_decimals}}",money_with_currency_format:"${{amount_no_decimals}} CLP"},CNY:{money_format:"&#165;{{amount}}",money_with_currency_format:"&#165;{{amount}} CNY"},COP:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} COP"},CRC:{money_format:"&#8353; {{amount_with_comma_separator}}",money_with_currency_format:"&#8353; {{amount_with_comma_separator}} CRC"},HRK:{money_format:"{{amount_with_comma_separator}} kn",money_with_currency_format:"{{amount_with_comma_separator}} kn HRK"},CZK:{money_format:"{{amount_with_comma_separator}} K&#269;",money_with_currency_format:"{{amount_with_comma_separator}} K&#269;"},DKK:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"kr.{{amount_with_comma_separator}}"},DOP:{money_format:"RD$ {{amount}}",money_with_currency_format:"RD$ {{amount}}"},XCD:{money_format:"${{amount}}",money_with_currency_format:"EC${{amount}}"},EGP:{money_format:"LE {{amount}}",money_with_currency_format:"LE {{amount}} EGP"},ETB:{money_format:"Br{{amount}}",money_with_currency_format:"Br{{amount}} ETB"},XPF:{money_format:"{{amount_no_decimals_with_comma_separator}} XPF",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} XPF"},FJD:{money_format:"${{amount}}",money_with_currency_format:"FJ${{amount}}"},GMD:{money_format:"D {{amount}}",money_with_currency_format:"D {{amount}} GMD"},GHS:{money_format:"GH&#8373;{{amount}}",money_with_currency_format:"GH&#8373;{{amount}}"},GTQ:{money_format:"Q{{amount}}",money_with_currency_format:"{{amount}} GTQ"},GYD:{money_format:"G${{amount}}",money_with_currency_format:"${{amount}} GYD"},GEL:{money_format:"{{amount}} GEL",money_with_currency_format:"{{amount}} GEL"},HNL:{money_format:"L {{amount}}",money_with_currency_format:"L {{amount}} HNL"},HKD:{money_format:"${{amount}}",money_with_currency_format:"HK${{amount}}"},HUF:{money_format:"{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} Ft"},ISK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr ISK"},INR:{money_format:"Rs. {{amount}}",money_with_currency_format:"Rs. {{amount}}"},IDR:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"Rp {{amount_with_comma_separator}}"},ILS:{money_format:"{{amount}} NIS",money_with_currency_format:"{{amount}} NIS"},JMD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} JMD"},JPY:{money_format:"&#165;{{amount_no_decimals}}",money_with_currency_format:"&#165;{{amount_no_decimals}} JPY"},JEP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} JEP"},JOD:{money_format:"{{amount}}0 JD",money_with_currency_format:"{{amount}}0 JOD"},KZT:{money_format:"{{amount}} KZT",money_with_currency_format:"{{amount}} KZT"},KES:{money_format:"KSh{{amount}}",money_with_currency_format:"KSh{{amount}}"},KWD:{money_format:"{{amount}}0 KD",money_with_currency_format:"{{amount}}0 KWD"},KGS:{money_format:"лв{{amount}}",money_with_currency_format:"лв{{amount}}"},LVL:{money_format:"Ls {{amount}}",money_with_currency_format:"Ls {{amount}} LVL"},LBP:{money_format:"L&pound;{{amount}}",money_with_currency_format:"L&pound;{{amount}} LBP"},LTL:{money_format:"{{amount}} Lt",money_with_currency_format:"{{amount}} Lt"},MGA:{money_format:"Ar {{amount}}",money_with_currency_format:"Ar {{amount}} MGA"},MKD:{money_format:"ден {{amount}}",money_with_currency_format:"ден {{amount}} MKD"},MOP:{money_format:"MOP${{amount}}",money_with_currency_format:"MOP${{amount}}"},MVR:{money_format:"Rf{{amount}}",money_with_currency_format:"Rf{{amount}} MRf"},MXN:{money_format:"$ {{amount}}",money_with_currency_format:"$ {{amount}} MXN"},MYR:{money_format:"RM{{amount}} MYR",money_with_currency_format:"RM{{amount}} MYR"},MUR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} MUR"},MDL:{money_format:"{{amount}} MDL",money_with_currency_format:"{{amount}} MDL"},MAD:{money_format:"{{amount}} dh",money_with_currency_format:"Dh {{amount}} MAD"},MNT:{money_format:"{{amount_no_decimals}} &#8366",money_with_currency_format:"{{amount_no_decimals}} MNT"},MZN:{money_format:"{{amount}} Mt",money_with_currency_format:"Mt {{amount}} MZN"},NAD:{money_format:"N${{amount}}",money_with_currency_format:"N${{amount}} NAD"},NPR:{money_format:"Rs{{amount}}",money_with_currency_format:"Rs{{amount}} NPR"},ANG:{money_format:"&fnof;{{amount}}",money_with_currency_format:"{{amount}} NA&fnof;"},NZD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} NZD"},NIO:{money_format:"C${{amount}}",money_with_currency_format:"C${{amount}} NIO"},NGN:{money_format:"&#8358;{{amount}}",money_with_currency_format:"&#8358;{{amount}} NGN"},NOK:{money_format:"kr {{amount_with_comma_separator}}",money_with_currency_format:"kr {{amount_with_comma_separator}} NOK"},OMR:{money_format:"{{amount_with_comma_separator}} OMR",money_with_currency_format:"{{amount_with_comma_separator}} OMR"},PKR:{money_format:"Rs.{{amount}}",money_with_currency_format:"Rs.{{amount}} PKR"},PGK:{money_format:"K {{amount}}",money_with_currency_format:"K {{amount}} PGK"},PYG:{money_format:"Gs. {{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"Gs. {{amount_no_decimals_with_comma_separator}} PYG"},PEN:{money_format:"S/. {{amount}}",money_with_currency_format:"S/. {{amount}} PEN"},PHP:{money_format:"&#8369;{{amount}}",money_with_currency_format:"&#8369;{{amount}} PHP"},PLN:{money_format:"{{amount_with_comma_separator}} zl",money_with_currency_format:"{{amount_with_comma_separator}} zl PLN"},QAR:{money_format:"QAR {{amount_with_comma_separator}}",money_with_currency_format:"QAR {{amount_with_comma_separator}}"},RON:{money_format:"{{amount_with_comma_separator}} lei",money_with_currency_format:"{{amount_with_comma_separator}} lei RON"},RUB:{money_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",money_with_currency_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"},RWF:{money_format:"{{amount_no_decimals}} RF",money_with_currency_format:"{{amount_no_decimals}} RWF"},WST:{money_format:"WS$ {{amount}}",money_with_currency_format:"WS$ {{amount}} WST"},SAR:{money_format:"{{amount}} SR",money_with_currency_format:"{{amount}} SAR"},STD:{money_format:"Db {{amount}}",money_with_currency_format:"Db {{amount}} STD"},RSD:{money_format:"{{amount}} RSD",money_with_currency_format:"{{amount}} RSD"},SCR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} SCR"},SGD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} SGD"},SYP:{money_format:"S&pound;{{amount}}",money_with_currency_format:"S&pound;{{amount}} SYP"},ZAR:{money_format:"R {{amount}}",money_with_currency_format:"R {{amount}} ZAR"},KRW:{money_format:"&#8361;{{amount_no_decimals}}",money_with_currency_format:"&#8361;{{amount_no_decimals}} KRW"},LKR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} LKR"},SEK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr SEK"},CHF:{money_format:"SFr. {{amount}}",money_with_currency_format:"SFr. {{amount}} CHF"},TWD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TWD"},THB:{money_format:"{{amount}} &#xe3f;",money_with_currency_format:"{{amount}} &#xe3f; THB"},TZS:{money_format:"{{amount}} TZS",money_with_currency_format:"{{amount}} TZS"},TTD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TTD"},TND:{money_format:"{{amount}}",money_with_currency_format:"{{amount}} DT"},TRY:{money_format:"{{amount}}TL",money_with_currency_format:"{{amount}}TL"},UGX:{money_format:"Ush {{amount_no_decimals}}",money_with_currency_format:"Ush {{amount_no_decimals}} UGX"},UAH:{money_format:"₴{{amount}}",money_with_currency_format:"₴{{amount}} UAH"},AED:{money_format:"Dhs. {{amount}}",money_with_currency_format:"Dhs. {{amount}} AED"},UYU:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} UYU"},VUV:{money_format:"${{amount}}",money_with_currency_format:"${{amount}}VT"},VEF:{money_format:"Bs. {{amount_with_comma_separator}}",money_with_currency_format:"Bs. {{amount_with_comma_separator}} VEF"},VND:{money_format:"{{amount_no_decimals_with_comma_separator}}&#8363;",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} VND"},XBT:{money_format:"{{amount_no_decimals}} BTC",money_with_currency_format:"{{amount_no_decimals}} BTC"},XOF:{money_format:"CFA{{amount}}",money_with_currency_format:"CFA{{amount}} XOF"},ZMW:{money_format:"K{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"ZMW{{amount_no_decimals_with_comma_separator}}"}};Currency.formatMoney=function(b,g){if(typeof Shopify.formatMoney==="function"){return Shopify.formatMoney(b,g)}if(typeof b=="string"){b=b.replace(".","")}var f="";var e=/\{\{\s*(\w+)\s*\}\}/;var a=g||"${{amount}}";function c(h,i){return(typeof h=="undefined"?i:h)}function d(m,k,l,j){k=c(k,2);l=c(l,",");j=c(j,".");if(isNaN(m)||m==null){return 0}m=(m/100).toFixed(k);var n=m.split("."),i=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+l),h=n[1]?(j+n[1]):"";return i+h}switch(a.match(e)[1]){case"amount":f=d(b,2);break;case"amount_no_decimals":f=d(b,0);break;case"amount_with_comma_separator":f=d(b,2,".",",");break;case"amount_no_decimals_with_comma_separator":f=d(b,0,".",",");break}return a.replace(e,f)};Currency.currentCurrency="";Currency.format="money_with_currency_format";Currency.convertAll=function(c,b,a,d){jQuery(a||"span.money").each(function(){if(jQuery(this).attr("data-currency")===b){return}if(jQuery(this).attr("data-currency-"+b)){jQuery(this).html(jQuery(this).attr("data-currency-"+b))}else{var e=0;var f=Currency.moneyFormats[c][d||Currency.format]||"{{amount}}";var g=Currency.moneyFormats[b][d||Currency.format]||"{{amount}}";if(f.indexOf("amount_no_decimals")!==-1){e=Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10)*100,c,b)}else{if(c==="JOD"||c=="KWD"||c=="BHD"){e=Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10)/10,c,b)}else{e=Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g,""),10),c,b)}}var h=Currency.formatMoney(e,g);jQuery(this).html(h);jQuery(this).attr("data-currency-"+b,h)}jQuery(this).attr("data-currency",b)});this.currentCurrency=b;this.cookie.write(b)};
/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));




/* Modules */ 
// Passive event listeners
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
function customMoney(value, decimal, type) {

	var moneyValue = Math.floor(value * 100);
	if (decimal == false) {
		moneyValue = Math.floor(value);
	}
	if (Shopify.currency.active == 'AUD' ) {
		var moneyCode = Shopify.formatMoney(moneyValue, shop_money);
	} else {
		var moneyCode = Shopify.formatMoney(moneyValue, shop_money_format);
	}	
	var moneyHTML = '<span class="moneys" data-currency="'+Shopify.currency.active+'">'+moneyCode+'</span>'
	if (type == 'static') {
		moneyHTML = '<span class="moneys" data-currency="'+Shopify.currency.active+'" data-market-price="'+moneyValue+'">'+moneyCode+'</span>'
	}

	
	return moneyHTML;
}


window.lazySizesConfig = window.lazySizesConfig || {};


window.lazySizesConfig.expand = 1200;


window.lazySizesConfig.loadMode = 3;


window.lazySizesConfig.ricTimeout = 50;
! function(t) {
    "use strict";

    function e(t) {
        var e = t.length,
            n = i.type(t);
        return "function" !== n && !i.isWindow(t) && (!(1 !== t.nodeType || !e) || "array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
    }
    if (!t.jQuery) {
        var i = function(t, e) {
            return new i.fn.init(t, e)
        };
        i.isWindow = function(t) {
            return t && t === t.window
        }, i.type = function(t) {
            return t ? "object" == typeof t || "function" == typeof t ? o[s.call(t)] || "object" : typeof t : t + ""
        }, i.isArray = Array.isArray || function(t) {
            return "array" === i.type(t)
        }, i.isPlainObject = function(t) {
            var e;
            if (!t || "object" !== i.type(t) || t.nodeType || i.isWindow(t)) return !1;
            try {
                if (t.constructor && !r.call(t, "constructor") && !r.call(t.constructor.prototype, "isPrototypeOf")) return !1
            } catch (t) {
                return !1
            }
            for (e in t);
            return void 0 === e || r.call(t, e)
        }, i.each = function(t, i, n) {
            var o = 0,
                r = t.length,
                s = e(t);
            if (n) {
                if (s)
                    for (; o < r && !1 !== i.apply(t[o], n); o++);
                else
                    for (o in t)
                        if (t.hasOwnProperty(o) && !1 === i.apply(t[o], n)) break
            } else if (s)
                for (; o < r && !1 !== i.call(t[o], o, t[o]); o++);
            else
                for (o in t)
                    if (t.hasOwnProperty(o) && !1 === i.call(t[o], o, t[o])) break;
            return t
        }, i.data = function(t, e, o) {
            if (void 0 === o) {
                var r = t[i.expando],
                    s = r && n[r];
                if (void 0 === e) return s;
                if (s && e in s) return s[e]
            } else if (void 0 !== e) {
                var a = t[i.expando] || (t[i.expando] = ++i.uuid);
                return n[a] = n[a] || {}, n[a][e] = o, o
            }
        }, i.removeData = function(t, e) {
            var o = t[i.expando],
                r = o && n[o];
            r && (e ? i.each(e, function(t, e) {
                delete r[e]
            }) : delete n[o])
        }, i.extend = function() {
            var t, e, n, o, r, s, a = arguments[0] || {},
                l = 1,
                u = arguments.length,
                c = !1;
            for ("boolean" == typeof a && (c = a, a = arguments[l] || {}, l++), "object" != typeof a && "function" !== i.type(a) && (a = {}), l === u && (a = this, l--); l < u; l++)
                if (r = arguments[l])
                    for (o in r) r.hasOwnProperty(o) && (t = a[o], a !== (n = r[o]) && (c && n && (i.isPlainObject(n) || (e = i.isArray(n))) ? (e ? (e = !1, s = t && i.isArray(t) ? t : []) : s = t && i.isPlainObject(t) ? t : {}, a[o] = i.extend(c, s, n)) : void 0 !== n && (a[o] = n)));
            return a
        }, i.queue = function(t, n, o) {
            if (t) {
                n = (n || "fx") + "queue";
                var r = i.data(t, n);
                return o ? (!r || i.isArray(o) ? r = i.data(t, n, function(t, i) {
                    var n = [];
                    return t && (e(Object(t)) ? function(t, e) {
                        for (var i = +e.length, n = 0, o = t.length; n < i;) t[o++] = e[n++];
                        if (i != i)
                            for (; void 0 !== e[n];) t[o++] = e[n++];
                        t.length = o
                    }(n, "string" == typeof t ? [t] : t) : [].push.call(n, t)), n
                }(o)) : r.push(o), r) : r || []
            }
        }, i.dequeue = function(t, e) {
            i.each(t.nodeType ? [t] : t, function(t, n) {
                e = e || "fx";
                var o = i.queue(n, e),
                    r = o.shift();
                "inprogress" === r && (r = o.shift()), r && ("fx" === e && o.unshift("inprogress"), r.call(n, function() {
                    i.dequeue(n, e)
                }))
            })
        }, i.fn = i.prototype = {
            init: function(t) {
                if (t.nodeType) return this[0] = t, this;
                throw new Error("Not a DOM node.")
            },
            offset: function() {
                var e = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {
                    top: 0,
                    left: 0
                };
                return {
                    top: e.top + (t.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
                    left: e.left + (t.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
                }
            },
            position: function() {
                var t = this[0],
                    e = function(t) {
                        for (var e = t.offsetParent; e && "html" !== e.nodeName.toLowerCase() && e.style && "static" === e.style.position;) e = e.offsetParent;
                        return e || document
                    }(t),
                    n = this.offset(),
                    o = /^(?:body|html)$/i.test(e.nodeName) ? {
                        top: 0,
                        left: 0
                    } : i(e).offset();
                return n.top -= parseFloat(t.style.marginTop) || 0, n.left -= parseFloat(t.style.marginLeft) || 0, e.style && (o.top += parseFloat(e.style.borderTopWidth) || 0, o.left += parseFloat(e.style.borderLeftWidth) || 0), {
                    top: n.top - o.top,
                    left: n.left - o.left
                }
            }
        };
        var n = {};
        i.expando = "velocity" + (new Date).getTime(), i.uuid = 0;
        for (var o = {}, r = o.hasOwnProperty, s = o.toString, a = "Boolean Number String Function Array Date RegExp Object Error".split(" "), l = 0; l < a.length; l++) o["[object " + a[l] + "]"] = a[l].toLowerCase();
        i.fn.init.prototype = i.fn, t.Velocity = {
            Utilities: i
        }
    }
}(window),
function(t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : t()
}(function() {
    "use strict";
    return function(t, e, i, n) {
        function o(t) {
            return y.isWrapped(t) ? t = g.call(t) : y.isNode(t) && (t = [t]), t
        }

        function r(t) {
            var e = p.data(t, "velocity");
            return null === e ? n : e
        }

        function s(t, e) {
            var i = r(t);
            i && i.delayTimer && !i.delayPaused && (i.delayRemaining = i.delay - e + i.delayBegin, i.delayPaused = !0, clearTimeout(i.delayTimer.setTimeout))
        }

        function a(t, e) {
            var i = r(t);
            i && i.delayTimer && i.delayPaused && (i.delayPaused = !1, i.delayTimer.setTimeout = setTimeout(i.delayTimer.next, i.delayRemaining))
        }

        function l(t, i, n, o) {
            function r(t, e) {
                return 1 - 3 * e + 3 * t
            }

            function s(t, e) {
                return 3 * e - 6 * t
            }

            function a(t) {
                return 3 * t
            }

            function l(t, e, i) {
                return ((r(e, i) * t + s(e, i)) * t + a(e)) * t
            }

            function u(t, e, i) {
                return 3 * r(e, i) * t * t + 2 * s(e, i) * t + a(e)
            }

            function c(e, i) {
                for (var o = 0; o < h; ++o) {
                    var r = u(i, t, n);
                    if (0 === r) return i;
                    i -= (l(i, t, n) - e) / r
                }
                return i
            }

            function d(e, i, o) {
                var r, s, a = 0;
                do {
                    (r = l(s = i + (o - i) / 2, t, n) - e) > 0 ? o = s : i = s
                } while (Math.abs(r) > m && ++a < g);
                return s
            }

            function p() {
                x = !0, t === i && n === o || function() {
                    for (var e = 0; e < v; ++e) _[e] = l(e * y, t, n)
                }()
            }
            var h = 4,
                f = .001,
                m = 1e-7,
                g = 10,
                v = 11,
                y = 1 / (v - 1),
                w = "Float32Array" in e;
            if (4 !== arguments.length) return !1;
            for (var b = 0; b < 4; ++b)
                if ("number" != typeof arguments[b] || isNaN(arguments[b]) || !isFinite(arguments[b])) return !1;
            t = Math.min(t, 1), n = Math.min(n, 1), t = Math.max(t, 0), n = Math.max(n, 0);
            var _ = w ? new Float32Array(v) : new Array(v),
                x = !1,
                S = function(e) {
                    return x || p(), t === i && n === o ? e : 0 === e ? 0 : 1 === e ? 1 : l(function(e) {
                        for (var i = 0, o = 1, r = v - 1; o !== r && _[o] <= e; ++o) i += y;
                        var s = i + (e - _[--o]) / (_[o + 1] - _[o]) * y,
                            a = u(s, t, n);
                        return a >= f ? c(e, s) : 0 === a ? s : d(e, i, i + y)
                    }(e), i, o)
                };
            S.getControlPoints = function() {
                return [{
                    x: t,
                    y: i
                }, {
                    x: n,
                    y: o
                }]
            };
            var k = "generateBezier(" + [t, i, n, o] + ")";
            return S.toString = function() {
                return k
            }, S
        }

        function u(t, e) {
            var i = t;
            return y.isString(t) ? x.Easings[t] || (i = !1) : i = y.isArray(t) && 1 === t.length ? function(t) {
                return function(e) {
                    return Math.round(e * t) * (1 / t)
                }
            }.apply(null, t) : y.isArray(t) && 2 === t.length ? S.apply(null, t.concat([e])) : !(!y.isArray(t) || 4 !== t.length) && l.apply(null, t), !1 === i && (i = x.Easings[x.defaults.easing] ? x.defaults.easing : _), i
        }

        function c(t) {
            if (t) {
                var e = x.timestamp && !0 !== t ? t : m.now(),
                    i = x.State.calls.length;
                i > 1e4 && (x.State.calls = function(t) {
                    for (var e = -1, i = t ? t.length : 0, n = []; ++e < i;) {
                        var o = t[e];
                        o && n.push(o)
                    }
                    return n
                }(x.State.calls), i = x.State.calls.length);
                for (var o = 0; o < i; o++)
                    if (x.State.calls[o]) {
                        var s = x.State.calls[o],
                            a = s[0],
                            l = s[2],
                            u = s[3],
                            f = !!u,
                            g = null,
                            v = s[5],
                            w = s[6];
                        if (u || (u = x.State.calls[o][3] = e - 16), v) {
                            if (!0 !== v.resume) continue;
                            u = s[3] = Math.round(e - w - 16), s[5] = null
                        }
                        w = s[6] = e - u;
                        for (var b = Math.min(w / l.duration, 1), _ = 0, S = a.length; _ < S; _++) {
                            var C = a[_],
                                I = C.element;
                            if (r(I)) {
                                var $ = !1;
                                if (l.display !== n && null !== l.display && "none" !== l.display) {
                                    if ("flex" === l.display) {
                                        p.each(["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"], function(t, e) {
                                            k.setPropertyValue(I, "display", e)
                                        })
                                    }
                                    k.setPropertyValue(I, "display", l.display)
                                }
                                for (var P in l.visibility !== n && "hidden" !== l.visibility && k.setPropertyValue(I, "visibility", l.visibility), C)
                                    if (C.hasOwnProperty(P) && "element" !== P) {
                                        var L, z = C[P],
                                            E = y.isString(z.easing) ? x.Easings[z.easing] : z.easing;
                                        if (y.isString(z.pattern)) {
                                            var A = 1 === b ? function(t, e, i) {
                                                var n = z.endValue[e];
                                                return i ? Math.round(n) : n
                                            } : function(t, e, i) {
                                                var n = z.startValue[e],
                                                    o = z.endValue[e] - n,
                                                    r = n + o * E(b, l, o);
                                                return i ? Math.round(r) : r
                                            };
                                            L = z.pattern.replace(/{(\d+)(!)?}/g, A)
                                        } else if (1 === b) L = z.endValue;
                                        else {
                                            var V = z.endValue - z.startValue;
                                            L = z.startValue + V * E(b, l, V)
                                        }
                                        if (!f && L === z.currentValue) continue;
                                        if (z.currentValue = L, "tween" === P) g = L;
                                        else {
                                            var O;
                                            if (k.Hooks.registered[P]) {
                                                O = k.Hooks.getRoot(P);
                                                var H = r(I).rootPropertyValueCache[O];
                                                H && (z.rootPropertyValue = H)
                                            }
                                            var M = k.setPropertyValue(I, P, z.currentValue + (h < 9 && 0 === parseFloat(L) ? "" : z.unitType), z.rootPropertyValue, z.scrollData);
                                            k.Hooks.registered[P] && (k.Normalizations.registered[O] ? r(I).rootPropertyValueCache[O] = k.Normalizations.registered[O]("extract", null, M[1]) : r(I).rootPropertyValueCache[O] = M[1]), "transform" === M[0] && ($ = !0)
                                        }
                                    } l.mobileHA && r(I).transformCache.translate3d === n && (r(I).transformCache.translate3d = "(0px, 0px, 0px)", $ = !0), $ && k.flushTransformCache(I)
                            }
                        }
                        l.display !== n && "none" !== l.display && (x.State.calls[o][2].display = !1), l.visibility !== n && "hidden" !== l.visibility && (x.State.calls[o][2].visibility = !1), l.progress && l.progress.call(s[1], s[1], b, Math.max(0, u + l.duration - e), u, g), 1 === b && d(o)
                    }
            }
            x.State.isTicking && T(c)
        }

        function d(t, e) {
            if (!x.State.calls[t]) return !1;
            for (var i = x.State.calls[t][0], o = x.State.calls[t][1], s = x.State.calls[t][2], a = x.State.calls[t][4], l = !1, u = 0, c = i.length; u < c; u++) {
                var d = i[u].element;
                e || s.loop || ("none" === s.display && k.setPropertyValue(d, "display", s.display), "hidden" === s.visibility && k.setPropertyValue(d, "visibility", s.visibility));
                var h = r(d);
                if (!0 !== s.loop && (p.queue(d)[1] === n || !/\.velocityQueueEntryFlag/i.test(p.queue(d)[1])) && h) {
                    h.isAnimating = !1, h.rootPropertyValueCache = {};
                    var f = !1;
                    p.each(k.Lists.transforms3D, function(t, e) {
                        var i = /^scale/.test(e) ? 1 : 0,
                            o = h.transformCache[e];
                        h.transformCache[e] !== n && new RegExp("^\\(" + i + "[^.]").test(o) && (f = !0, delete h.transformCache[e])
                    }), s.mobileHA && (f = !0, delete h.transformCache.translate3d), f && k.flushTransformCache(d), k.Values.removeClass(d, "velocity-animating")
                }
                if (!e && s.complete && !s.loop && u === c - 1) try {
                    s.complete.call(o, o)
                } catch (t) {
                    setTimeout(function() {
                        throw t
                    }, 1)
                }
                a && !0 !== s.loop && a(o), h && !0 === s.loop && !e && (p.each(h.tweensContainer, function(t, e) {
                    if (/^rotate/.test(t) && (parseFloat(e.startValue) - parseFloat(e.endValue)) % 360 == 0) {
                        var i = e.startValue;
                        e.startValue = e.endValue, e.endValue = i
                    }
                    /^backgroundPosition/.test(t) && 100 === parseFloat(e.endValue) && "%" === e.unitType && (e.endValue = 0, e.startValue = 100)
                }), x(d, "reverse", {
                    loop: !0,
                    delay: s.delay
                })), !1 !== s.queue && p.dequeue(d, s.queue)
            }
            x.State.calls[t] = !1;
            for (var m = 0, g = x.State.calls.length; m < g; m++)
                if (!1 !== x.State.calls[m]) {
                    l = !0;
                    break
                }! 1 === l && (x.State.isTicking = !1, delete x.State.calls, x.State.calls = [])
        }
        var p, h = function() {
                if (i.documentMode) return i.documentMode;
                for (var t = 7; t > 4; t--) {
                    var e = i.createElement("div");
                    if (e.innerHTML = "\x3c!--[if IE " + t + "]><span></span><![endif]--\x3e", e.getElementsByTagName("span").length) return e = null, t
                }
                return n
            }(),
            f = function() {
                var t = 0;
                return e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || function(e) {
                    var i, n = (new Date).getTime();
                    return i = Math.max(0, 16 - (n - t)), t = n + i, setTimeout(function() {
                        e(n + i)
                    }, i)
                }
            }(),
            m = function() {
                var t = e.performance || {};
                if ("function" != typeof t.now) {
                    var i = t.timing && t.timing.navigationStart ? t.timing.navigationStart : (new Date).getTime();
                    t.now = function() {
                        return (new Date).getTime() - i
                    }
                }
                return t
            }(),
            g = function() {
                var t = Array.prototype.slice;
                try {
                    return t.call(i.documentElement), t
                } catch (e) {
                    return function(e, i) {
                        var n = this.length;
                        if ("number" != typeof e && (e = 0), "number" != typeof i && (i = n), this.slice) return t.call(this, e, i);
                        var o, r = [],
                            s = e >= 0 ? e : Math.max(0, n + e),
                            a = (i < 0 ? n + i : Math.min(i, n)) - s;
                        if (a > 0)
                            if (r = new Array(a), this.charAt)
                                for (o = 0; o < a; o++) r[o] = this.charAt(s + o);
                            else
                                for (o = 0; o < a; o++) r[o] = this[s + o];
                        return r
                    }
                }
            }(),
            v = function() {
                return Array.prototype.includes ? function(t, e) {
                    return t.includes(e)
                } : Array.prototype.indexOf ? function(t, e) {
                    return t.indexOf(e) >= 0
                } : function(t, e) {
                    for (var i = 0; i < t.length; i++)
                        if (t[i] === e) return !0;
                    return !1
                }
            },
            y = {
                isNumber: function(t) {
                    return "number" == typeof t
                },
                isString: function(t) {
                    return "string" == typeof t
                },
                isArray: Array.isArray || function(t) {
                    return "[object Array]" === Object.prototype.toString.call(t)
                },
                isFunction: function(t) {
                    return "[object Function]" === Object.prototype.toString.call(t)
                },
                isNode: function(t) {
                    return t && t.nodeType
                },
                isWrapped: function(t) {
                    return t && t !== e && y.isNumber(t.length) && !y.isString(t) && !y.isFunction(t) && !y.isNode(t) && (0 === t.length || y.isNode(t[0]))
                },
                isSVG: function(t) {
                    return e.SVGElement && t instanceof e.SVGElement
                },
                isEmptyObject: function(t) {
                    for (var e in t)
                        if (t.hasOwnProperty(e)) return !1;
                    return !0
                }
            },
            w = !1;
        if (t.fn && t.fn.jquery ? (p = t, w = !0) : p = e.Velocity.Utilities, h <= 8 && !w) throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
        if (!(h <= 7)) {
            var b = 400,
                _ = "swing",
                x = {
                    State: {
                        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                        isAndroid: /Android/i.test(navigator.userAgent),
                        isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
                        isChrome: e.chrome,
                        isFirefox: /Firefox/i.test(navigator.userAgent),
                        prefixElement: i.createElement("div"),
                        prefixMatches: {},
                        scrollAnchor: null,
                        scrollPropertyLeft: null,
                        scrollPropertyTop: null,
                        isTicking: !1,
                        calls: [],
                        delayedElements: {
                            count: 0
                        }
                    },
                    CSS: {},
                    Utilities: p,
                    Redirects: {},
                    Easings: {},
                    Promise: e.Promise,
                    defaults: {
                        queue: "",
                        duration: b,
                        easing: _,
                        begin: n,
                        complete: n,
                        progress: n,
                        display: n,
                        visibility: n,
                        loop: !1,
                        delay: !1,
                        mobileHA: !0,
                        _cacheValues: !0,
                        promiseRejectEmpty: !0
                    },
                    init: function(t) {
                        p.data(t, "velocity", {
                            isSVG: y.isSVG(t),
                            isAnimating: !1,
                            computedStyle: null,
                            tweensContainer: null,
                            rootPropertyValueCache: {},
                            transformCache: {}
                        })
                    },
                    hook: null,
                    mock: !1,
                    version: {
                        major: 1,
                        minor: 5,
                        patch: 0
                    },
                    debug: !1,
                    timestamp: !0,
                    pauseAll: function(t) {
                        var e = (new Date).getTime();
                        p.each(x.State.calls, function(e, i) {
                            if (i) {
                                if (t !== n && (i[2].queue !== t || !1 === i[2].queue)) return !0;
                                i[5] = {
                                    resume: !1
                                }
                            }
                        }), p.each(x.State.delayedElements, function(t, i) {
                            i && s(i, e)
                        })
                    },
                    resumeAll: function(t) {
                        (new Date).getTime();
                        p.each(x.State.calls, function(e, i) {
                            if (i) {
                                if (t !== n && (i[2].queue !== t || !1 === i[2].queue)) return !0;
                                i[5] && (i[5].resume = !0)
                            }
                        }), p.each(x.State.delayedElements, function(t, e) {
                            e && a(e)
                        })
                    }
                };
            e.pageYOffset !== n ? (x.State.scrollAnchor = e, x.State.scrollPropertyLeft = "pageXOffset", x.State.scrollPropertyTop = "pageYOffset") : (x.State.scrollAnchor = i.documentElement || i.body.parentNode || i.body, x.State.scrollPropertyLeft = "scrollLeft", x.State.scrollPropertyTop = "scrollTop");
            var S = function() {
                function t(t) {
                    return -t.tension * t.x - t.friction * t.v
                }

                function e(e, i, n) {
                    var o = {
                        x: e.x + n.dx * i,
                        v: e.v + n.dv * i,
                        tension: e.tension,
                        friction: e.friction
                    };
                    return {
                        dx: o.v,
                        dv: t(o)
                    }
                }

                function i(i, n) {
                    var o = {
                            dx: i.v,
                            dv: t(i)
                        },
                        r = e(i, .5 * n, o),
                        s = e(i, .5 * n, r),
                        a = e(i, n, s),
                        l = 1 / 6 * (o.dx + 2 * (r.dx + s.dx) + a.dx),
                        u = 1 / 6 * (o.dv + 2 * (r.dv + s.dv) + a.dv);
                    return i.x = i.x + l * n, i.v = i.v + u * n, i
                }
                return function t(e, n, o) {
                    var r, s, a, l = {
                            x: -1,
                            v: 0,
                            tension: null,
                            friction: null
                        },
                        u = [0],
                        c = 0;
                    for (e = parseFloat(e) || 500, n = parseFloat(n) || 20, o = o || null, l.tension = e, l.friction = n, (r = null !== o) ? s = (c = t(e, n)) / o * .016 : s = .016; a = i(a || l, s), u.push(1 + a.x), c += 16, Math.abs(a.x) > 1e-4 && Math.abs(a.v) > 1e-4;);
                    return r ? function(t) {
                        return u[t * (u.length - 1) | 0]
                    } : c
                }
            }();
            x.Easings = {
                linear: function(t) {
                    return t
                },
                swing: function(t) {
                    return .5 - Math.cos(t * Math.PI) / 2
                },
                spring: function(t) {
                    return 1 - Math.cos(4.5 * t * Math.PI) * Math.exp(6 * -t)
                }
            }, p.each([
                ["ease", [.25, .1, .25, 1]],
                ["ease-in", [.42, 0, 1, 1]],
                ["ease-out", [0, 0, .58, 1]],
                ["ease-in-out", [.42, 0, .58, 1]],
                ["easeInSine", [.47, 0, .745, .715]],
                ["easeOutSine", [.39, .575, .565, 1]],
                ["easeInOutSine", [.445, .05, .55, .95]],
                ["easeInQuad", [.55, .085, .68, .53]],
                ["easeOutQuad", [.25, .46, .45, .94]],
                ["easeInOutQuad", [.455, .03, .515, .955]],
                ["easeInCubic", [.55, .055, .675, .19]],
                ["easeOutCubic", [.215, .61, .355, 1]],
                ["easeInOutCubic", [.645, .045, .355, 1]],
                ["easeInQuart", [.895, .03, .685, .22]],
                ["easeOutQuart", [.165, .84, .44, 1]],
                ["easeInOutQuart", [.77, 0, .175, 1]],
                ["easeInQuint", [.755, .05, .855, .06]],
                ["easeOutQuint", [.23, 1, .32, 1]],
                ["easeInOutQuint", [.86, 0, .07, 1]],
                ["easeInExpo", [.95, .05, .795, .035]],
                ["easeOutExpo", [.19, 1, .22, 1]],
                ["easeInOutExpo", [1, 0, 0, 1]],
                ["easeInCirc", [.6, .04, .98, .335]],
                ["easeOutCirc", [.075, .82, .165, 1]],
                ["easeInOutCirc", [.785, .135, .15, .86]]
            ], function(t, e) {
                x.Easings[e[0]] = l.apply(null, e[1])
            });
            var k = x.CSS = {
                RegEx: {
                    isHex: /^#([A-f\d]{3}){1,2}$/i,
                    valueUnwrap: /^[A-z]+\((.*)\)$/i,
                    wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
                    valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi
                },
                Lists: {
                    colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
                    transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
                    transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
                    units: ["%", "em", "ex", "ch", "rem", "vw", "vh", "vmin", "vmax", "cm", "mm", "Q", "in", "pc", "pt", "px", "deg", "grad", "rad", "turn", "s", "ms"],
                    colorNames: {
                        aliceblue: "240,248,255",
                        antiquewhite: "250,235,215",
                        aquamarine: "127,255,212",
                        aqua: "0,255,255",
                        azure: "240,255,255",
                        beige: "245,245,220",
                        bisque: "255,228,196",
                        black: "0,0,0",
                        blanchedalmond: "255,235,205",
                        blueviolet: "138,43,226",
                        blue: "0,0,255",
                        brown: "165,42,42",
                        burlywood: "222,184,135",
                        cadetblue: "95,158,160",
                        chartreuse: "127,255,0",
                        chocolate: "210,105,30",
                        coral: "255,127,80",
                        cornflowerblue: "100,149,237",
                        cornsilk: "255,248,220",
                        crimson: "220,20,60",
                        cyan: "0,255,255",
                        darkblue: "0,0,139",
                        darkcyan: "0,139,139",
                        darkgoldenrod: "184,134,11",
                        darkgray: "169,169,169",
                        darkgrey: "169,169,169",
                        darkgreen: "0,100,0",
                        darkkhaki: "189,183,107",
                        darkmagenta: "139,0,139",
                        darkolivegreen: "85,107,47",
                        darkorange: "255,140,0",
                        darkorchid: "153,50,204",
                        darkred: "139,0,0",
                        darksalmon: "233,150,122",
                        darkseagreen: "143,188,143",
                        darkslateblue: "72,61,139",
                        darkslategray: "47,79,79",
                        darkturquoise: "0,206,209",
                        darkviolet: "148,0,211",
                        deeppink: "255,20,147",
                        deepskyblue: "0,191,255",
                        dimgray: "105,105,105",
                        dimgrey: "105,105,105",
                        dodgerblue: "30,144,255",
                        firebrick: "178,34,34",
                        floralwhite: "255,250,240",
                        forestgreen: "34,139,34",
                        fuchsia: "255,0,255",
                        gainsboro: "220,220,220",
                        ghostwhite: "248,248,255",
                        gold: "255,215,0",
                        goldenrod: "218,165,32",
                        gray: "128,128,128",
                        grey: "128,128,128",
                        greenyellow: "173,255,47",
                        green: "0,128,0",
                        honeydew: "240,255,240",
                        hotpink: "255,105,180",
                        indianred: "205,92,92",
                        indigo: "75,0,130",
                        ivory: "255,255,240",
                        khaki: "240,230,140",
                        lavenderblush: "255,240,245",
                        lavender: "230,230,250",
                        lawngreen: "124,252,0",
                        lemonchiffon: "255,250,205",
                        lightblue: "173,216,230",
                        lightcoral: "240,128,128",
                        lightcyan: "224,255,255",
                        lightgoldenrodyellow: "250,250,210",
                        lightgray: "211,211,211",
                        lightgrey: "211,211,211",
                        lightgreen: "144,238,144",
                        lightpink: "255,182,193",
                        lightsalmon: "255,160,122",
                        lightseagreen: "32,178,170",
                        lightskyblue: "135,206,250",
                        lightslategray: "119,136,153",
                        lightsteelblue: "176,196,222",
                        lightyellow: "255,255,224",
                        limegreen: "50,205,50",
                        lime: "0,255,0",
                        linen: "250,240,230",
                        magenta: "255,0,255",
                        maroon: "128,0,0",
                        mediumaquamarine: "102,205,170",
                        mediumblue: "0,0,205",
                        mediumorchid: "186,85,211",
                        mediumpurple: "147,112,219",
                        mediumseagreen: "60,179,113",
                        mediumslateblue: "123,104,238",
                        mediumspringgreen: "0,250,154",
                        mediumturquoise: "72,209,204",
                        mediumvioletred: "199,21,133",
                        midnightblue: "25,25,112",
                        mintcream: "245,255,250",
                        mistyrose: "255,228,225",
                        moccasin: "255,228,181",
                        navajowhite: "255,222,173",
                        navy: "0,0,128",
                        oldlace: "253,245,230",
                        olivedrab: "107,142,35",
                        olive: "128,128,0",
                        orangered: "255,69,0",
                        orange: "255,165,0",
                        orchid: "218,112,214",
                        palegoldenrod: "238,232,170",
                        palegreen: "152,251,152",
                        paleturquoise: "175,238,238",
                        palevioletred: "219,112,147",
                        papayawhip: "255,239,213",
                        peachpuff: "255,218,185",
                        peru: "205,133,63",
                        pink: "255,192,203",
                        plum: "221,160,221",
                        powderblue: "176,224,230",
                        purple: "128,0,128",
                        red: "255,0,0",
                        rosybrown: "188,143,143",
                        royalblue: "65,105,225",
                        saddlebrown: "139,69,19",
                        salmon: "250,128,114",
                        sandybrown: "244,164,96",
                        seagreen: "46,139,87",
                        seashell: "255,245,238",
                        sienna: "160,82,45",
                        silver: "192,192,192",
                        skyblue: "135,206,235",
                        slateblue: "106,90,205",
                        slategray: "112,128,144",
                        snow: "255,250,250",
                        springgreen: "0,255,127",
                        steelblue: "70,130,180",
                        tan: "210,180,140",
                        teal: "0,128,128",
                        thistle: "216,191,216",
                        tomato: "255,99,71",
                        turquoise: "64,224,208",
                        violet: "238,130,238",
                        wheat: "245,222,179",
                        whitesmoke: "245,245,245",
                        white: "255,255,255",
                        yellowgreen: "154,205,50",
                        yellow: "255,255,0"
                    }
                },
                Hooks: {
                    templates: {
                        textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
                        boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
                        clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
                        backgroundPosition: ["X Y", "0% 0%"],
                        transformOrigin: ["X Y Z", "50% 50% 0px"],
                        perspectiveOrigin: ["X Y", "50% 50%"]
                    },
                    registered: {},
                    register: function() {
                        for (var t = 0; t < k.Lists.colors.length; t++) {
                            var e = "color" === k.Lists.colors[t] ? "0 0 0 1" : "255 255 255 1";
                            k.Hooks.templates[k.Lists.colors[t]] = ["Red Green Blue Alpha", e]
                        }
                        var i, n, o;
                        if (h)
                            for (i in k.Hooks.templates)
                                if (k.Hooks.templates.hasOwnProperty(i)) {
                                    o = (n = k.Hooks.templates[i])[0].split(" ");
                                    var r = n[1].match(k.RegEx.valueSplit);
                                    "Color" === o[0] && (o.push(o.shift()), r.push(r.shift()), k.Hooks.templates[i] = [o.join(" "), r.join(" ")])
                                } for (i in k.Hooks.templates)
                            if (k.Hooks.templates.hasOwnProperty(i))
                                for (var s in o = (n = k.Hooks.templates[i])[0].split(" "))
                                    if (o.hasOwnProperty(s)) {
                                        var a = i + o[s],
                                            l = s;
                                        k.Hooks.registered[a] = [i, l]
                                    }
                    },
                    getRoot: function(t) {
                        var e = k.Hooks.registered[t];
                        return e ? e[0] : t
                    },
                    getUnit: function(t, e) {
                        var i = (t.substr(e || 0, 5).match(/^[a-z%]+/) || [])[0] || "";
                        return i && v(k.Lists.units, i) ? i : ""
                    },
                    fixColors: function(t) {
                        return t.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function(t, e, i) {
                            return k.Lists.colorNames.hasOwnProperty(i) ? (e || "rgba(") + k.Lists.colorNames[i] + (e ? "" : ",1)") : e + i
                        })
                    },
                    cleanRootPropertyValue: function(t, e) {
                        return k.RegEx.valueUnwrap.test(e) && (e = e.match(k.RegEx.valueUnwrap)[1]), k.Values.isCSSNullValue(e) && (e = k.Hooks.templates[t][1]), e
                    },
                    extractValue: function(t, e) {
                        var i = k.Hooks.registered[t];
                        if (i) {
                            var n = i[0],
                                o = i[1];
                            return (e = k.Hooks.cleanRootPropertyValue(n, e)).toString().match(k.RegEx.valueSplit)[o]
                        }
                        return e
                    },
                    injectValue: function(t, e, i) {
                        var n = k.Hooks.registered[t];
                        if (n) {
                            var o, r = n[0],
                                s = n[1];
                            return (o = (i = k.Hooks.cleanRootPropertyValue(r, i)).toString().match(k.RegEx.valueSplit))[s] = e, o.join(" ")
                        }
                        return i
                    }
                },
                Normalizations: {
                    registered: {
                        clip: function(t, e, i) {
                            switch (t) {
                                case "name":
                                    return "clip";
                                case "extract":
                                    var n;
                                    return k.RegEx.wrappedValueAlreadyExtracted.test(i) ? n = i : n = (n = i.toString().match(k.RegEx.valueUnwrap)) ? n[1].replace(/,(\s+)?/g, " ") : i, n;
                                case "inject":
                                    return "rect(" + i + ")"
                            }
                        },
                        blur: function(t, e, i) {
                            switch (t) {
                                case "name":
                                    return x.State.isFirefox ? "filter" : "-webkit-filter";
                                case "extract":
                                    var n = parseFloat(i);
                                    if (!n && 0 !== n) {
                                        var o = i.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
                                        n = o ? o[1] : 0
                                    }
                                    return n;
                                case "inject":
                                    return parseFloat(i) ? "blur(" + i + ")" : "none"
                            }
                        },
                        opacity: function(t, e, i) {
                            if (h <= 8) switch (t) {
                                case "name":
                                    return "filter";
                                case "extract":
                                    var n = i.toString().match(/alpha\(opacity=(.*)\)/i);
                                    return n ? n[1] / 100 : 1;
                                case "inject":
                                    return e.style.zoom = 1, parseFloat(i) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(i), 10) + ")"
                            } else switch (t) {
                                case "name":
                                    return "opacity";
                                case "extract":
                                case "inject":
                                    return i
                            }
                        }
                    },
                    register: function() {
                        function t(t, e, i) {
                            if ("border-box" === k.getPropertyValue(e, "boxSizing").toString().toLowerCase() === (i || !1)) {
                                var n, o, r = 0,
                                    s = "width" === t ? ["Left", "Right"] : ["Top", "Bottom"],
                                    a = ["padding" + s[0], "padding" + s[1], "border" + s[0] + "Width", "border" + s[1] + "Width"];
                                for (n = 0; n < a.length; n++) o = parseFloat(k.getPropertyValue(e, a[n])), isNaN(o) || (r += o);
                                return i ? -r : r
                            }
                            return 0
                        }

                        function e(e, i) {
                            return function(n, o, r) {
                                switch (n) {
                                    case "name":
                                        return e;
                                    case "extract":
                                        return parseFloat(r) + t(e, o, i);
                                    case "inject":
                                        return parseFloat(r) - t(e, o, i) + "px"
                                }
                            }
                        }
                        h && !(h > 9) || x.State.isGingerbread || (k.Lists.transformsBase = k.Lists.transformsBase.concat(k.Lists.transforms3D));
                        for (var i = 0; i < k.Lists.transformsBase.length; i++) ! function() {
                            var t = k.Lists.transformsBase[i];
                            k.Normalizations.registered[t] = function(e, i, o) {
                                switch (e) {
                                    case "name":
                                        return "transform";
                                    case "extract":
                                        return r(i) === n || r(i).transformCache[t] === n ? /^scale/i.test(t) ? 1 : 0 : r(i).transformCache[t].replace(/[()]/g, "");
                                    case "inject":
                                        var s = !1;
                                        switch (t.substr(0, t.length - 1)) {
                                            case "translate":
                                                s = !/(%|px|em|rem|vw|vh|\d)$/i.test(o);
                                                break;
                                            case "scal":
                                            case "scale":
                                                x.State.isAndroid && r(i).transformCache[t] === n && o < 1 && (o = 1), s = !/(\d)$/i.test(o);
                                                break;
                                            case "skew":
                                            case "rotate":
                                                s = !/(deg|\d)$/i.test(o)
                                        }
                                        return s || (r(i).transformCache[t] = "(" + o + ")"), r(i).transformCache[t]
                                }
                            }
                        }();
                        for (var o = 0; o < k.Lists.colors.length; o++) ! function() {
                            var t = k.Lists.colors[o];
                            k.Normalizations.registered[t] = function(e, i, o) {
                                switch (e) {
                                    case "name":
                                        return t;
                                    case "extract":
                                        var r;
                                        if (k.RegEx.wrappedValueAlreadyExtracted.test(o)) r = o;
                                        else {
                                            var s, a = {
                                                black: "rgb(0, 0, 0)",
                                                blue: "rgb(0, 0, 255)",
                                                gray: "rgb(128, 128, 128)",
                                                green: "rgb(0, 128, 0)",
                                                red: "rgb(255, 0, 0)",
                                                white: "rgb(255, 255, 255)"
                                            };
                                            /^[A-z]+$/i.test(o) ? s = a[o] !== n ? a[o] : a.black : k.RegEx.isHex.test(o) ? s = "rgb(" + k.Values.hexToRgb(o).join(" ") + ")" : /^rgba?\(/i.test(o) || (s = a.black), r = (s || o).toString().match(k.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ")
                                        }
                                        return (!h || h > 8) && 3 === r.split(" ").length && (r += " 1"), r;
                                    case "inject":
                                        return /^rgb/.test(o) ? o : (h <= 8 ? 4 === o.split(" ").length && (o = o.split(/\s+/).slice(0, 3).join(" ")) : 3 === o.split(" ").length && (o += " 1"), (h <= 8 ? "rgb" : "rgba") + "(" + o.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")")
                                }
                            }
                        }();
                        k.Normalizations.registered.innerWidth = e("width", !0), k.Normalizations.registered.innerHeight = e("height", !0), k.Normalizations.registered.outerWidth = e("width"), k.Normalizations.registered.outerHeight = e("height")
                    }
                },
                Names: {
                    camelCase: function(t) {
                        return t.replace(/-(\w)/g, function(t, e) {
                            return e.toUpperCase()
                        })
                    },
                    SVGAttribute: function(t) {
                        var e = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
                        return (h || x.State.isAndroid && !x.State.isChrome) && (e += "|transform"), new RegExp("^(" + e + ")$", "i").test(t)
                    },
                    prefixCheck: function(t) {
                        if (x.State.prefixMatches[t]) return [x.State.prefixMatches[t], !0];
                        for (var e = ["", "Webkit", "Moz", "ms", "O"], i = 0, n = e.length; i < n; i++) {
                            var o;
                            if (o = 0 === i ? t : e[i] + t.replace(/^\w/, function(t) {
                                    return t.toUpperCase()
                                }), y.isString(x.State.prefixElement.style[o])) return x.State.prefixMatches[t] = o, [o, !0]
                        }
                        return [t, !1]
                    }
                },
                Values: {
                    hexToRgb: function(t) {
                        var e;
                        return t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(t, e, i, n) {
                            return e + e + i + i + n + n
                        }), (e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t)) ? [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)] : [0, 0, 0]
                    },
                    isCSSNullValue: function(t) {
                        return !t || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(t)
                    },
                    getUnitType: function(t) {
                        return /^(rotate|skew)/i.test(t) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(t) ? "" : "px"
                    },
                    getDisplayType: function(t) {
                        var e = t && t.tagName.toString().toLowerCase();
                        return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(e) ? "inline" : /^(li)$/i.test(e) ? "list-item" : /^(tr)$/i.test(e) ? "table-row" : /^(table)$/i.test(e) ? "table" : /^(tbody)$/i.test(e) ? "table-row-group" : "block"
                    },
                    addClass: function(t, e) {
                        if (t)
                            if (t.classList) t.classList.add(e);
                            else if (y.isString(t.className)) t.className += (t.className.length ? " " : "") + e;
                        else {
                            var i = t.getAttribute(h <= 7 ? "className" : "class") || "";
                            t.setAttribute("class", i + (i ? " " : "") + e)
                        }
                    },
                    removeClass: function(t, e) {
                        if (t)
                            if (t.classList) t.classList.remove(e);
                            else if (y.isString(t.className)) t.className = t.className.toString().replace(new RegExp("(^|\\s)" + e.split(" ").join("|") + "(\\s|$)", "gi"), " ");
                        else {
                            var i = t.getAttribute(h <= 7 ? "className" : "class") || "";
                            t.setAttribute("class", i.replace(new RegExp("(^|s)" + e.split(" ").join("|") + "(s|$)", "gi"), " "))
                        }
                    }
                },
                getPropertyValue: function(t, i, o, s) {
                    function a(t, i) {
                        var o = 0;
                        if (h <= 8) o = p.css(t, i);
                        else {
                            var l = !1;
                            /^(width|height)$/.test(i) && 0 === k.getPropertyValue(t, "display") && (l = !0, k.setPropertyValue(t, "display", k.Values.getDisplayType(t)));
                            var u, c = function() {
                                l && k.setPropertyValue(t, "display", "none")
                            };
                            if (!s) {
                                if ("height" === i && "border-box" !== k.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                                    var d = t.offsetHeight - (parseFloat(k.getPropertyValue(t, "borderTopWidth")) || 0) - (parseFloat(k.getPropertyValue(t, "borderBottomWidth")) || 0) - (parseFloat(k.getPropertyValue(t, "paddingTop")) || 0) - (parseFloat(k.getPropertyValue(t, "paddingBottom")) || 0);
                                    return c(), d
                                }
                                if ("width" === i && "border-box" !== k.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                                    var f = t.offsetWidth - (parseFloat(k.getPropertyValue(t, "borderLeftWidth")) || 0) - (parseFloat(k.getPropertyValue(t, "borderRightWidth")) || 0) - (parseFloat(k.getPropertyValue(t, "paddingLeft")) || 0) - (parseFloat(k.getPropertyValue(t, "paddingRight")) || 0);
                                    return c(), f
                                }
                            }
                            u = r(t) === n ? e.getComputedStyle(t, null) : r(t).computedStyle ? r(t).computedStyle : r(t).computedStyle = e.getComputedStyle(t, null), "borderColor" === i && (i = "borderTopColor"), "" !== (o = 9 === h && "filter" === i ? u.getPropertyValue(i) : u[i]) && null !== o || (o = t.style[i]), c()
                        }
                        if ("auto" === o && /^(top|right|bottom|left)$/i.test(i)) {
                            var m = a(t, "position");
                            ("fixed" === m || "absolute" === m && /top|left/i.test(i)) && (o = p(t).position()[i] + "px")
                        }
                        return o
                    }
                    var l;
                    if (k.Hooks.registered[i]) {
                        var u = i,
                            c = k.Hooks.getRoot(u);
                        o === n && (o = k.getPropertyValue(t, k.Names.prefixCheck(c)[0])), k.Normalizations.registered[c] && (o = k.Normalizations.registered[c]("extract", t, o)), l = k.Hooks.extractValue(u, o)
                    } else if (k.Normalizations.registered[i]) {
                        var d, f;
                        "transform" !== (d = k.Normalizations.registered[i]("name", t)) && (f = a(t, k.Names.prefixCheck(d)[0]), k.Values.isCSSNullValue(f) && k.Hooks.templates[i] && (f = k.Hooks.templates[i][1])), l = k.Normalizations.registered[i]("extract", t, f)
                    }
                    if (!/^[\d-]/.test(l)) {
                        var m = r(t);
                        if (m && m.isSVG && k.Names.SVGAttribute(i))
                            if (/^(height|width)$/i.test(i)) try {
                                l = t.getBBox()[i]
                            } catch (t) {
                                l = 0
                            } else l = t.getAttribute(i);
                            else l = a(t, k.Names.prefixCheck(i)[0])
                    }
                    return k.Values.isCSSNullValue(l) && (l = 0), x.debug >= 2 && console.log("Get " + i + ": " + l), l
                },
                setPropertyValue: function(t, i, n, o, s) {
                    var a = i;
                    if ("scroll" === i) s.container ? s.container["scroll" + s.direction] = n : "Left" === s.direction ? e.scrollTo(n, s.alternateValue) : e.scrollTo(s.alternateValue, n);
                    else if (k.Normalizations.registered[i] && "transform" === k.Normalizations.registered[i]("name", t)) k.Normalizations.registered[i]("inject", t, n), a = "transform", n = r(t).transformCache[i];
                    else {
                        if (k.Hooks.registered[i]) {
                            var l = i,
                                u = k.Hooks.getRoot(i);
                            o = o || k.getPropertyValue(t, u), n = k.Hooks.injectValue(l, n, o), i = u
                        }
                        if (k.Normalizations.registered[i] && (n = k.Normalizations.registered[i]("inject", t, n), i = k.Normalizations.registered[i]("name", t)), a = k.Names.prefixCheck(i)[0], h <= 8) try {
                            t.style[a] = n
                        } catch (t) {
                            x.debug && console.log("Browser does not support [" + n + "] for [" + a + "]")
                        } else {
                            var c = r(t);
                            c && c.isSVG && k.Names.SVGAttribute(i) ? t.setAttribute(i, n) : t.style[a] = n
                        }
                        x.debug >= 2 && console.log("Set " + i + " (" + a + "): " + n)
                    }
                    return [a, n]
                },
                flushTransformCache: function(t) {
                    var e = "",
                        i = r(t);
                    if ((h || x.State.isAndroid && !x.State.isChrome) && i && i.isSVG) {
                        var n = function(e) {
                                return parseFloat(k.getPropertyValue(t, e))
                            },
                            o = {
                                translate: [n("translateX"), n("translateY")],
                                skewX: [n("skewX")],
                                skewY: [n("skewY")],
                                scale: 1 !== n("scale") ? [n("scale"), n("scale")] : [n("scaleX"), n("scaleY")],
                                rotate: [n("rotateZ"), 0, 0]
                            };
                        p.each(r(t).transformCache, function(t) {
                            /^translate/i.test(t) ? t = "translate" : /^scale/i.test(t) ? t = "scale" : /^rotate/i.test(t) && (t = "rotate"), o[t] && (e += t + "(" + o[t].join(" ") + ") ", delete o[t])
                        })
                    } else {
                        var s, a;
                        p.each(r(t).transformCache, function(i) {
                            if (s = r(t).transformCache[i], "transformPerspective" === i) return a = s, !0;
                            9 === h && "rotateZ" === i && (i = "rotate"), e += i + s + " "
                        }), a && (e = "perspective" + a + " " + e)
                    }
                    k.setPropertyValue(t, "transform", e)
                }
            };
            k.Hooks.register(), k.Normalizations.register(), x.hook = function(t, e, i) {
                var s;
                return t = o(t), p.each(t, function(t, o) {
                    if (r(o) === n && x.init(o), i === n) s === n && (s = k.getPropertyValue(o, e));
                    else {
                        var a = k.setPropertyValue(o, e, i);
                        "transform" === a[0] && x.CSS.flushTransformCache(o), s = a
                    }
                }), s
            };
            var C = function() {
                function t() {
                    return f ? I.promise || null : m
                }

                function l(t, o) {
                    function s(s) {
                        var h, f;
                        if (l.begin && 0 === L) try {
                            l.begin.call(w, w)
                        } catch (t) {
                            setTimeout(function() {
                                throw t
                            }, 1)
                        }
                        if ("scroll" === $) {
                            var m, g, b, C = /^x$/i.test(l.axis) ? "Left" : "Top",
                                T = parseFloat(l.offset) || 0;
                            l.container ? y.isWrapped(l.container) || y.isNode(l.container) ? (l.container = l.container[0] || l.container, b = (m = l.container["scroll" + C]) + p(t).position()[C.toLowerCase()] + T) : l.container = null : (m = x.State.scrollAnchor[x.State["scrollProperty" + C]], g = x.State.scrollAnchor[x.State["scrollProperty" + ("Left" === C ? "Top" : "Left")]], b = p(t).offset()[C.toLowerCase()] + T), d = {
                                scroll: {
                                    rootPropertyValue: !1,
                                    startValue: m,
                                    currentValue: m,
                                    endValue: b,
                                    unitType: "",
                                    easing: l.easing,
                                    scrollData: {
                                        container: l.container,
                                        direction: C,
                                        alternateValue: g
                                    }
                                },
                                element: t
                            }, x.debug && console.log("tweensContainer (scroll): ", d.scroll, t)
                        } else if ("reverse" === $) {
                            if (!(h = r(t))) return;
                            if (!h.tweensContainer) return void p.dequeue(t, l.queue);
                            for (var z in "none" === h.opts.display && (h.opts.display = "auto"), "hidden" === h.opts.visibility && (h.opts.visibility = "visible"), h.opts.loop = !1, h.opts.begin = null, h.opts.complete = null, S.easing || delete l.easing, S.duration || delete l.duration, l = p.extend({}, h.opts, l), f = p.extend(!0, {}, h ? h.tweensContainer : null))
                                if (f.hasOwnProperty(z) && "element" !== z) {
                                    var E = f[z].startValue;
                                    f[z].startValue = f[z].currentValue = f[z].endValue, f[z].endValue = E, y.isEmptyObject(S) || (f[z].easing = l.easing), x.debug && console.log("reverse tweensContainer (" + z + "): " + JSON.stringify(f[z]), t)
                                } d = f
                        } else if ("start" === $) {
                            (h = r(t)) && h.tweensContainer && !0 === h.isAnimating && (f = h.tweensContainer);
                            var A = function(o, r) {
                                var s, u = k.Hooks.getRoot(o),
                                    c = !1,
                                    m = r[0],
                                    g = r[1],
                                    v = r[2];
                                if (h && h.isSVG || "tween" === u || !1 !== k.Names.prefixCheck(u)[1] || k.Normalizations.registered[u] !== n) {
                                    (l.display !== n && null !== l.display && "none" !== l.display || l.visibility !== n && "hidden" !== l.visibility) && /opacity|filter/.test(o) && !v && 0 !== m && (v = 0), l._cacheValues && f && f[o] ? (v === n && (v = f[o].endValue + f[o].unitType), c = h.rootPropertyValueCache[u]) : k.Hooks.registered[o] ? v === n ? (c = k.getPropertyValue(t, u), v = k.getPropertyValue(t, o, c)) : c = k.Hooks.templates[u][1] : v === n && (v = k.getPropertyValue(t, o));
                                    var w, b, _, S = !1,
                                        C = function(t, e) {
                                            var i, n;
                                            return n = (e || "0").toString().toLowerCase().replace(/[%A-z]+$/, function(t) {
                                                return i = t, ""
                                            }), i || (i = k.Values.getUnitType(t)), [n, i]
                                        };
                                    if (v !== m && y.isString(v) && y.isString(m)) {
                                        s = "";
                                        var T = 0,
                                            I = 0,
                                            $ = [],
                                            P = [],
                                            L = 0,
                                            z = 0,
                                            E = 0;
                                        for (v = k.Hooks.fixColors(v), m = k.Hooks.fixColors(m); T < v.length && I < m.length;) {
                                            var A = v[T],
                                                V = m[I];
                                            if (/[\d\.-]/.test(A) && /[\d\.-]/.test(V)) {
                                                for (var O = A, H = V, F = ".", j = "."; ++T < v.length;) {
                                                    if ((A = v[T]) === F) F = "..";
                                                    else if (!/\d/.test(A)) break;
                                                    O += A
                                                }
                                                for (; ++I < m.length;) {
                                                    if ((V = m[I]) === j) j = "..";
                                                    else if (!/\d/.test(V)) break;
                                                    H += V
                                                }
                                                var N = k.Hooks.getUnit(v, T),
                                                    R = k.Hooks.getUnit(m, I);
                                                if (T += N.length, I += R.length, N === R) O === H ? s += O + N : (s += "{" + $.length + (z ? "!" : "") + "}" + N, $.push(parseFloat(O)), P.push(parseFloat(H)));
                                                else {
                                                    var W = parseFloat(O),
                                                        q = parseFloat(H);
                                                    s += (L < 5 ? "calc" : "") + "(" + (W ? "{" + $.length + (z ? "!" : "") + "}" : "0") + N + " + " + (q ? "{" + ($.length + (W ? 1 : 0)) + (z ? "!" : "") + "}" : "0") + R + ")", W && ($.push(W), P.push(0)), q && ($.push(0), P.push(q))
                                                }
                                            } else {
                                                if (A !== V) {
                                                    L = 0;
                                                    break
                                                }
                                                s += A, T++, I++, 0 === L && "c" === A || 1 === L && "a" === A || 2 === L && "l" === A || 3 === L && "c" === A || L >= 4 && "(" === A ? L++ : (L && L < 5 || L >= 4 && ")" === A && --L < 5) && (L = 0), 0 === z && "r" === A || 1 === z && "g" === A || 2 === z && "b" === A || 3 === z && "a" === A || z >= 3 && "(" === A ? (3 === z && "a" === A && (E = 1), z++) : E && "," === A ? ++E > 3 && (z = E = 0) : (E && z < (E ? 5 : 4) || z >= (E ? 4 : 3) && ")" === A && --z < (E ? 5 : 4)) && (z = E = 0)
                                            }
                                        }
                                        T === v.length && I === m.length || (x.debug && console.error('Trying to pattern match mis-matched strings ["' + m + '", "' + v + '"]'), s = n), s && ($.length ? (x.debug && console.log('Pattern found "' + s + '" -> ', $, P, "[" + v + "," + m + "]"), v = $, m = P, b = _ = "") : s = n)
                                    }
                                    if (s || (v = (w = C(o, v))[0], _ = w[1], m = (w = C(o, m))[0].replace(/^([+-\/*])=/, function(t, e) {
                                            return S = e, ""
                                        }), b = w[1], v = parseFloat(v) || 0, m = parseFloat(m) || 0, "%" === b && (/^(fontSize|lineHeight)$/.test(o) ? (m /= 100, b = "em") : /^scale/.test(o) ? (m /= 100, b = "") : /(Red|Green|Blue)$/i.test(o) && (m = m / 100 * 255, b = ""))), /[\/*]/.test(S)) b = _;
                                    else if (_ !== b && 0 !== v)
                                        if (0 === m) b = _;
                                        else {
                                            a = a || function() {
                                                var n = {
                                                        myParent: t.parentNode || i.body,
                                                        position: k.getPropertyValue(t, "position"),
                                                        fontSize: k.getPropertyValue(t, "fontSize")
                                                    },
                                                    o = n.position === M.lastPosition && n.myParent === M.lastParent,
                                                    r = n.fontSize === M.lastFontSize;
                                                M.lastParent = n.myParent, M.lastPosition = n.position, M.lastFontSize = n.fontSize;
                                                var s = {};
                                                if (r && o) s.emToPx = M.lastEmToPx, s.percentToPxWidth = M.lastPercentToPxWidth, s.percentToPxHeight = M.lastPercentToPxHeight;
                                                else {
                                                    var a = h && h.isSVG ? i.createElementNS("http://www.w3.org/2000/svg", "rect") : i.createElement("div");
                                                    x.init(a), n.myParent.appendChild(a), p.each(["overflow", "overflowX", "overflowY"], function(t, e) {
                                                        x.CSS.setPropertyValue(a, e, "hidden")
                                                    }), x.CSS.setPropertyValue(a, "position", n.position), x.CSS.setPropertyValue(a, "fontSize", n.fontSize), x.CSS.setPropertyValue(a, "boxSizing", "content-box"), p.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(t, e) {
                                                        x.CSS.setPropertyValue(a, e, "100%")
                                                    }), x.CSS.setPropertyValue(a, "paddingLeft", "100em"), s.percentToPxWidth = M.lastPercentToPxWidth = (parseFloat(k.getPropertyValue(a, "width", null, !0)) || 1) / 100, s.percentToPxHeight = M.lastPercentToPxHeight = (parseFloat(k.getPropertyValue(a, "height", null, !0)) || 1) / 100, s.emToPx = M.lastEmToPx = (parseFloat(k.getPropertyValue(a, "paddingLeft")) || 1) / 100, n.myParent.removeChild(a)
                                                }
                                                return null === M.remToPx && (M.remToPx = parseFloat(k.getPropertyValue(i.body, "fontSize")) || 16), null === M.vwToPx && (M.vwToPx = parseFloat(e.innerWidth) / 100, M.vhToPx = parseFloat(e.innerHeight) / 100), s.remToPx = M.remToPx, s.vwToPx = M.vwToPx, s.vhToPx = M.vhToPx, x.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(s), t), s
                                            }();
                                            var B = /margin|padding|left|right|width|text|word|letter/i.test(o) || /X$/.test(o) || "x" === o ? "x" : "y";
                                            switch (_) {
                                                case "%":
                                                    v *= "x" === B ? a.percentToPxWidth : a.percentToPxHeight;
                                                    break;
                                                case "px":
                                                    break;
                                                default:
                                                    v *= a[_ + "ToPx"]
                                            }
                                            switch (b) {
                                                case "%":
                                                    v *= 1 / ("x" === B ? a.percentToPxWidth : a.percentToPxHeight);
                                                    break;
                                                case "px":
                                                    break;
                                                default:
                                                    v *= 1 / a[b + "ToPx"]
                                            }
                                        } switch (S) {
                                        case "+":
                                            m = v + m;
                                            break;
                                        case "-":
                                            m = v - m;
                                            break;
                                        case "*":
                                            m *= v;
                                            break;
                                        case "/":
                                            m = v / m
                                    }
                                    d[o] = {
                                        rootPropertyValue: c,
                                        startValue: v,
                                        currentValue: v,
                                        endValue: m,
                                        unitType: b,
                                        easing: g
                                    }, s && (d[o].pattern = s), x.debug && console.log("tweensContainer (" + o + "): " + JSON.stringify(d[o]), t)
                                } else x.debug && console.log("Skipping [" + u + "] due to a lack of browser support.")
                            };
                            for (var V in _)
                                if (_.hasOwnProperty(V)) {
                                    var O = k.Names.camelCase(V),
                                        H = function(e, i) {
                                            var n, r, s;
                                            return y.isFunction(e) && (e = e.call(t, o, P)), y.isArray(e) ? (n = e[0], !y.isArray(e[1]) && /^[\d-]/.test(e[1]) || y.isFunction(e[1]) || k.RegEx.isHex.test(e[1]) ? s = e[1] : y.isString(e[1]) && !k.RegEx.isHex.test(e[1]) && x.Easings[e[1]] || y.isArray(e[1]) ? (r = u(e[1], l.duration), s = e[2]) : s = e[1] || e[2]) : n = e, r = r || l.easing, y.isFunction(n) && (n = n.call(t, o, P)), y.isFunction(s) && (s = s.call(t, o, P)), [n || 0, r, s]
                                        }(_[V]);
                                    if (v(k.Lists.colors, O)) {
                                        var j = H[0],
                                            N = H[1],
                                            R = H[2];
                                        if (k.RegEx.isHex.test(j)) {
                                            for (var W = ["Red", "Green", "Blue"], q = k.Values.hexToRgb(j), B = R ? k.Values.hexToRgb(R) : n, D = 0; D < W.length; D++) {
                                                var U = [q[D]];
                                                N && U.push(N), B !== n && U.push(B[D]), A(O + W[D], U)
                                            }
                                            continue
                                        }
                                    }
                                    A(O, H)
                                } d.element = t
                        }
                        d.element && (k.Values.addClass(t, "velocity-animating"), F.push(d), (h = r(t)) && ("" === l.queue && (h.tweensContainer = d, h.opts = l), h.isAnimating = !0), L === P - 1 ? (x.State.calls.push([F, w, l, null, I.resolver, null, 0]), !1 === x.State.isTicking && (x.State.isTicking = !0, c())) : L++)
                    }
                    var a, l = p.extend({}, x.defaults, S),
                        d = {};
                    switch (r(t) === n && x.init(t), parseFloat(l.delay) && !1 !== l.queue && p.queue(t, l.queue, function(e) {
                            x.velocityQueueEntryFlag = !0;
                            var i = x.State.delayedElements.count++;
                            x.State.delayedElements[i] = t;
                            var n = function(t) {
                                return function() {
                                    x.State.delayedElements[t] = !1, e()
                                }
                            }(i);
                            r(t).delayBegin = (new Date).getTime(), r(t).delay = parseFloat(l.delay), r(t).delayTimer = {
                                setTimeout: setTimeout(e, parseFloat(l.delay)),
                                next: n
                            }
                        }), l.duration.toString().toLowerCase()) {
                        case "fast":
                            l.duration = 200;
                            break;
                        case "normal":
                            l.duration = b;
                            break;
                        case "slow":
                            l.duration = 600;
                            break;
                        default:
                            l.duration = parseFloat(l.duration) || 1
                    }
                    if (!1 !== x.mock && (!0 === x.mock ? l.duration = l.delay = 1 : (l.duration *= parseFloat(x.mock) || 1, l.delay *= parseFloat(x.mock) || 1)), l.easing = u(l.easing, l.duration), l.begin && !y.isFunction(l.begin) && (l.begin = null), l.progress && !y.isFunction(l.progress) && (l.progress = null), l.complete && !y.isFunction(l.complete) && (l.complete = null), l.display !== n && null !== l.display && (l.display = l.display.toString().toLowerCase(), "auto" === l.display && (l.display = x.CSS.Values.getDisplayType(t))), l.visibility !== n && null !== l.visibility && (l.visibility = l.visibility.toString().toLowerCase()), l.mobileHA = l.mobileHA && x.State.isMobile && !x.State.isGingerbread, !1 === l.queue)
                        if (l.delay) {
                            var h = x.State.delayedElements.count++;
                            x.State.delayedElements[h] = t;
                            var f = function(t) {
                                return function() {
                                    x.State.delayedElements[t] = !1, s()
                                }
                            }(h);
                            r(t).delayBegin = (new Date).getTime(), r(t).delay = parseFloat(l.delay), r(t).delayTimer = {
                                setTimeout: setTimeout(s, parseFloat(l.delay)),
                                next: f
                            }
                        } else s();
                    else p.queue(t, l.queue, function(t, e) {
                        if (!0 === e) return I.promise && I.resolver(w), !0;
                        x.velocityQueueEntryFlag = !0, s()
                    });
                    "" !== l.queue && "fx" !== l.queue || "inprogress" === p.queue(t)[0] || p.dequeue(t)
                }
                var h, f, m, g, w, _, S, T = arguments[0] && (arguments[0].p || p.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || y.isString(arguments[0].properties));
                y.isWrapped(this) ? (f = !1, g = 0, w = this, m = this) : (f = !0, g = 1, w = T ? arguments[0].elements || arguments[0].e : arguments[0]);
                var I = {
                    promise: null,
                    resolver: null,
                    rejecter: null
                };
                if (f && x.Promise && (I.promise = new x.Promise(function(t, e) {
                        I.resolver = t, I.rejecter = e
                    })), T ? (_ = arguments[0].properties || arguments[0].p, S = arguments[0].options || arguments[0].o) : (_ = arguments[g], S = arguments[g + 1]), w = o(w)) {
                    var $, P = w.length,
                        L = 0;
                    if (!/^(stop|finish|finishAll|pause|resume)$/i.test(_) && !p.isPlainObject(S)) {
                        S = {};
                        for (var z = g + 1; z < arguments.length; z++) y.isArray(arguments[z]) || !/^(fast|normal|slow)$/i.test(arguments[z]) && !/^\d/.test(arguments[z]) ? y.isString(arguments[z]) || y.isArray(arguments[z]) ? S.easing = arguments[z] : y.isFunction(arguments[z]) && (S.complete = arguments[z]) : S.duration = arguments[z]
                    }
                    switch (_) {
                        case "scroll":
                            $ = "scroll";
                            break;
                        case "reverse":
                            $ = "reverse";
                            break;
                        case "pause":
                            var E = (new Date).getTime();
                            return p.each(w, function(t, e) {
                                s(e, E)
                            }), p.each(x.State.calls, function(t, e) {
                                var i = !1;
                                e && p.each(e[1], function(t, o) {
                                    var r = S === n ? "" : S;
                                    return !0 !== r && e[2].queue !== r && (S !== n || !1 !== e[2].queue) || (p.each(w, function(t, n) {
                                        if (n === o) return e[5] = {
                                            resume: !1
                                        }, i = !0, !1
                                    }), !i && void 0)
                                })
                            }), t();
                        case "resume":
                            return p.each(w, function(t, e) {
                                a(e)
                            }), p.each(x.State.calls, function(t, e) {
                                var i = !1;
                                e && p.each(e[1], function(t, o) {
                                    var r = S === n ? "" : S;
                                    return !0 !== r && e[2].queue !== r && (S !== n || !1 !== e[2].queue) || !e[5] || (p.each(w, function(t, n) {
                                        if (n === o) return e[5].resume = !0, i = !0, !1
                                    }), !i && void 0)
                                })
                            }), t();
                        case "finish":
                        case "finishAll":
                        case "stop":
                            p.each(w, function(t, e) {
                                r(e) && r(e).delayTimer && (clearTimeout(r(e).delayTimer.setTimeout), r(e).delayTimer.next && r(e).delayTimer.next(), delete r(e).delayTimer), "finishAll" !== _ || !0 !== S && !y.isString(S) || (p.each(p.queue(e, y.isString(S) ? S : ""), function(t, e) {
                                    y.isFunction(e) && e()
                                }), p.queue(e, y.isString(S) ? S : "", []))
                            });
                            var A = [];
                            return p.each(x.State.calls, function(t, e) {
                                e && p.each(e[1], function(i, o) {
                                    var s = S === n ? "" : S;
                                    if (!0 !== s && e[2].queue !== s && (S !== n || !1 !== e[2].queue)) return !0;
                                    p.each(w, function(i, n) {
                                        if (n === o)
                                            if ((!0 === S || y.isString(S)) && (p.each(p.queue(n, y.isString(S) ? S : ""), function(t, e) {
                                                    y.isFunction(e) && e(null, !0)
                                                }), p.queue(n, y.isString(S) ? S : "", [])), "stop" === _) {
                                                var a = r(n);
                                                a && a.tweensContainer && !1 !== s && p.each(a.tweensContainer, function(t, e) {
                                                    e.endValue = e.currentValue
                                                }), A.push(t)
                                            } else "finish" !== _ && "finishAll" !== _ || (e[2].duration = 1)
                                    })
                                })
                            }), "stop" === _ && (p.each(A, function(t, e) {
                                d(e, !0)
                            }), I.promise && I.resolver(w)), t();
                        default:
                            if (!p.isPlainObject(_) || y.isEmptyObject(_)) {
                                if (y.isString(_) && x.Redirects[_]) {
                                    var V = (h = p.extend({}, S)).duration,
                                        O = h.delay || 0;
                                    return !0 === h.backwards && (w = p.extend(!0, [], w).reverse()), p.each(w, function(t, e) {
                                        parseFloat(h.stagger) ? h.delay = O + parseFloat(h.stagger) * t : y.isFunction(h.stagger) && (h.delay = O + h.stagger.call(e, t, P)), h.drag && (h.duration = parseFloat(V) || (/^(callout|transition)/.test(_) ? 1e3 : b), h.duration = Math.max(h.duration * (h.backwards ? 1 - t / P : (t + 1) / P), .75 * h.duration, 200)), x.Redirects[_].call(e, e, h || {}, t, P, w, I.promise ? I : n)
                                    }), t()
                                }
                                var H = "Velocity: First argument (" + _ + ") was not a property map, a known action, or a registered redirect. Aborting.";
                                return I.promise ? I.rejecter(new Error(H)) : e.console && console.log(H), t()
                            }
                            $ = "start"
                    }
                    var M = {
                            lastParent: null,
                            lastPosition: null,
                            lastFontSize: null,
                            lastPercentToPxWidth: null,
                            lastPercentToPxHeight: null,
                            lastEmToPx: null,
                            remToPx: null,
                            vwToPx: null,
                            vhToPx: null
                        },
                        F = [];
                    p.each(w, function(t, e) {
                        y.isNode(e) && l(e, t)
                    }), (h = p.extend({}, x.defaults, S)).loop = parseInt(h.loop, 10);
                    var j = 2 * h.loop - 1;
                    if (h.loop)
                        for (var N = 0; N < j; N++) {
                            var R = {
                                delay: h.delay,
                                progress: h.progress
                            };
                            N === j - 1 && (R.display = h.display, R.visibility = h.visibility, R.complete = h.complete), C(w, "reverse", R)
                        }
                    return t()
                }
                I.promise && (_ && S && !1 === S.promiseRejectEmpty ? I.resolver() : I.rejecter())
            };
            (x = p.extend(C, x)).animate = C;
            var T = e.requestAnimationFrame || f;
            if (!x.State.isMobile && i.hidden !== n) {
                var I = function() {
                    i.hidden ? (T = function(t) {
                        return setTimeout(function() {
                            t(!0)
                        }, 16)
                    }, c()) : T = e.requestAnimationFrame || f
                };
                I(), i.addEventListener("visibilitychange", I)
            }
            return t.Velocity = x, t !== e && (t.fn.velocity = C, t.fn.velocity.defaults = x.defaults), p.each(["Down", "Up"], function(t, e) {
                x.Redirects["slide" + e] = function(t, i, o, r, s, a) {
                    var l = p.extend({}, i),
                        u = l.begin,
                        c = l.complete,
                        d = {},
                        h = {
                            height: "",
                            marginTop: "",
                            marginBottom: "",
                            paddingTop: "",
                            paddingBottom: ""
                        };
                    l.display === n && (l.display = "Down" === e ? "inline" === x.CSS.Values.getDisplayType(t) ? "inline-block" : "block" : "none"), l.begin = function() {
                        for (var i in 0 === o && u && u.call(s, s), h)
                            if (h.hasOwnProperty(i)) {
                                d[i] = t.style[i];
                                var n = k.getPropertyValue(t, i);
                                h[i] = "Down" === e ? [n, 0] : [0, n]
                            } d.overflow = t.style.overflow, t.style.overflow = "hidden"
                    }, l.complete = function() {
                        for (var e in d) d.hasOwnProperty(e) && (t.style[e] = d[e]);
                        o === r - 1 && (c && c.call(s, s), a && a.resolver(s))
                    }, x(t, h, l)
                }
            }), p.each(["In", "Out"], function(t, e) {
                x.Redirects["fade" + e] = function(t, i, o, r, s, a) {
                    var l = p.extend({}, i),
                        u = l.complete,
                        c = {
                            opacity: "In" === e ? 1 : 0
                        };
                    0 !== o && (l.begin = null), l.complete = o !== r - 1 ? null : function() {
                        u && u.call(s, s), a && a.resolver(s)
                    }, l.display === n && (l.display = "In" === e ? "auto" : "none"), x(this, c, l)
                }
            }), x
        }
        jQuery.fn.velocity = jQuery.fn.animate
    }(window.jQuery || window.Zepto || window, window, window ? window.document : void 0)
}),
function(t) {
    "use strict";
    t.fn.fitVids = function(e) {
        var i = {
            customSelector: null,
            ignore: null
        };
        if (!document.getElementById("fit-vids-style")) {
            var n = document.head || document.getElementsByTagName("head")[0],
                o = document.createElement("div");
            o.innerHTML = '<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>', n.appendChild(o.childNodes[1])
        }
        return e && t.extend(i, e), this.each(function() {
            var e = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', "object", "embed"];
            i.customSelector && e.push(i.customSelector);
            var n = ".fitvidsignore";
            i.ignore && (n = n + ", " + i.ignore);
            var o = t(this).find(e.join(","));
            (o = (o = o.not("object object")).not(n)).each(function() {
                var e = t(this);
                if (!(e.parents(n).length > 0 || "embed" === this.tagName.toLowerCase() && e.parent("object").length || e.parent(".fluid-width-video-wrapper").length)) {
                    e.css("height") || e.css("width") || !isNaN(e.attr("height")) && !isNaN(e.attr("width")) || (e.attr("height", 9), e.attr("width", 16));
                    var i = ("object" === this.tagName.toLowerCase() || e.attr("height") && !isNaN(parseInt(e.attr("height"), 10)) ? parseInt(e.attr("height"), 10) : e.height()) / (isNaN(parseInt(e.attr("width"), 10)) ? e.width() : parseInt(e.attr("width"), 10));
                    if (!e.attr("name")) {
                        var o = "fitvid" + t.fn.fitVids._count;
                        e.attr("name", o), t.fn.fitVids._count++
                    }
                    e.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", 100 * i + "%"), e.removeAttr("height").removeAttr("width")
                }
            })
        })
    }, t.fn.fitVids._count = 0
}(window.jQuery || window.Zepto),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self).cssVars = e()
}(this, function() {
    "use strict";

    function t() {
        return (t = Object.assign || function(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
            }
            return t
        }).apply(this, arguments)
    }

    function e(t) {
        function e() {
            return !("<" === (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").trim().charAt(0))
        }

        function i(t, e) {
            r.onError(t, s[e], e)
        }

        function n(t, e) {
            var i = r.onSuccess(t, s[e], e);
            t = !1 === i ? "" : i || t, a[e] = t, -1 === a.indexOf(null) && r.onComplete(a)
        }
        var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = {
                mimeType: o.mimeType || null,
                onBeforeSend: o.onBeforeSend || Function.prototype,
                onSuccess: o.onSuccess || Function.prototype,
                onError: o.onError || Function.prototype,
                onComplete: o.onComplete || Function.prototype
            },
            s = Array.isArray(t) ? t : [t],
            a = Array.apply(null, Array(s.length)).map(function(t) {
                return null
            }),
            l = document.createElement("a");
        s.forEach(function(t, o) {
            if (l.setAttribute("href", t), l.href = String(l.href), Boolean(document.all && !window.atob) && l.host.split(":")[0] !== location.host.split(":")[0])
                if (l.protocol === location.protocol) {
                    var s = new XDomainRequest;
                    s.open("GET", t), s.timeout = 0, s.onprogress = Function.prototype, s.ontimeout = Function.prototype, s.onload = function() {
                        e(s.responseText) ? n(s.responseText, o) : i(s, o)
                    }, s.onerror = function(t) {
                        i(s, o)
                    }, setTimeout(function() {
                        s.send()
                    }, 0)
                } else console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(t, ")")), i(null, o);
            else {
                var a = new XMLHttpRequest;
                a.open("GET", t), r.mimeType && a.overrideMimeType && a.overrideMimeType(r.mimeType), r.onBeforeSend(a, t, o), a.onreadystatechange = function() {
                    4 === a.readyState && (200 === a.status && e(a.responseText) ? n(a.responseText, o) : i(a, o))
                }, a.send()
            }
        })
    }

    function i(t) {
        function i() {
            if (-1 === u.indexOf(null)) {
                var t = u.join("");
                a.onComplete(t, u, l)
            }
        }

        function o(t, n, o, s) {
            var l = a.onSuccess(t, o, s);
            ! function t(i, n, o, s) {
                var l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [],
                    u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : [],
                    c = r(i, o, u);
                c.rules.length ? e(c.absoluteUrls, {
                    onBeforeSend: function(t, e, i) {
                        a.onBeforeSend(t, n, e)
                    },
                    onSuccess: function(t, e, i) {
                        var o = a.onSuccess(t, n, e),
                            s = r(t = !1 === o ? "" : o || t, e, u);
                        return s.rules.forEach(function(e, i) {
                            t = t.replace(e, s.absoluteRules[i])
                        }), t
                    },
                    onError: function(e, r, a) {
                        l.push({
                            xhr: e,
                            url: r
                        }), u.push(c.rules[a]), t(i, n, o, s, l, u)
                    },
                    onComplete: function(e) {
                        e.forEach(function(t, e) {
                            i = i.replace(c.rules[e], t)
                        }), t(i, n, o, s, l, u)
                    }
                }) : s(i, l)
            }(t = void 0 !== l && !1 === Boolean(l) ? "" : l || t, o, s, function(t, e) {
                null === u[n] && (e.forEach(function(t) {
                    return a.onError(t.xhr, o, t.url)
                }), !a.filter || a.filter.test(t) ? u[n] = t : u[n] = "", i())
            })
        }

        function r(t, e) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
                o = {};
            return o.rules = (t.replace(s.cssComments, "").match(s.cssImports) || []).filter(function(t) {
                return -1 === i.indexOf(t)
            }), o.urls = o.rules.map(function(t) {
                return t.replace(s.cssImports, "$1")
            }), o.absoluteUrls = o.urls.map(function(t) {
                return n(t, e)
            }), o.absoluteRules = o.rules.map(function(t, i) {
                var r = o.urls[i],
                    s = n(o.absoluteUrls[i], e);
                return t.replace(r, s)
            }), o
        }
        var s = {
                cssComments: /\/\*[\s\S]+?\*\//g,
                cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g
            },
            a = {
                rootElement: t.rootElement || document,
                include: t.include || 'style,link[rel="stylesheet"]',
                exclude: t.exclude || null,
                filter: t.filter || null,
                useCSSOM: t.useCSSOM || !1,
                onBeforeSend: t.onBeforeSend || Function.prototype,
                onSuccess: t.onSuccess || Function.prototype,
                onError: t.onError || Function.prototype,
                onComplete: t.onComplete || Function.prototype
            },
            l = Array.apply(null, a.rootElement.querySelectorAll(a.include)).filter(function(t) {
                return e = t, i = a.exclude, !(e.matches || e.matchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector).call(e, i);
                var e, i
            }),
            u = Array.apply(null, Array(l.length)).map(function(t) {
                return null
            });
        l.length ? l.forEach(function(t, r) {
            var s = t.getAttribute("href"),
                l = t.getAttribute("rel"),
                c = "LINK" === t.nodeName && s && l && "stylesheet" === l.toLowerCase(),
                d = "STYLE" === t.nodeName;
            if (c) e(s, {
                mimeType: "text/css",
                onBeforeSend: function(e, i, n) {
                    a.onBeforeSend(e, t, i)
                },
                onSuccess: function(e, i, a) {
                    var l = n(s, location.href);
                    o(e, r, t, l)
                },
                onError: function(e, n, o) {
                    u[r] = "", a.onError(e, t, n), i()
                }
            });
            else if (d) {
                var p = t.textContent;
                a.useCSSOM && (p = Array.apply(null, t.sheet.cssRules).map(function(t) {
                    return t.cssText
                }).join("")), o(p, r, t, location.href)
            } else u[r] = "", i()
        }) : a.onComplete("", [])
    }

    function n(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : location.href,
            i = document.implementation.createHTMLDocument(""),
            n = i.createElement("base"),
            o = i.createElement("a");
        return i.head.appendChild(n), i.body.appendChild(o), n.href = e, o.href = t, o.href
    }

    function o(t, e, i) {
        t instanceof RegExp && (t = r(t, i)), e instanceof RegExp && (e = r(e, i));
        var n = s(t, e, i);
        return n && {
            start: n[0],
            end: n[1],
            pre: i.slice(0, n[0]),
            body: i.slice(n[0] + t.length, n[1]),
            post: i.slice(n[1] + e.length)
        }
    }

    function r(t, e) {
        var i = e.match(t);
        return i ? i[0] : null
    }

    function s(t, e, i) {
        var n, o, r, s, a, l = i.indexOf(t),
            u = i.indexOf(e, l + 1),
            c = l;
        if (l >= 0 && u > 0) {
            for (n = [], r = i.length; c >= 0 && !a;) c == l ? (n.push(c), l = i.indexOf(t, c + 1)) : 1 == n.length ? a = [n.pop(), u] : ((o = n.pop()) < r && (r = o, s = u), u = i.indexOf(e, c + 1)), c = l < u && l >= 0 ? l : u;
            n.length && (a = [r, s])
        }
        return a
    }

    function a(e) {
        var i, n, o = t({}, {
                fixNestedCalc: !0,
                onlyVars: !1,
                persist: !1,
                preserve: !1,
                variables: {},
                onWarning: function() {}
            }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}),
            r = o.persist ? h.dom : h.temp = JSON.parse(JSON.stringify(h.dom)),
            s = function(e) {
                function i(t) {
                    throw new Error("CSS parse error: ".concat(t))
                }

                function n(t) {
                    var i = t.exec(e);
                    if (i) return e = e.slice(i[0].length), i
                }

                function o() {
                    return n(/^{\s*/)
                }

                function r() {
                    return n(/^}/)
                }

                function s() {
                    n(/^\s*/)
                }

                function a() {
                    if (s(), "/" === e[0] && "*" === e[1]) {
                        for (var t = 2; e[t] && ("*" !== e[t] || "/" !== e[t + 1]);) t++;
                        if (!e[t]) return i("end of comment is missing");
                        var n = e.slice(2, t);
                        return e = e.slice(t + 2), {
                            type: "comment",
                            comment: n
                        }
                    }
                }

                function l() {
                    for (var t, e = []; t = a();) e.push(t);
                    return v.removeComments ? [] : e
                }

                function u() {
                    for (s();
                        "}" === e[0];) i("extra closing bracket");
                    var t = n(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
                    if (t) return t[0].trim().replace(/\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(t) {
                        return t.replace(/,/g, "‌")
                    }).split(/\s*(?![^(]*\)),\s*/).map(function(t) {
                        return t.replace(/\u200C/g, ",")
                    })
                }

                function d() {
                    n(/^([;\s]*)+/);
                    var t = /\/\*[^*]*\*+([^\/*][^*]*\*+)*\//g,
                        e = n(/^(\*?[-#\/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
                    if (e) {
                        if (e = e[0].trim(), !n(/^:\s*/)) return i("property missing ':'");
                        var o = n(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/),
                            r = {
                                type: "declaration",
                                property: e.replace(t, ""),
                                value: o ? o[0].replace(t, "").trim() : ""
                            };
                        return n(/^[;\s]*/), r
                    }
                }

                function p() {
                    if (!o()) return i("missing '{'");
                    for (var t, e = l(); t = d();) e.push(t), e = e.concat(l());
                    return r() ? e : i("missing '}'")
                }

                function h() {
                    s();
                    for (var t, e = []; t = n(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/);) e.push(t[1]), n(/^,\s*/);
                    if (e.length) return {
                        type: "keyframe",
                        values: e,
                        declarations: p()
                    }
                }

                function f() {
                    if (s(), "@" === e[0]) {
                        var t = function() {
                            var t = n(/^@([-\w]+)?keyframes\s*/);
                            if (t) {
                                var e = t[1];
                                if (!(t = n(/^([-\w]+)\s*/))) return i("@keyframes missing name");
                                var s, a = t[1];
                                if (!o()) return i("@keyframes missing '{'");
                                for (var u = l(); s = h();) u.push(s), u = u.concat(l());
                                return r() ? {
                                    type: "keyframes",
                                    name: a,
                                    vendor: e,
                                    keyframes: u
                                } : i("@keyframes missing '}'")
                            }
                        }() || function() {
                            var t = n(/^@supports *([^{]+)/);
                            if (t) return {
                                type: "supports",
                                supports: t[1].trim(),
                                rules: g()
                            }
                        }() || function() {
                            if (n(/^@host\s*/)) return {
                                type: "host",
                                rules: g()
                            }
                        }() || function() {
                            var t = n(/^@media *([^{]+)/);
                            if (t) return {
                                type: "media",
                                media: t[1].trim(),
                                rules: g()
                            }
                        }() || function() {
                            var t = n(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
                            if (t) return {
                                type: "custom-media",
                                name: t[1].trim(),
                                media: t[2].trim()
                            }
                        }() || function() {
                            if (n(/^@page */)) return {
                                type: "page",
                                selectors: u() || [],
                                declarations: p()
                            }
                        }() || function() {
                            var t = n(/^@([-\w]+)?document *([^{]+)/);
                            if (t) return {
                                type: "document",
                                document: t[2].trim(),
                                vendor: t[1] ? t[1].trim() : null,
                                rules: g()
                            }
                        }() || function() {
                            if (n(/^@font-face\s*/)) return {
                                type: "font-face",
                                declarations: p()
                            }
                        }() || function() {
                            var t = n(/^@(import|charset|namespace)\s*([^;]+);/);
                            if (t) return {
                                type: t[1],
                                name: t[2].trim()
                            }
                        }();
                        return t && v.onlyVars ? (t.declarations ? t.declarations.some(function(t) {
                            return /var\(/.test(t.value)
                        }) : (t.keyframes || t.rules || []).some(function(t) {
                            return (t.declarations || []).some(function(t) {
                                return /var\(/.test(t.value)
                            })
                        })) ? t : {} : t
                    }
                }

                function m() {
                    if (v.onlyVars) {
                        var t = c("{", "}", e);
                        if (t) {
                            var n = -1 !== t.pre.indexOf(":root") && /--\S*\s*:/.test(t.body),
                                o = /var\(/.test(t.body);
                            if (!n && !o) return e = e.slice(t.end + 1), {}
                        }
                    }
                    var r = u() || [],
                        s = v.onlyVars ? p().filter(function(t) {
                            var e = r.some(function(t) {
                                    return -1 !== t.indexOf(":root")
                                }) && /^--\S/.test(t.property),
                                i = /var\(/.test(t.value);
                            return e || i
                        }) : p();
                    return r.length || i("selector missing"), {
                        type: "rule",
                        selectors: r,
                        declarations: s
                    }
                }

                function g(t) {
                    if (!t && !o()) return i("missing '{'");
                    for (var n, s = l(); e.length && (t || "}" !== e[0]) && (n = f() || m());) n.type && s.push(n), s = s.concat(l());
                    return t || r() ? s : i("missing '}'")
                }
                var v = t({}, {
                    onlyVars: !1,
                    removeComments: !1
                }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                return {
                    type: "stylesheet",
                    stylesheet: {
                        rules: g(!0),
                        errors: []
                    }
                }
            }(e, {
                onlyVars: o.onlyVars
            });
        if (s.stylesheet.rules.forEach(function(t) {
                var e = [];
                if ("rule" === t.type && 1 === t.selectors.length && ":root" === t.selectors[0] && (t.declarations.forEach(function(t, i) {
                        var n = t.property,
                            o = t.value;
                        n && 0 === n.indexOf(d) && (r[n] = o, e.push(i))
                    }), !o.preserve))
                    for (var i = e.length - 1; i >= 0; i--) t.declarations.splice(e[i], 1)
            }), Object.keys(h.user).forEach(function(t) {
                r[t] = h.user[t]
            }), Object.keys(o.variables).length) {
            var a = {
                declarations: [],
                selectors: [":root"],
                type: "rule"
            };
            Object.keys(o.variables).forEach(function(t) {
                var e = "--".concat(t.replace(/^-+/, "")),
                    i = o.variables[t];
                o.persist && (h.user[e] = i), r[e] !== i && (r[e] = i, a.declarations.push({
                    type: "declaration",
                    property: e,
                    value: i
                }))
            }), o.preserve && a.declarations.length && s.stylesheet.rules.push(a)
        }
        return function t(e, i) {
                e.rules.forEach(function(n) {
                    n.rules ? t(n, i) : n.keyframes ? n.keyframes.forEach(function(t) {
                        "keyframe" === t.type && i(t.declarations, n)
                    }) : n.declarations && i(n.declarations, e)
                })
            }(s.stylesheet, function(t, e) {
                for (var i, n, s, a = 0; a < t.length; a++) s = (i = t[a]).value, "declaration" === i.type && s && -1 !== s.indexOf(p + "(") && (n = l(s, r, o)) !== i.value && (o.preserve ? (t.splice(a, 0, {
                    type: i.type,
                    property: i.property,
                    value: n
                }), a++) : i.value = n)
            }), o.fixNestedCalc && (i = s.stylesheet.rules, n = /(-[a-z]+-)?calc\(/, i.forEach(function(t) {
                t.declarations && t.declarations.forEach(function(t) {
                    for (var e = t.value, i = ""; n.test(e);) {
                        var o = c("calc(", ")", e || "");
                        for (e = e.slice(o.end); n.test(o.body);) {
                            var r = c(n, ")", o.body);
                            o.body = "".concat(r.pre, "(").concat(r.body, ")").concat(r.post)
                        }
                        i += "".concat(o.pre, "calc(").concat(o.body), i += n.test(e) ? "" : ")".concat(o.post)
                    }
                    t.value = i || t.value
                })
            })),
            function(t) {
                function e(t) {
                    for (var e = "", r = 0; r < t.length; r++) {
                        var s = t[r];
                        n && n(s);
                        var a = o[s.type](s);
                        a && (e += a, a.length && s.selectors && (e += i))
                    }
                    return e
                }
                var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                    n = arguments.length > 2 ? arguments[2] : void 0,
                    o = {
                        charset: function(t) {
                            return "@charset " + t.name + ";"
                        },
                        comment: function(t) {
                            return 0 === t.comment.indexOf("__CSSVARSPONYFILL") ? "/*" + t.comment + "*/" : ""
                        },
                        "custom-media": function(t) {
                            return "@custom-media " + t.name + " " + t.media + ";"
                        },
                        declaration: function(t) {
                            return t.property + ":" + t.value + ";"
                        },
                        document: function(t) {
                            return "@" + (t.vendor || "") + "document " + t.document + "{" + e(t.rules) + "}"
                        },
                        "font-face": function(t) {
                            return "@font-face{" + e(t.declarations) + "}"
                        },
                        host: function(t) {
                            return "@host{" + e(t.rules) + "}"
                        },
                        import: function(t) {
                            return "@import " + t.name + ";"
                        },
                        keyframe: function(t) {
                            return t.values.join(",") + "{" + e(t.declarations) + "}"
                        },
                        keyframes: function(t) {
                            return "@" + (t.vendor || "") + "keyframes " + t.name + "{" + e(t.keyframes) + "}"
                        },
                        media: function(t) {
                            return "@media " + t.media + "{" + e(t.rules) + "}"
                        },
                        namespace: function(t) {
                            return "@namespace " + t.name + ";"
                        },
                        page: function(t) {
                            return "@page " + (t.selectors.length ? t.selectors.join(", ") : "") + "{" + e(t.declarations) + "}"
                        },
                        rule: function(t) {
                            var i = t.declarations;
                            if (i.length) return t.selectors.join(",") + "{" + e(i) + "}"
                        },
                        supports: function(t) {
                            return "@supports " + t.supports + "{" + e(t.rules) + "}"
                        }
                    };
                return e(t.stylesheet.rules)
            }(s)
    }

    function l(t, e) {
        var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = arguments.length > 3 ? arguments[3] : void 0;
        if (-1 === t.indexOf("var(")) return t;
        var o = c("(", ")", t),
            r = "CSS transform warning:";
        return o ? "var" === o.pre.slice(-3) ? 0 === o.body.trim().length ? (i.onWarning("".concat(r, " var() must contain a non-whitespace string")), t) : o.pre.slice(0, -3) + function(t) {
            var o = t.split(",")[0].replace(/[\s\n\t]/g, ""),
                s = (t.match(/(?:\s*,\s*){1}(.*)?/) || [])[1],
                a = e.hasOwnProperty(o) ? String(e[o]) : void 0,
                u = a || (s ? String(s) : void 0),
                c = n || t;
            return a || i.onWarning("".concat(r, ' variable "').concat(o, '" is undefined')), u && "undefined" !== u && u.length > 0 ? l(u, e, i, c) : "var(".concat(c, ")")
        }(o.body) + l(o.post, e, i) : o.pre + "(".concat(l(o.body, e, i), ")") + l(o.post, e, i) : (-1 !== t.indexOf("var(") && i.onWarning("".concat(r, ' missing closing ")" in the value "').concat(t, '"')), t)
    }

    function u(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : location.href,
            i = document.implementation.createHTMLDocument(""),
            n = i.createElement("base"),
            o = i.createElement("a");
        return i.head.appendChild(n), i.body.appendChild(o), n.href = e, o.href = t, o.href
    }
    var c = o;
    o.range = s;
    var d = "--",
        p = "var",
        h = {
            dom: {},
            temp: {},
            user: {}
        },
        f = "css-vars-ponyfill",
        m = "undefined" != typeof window,
        g = m && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)"),
        v = {
            rootElement: m ? document : null,
            include: "style,link[rel=stylesheet]",
            exclude: "",
            fixNestedCalc: !0,
            onlyLegacy: !0,
            onlyVars: !1,
            preserve: !1,
            shadowDOM: !1,
            silent: !1,
            updateDOM: !0,
            updateURLs: !0,
            variables: {},
            watch: null,
            onBeforeSend: function() {},
            onSuccess: function() {},
            onWarning: function() {},
            onError: function() {},
            onComplete: function() {}
        },
        y = {
            cssComments: /\/\*[\s\S]+?\*\//g,
            cssKeyframes: /@(?:-\w*-)?keyframes/,
            cssRootRules: /(?::root\s*{\s*[^}]*})/g,
            cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
            cssVars: /(?:(?::root\s*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
        },
        w = null,
        b = !1;
    return function e() {
        function n(t, e, i, n) {
            s.silent || console.error("".concat(t, "\n"), e), s.onError(t, e, i, n)
        }

        function o(t) {
            s.silent || console.warn(t), s.onWarning(t)
        }
        var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            s = t({}, v, r),
            l = f;
        if (s.exclude = "#".concat(l) + (s.exclude ? ",".concat(s.exclude) : ""), m)
            if ("loading" !== document.readyState) {
                var c = s.shadowDOM || s.rootElement.shadowRoot || s.rootElement.host;
                if (g && s.onlyLegacy) {
                    if (s.updateDOM) {
                        var d = s.rootElement.host || (s.rootElement === document ? document.documentElement : s.rootElement);
                        Object.keys(s.variables).forEach(function(t) {
                            var e = "--".concat(t.replace(/^-+/, "")),
                                i = s.variables[t];
                            d.style.setProperty(e, i)
                        })
                    }
                } else c && !b ? i({
                    rootElement: v.rootElement,
                    include: v.include,
                    exclude: s.exclude,
                    onSuccess: function(t, e, i) {
                        return (t.match(y.cssRootRules) || []).join("") || !1
                    },
                    onComplete: function(t, i, n) {
                        a(t, {
                            persist: !0
                        }), b = !0, e(s)
                    }
                }) : (s.watch ? function(t, i) {
                    if (window.MutationObserver) {
                        var n = function(t) {
                                return "LINK" === t.tagName && -1 !== (t.getAttribute("rel") || "").indexOf("stylesheet")
                            },
                            o = function(t) {
                                return "STYLE" === t.tagName && (!i || t.id !== i)
                            },
                            r = null;
                        w && w.disconnect(), t.watch = v.watch, (w = new MutationObserver(function(i) {
                            var s = !1;
                            i.forEach(function(i) {
                                if ("attributes" === i.type) s = n(i.target) || o(i.target);
                                else if ("childList" === i.type) {
                                    var a = Array.apply(null, i.addedNodes),
                                        l = Array.apply(null, i.removedNodes);
                                    s = [].concat(a, l).some(function(t) {
                                        var e = n(t) && !t.disabled,
                                            i = o(t) && !t.disabled && y.cssVars.test(t.textContent);
                                        return e || i
                                    })
                                }
                                s && (clearTimeout(r), r = setTimeout(function() {
                                    e(t)
                                }, 1))
                            })
                        })).observe(document.documentElement, {
                            attributes: !0,
                            attributeFilter: ["disabled", "href"],
                            childList: !0,
                            subtree: !0
                        })
                    }
                }(s, l) : !1 === s.watch && w && w.disconnect(), i({
                    rootElement: s.rootElement,
                    include: s.include,
                    exclude: s.exclude,
                    filter: s.onlyVars ? y.cssVars : null,
                    onBeforeSend: s.onBeforeSend,
                    onSuccess: function(t, e, i) {
                        var n = s.onSuccess(t, e, i);
                        return t = void 0 !== n && !1 === Boolean(n) ? "" : n || t, s.updateURLs && (t.replace(y.cssComments, "").match(y.cssUrls) || []).forEach(function(e) {
                            var n = e.replace(y.cssUrls, "$1"),
                                o = u(n, i);
                            t = t.replace(e, e.replace(n, o))
                        }), t
                    },
                    onError: function(t, e, i) {
                        var o = t.responseURL || u(i, location.href),
                            r = t.statusText ? "(".concat(t.statusText, ")") : "Unspecified Error" + (0 === t.status ? " (possibly CORS related)" : "");
                        n("CSS XHR Error: ".concat(o, " ").concat(t.status, " ").concat(r), e, t, o)
                    },
                    onComplete: function(i, r, u) {
                        var c = null;
                        i = r.map(function(t, e) {
                            return y.cssVars.test(t) ? t : "/*__CSSVARSPONYFILL-".concat(e, "__*/")
                        }).join("");
                        try {
                            i = a(i, {
                                fixNestedCalc: s.fixNestedCalc,
                                onlyVars: s.onlyVars,
                                persist: s.updateDOM,
                                preserve: s.preserve,
                                variables: s.variables,
                                onWarning: o
                            });
                            var d = y.cssKeyframes.test(i);
                            if (i = i.replace(/\/\*__CSSVARSPONYFILL-(\d+)__\*\//g, function(t, e) {
                                    return r[e]
                                }), s.updateDOM && u && u.length) {
                                var p = u[u.length - 1];
                                (c = s.rootElement.querySelector("#".concat(l)) || document.createElement("style")).setAttribute("id", l), c.textContent !== i && (c.textContent = i), p.nextSibling !== c && p.parentNode && p.parentNode.insertBefore(c, p.nextSibling), d && function(t) {
                                    var e = ["animation-name", "-moz-animation-name", "-webkit-animation-name"].filter(function(t) {
                                        return getComputedStyle(document.body)[t]
                                    })[0];
                                    if (e) {
                                        for (var i = t.getElementsByTagName("*"), n = [], o = 0, r = i.length; o < r; o++) {
                                            var s = i[o];
                                            "none" !== getComputedStyle(s)[e] && (s.style[e] += "__CSSVARSPONYFILL-KEYFRAMES__", n.push(s))
                                        }
                                        document.body.offsetHeight;
                                        for (var a = 0, l = n.length; a < l; a++) {
                                            var u = n[a].style;
                                            u[e] = u[e].replace("__CSSVARSPONYFILL-KEYFRAMES__", "")
                                        }
                                    }
                                }(s.rootElement)
                            }
                        } catch (t) {
                            var f = !1;
                            r.forEach(function(t, e) {
                                try {
                                    t = a(t, s)
                                } catch (t) {
                                    var i = u[e - 0];
                                    f = !0, n(t.message, i)
                                }
                            }), f || n(t.message || t)
                        }
                        if (s.shadowDOM)
                            for (var m, g = [s.rootElement].concat(function(t) {
                                    return function(t) {
                                        if (Array.isArray(t)) {
                                            for (var e = 0, i = new Array(t.length); e < t.length; e++) i[e] = t[e];
                                            return i
                                        }
                                    }(t) || function(t) {
                                        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t)
                                    }(t) || function() {
                                        throw new TypeError("Invalid attempt to spread non-iterable instance")
                                    }()
                                }(s.rootElement.querySelectorAll("*"))), v = 0; m = g[v]; ++v) m.shadowRoot && m.shadowRoot.querySelector("style") && e(t({}, s, {
                                rootElement: m.shadowRoot,
                                variables: h.dom
                            }));
                        s.onComplete(i, c, JSON.parse(JSON.stringify(s.updateDOM ? h.dom : h.temp)))
                    }
                }))
            } else document.addEventListener("DOMContentLoaded", function t(i) {
                e(r), document.removeEventListener("DOMContentLoaded", t)
            })
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
}(window, function(t, e) {
    "use strict";

    function i(i, r, a) {
        (a = a || e || t.jQuery) && (r.prototype.option || (r.prototype.option = function(t) {
            a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t))
        }), a.fn[i] = function(t) {
            return "string" == typeof t ? function(t, e, n) {
                var o, r = "$()." + i + '("' + e + '")';
                return t.each(function(t, l) {
                    var u = a.data(l, i);
                    if (u) {
                        var c = u[e];
                        if (c && "_" != e.charAt(0)) {
                            var d = c.apply(u, n);
                            o = void 0 === o ? d : o
                        } else s(r + " is not a valid method")
                    } else s(i + " not initialized. Cannot call methods, i.e. " + r)
                }), void 0 !== o ? o : t
            }(this, t, o.call(arguments, 1)) : (function(t, e) {
                t.each(function(t, n) {
                    var o = a.data(n, i);
                    o ? (o.option(e), o._init()) : (o = new r(n, e), a.data(n, i, o))
                })
            }(this, t), this)
        }, n(a))
    }

    function n(t) {
        !t || t && t.bridget || (t.bridget = i)
    }
    var o = Array.prototype.slice,
        r = t.console,
        s = void 0 === r ? function() {} : function(t) {
            r.error(t)
        };
    return n(e || t.jQuery), i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {},
                n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e), this
        }
    }, e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {};
            return (i[t] = i[t] || {})[e] = !0, this
        }
    }, e.off = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this
        }
    }, e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0), e = e || [];
            for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                var r = i[o];
                n && n[r] && (this.off(t, r), delete n[r]), r.apply(this, e)
            }
            return this
        }
    }, e.allOff = function() {
        delete this._events, delete this._onceEvents
    }, t
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function() {
    "use strict";

    function t(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }

    function e(t) {
        var e = getComputedStyle(t);
        return e || r("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e
    }

    function i() {
        if (!l) {
            l = !0;
            var i = document.createElement("div");
            i.style.width = "200px", i.style.padding = "1px 2px 3px 4px", i.style.borderStyle = "solid", i.style.borderWidth = "1px 2px 3px 4px", i.style.boxSizing = "border-box";
            var r = document.body || document.documentElement;
            r.appendChild(i);
            var s = e(i);
            o = 200 == Math.round(t(s.width)), n.isBoxSizeOuter = o, r.removeChild(i)
        }
    }

    function n(n) {
        if (i(), "string" == typeof n && (n = document.querySelector(n)), n && "object" == typeof n && n.nodeType) {
            var r = e(n);
            if ("none" == r.display) return function() {
                for (var t = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0
                    }, e = 0; a > e; e++) t[s[e]] = 0;
                return t
            }();
            var l = {};
            l.width = n.offsetWidth, l.height = n.offsetHeight;
            for (var u = l.isBorderBox = "border-box" == r.boxSizing, c = 0; a > c; c++) {
                var d = s[c],
                    p = r[d],
                    h = parseFloat(p);
                l[d] = isNaN(h) ? 0 : h
            }
            var f = l.paddingLeft + l.paddingRight,
                m = l.paddingTop + l.paddingBottom,
                g = l.marginLeft + l.marginRight,
                v = l.marginTop + l.marginBottom,
                y = l.borderLeftWidth + l.borderRightWidth,
                w = l.borderTopWidth + l.borderBottomWidth,
                b = u && o,
                _ = t(r.width);
            !1 !== _ && (l.width = _ + (b ? 0 : f + y));
            var x = t(r.height);
            return !1 !== x && (l.height = x + (b ? 0 : m + w)), l.innerWidth = l.width - (f + y), l.innerHeight = l.height - (m + w), l.outerWidth = l.width + g, l.outerHeight = l.height + v, l
        }
    }
    var o, r = "undefined" == typeof console ? function() {} : function(t) {
            console.error(t)
        },
        s = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
        a = s.length,
        l = !1;
    return n
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function() {
    "use strict";
    var t = function() {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n = e[i] + "MatchesSelector";
            if (t[n]) return n
        }
    }();
    return function(e, i) {
        return e[t](i)
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector)
}(window, function(t, e) {
    var i = {
            extend: function(t, e) {
                for (var i in e) t[i] = e[i];
                return t
            },
            modulo: function(t, e) {
                return (t % e + e) % e
            }
        },
        n = Array.prototype.slice;
    i.makeArray = function(t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? n.call(t) : [t]
    }, i.removeFrom = function(t, e) {
        var i = t.indexOf(e); - 1 != i && t.splice(i, 1)
    }, i.getParent = function(t, i) {
        for (; t.parentNode && t != document.body;)
            if (t = t.parentNode, e(t, i)) return t
    }, i.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }, i.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, i.filterFindElements = function(t, n) {
        t = i.makeArray(t);
        var o = [];
        return t.forEach(function(t) {
            if (t instanceof HTMLElement) {
                if (!n) return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++) o.push(i[r])
            }
        }), o
    }, i.debounceMethod = function(t, e, i) {
        i = i || 100;
        var n = t.prototype[e],
            o = e + "Timeout";
        t.prototype[e] = function() {
            var t = this[o];
            clearTimeout(t);
            var e = arguments,
                r = this;
            this[o] = setTimeout(function() {
                n.apply(r, e), delete r[o]
            }, i)
        }
    }, i.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }, i.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(t, e, i) {
            return e + "-" + i
        }).toLowerCase()
    };
    var o = t.console;
    return i.htmlInit = function(e, n) {
        i.docReady(function() {
            var r = i.toDashed(n),
                s = "data-" + r,
                a = document.querySelectorAll("[" + s + "]"),
                l = document.querySelectorAll(".js-" + r),
                u = i.makeArray(a).concat(i.makeArray(l)),
                c = s + "-options",
                d = t.jQuery;
            u.forEach(function(t) {
                var i, r = t.getAttribute(s) || t.getAttribute(c);
                try {
                    i = r && JSON.parse(r)
                } catch (e) {
                    return void(o && o.error("Error parsing " + s + " on " + t.className + ": " + e))
                }
                var a = new e(t, i);
                d && d.data(t, n, a)
            })
        })
    }, i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize))
}(window, function(t, e) {
    "use strict";

    function i(t, e) {
        t && (this.element = t, this.layout = e, this.position = {
            x: 0,
            y: 0
        }, this._create())
    }
    var n = document.documentElement.style,
        o = "string" == typeof n.transition ? "transition" : "WebkitTransition",
        r = "string" == typeof n.transform ? "transform" : "WebkitTransform",
        s = {
            WebkitTransition: "webkitTransitionEnd",
            transition: "transitionend"
        } [o],
        a = {
            transform: r,
            transition: o,
            transitionDuration: o + "Duration",
            transitionProperty: o + "Property",
            transitionDelay: o + "Delay"
        },
        l = i.prototype = Object.create(t.prototype);
    l.constructor = i, l._create = function() {
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        }, this.css({
            position: "absolute"
        })
    }, l.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, l.getSize = function() {
        this.size = e(this.element)
    }, l.css = function(t) {
        var e = this.element.style;
        for (var i in t) e[a[i] || i] = t[i]
    }, l.getPosition = function() {
        var t = getComputedStyle(this.element),
            e = this.layout._getOption("originLeft"),
            i = this.layout._getOption("originTop"),
            n = t[e ? "left" : "right"],
            o = t[i ? "top" : "bottom"],
            r = parseFloat(n),
            s = parseFloat(o),
            a = this.layout.size; - 1 != n.indexOf("%") && (r = r / 100 * a.width), -1 != o.indexOf("%") && (s = s / 100 * a.height), r = isNaN(r) ? 0 : r, s = isNaN(s) ? 0 : s, r -= e ? a.paddingLeft : a.paddingRight, s -= i ? a.paddingTop : a.paddingBottom, this.position.x = r, this.position.y = s
    }, l.layoutPosition = function() {
        var t = this.layout.size,
            e = {},
            i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop"),
            o = i ? "paddingLeft" : "paddingRight",
            r = i ? "left" : "right",
            s = i ? "right" : "left",
            a = this.position.x + t[o];
        e[r] = this.getXValue(a), e[s] = "";
        var l = n ? "paddingTop" : "paddingBottom",
            u = n ? "top" : "bottom",
            c = n ? "bottom" : "top",
            d = this.position.y + t[l];
        e[u] = this.getYValue(d), e[c] = "", this.css(e), this.emitEvent("layout", [this])
    }, l.getXValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
    }, l.getYValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
    }, l._transitionTo = function(t, e) {
        this.getPosition();
        var i = this.position.x,
            n = this.position.y,
            o = t == this.position.x && e == this.position.y;
        if (this.setPosition(t, e), !o || this.isTransitioning) {
            var r = t - i,
                s = e - n,
                a = {};
            a.transform = this.getTranslate(r, s), this.transition({
                to: a,
                onTransitionEnd: {
                    transform: this.layoutPosition
                },
                isCleaning: !0
            })
        } else this.layoutPosition()
    }, l.getTranslate = function(t, e) {
        return "translate3d(" + (t = this.layout._getOption("originLeft") ? t : -t) + "px, " + (e = this.layout._getOption("originTop") ? e : -e) + "px, 0)"
    }, l.goTo = function(t, e) {
        this.setPosition(t, e), this.layoutPosition()
    }, l.moveTo = l._transitionTo, l.setPosition = function(t, e) {
        this.position.x = parseFloat(t), this.position.y = parseFloat(e)
    }, l._nonTransition = function(t) {
        for (var e in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) t.onTransitionEnd[e].call(this)
    }, l.transition = function(t) {
        if (parseFloat(this.layout.options.transitionDuration)) {
            var e = this._transn;
            for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
            for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
            t.from && (this.css(t.from), this.element.offsetHeight), this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
        } else this._nonTransition(t)
    };
    var u = "opacity," + r.replace(/([A-Z])/g, function(t) {
        return "-" + t.toLowerCase()
    });
    l.enableTransition = function() {
        if (!this.isTransitioning) {
            var t = this.layout.options.transitionDuration;
            t = "number" == typeof t ? t + "ms" : t, this.css({
                transitionProperty: u,
                transitionDuration: t,
                transitionDelay: this.staggerDelay || 0
            }), this.element.addEventListener(s, this, !1)
        }
    }, l.onwebkitTransitionEnd = function(t) {
        this.ontransitionend(t)
    }, l.onotransitionend = function(t) {
        this.ontransitionend(t)
    };
    var c = {
        "-webkit-transform": "transform"
    };
    l.ontransitionend = function(t) {
        if (t.target === this.element) {
            var e = this._transn,
                i = c[t.propertyName] || t.propertyName;
            delete e.ingProperties[i],
                function(t) {
                    for (var e in t) return !1;
                    return !0
                }(e.ingProperties) && this.disableTransition(), i in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[i]), i in e.onEnd && (e.onEnd[i].call(this), delete e.onEnd[i]), this.emitEvent("transitionEnd", [this])
        }
    }, l.disableTransition = function() {
        this.removeTransitionStyles(), this.element.removeEventListener(s, this, !1), this.isTransitioning = !1
    }, l._removeStyles = function(t) {
        var e = {};
        for (var i in t) e[i] = "";
        this.css(e)
    };
    var d = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
    };
    return l.removeTransitionStyles = function() {
        this.css(d)
    }, l.stagger = function(t) {
        t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms"
    }, l.removeElem = function() {
        this.element.parentNode.removeChild(this.element), this.css({
            display: ""
        }), this.emitEvent("remove", [this])
    }, l.remove = function() {
        return o && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
            this.removeElem()
        }), void this.hide()) : void this.removeElem()
    }, l.reveal = function() {
        delete this.isHidden, this.css({
            display: ""
        });
        var t = this.layout.options,
            e = {};
        e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, l.onRevealTransitionEnd = function() {
        this.isHidden || this.emitEvent("reveal")
    }, l.getHideRevealTransitionEndProperty = function(t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var i in e) return i
    }, l.hide = function() {
        this.isHidden = !0, this.css({
            display: ""
        });
        var t = this.layout.options,
            e = {};
        e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, l.onHideTransitionEnd = function() {
        this.isHidden && (this.css({
            display: "none"
        }), this.emitEvent("hide"))
    }, l.destroy = function() {
        this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: ""
        })
    }, i
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(i, n, o, r) {
        return e(t, i, n, o, r)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item)
}(window, function(t, e, i, n, o) {
    "use strict";

    function r(t, e) {
        var i = n.getQueryElement(t);
        if (i) {
            this.element = i, l && (this.$element = l(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e);
            var o = ++c;
            this.element.outlayerGUID = o, d[o] = this, this._create(), this._getOption("initLayout") && this.layout()
        } else a && a.error("Bad element for " + this.constructor.namespace + ": " + (i || t))
    }

    function s(t) {
        function e() {
            t.apply(this, arguments)
        }
        return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e
    }
    var a = t.console,
        l = t.jQuery,
        u = function() {},
        c = 0,
        d = {};
    r.namespace = "outlayer", r.Item = o, r.defaults = {
        containerStyle: {
            position: "relative"
        },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)"
        },
        visibleStyle: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
    var p = r.prototype;
    n.extend(p, e.prototype), p.option = function(t) {
        n.extend(this.options, t)
    }, p._getOption = function(t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
    }, r.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    }, p._create = function() {
        this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize()
    }, p.reloadItems = function() {
        this.items = this._itemize(this.element.children)
    }, p._itemize = function(t) {
        for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
            var r = new i(e[o], this);
            n.push(r)
        }
        return n
    }, p._filterFindItemElements = function(t) {
        return n.filterFindElements(t, this.options.itemSelector)
    }, p.getItemElements = function() {
        return this.items.map(function(t) {
            return t.element
        })
    }, p.layout = function() {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"),
            e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), this._isLayoutInited = !0
    }, p._init = p.layout, p._resetLayout = function() {
        this.getSize()
    }, p.getSize = function() {
        this.size = i(this.element)
    }, p._getMeasurement = function(t, e) {
        var n, o = this.options[t];
        o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o), this[t] = n ? i(n)[e] : o) : this[t] = 0
    }, p.layoutItems = function(t, e) {
        t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
    }, p._getItemsForLayout = function(t) {
        return t.filter(function(t) {
            return !t.isIgnored
        })
    }, p._layoutItems = function(t, e) {
        if (this._emitCompleteOnItems("layout", t), t && t.length) {
            var i = [];
            t.forEach(function(t) {
                var n = this._getItemLayoutPosition(t);
                n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n)
            }, this), this._processLayoutQueue(i)
        }
    }, p._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        }
    }, p._processLayoutQueue = function(t) {
        this.updateStagger(), t.forEach(function(t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e)
        }, this)
    }, p.updateStagger = function() {
        var t = this.options.stagger;
        return null == t ? void(this.stagger = 0) : (this.stagger = function(t) {
            if ("number" == typeof t) return t;
            var e = t.match(/(^\d*\.?\d*)(\w*)/),
                i = e && e[1],
                n = e && e[2];
            return i.length ? (i = parseFloat(i)) * (h[n] || 1) : 0
        }(t), this.stagger)
    }, p._positionItem = function(t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i))
    }, p._postLayout = function() {
        this.resizeContainer()
    }, p.resizeContainer = function() {
        if (this._getOption("resizeContainer")) {
            var t = this._getContainerSize();
            t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1))
        }
    }, p._getContainerSize = u, p._setContainerMeasure = function(t, e) {
        if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px"
        }
    }, p._emitCompleteOnItems = function(t, e) {
        function i() {
            o.dispatchEvent(t + "Complete", null, [e])
        }

        function n() {
            ++s == r && i()
        }
        var o = this,
            r = e.length;
        if (e && r) {
            var s = 0;
            e.forEach(function(e) {
                e.once(t, n)
            })
        } else i()
    }, p.dispatchEvent = function(t, e, i) {
        var n = e ? [e].concat(i) : i;
        if (this.emitEvent(t, n), l)
            if (this.$element = this.$element || l(this.element), e) {
                var o = l.Event(e);
                o.type = t, this.$element.trigger(o, i)
            } else this.$element.trigger(t, i)
    }, p.ignore = function(t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0)
    }, p.unignore = function(t) {
        var e = this.getItem(t);
        e && delete e.isIgnored
    }, p.stamp = function(t) {
        (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this))
    }, p.unstamp = function(t) {
        (t = this._find(t)) && t.forEach(function(t) {
            n.removeFrom(this.stamps, t), this.unignore(t)
        }, this)
    }, p._find = function(t) {
        return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t)) : void 0
    }, p._manageStamps = function() {
        this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
    }, p._getBoundingRect = function() {
        var t = this.element.getBoundingClientRect(),
            e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        }
    }, p._manageStamp = u, p._getElementOffset = function(t) {
        var e = t.getBoundingClientRect(),
            n = this._boundingRect,
            o = i(t);
        return {
            left: e.left - n.left - o.marginLeft,
            top: e.top - n.top - o.marginTop,
            right: n.right - e.right - o.marginRight,
            bottom: n.bottom - e.bottom - o.marginBottom
        }
    }, p.handleEvent = n.handleEvent, p.bindResize = function() {
        t.addEventListener("resize", this), this.isResizeBound = !0
    }, p.unbindResize = function() {
        t.removeEventListener("resize", this), this.isResizeBound = !1
    }, p.onresize = function() {
        this.resize()
    }, n.debounceMethod(r, "onresize", 100), p.resize = function() {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }, p.needsResizeLayout = function() {
        var t = i(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth
    }, p.addItems = function(t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e
    }, p.appended = function(t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e))
    }, p.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            var i = this.items.slice(0);
            this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i)
        }
    }, p.reveal = function(t) {
        if (this._emitCompleteOnItems("reveal", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e), t.reveal()
            })
        }
    }, p.hide = function(t) {
        if (this._emitCompleteOnItems("hide", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function(t, i) {
                t.stagger(i * e), t.hide()
            })
        }
    }, p.revealItemElements = function(t) {
        var e = this.getItems(t);
        this.reveal(e)
    }, p.hideItemElements = function(t) {
        var e = this.getItems(t);
        this.hide(e)
    }, p.getItem = function(t) {
        for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t) return i
        }
    }, p.getItems = function(t) {
        t = n.makeArray(t);
        var e = [];
        return t.forEach(function(t) {
            var i = this.getItem(t);
            i && e.push(i)
        }, this), e
    }, p.remove = function(t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function(t) {
            t.remove(), n.removeFrom(this.items, t)
        }, this)
    }, p.destroy = function() {
        var t = this.element.style;
        t.height = "", t.position = "", t.width = "", this.items.forEach(function(t) {
            t.destroy()
        }), this.unbindResize();
        var e = this.element.outlayerGUID;
        delete d[e], delete this.element.outlayerGUID, l && l.removeData(this.element, this.constructor.namespace)
    }, r.data = function(t) {
        var e = (t = n.getQueryElement(t)) && t.outlayerGUID;
        return e && d[e]
    }, r.create = function(t, e) {
        var i = s(r);
        return i.defaults = n.extend({}, r.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, r.compatOptions), i.namespace = t, i.data = r.data, i.Item = s(o), n.htmlInit(i, t), l && l.bridget && l.bridget(t, i), i
    };
    var h = {
        ms: 1,
        s: 1e3
    };
    return r.Item = o, r
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
}(window, function(t, e) {
    var i = t.create("masonry");
    i.compatOptions.fitWidth = "isFitWidth";
    var n = i.prototype;
    return n._resetLayout = function() {
        this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        this.maxY = 0, this.horizontalColIndex = 0
    }, n.measureColumns = function() {
        if (this.getContainerWidth(), !this.columnWidth) {
            var t = this.items[0],
                i = t && t.element;
            this.columnWidth = i && e(i).outerWidth || this.containerWidth
        }
        var n = this.columnWidth += this.gutter,
            o = this.containerWidth + this.gutter,
            r = o / n,
            s = n - o % n;
        r = Math[s && 1 > s ? "round" : "floor"](r), this.cols = Math.max(r, 1)
    }, n.getContainerWidth = function() {
        var t = this._getOption("fitWidth") ? this.element.parentNode : this.element,
            i = e(t);
        this.containerWidth = i && i.innerWidth
    }, n._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth,
            i = Math[e && 1 > e ? "round" : "ceil"](t.size.outerWidth / this.columnWidth);
        i = Math.min(i, this.cols);
        for (var n = this[this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition"](i, t), o = {
                x: this.columnWidth * n.col,
                y: n.y
            }, r = n.y + t.size.outerHeight, s = i + n.col, a = n.col; s > a; a++) this.colYs[a] = r;
        return o
    }, n._getTopColPosition = function(t) {
        var e = this._getTopColGroup(t),
            i = Math.min.apply(Math, e);
        return {
            col: e.indexOf(i),
            y: i
        }
    }, n._getTopColGroup = function(t) {
        if (2 > t) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) e[n] = this._getColGroupY(n, t);
        return e
    }, n._getColGroupY = function(t, e) {
        if (2 > e) return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i)
    }, n._getHorizontalColPosition = function(t, e) {
        var i = this.horizontalColIndex % this.cols;
        i = t > 1 && i + t > this.cols ? 0 : i;
        var n = e.size.outerWidth && e.size.outerHeight;
        return this.horizontalColIndex = n ? i + t : this.horizontalColIndex, {
            col: i,
            y: this._getColGroupY(i, t)
        }
    }, n._manageStamp = function(t) {
        var i = e(t),
            n = this._getElementOffset(t),
            o = this._getOption("originLeft") ? n.left : n.right,
            r = o + i.outerWidth,
            s = Math.floor(o / this.columnWidth);
        s = Math.max(0, s);
        var a = Math.floor(r / this.columnWidth);
        a -= r % this.columnWidth ? 0 : 1, a = Math.min(this.cols - 1, a);
        for (var l = (this._getOption("originTop") ? n.top : n.bottom) + i.outerHeight, u = s; a >= u; u++) this.colYs[u] = Math.max(l, this.colYs[u])
    }, n._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {
            height: this.maxY
        };
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t
    }, n._getContainerFitWidth = function() {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) t++;
        return (this.cols - t) * this.columnWidth - this.gutter
    }, n.needsResizeLayout = function() {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth
    }, i
}), window.matchMedia || (window.matchMedia = function() {
        "use strict";
        var t = window.styleMedia || window.media;
        if (!t) {
            var e, i = document.createElement("style"),
                n = document.getElementsByTagName("script")[0];
            i.type = "text/css", i.id = "matchmediajs-test", n.parentNode.insertBefore(i, n), e = "getComputedStyle" in window && window.getComputedStyle(i, null) || i.currentStyle, t = {
                matchMedium: function(t) {
                    var n = "@media " + t + "{ #matchmediajs-test { width: 1px; } }";
                    return i.styleSheet ? i.styleSheet.cssText = n : i.textContent = n, "1px" === e.width
                }
            }
        }
        return function(e) {
            return {
                matches: t.matchMedium(e || "all"),
                media: e || "all"
            }
        }
    }()),
    function(t, e, i) {
        function n(t, e) {
            return typeof t === e
        }

        function o(t) {
            return t.replace(/([a-z])-([a-z])/g, function(t, e, i) {
                return e + i.toUpperCase()
            }).replace(/^-/, "")
        }

        function r() {
            return "function" != typeof e.createElement ? e.createElement(arguments[0]) : b ? e.createElementNS.call(e, "http://www.w3.org/2000/svg", arguments[0]) : e.createElement.apply(e, arguments)
        }

        function s(t, i, n, o) {
            var s, a, l, u, c = "modernizr",
                d = r("div"),
                p = function() {
                    var t = e.body;
                    return t || ((t = r(b ? "svg" : "body")).fake = !0), t
                }();
            if (parseInt(n, 10))
                for (; n--;)(l = r("div")).id = o ? o[n] : c + (n + 1), d.appendChild(l);
            return (s = r("style")).type = "text/css", s.id = "s" + c, (p.fake ? p : d).appendChild(s), p.appendChild(d), s.styleSheet ? s.styleSheet.cssText = t : s.appendChild(e.createTextNode(t)), d.id = c, p.fake && (p.style.background = "", p.style.overflow = "hidden", u = w.style.overflow, w.style.overflow = "hidden", w.appendChild(p)), a = i(d, t), p.fake ? (p.parentNode.removeChild(p), w.style.overflow = u, w.offsetHeight) : d.parentNode.removeChild(d), !!a
        }

        function a(t, e) {
            return !!~("" + t).indexOf(e)
        }

        function l(t, e) {
            return function() {
                return t.apply(e, arguments)
            }
        }

        function u(t) {
            return t.replace(/([A-Z])/g, function(t, e) {
                return "-" + e.toLowerCase()
            }).replace(/^ms-/, "-ms-")
        }

        function c(e, i, n) {
            var o;
            if ("getComputedStyle" in t) {
                o = getComputedStyle.call(t, e, i);
                var r = t.console;
                if (null !== o) n && (o = o.getPropertyValue(n));
                else if (r) {
                    r[r.error ? "error" : "log"].call(r, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
                }
            } else o = !i && e.currentStyle && e.currentStyle[n];
            return o
        }

        function d(e, n) {
            var o = e.length;
            if ("CSS" in t && "supports" in t.CSS) {
                for (; o--;)
                    if (t.CSS.supports(u(e[o]), n)) return !0;
                return !1
            }
            if ("CSSSupportsRule" in t) {
                for (var r = []; o--;) r.push("(" + u(e[o]) + ":" + n + ")");
                return s("@supports (" + (r = r.join(" or ")) + ") { #modernizr { position: absolute; } }", function(t) {
                    return "absolute" == c(t, null, "position")
                })
            }
            return i
        }

        function p(t, e, s, l) {
            function u() {
                p && (delete $.style, delete $.modElem)
            }
            if (l = !n(l, "undefined") && l, !n(s, "undefined")) {
                var c = d(t, s);
                if (!n(c, "undefined")) return c
            }
            for (var p, h, f, m, g, v = ["modernizr", "tspan", "samp"]; !$.style && v.length;) p = !0, $.modElem = r(v.shift()), $.style = $.modElem.style;
            for (f = t.length, h = 0; f > h; h++)
                if (m = t[h], g = $.style[m], a(m, "-") && (m = o(m)), $.style[m] !== i) {
                    if (l || n(s, "undefined")) return u(), "pfx" != e || m;
                    try {
                        $.style[m] = s
                    } catch (t) {}
                    if ($.style[m] != g) return u(), "pfx" != e || m
                } return u(), !1
        }

        function h(t, e, i, o, r) {
            var s = t.charAt(0).toUpperCase() + t.slice(1),
                a = (t + " " + k.join(s + " ") + s).split(" ");
            return n(e, "string") || n(e, "undefined") ? p(a, e, o, r) : function(t, e, i) {
                var o;
                for (var r in t)
                    if (t[r] in e) return !1 === i ? t[r] : n(o = e[t[r]], "function") ? l(o, i || e) : o;
                return !1
            }(a = (t + " " + T.join(s + " ") + s).split(" "), e, i)
        }

        function f(t, e, n) {
            return h(t, i, i, e, n)
        }
        var m = [],
            g = [],
            v = {
                _version: "3.6.0",
                _config: {
                    classPrefix: "",
                    enableClasses: !0,
                    enableJSClass: !0,
                    usePrefixes: !0
                },
                _q: [],
                on: function(t, e) {
                    var i = this;
                    setTimeout(function() {
                        e(i[t])
                    }, 0)
                },
                addTest: function(t, e, i) {
                    g.push({
                        name: t,
                        fn: e,
                        options: i
                    })
                },
                addAsyncTest: function(t) {
                    g.push({
                        name: null,
                        fn: t
                    })
                }
            },
            y = function() {};
        y.prototype = v, (y = new y).addTest("localstorage", function() {
            var t = "modernizr";
            try {
                return localStorage.setItem(t, t), localStorage.removeItem(t), !0
            } catch (t) {
                return !1
            }
        });
        var w = e.documentElement,
            b = "svg" === w.nodeName.toLowerCase(),
            _ = v._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
        v._prefixes = _;
        var x = v.testStyles = s;
        y.addTest("touchevents", function() {
            var i;
            if ("ontouchstart" in t || t.DocumentTouch && e instanceof DocumentTouch) i = !0;
            else {
                var n = ["@media (", _.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
                x(n, function(t) {
                    i = 9 === t.offsetTop
                })
            }
            return i
        });
        var S = "Moz O ms Webkit",
            k = v._config.usePrefixes ? S.split(" ") : [];
        v._cssomPrefixes = k;
        var C = function(e) {
            var n, o = _.length,
                r = t.CSSRule;
            if (void 0 === r) return i;
            if (!e) return !1;
            if ((n = (e = e.replace(/^@/, "")).replace(/-/g, "_").toUpperCase() + "_RULE") in r) return "@" + e;
            for (var s = 0; o > s; s++) {
                var a = _[s];
                if (a.toUpperCase() + "_" + n in r) return "@-" + a.toLowerCase() + "-" + e
            }
            return !1
        };
        v.atRule = C;
        var T = v._config.usePrefixes ? S.toLowerCase().split(" ") : [];
        v._domPrefixes = T;
        var I = {
            elem: r("modernizr")
        };
        y._q.push(function() {
            delete I.elem
        });
        var $ = {
            style: I.elem.style
        };
        y._q.unshift(function() {
            delete $.style
        }), v.testAllProps = h, v.testAllProps = f, y.addTest("cssgridlegacy", f("grid-columns", "10px", !0)), y.addTest("cssgrid", f("grid-template-rows", "none", !0));
        var P = v.prefixed = function(t, e, i) {
            return 0 === t.indexOf("@") ? C(t) : (-1 != t.indexOf("-") && (t = o(t)), e ? h(t, e, i) : h(t, "pfx"))
        };
        y.addTest("objectfit", !!P("objectFit"), {
                aliases: ["object-fit"]
            }),
            function() {
                var t, e, i, o, r, s;
                for (var a in g)
                    if (g.hasOwnProperty(a)) {
                        if (t = [], (e = g[a]).name && (t.push(e.name.toLowerCase()), e.options && e.options.aliases && e.options.aliases.length))
                            for (i = 0; i < e.options.aliases.length; i++) t.push(e.options.aliases[i].toLowerCase());
                        for (o = n(e.fn, "function") ? e.fn() : e.fn, r = 0; r < t.length; r++) 1 === (s = t[r].split(".")).length ? y[s[0]] = o : (!y[s[0]] || y[s[0]] instanceof Boolean || (y[s[0]] = new Boolean(y[s[0]])), y[s[0]][s[1]] = o), m.push((o ? "" : "no-") + s.join("-"))
                    }
            }(),
            function(t) {
                var e = w.className,
                    i = y._config.classPrefix || "";
                if (b && (e = e.baseVal), y._config.enableJSClass) {
                    var n = new RegExp("(^|\\s)" + i + "no-js(\\s|$)");
                    e = e.replace(n, "$1" + i + "js$2")
                }
                y._config.enableClasses && (e += " " + i + t.join(" " + i), b ? w.className.baseVal = e : w.className = e)
            }(m), delete v.addTest, delete v.addAsyncTest;
        for (var L = 0; L < y._q.length; L++) y._q[L]();
        t.Modernizr = y
    }(window, document), "function" != typeof Object.create && (Object.create = function(t) {
        function e() {}
        return e.prototype = t, new e
    }),
    function(t, e, i, n) {
        var o = {
            init: function(e, i) {
                var n = this;
                n.$elem = t(i), n.options = t.extend({}, t.fn.owlCarousel.options, n.$elem.data(), e), n.userOptions = e, n.loadContent()
            },
            loadContent: function() {
                var e = this;
                if ("function" == typeof e.options.beforeInit && e.options.beforeInit.apply(this, [e.$elem]), "string" == typeof e.options.jsonPath) {
                    var i = e.options.jsonPath;
                    t.getJSON(i, function(t) {
                        if ("function" == typeof e.options.jsonSuccess) e.options.jsonSuccess.apply(this, [t]);
                        else {
                            var i = "";
                            for (var n in t.owl) i += t.owl[n].item;
                            e.$elem.html(i)
                        }
                        e.logIn()
                    })
                } else e.logIn()
            },
            logIn: function(t) {
                var e = this;
                e.$elem.data("owl-originalStyles", e.$elem.attr("style")).data("owl-originalClasses", e.$elem.attr("class")), e.$elem.css({
                    opacity: 0
                }), e.orignalItems = e.options.items, e.checkBrowser(), e.wrapperWidth = 0, e.checkVisible, e.setVars()
            },
            setVars: function() {
                var t = this;
                if (0 === t.$elem.children().length) return !1;
                t.baseClass(), t.eventTypes(), t.$userItems = t.$elem.children(), t.itemsAmount = t.$userItems.length, t.wrapItems(), t.$owlItems = t.$elem.find(".owl-item"), t.$owlWrapper = t.$elem.find(".owl-wrapper"), t.playDirection = "next", t.prevItem = 0, t.prevArr = [0], t.currentItem = 0, t.customEvents(), t.onStartup()
            },
            onStartup: function() {
                var t = this;
                t.updateItems(), t.calculateAll(), t.buildControls(), t.updateControls(), t.response(), t.moveEvents(), t.stopOnHover(), t.owlStatus(), !1 !== t.options.transitionStyle && t.transitionTypes(t.options.transitionStyle), !0 === t.options.autoPlay && (t.options.autoPlay = 5e3), t.play(), t.$elem.find(".owl-wrapper").css("display", "block"), t.$elem.is(":visible") ? t.$elem.css("opacity", 1) : t.watchVisibility(), t.onstartup = !1, t.eachMoveUpdate(), "function" == typeof t.options.afterInit && t.options.afterInit.apply(this, [t.$elem])
            },
            eachMoveUpdate: function() {
                var t = this;
                !0 === t.options.lazyLoad && t.lazyLoad(), !0 === t.options.autoHeight && t.autoHeight(), t.onVisibleItems(), "function" == typeof t.options.afterAction && t.options.afterAction.apply(this, [t.$elem])
            },
            updateVars: function() {
                var t = this;
                "function" == typeof t.options.beforeUpdate && t.options.beforeUpdate.apply(this, [t.$elem]), t.watchVisibility(), t.updateItems(), t.calculateAll(), t.updatePosition(), t.updateControls(), t.eachMoveUpdate(), "function" == typeof t.options.afterUpdate && t.options.afterUpdate.apply(this, [t.$elem])
            },
            reload: function(t) {
                var e = this;
                setTimeout(function() {
                    e.updateVars()
                }, 0)
            },
            watchVisibility: function() {
                var t = this;
                if (!1 !== t.$elem.is(":visible")) return !1;
                t.$elem.css({
                    opacity: 0
                }), clearInterval(t.autoPlayInterval), clearInterval(t.checkVisible), t.checkVisible = setInterval(function() {
                    t.$elem.is(":visible") && (t.reload(), t.$elem.animate({
                        opacity: 1
                    }, 200), clearInterval(t.checkVisible))
                }, 500)
            },
            wrapItems: function() {
                var t = this;
                t.$userItems.wrapAll('<div class="owl-wrapper">').wrap('<div class="owl-item"></div>'), t.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'), t.wrapperOuter = t.$elem.find(".owl-wrapper-outer"), t.$elem.css("display", "block")
            },
            baseClass: function() {
                var t = this,
                    e = t.$elem.hasClass(t.options.baseClass),
                    i = t.$elem.hasClass(t.options.theme);
                e || t.$elem.addClass(t.options.baseClass), i || t.$elem.addClass(t.options.theme)
            },
            updateItems: function() {
                var e = this;
                if (!1 === e.options.responsive) return !1;
                if (!0 === e.options.singleItem) return e.options.items = e.orignalItems = 1, e.options.itemsCustom = !1, e.options.itemsDesktop = !1, e.options.itemsDesktopSmall = !1, e.options.itemsTablet = !1, e.options.itemsTabletSmall = !1, e.options.itemsMobile = !1, !1;
                var i = t(e.options.responsiveBaseWidth).width();
                if (i > (e.options.itemsDesktop[0] || e.orignalItems) && (e.options.items = e.orignalItems), void 0 !== e.options.itemsCustom && !1 !== e.options.itemsCustom)
                    for (var n in e.options.itemsCustom.sort(function(t, e) {
                            return t[0] - e[0]
                        }), e.options.itemsCustom) void 0 !== e.options.itemsCustom[n] && e.options.itemsCustom[n][0] <= i && (e.options.items = e.options.itemsCustom[n][1]);
                else i <= e.options.itemsDesktop[0] && !1 !== e.options.itemsDesktop && (e.options.items = e.options.itemsDesktop[1]), i <= e.options.itemsDesktopSmall[0] && !1 !== e.options.itemsDesktopSmall && (e.options.items = e.options.itemsDesktopSmall[1]), i <= e.options.itemsTablet[0] && !1 !== e.options.itemsTablet && (e.options.items = e.options.itemsTablet[1]), i <= e.options.itemsTabletSmall[0] && !1 !== e.options.itemsTabletSmall && (e.options.items = e.options.itemsTabletSmall[1]), i <= e.options.itemsMobile[0] && !1 !== e.options.itemsMobile && (e.options.items = e.options.itemsMobile[1]);
                e.options.items > e.itemsAmount && !0 === e.options.itemsScaleUp && (e.options.items = e.itemsAmount)
            },
            response: function() {
                var i, n = this;
                if (!0 !== n.options.responsive) return !1;
                var o = t(e).width();
                n.resizer = function() {
                    t(e).width() !== o && (!1 !== n.options.autoPlay && clearInterval(n.autoPlayInterval), clearTimeout(i), i = setTimeout(function() {
                        o = t(e).width(), n.updateVars()
                    }, n.options.responsiveRefreshRate))
                }, t(e).resize(n.resizer)
            },
            updatePosition: function() {
                var t = this;
                t.jumpTo(t.currentItem), !1 !== t.options.autoPlay && t.checkAp()
            },
            appendItemsSizes: function() {
                var e = this,
                    i = 0,
                    n = e.itemsAmount - e.options.items;
                e.$owlItems.each(function(o) {
                    var r = t(this);
                    r.css({
                        width: e.itemWidth
                    }).data("owl-item", Number(o)), o % e.options.items != 0 && o !== n || o > n || (i += 1), r.data("owl-roundPages", i)
                })
            },
            appendWrapperSizes: function() {
                var t = this,
                    e = t.$owlItems.length * t.itemWidth;
                t.$owlWrapper.css({
                    width: 2 * e,
                    left: 0
                }), t.appendItemsSizes()
            },
            calculateAll: function() {
                var t = this;
                t.calculateWidth(), t.appendWrapperSizes(), t.loops(), t.max()
            },
            calculateWidth: function() {
                var t = this;
                t.itemWidth = Math.floor(t.$elem.width() / t.options.items)
            },
            max: function() {
                var t = this,
                    e = -1 * (t.itemsAmount * t.itemWidth - t.options.items * t.itemWidth);
                return t.options.items > t.itemsAmount ? (t.maximumItem = 0, e = 0, t.maximumPixels = 0) : (t.maximumItem = t.itemsAmount - t.options.items, t.maximumPixels = e), e
            },
            min: function() {
                return 0
            },
            loops: function() {
                var e = this;
                e.positionsInArray = [0], e.pagesInArray = [];
                for (var i = 0, n = 0, o = 0; o < e.itemsAmount; o++)
                    if (n += e.itemWidth, e.positionsInArray.push(-n), !0 === e.options.scrollPerPage) {
                        var r = t(e.$owlItems[o]).data("owl-roundPages");
                        r !== i && (e.pagesInArray[i] = e.positionsInArray[o], i = r)
                    }
            },
            buildControls: function() {
                var e = this;
                !0 !== e.options.navigation && !0 !== e.options.pagination || (e.owlControls = t('<div class="owl-controls"/>').toggleClass("clickable", !e.browser.isTouch).appendTo(e.$elem)), !0 === e.options.pagination && e.buildPagination(), !0 === e.options.navigation && e.buildButtons()
            },
            buildButtons: function() {
                var e = this,
                    i = t('<div class="owl-buttons"/>');
                e.owlControls.append(i), e.buttonPrev = t("<div/>", {
                    class: "owl-prev",
                    html: e.options.navigationText[0] || ""
                }), e.buttonNext = t("<div/>", {
                    class: "owl-next",
                    html: e.options.navigationText[1] || ""
                }), i.append(e.buttonPrev).append(e.buttonNext), i.on("touchstart.owlControls mousedown.owlControls", 'div[class^="owl"]', function(t) {
                    t.preventDefault()
                }), i.on("touchend.owlControls mouseup.owlControls", 'div[class^="owl"]', function(i) {
                    i.preventDefault(), t(this).hasClass("owl-next") ? e.next() : e.prev()
                })
            },
            buildPagination: function() {
                var e = this;
                e.paginationWrapper = t('<div class="owl-pagination"/>'), e.owlControls.append(e.paginationWrapper), e.paginationWrapper.on("touchend.owlControls mouseup.owlControls", ".owl-page", function(i) {
                    i.preventDefault(), Number(t(this).data("owl-page")) !== e.currentItem && e.goTo(Number(t(this).data("owl-page")), !0)
                })
            },
            updatePagination: function() {
                var e = this;
                if (!1 === e.options.pagination) return !1;
                e.paginationWrapper.html("");
                for (var i = 0, n = e.itemsAmount - e.itemsAmount % e.options.items, o = 0; o < e.itemsAmount; o++)
                    if (o % e.options.items == 0) {
                        if (i += 1, n === o) var r = e.itemsAmount - e.options.items;
                        var s = t("<div/>", {
                                class: "owl-page"
                            }),
                            a = t("<span></span>", {
                                text: !0 === e.options.paginationNumbers ? i : "",
                                class: !0 === e.options.paginationNumbers ? "owl-numbers" : ""
                            });
                        s.append(a), s.data("owl-page", n === o ? r : o), s.data("owl-roundPages", i), e.paginationWrapper.append(s)
                    } e.checkPagination()
            },
            checkPagination: function() {
                var e = this;
                if (!1 === e.options.pagination) return !1;
                e.paginationWrapper.find(".owl-page").each(function(i, n) {
                    t(this).data("owl-roundPages") === t(e.$owlItems[e.currentItem]).data("owl-roundPages") && (e.paginationWrapper.find(".owl-page").removeClass("active"), t(this).addClass("active"))
                })
            },
            checkNavigation: function() {
                var t = this;
                if (!1 === t.options.navigation) return !1;
                !1 === t.options.rewindNav && (0 === t.currentItem && 0 === t.maximumItem ? (t.buttonPrev.addClass("disabled"), t.buttonNext.addClass("disabled")) : 0 === t.currentItem && 0 !== t.maximumItem ? (t.buttonPrev.addClass("disabled"), t.buttonNext.removeClass("disabled")) : t.currentItem === t.maximumItem ? (t.buttonPrev.removeClass("disabled"), t.buttonNext.addClass("disabled")) : 0 !== t.currentItem && t.currentItem !== t.maximumItem && (t.buttonPrev.removeClass("disabled"), t.buttonNext.removeClass("disabled")))
            },
            updateControls: function() {
                var t = this;
                t.updatePagination(), t.checkNavigation(), t.owlControls && (t.options.items >= t.itemsAmount ? t.owlControls.hide() : t.owlControls.show())
            },
            destroyControls: function() {
                this.owlControls && this.owlControls.remove()
            },
            next: function(t) {
                var e = this;
                if (e.isTransition) return !1;
                if (e.currentItem += !0 === e.options.scrollPerPage ? e.options.items : 1, e.currentItem > e.maximumItem + (1 == e.options.scrollPerPage ? e.options.items - 1 : 0)) {
                    if (!0 !== e.options.rewindNav) return e.currentItem = e.maximumItem, !1;
                    e.currentItem = 0, t = "rewind"
                }
                e.goTo(e.currentItem, t)
            },
            prev: function(t) {
                var e = this;
                if (e.isTransition) return !1;
                if (!0 === e.options.scrollPerPage && e.currentItem > 0 && e.currentItem < e.options.items ? e.currentItem = 0 : e.currentItem -= !0 === e.options.scrollPerPage ? e.options.items : 1, e.currentItem < 0) {
                    if (!0 !== e.options.rewindNav) return e.currentItem = 0, !1;
                    e.currentItem = e.maximumItem, t = "rewind"
                }
                e.goTo(e.currentItem, t)
            },
            goTo: function(t, e, i) {
                var n = this;
                if (n.isTransition) return !1;
                if ("function" == typeof n.options.beforeMove && n.options.beforeMove.apply(this, [n.$elem]), t >= n.maximumItem ? t = n.maximumItem : t <= 0 && (t = 0), n.currentItem = n.owl.currentItem = t, !1 !== n.options.transitionStyle && "drag" !== i && 1 === n.options.items && !0 === n.browser.support3d) return n.swapSpeed(0), !0 === n.browser.support3d ? n.transition3d(n.positionsInArray[t]) : n.css2slide(n.positionsInArray[t], 1), n.afterGo(), n.singleItemTransition(), !1;
                var o = n.positionsInArray[t];
                !0 === n.browser.support3d ? (n.isCss3Finish = !1, !0 === e ? (n.swapSpeed("paginationSpeed"), setTimeout(function() {
                    n.isCss3Finish = !0
                }, n.options.paginationSpeed)) : "rewind" === e ? (n.swapSpeed(n.options.rewindSpeed), setTimeout(function() {
                    n.isCss3Finish = !0
                }, n.options.rewindSpeed)) : (n.swapSpeed("slideSpeed"), setTimeout(function() {
                    n.isCss3Finish = !0
                }, n.options.slideSpeed)), n.transition3d(o)) : !0 === e ? n.css2slide(o, n.options.paginationSpeed) : "rewind" === e ? n.css2slide(o, n.options.rewindSpeed) : n.css2slide(o, n.options.slideSpeed), n.afterGo()
            },
            jumpTo: function(t) {
                var e = this;
                "function" == typeof e.options.beforeMove && e.options.beforeMove.apply(this, [e.$elem]), t >= e.maximumItem || -1 === t ? t = e.maximumItem : t <= 0 && (t = 0), e.swapSpeed(0), !0 === e.browser.support3d ? e.transition3d(e.positionsInArray[t]) : e.css2slide(e.positionsInArray[t], 1), e.currentItem = e.owl.currentItem = t, e.afterGo()
            },
            afterGo: function() {
                var t = this;
                t.prevArr.push(t.currentItem), t.prevItem = t.owl.prevItem = t.prevArr[t.prevArr.length - 2], t.prevArr.shift(0), t.prevItem !== t.currentItem && (t.checkPagination(), t.checkNavigation(), t.eachMoveUpdate(), !1 !== t.options.autoPlay && t.checkAp()), "function" == typeof t.options.afterMove && t.prevItem !== t.currentItem && t.options.afterMove.apply(this, [t.$elem])
            },
            stop: function() {
                this.apStatus = "stop", clearInterval(this.autoPlayInterval)
            },
            checkAp: function() {
                "stop" !== this.apStatus && this.play()
            },
            play: function() {
                var t = this;
                if (t.apStatus = "play", !1 === t.options.autoPlay) return !1;
                clearInterval(t.autoPlayInterval), t.autoPlayInterval = setInterval(function() {
                    t.next(!0)
                }, t.options.autoPlay)
            },
            swapSpeed: function(t) {
                var e = this;
                "slideSpeed" === t ? e.$owlWrapper.css(e.addCssSpeed(e.options.slideSpeed)) : "paginationSpeed" === t ? e.$owlWrapper.css(e.addCssSpeed(e.options.paginationSpeed)) : "string" != typeof t && e.$owlWrapper.css(e.addCssSpeed(t))
            },
            addCssSpeed: function(t) {
                return {
                    "-webkit-transition": "all " + t + "ms ease",
                    "-moz-transition": "all " + t + "ms ease",
                    "-o-transition": "all " + t + "ms ease",
                    transition: "all " + t + "ms ease"
                }
            },
            removeTransition: function() {
                return {
                    "-webkit-transition": "",
                    "-moz-transition": "",
                    "-o-transition": "",
                    transition: ""
                }
            },
            doTranslate: function(t) {
                return {
                    "-webkit-transform": "translate3d(" + t + "px, 0px, 0px)",
                    "-moz-transform": "translate3d(" + t + "px, 0px, 0px)",
                    "-o-transform": "translate3d(" + t + "px, 0px, 0px)",
                    "-ms-transform": "translate3d(" + t + "px, 0px, 0px)",
                    transform: "translate3d(" + t + "px, 0px,0px)"
                }
            },
            transition3d: function(t) {
                this.$owlWrapper.css(this.doTranslate(t))
            },
            css2move: function(t) {
                this.$owlWrapper.css({
                    left: t
                })
            },
            css2slide: function(t, e) {
                var i = this;
                i.isCssFinish = !1, i.$owlWrapper.stop(!0, !0).animate({
                    left: t
                }, {
                    duration: e || i.options.slideSpeed,
                    complete: function() {
                        i.isCssFinish = !0
                    }
                })
            },
            checkBrowser: function() {
                var t = "translate3d(0px, 0px, 0px)",
                    n = i.createElement("div");
                n.style.cssText = "  -moz-transform:" + t + "; -ms-transform:" + t + "; -o-transform:" + t + "; -webkit-transform:" + t + "; transform:" + t;
                var o = n.style.cssText.match(/translate3d\(0px, 0px, 0px\)/g),
                    r = null !== o && 1 === o.length,
                    s = "ontouchstart" in e || navigator.msMaxTouchPoints;
                this.browser = {
                    support3d: r,
                    isTouch: s
                }
            },
            moveEvents: function() {
                var t = this;
                !1 === t.options.mouseDrag && !1 === t.options.touchDrag || (t.gestures(), t.disabledEvents())
            },
            eventTypes: function() {
                var t = this,
                    e = ["s", "e", "x"];
                t.ev_types = {}, !0 === t.options.mouseDrag && !0 === t.options.touchDrag ? e = ["touchstart.owl mousedown.owl", "touchmove.owl mousemove.owl", "touchend.owl touchcancel.owl mouseup.owl"] : !1 === t.options.mouseDrag && !0 === t.options.touchDrag ? e = ["touchstart.owl", "touchmove.owl", "touchend.owl touchcancel.owl"] : !0 === t.options.mouseDrag && !1 === t.options.touchDrag && (e = ["mousedown.owl", "mousemove.owl", "mouseup.owl"]), t.ev_types.start = e[0], t.ev_types.move = e[1], t.ev_types.end = e[2]
            },
            disabledEvents: function() {
                this.$elem.on("dragstart.owl", function(t) {
                    t.preventDefault()
                }), this.$elem.on("mousedown.disableTextSelect", function(e) {
                    return t(e.target).is("input, textarea, select, option")
                })
            },
            gestures: function() {
                function o(t) {
                    return t.touches ? {
                        x: t.touches[0].pageX,
                        y: t.touches[0].pageY
                    } : t.pageX !== n ? {
                        x: t.pageX,
                        y: t.pageY
                    } : {
                        x: t.clientX,
                        y: t.clientY
                    }
                }

                function r(e) {
                    "on" === e ? (t(i).on(l.ev_types.move, s), t(i).on(l.ev_types.end, a)) : "off" === e && (t(i).off(l.ev_types.move), t(i).off(l.ev_types.end))
                }

                function s(n) {
                    n = n.originalEvent || n || e.event;
                    l.newPosX = o(n).x - u.offsetX, l.newPosY = o(n).y - u.offsetY, l.newRelativeX = l.newPosX - u.relativePos, "function" == typeof l.options.startDragging && !0 !== u.dragging && 0 !== l.newRelativeX && (u.dragging = !0, l.options.startDragging.apply(l, [l.$elem])), (l.newRelativeX > 8 || l.newRelativeX < -8 && !0 === l.browser.isTouch) && (n.preventDefault ? n.preventDefault() : n.returnValue = !1, u.sliding = !0), (l.newPosY > 10 || l.newPosY < -10) && !1 === u.sliding && t(i).off("touchmove.owl"), l.newPosX = Math.max(Math.min(l.newPosX, l.newRelativeX / 5), l.maximumPixels + l.newRelativeX / 5), !0 === l.browser.support3d ? l.transition3d(l.newPosX) : l.css2move(l.newPosX)
                }

                function a(i) {
                    if ((i = i.originalEvent || i || e.event).target = i.target || i.srcElement, u.dragging = !1, !0 !== l.browser.isTouch && l.$owlWrapper.removeClass("grabbing"), l.newRelativeX < 0 ? l.dragDirection = l.owl.dragDirection = "left" : l.dragDirection = l.owl.dragDirection = "right", 0 !== l.newRelativeX) {
                        var n = l.getNewPosition();
                        if (l.goTo(n, !1, "drag"), u.targetElement === i.target && !0 !== l.browser.isTouch) {
                            t(i.target).on("click.disable", function(e) {
                                e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault(), t(i.target).off("click.disable")
                            });
                            var o = t._data(i.target, "events").click,
                                s = o.pop();
                            o.splice(0, 0, s)
                        }
                    }
                    r("off")
                }
                var l = this,
                    u = {
                        offsetX: 0,
                        offsetY: 0,
                        baseElWidth: 0,
                        relativePos: 0,
                        position: null,
                        minSwipe: null,
                        maxSwipe: null,
                        sliding: null,
                        dargging: null,
                        targetElement: null
                    };
                l.isCssFinish = !0, l.$elem.on(l.ev_types.start, ".owl-wrapper", function(i) {
                    if (3 === (i = i.originalEvent || i || e.event).which) return !1;
                    if (!(l.itemsAmount <= l.options.items)) {
                        if (!1 === l.isCssFinish && !l.options.dragBeforeAnimFinish) return !1;
                        if (!1 === l.isCss3Finish && !l.options.dragBeforeAnimFinish) return !1;
                        !1 !== l.options.autoPlay && clearInterval(l.autoPlayInterval), !0 === l.browser.isTouch || l.$owlWrapper.hasClass("grabbing") || l.$owlWrapper.addClass("grabbing"), l.newPosX = 0, l.newRelativeX = 0, t(this).css(l.removeTransition());
                        var n = t(this).position();
                        u.relativePos = n.left, u.offsetX = o(i).x - n.left, u.offsetY = o(i).y - n.top, r("on"), u.sliding = !1, u.targetElement = i.target || i.srcElement
                    }
                })
            },
            getNewPosition: function() {
                var t, e = this;
                return (t = e.closestItem()) > e.maximumItem ? (e.currentItem = e.maximumItem, t = e.maximumItem) : e.newPosX >= 0 && (t = 0, e.currentItem = 0), t
            },
            closestItem: function() {
                var e = this,
                    i = !0 === e.options.scrollPerPage ? e.pagesInArray : e.positionsInArray,
                    n = e.newPosX,
                    o = null;
                return t.each(i, function(r, s) {
                    n - e.itemWidth / 20 > i[r + 1] && n - e.itemWidth / 20 < s && "left" === e.moveDirection() ? (o = s, !0 === e.options.scrollPerPage ? e.currentItem = t.inArray(o, e.positionsInArray) : e.currentItem = r) : n + e.itemWidth / 20 < s && n + e.itemWidth / 20 > (i[r + 1] || i[r] - e.itemWidth) && "right" === e.moveDirection() && (!0 === e.options.scrollPerPage ? (o = i[r + 1] || i[i.length - 1], e.currentItem = t.inArray(o, e.positionsInArray)) : (o = i[r + 1], e.currentItem = r + 1))
                }), e.currentItem
            },
            moveDirection: function() {
                var t, e = this;
                return e.newRelativeX < 0 ? (t = "right", e.playDirection = "next") : (t = "left", e.playDirection = "prev"), t
            },
            customEvents: function() {
                var t = this;
                t.$elem.on("owl.next", function() {
                    t.next()
                }), t.$elem.on("owl.prev", function() {
                    t.prev()
                }), t.$elem.on("owl.play", function(e, i) {
                    t.options.autoPlay = i, t.play(), t.hoverStatus = "play"
                }), t.$elem.on("owl.stop", function() {
                    t.stop(), t.hoverStatus = "stop"
                }), t.$elem.on("owl.goTo", function(e, i) {
                    t.goTo(i)
                }), t.$elem.on("owl.jumpTo", function(e, i) {
                    t.jumpTo(i)
                })
            },
            stopOnHover: function() {
                var t = this;
                !0 === t.options.stopOnHover && !0 !== t.browser.isTouch && !1 !== t.options.autoPlay && (t.$elem.on("mouseover", function() {
                    t.stop()
                }), t.$elem.on("mouseout", function() {
                    "stop" !== t.hoverStatus && t.play()
                }))
            },
            lazyLoad: function() {
                var e = this;
                if (!1 === e.options.lazyLoad) return !1;
                for (var i = 0; i < e.itemsAmount; i++) {
                    var o = t(e.$owlItems[i]);
                    if ("loaded" !== o.data("owl-loaded")) {
                        var r = o.data("owl-item"),
                            s = o.find(".lazyOwl");
                        "string" == typeof s.data("src") ? (o.data("owl-loaded") === n && (s.hide(), o.addClass("loading").data("owl-loaded", "checked")), (!0 !== e.options.lazyFollow || r >= e.currentItem) && r < e.currentItem + e.options.items && s.length && e.lazyPreload(o, s)) : o.data("owl-loaded", "loaded")
                    }
                }
            },
            lazyPreload: function(t, e) {
                function i() {
                    t.data("owl-loaded", "loaded").removeClass("loading"), e.removeAttr("data-src"), "fade" === n.options.lazyEffect ? e.fadeIn(400) : e.show(), "function" == typeof n.options.afterLazyLoad && n.options.afterLazyLoad.apply(this, [n.$elem])
                }
                var n = this,
                    o = 0;
                if ("DIV" === e.prop("tagName")) {
                    e.css("background-image", "url(" + e.data("src") + ")");
                    var r = !0
                } else e[0].src = e.data("src");
                ! function t() {
                    o += 1, n.completeImg(e.get(0)) || !0 === r ? i() : o <= 100 ? setTimeout(t, 100) : i()
                }()
            },
            autoHeight: function() {
                function e() {
                    var e = t(i.$owlItems[i.currentItem]).height();
                    i.wrapperOuter.css("height", e + "px"), i.wrapperOuter.hasClass("autoHeight") || setTimeout(function() {
                        i.wrapperOuter.addClass("autoHeight")
                    }, 0)
                }
                var i = this,
                    o = t(i.$owlItems[i.currentItem]).find("img");
                if (o.get(0) !== n) {
                    var r = 0;
                    ! function t() {
                        r += 1, i.completeImg(o.get(0)) ? e() : r <= 100 ? setTimeout(t, 100) : i.wrapperOuter.css("height", "")
                    }()
                } else e()
            },
            completeImg: function(t) {
                return !!t.complete && (void 0 === t.naturalWidth || 0 != t.naturalWidth)
            },
            onVisibleItems: function() {
                var e = this;
                !0 === e.options.addClassActive && e.$owlItems.removeClass("active"), e.visibleItems = [];
                for (var i = e.currentItem; i < e.currentItem + e.options.items; i++) e.visibleItems.push(i), !0 === e.options.addClassActive && t(e.$owlItems[i]).addClass("active");
                e.owl.visibleItems = e.visibleItems
            },
            transitionTypes: function(t) {
                this.outClass = "owl-" + t + "-out", this.inClass = "owl-" + t + "-in"
            },
            singleItemTransition: function() {
                var t = this;
                t.isTransition = !0;
                var e = t.outClass,
                    i = t.inClass,
                    n = t.$owlItems.eq(t.currentItem),
                    o = t.$owlItems.eq(t.prevItem),
                    r = Math.abs(t.positionsInArray[t.currentItem]) + t.positionsInArray[t.prevItem],
                    s = Math.abs(t.positionsInArray[t.currentItem]) + t.itemWidth / 2;
                t.$owlWrapper.addClass("owl-origin").css({
                    "-webkit-transform-origin": s + "px",
                    "-moz-perspective-origin": s + "px",
                    "perspective-origin": s + "px"
                });
                var a = "webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";
                o.css({
                    position: "relative",
                    left: r + "px"
                }).addClass(e).on(a, function() {
                    t.endPrev = !0, o.off(a), t.clearTransStyle(o, e)
                }), n.addClass(i).on(a, function() {
                    t.endCurrent = !0, n.off(a), t.clearTransStyle(n, i)
                })
            },
            clearTransStyle: function(t, e) {
                var i = this;
                t.css({
                    position: "",
                    left: ""
                }).removeClass(e), i.endPrev && i.endCurrent && (i.$owlWrapper.removeClass("owl-origin"), i.endPrev = !1, i.endCurrent = !1, i.isTransition = !1)
            },
            owlStatus: function() {
                var t = this;
                t.owl = {
                    userOptions: t.userOptions,
                    baseElement: t.$elem,
                    userItems: t.$userItems,
                    owlItems: t.$owlItems,
                    currentItem: t.currentItem,
                    prevItem: t.prevItem,
                    visibleItems: t.visibleItems,
                    isTouch: t.browser.isTouch,
                    browser: t.browser,
                    dragDirection: t.dragDirection
                }
            },
            clearEvents: function() {
                this.$elem.off(".owl owl mousedown.disableTextSelect"), t(i).off(".owl owl"), t(e).off("resize", this.resizer)
            },
            unWrap: function() {
                var t = this;
                0 !== t.$elem.children().length && (t.$owlWrapper.unwrap(), t.$userItems.unwrap().unwrap(), t.owlControls && t.owlControls.remove()), t.clearEvents(), t.$elem.attr("style", t.$elem.data("owl-originalStyles") || "").attr("class", t.$elem.data("owl-originalClasses"))
            },
            destroy: function() {
                var t = this;
                t.stop(), clearInterval(t.checkVisible), t.unWrap(), t.$elem.removeData()
            },
            reinit: function(e) {
                var i = this,
                    n = t.extend({}, i.userOptions, e);
                i.unWrap(), i.init(n, i.$elem)
            },
            addItem: function(t, e) {
                var i, o = this;
                return !!t && (0 === o.$elem.children().length ? (o.$elem.append(t), o.setVars(), !1) : (o.unWrap(), (i = e === n || -1 === e ? -1 : e) >= o.$userItems.length || -1 === i ? o.$userItems.eq(-1).after(t) : o.$userItems.eq(i).before(t), void o.setVars()))
            },
            removeItem: function(t) {
                var e, i = this;
                if (0 === i.$elem.children().length) return !1;
                e = t === n || -1 === t ? -1 : t, i.unWrap(), i.$userItems.eq(e).remove(), i.setVars()
            }
        };
        t.fn.owlCarousel = function(e) {
            return this.each(function() {
                if (!0 === t(this).data("owl-init")) return !1;
                t(this).data("owl-init", !0);
                var i = Object.create(o);
                i.init(e, this), t.data(this, "owlCarousel", i)
            })
        }, t.fn.owlCarousel.options = {
            items: 5,
            itemsCustom: !1,
            itemsDesktop: [1199, 4],
            itemsDesktopSmall: [979, 3],
            itemsTablet: [768, 2],
            itemsTabletSmall: !1,
            itemsMobile: [479, 1],
            singleItem: !1,
            itemsScaleUp: !1,
            slideSpeed: 200,
            paginationSpeed: 800,
            rewindSpeed: 1e3,
            autoPlay: !1,
            stopOnHover: !1,
            navigation: !1,
            navigationText: ["prev", "next"],
            rewindNav: !0,
            scrollPerPage: !1,
            pagination: !0,
            paginationNumbers: !1,
            responsive: !0,
            responsiveRefreshRate: 200,
            responsiveBaseWidth: e,
            baseClass: "owl-carousel",
            theme: "owl-theme",
            lazyLoad: !1,
            lazyFollow: !0,
            lazyEffect: "fade",
            autoHeight: !1,
            jsonPath: !1,
            jsonSuccess: !1,
            dragBeforeAnimFinish: !0,
            mouseDrag: !0,
            touchDrag: !0,
            addClassActive: !1,
            transitionStyle: !1,
            beforeUpdate: !1,
            afterUpdate: !1,
            beforeInit: !1,
            afterInit: !1,
            beforeMove: !1,
            afterMove: !1,
            afterAction: !1,
            startDragging: !1,
            afterLazyLoad: !1
        }
    }(jQuery, window, document),
    function(t, e) {
        "object" == typeof exports ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Spinner = e()
    }(this, function() {
        "use strict";

        function t(t, e) {
            var i, n = document.createElement(t || "div");
            for (i in e) n[i] = e[i];
            return n
        }

        function e(t) {
            for (var e = 1, i = arguments.length; e < i; e++) t.appendChild(arguments[e]);
            return t
        }

        function i(t, e, i, n) {
            var o = ["opacity", e, ~~(100 * t), i, n].join("-"),
                r = .01 + i / n * 100,
                s = Math.max(1 - (1 - t) / e * (100 - r), t),
                a = u.substring(0, u.indexOf("Animation")).toLowerCase(),
                l = a && "-" + a + "-" || "";
            return d[o] || (p.insertRule("@" + l + "keyframes " + o + "{0%{opacity:" + s + "}" + r + "%{opacity:" + t + "}" + (r + .01) + "%{opacity:1}" + (r + e) % 100 + "%{opacity:" + t + "}100%{opacity:" + s + "}}", p.cssRules.length), d[o] = 1), o
        }

        function n(t, e) {
            var i, n, o = t.style;
            for (e = e.charAt(0).toUpperCase() + e.slice(1), n = 0; n < c.length; n++)
                if (void 0 !== o[i = c[n] + e]) return i;
            if (void 0 !== o[e]) return e
        }

        function o(t, e) {
            for (var i in e) t.style[n(t, i) || i] = e[i];
            return t
        }

        function r(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var n in i) void 0 === t[n] && (t[n] = i[n])
            }
            return t
        }

        function s(t) {
            for (var e = {
                    x: t.offsetLeft,
                    y: t.offsetTop
                }; t = t.offsetParent;) e.x += t.offsetLeft, e.y += t.offsetTop;
            return e
        }

        function a(t, e) {
            return "string" == typeof t ? t : t[e % t.length]
        }

        function l(t) {
            if (void 0 === this) return new l(t);
            this.opts = r(t || {}, l.defaults, h)
        }
        var u, c = ["webkit", "Moz", "ms", "O"],
            d = {},
            p = function() {
                var i = t("style", {
                    type: "text/css"
                });
                return e(document.getElementsByTagName("head")[0], i), i.sheet || i.styleSheet
            }(),
            h = {
                lines: 12,
                length: 7,
                width: 5,
                radius: 10,
                rotate: 0,
                corners: 1,
                color: "#000",
                direction: 1,
                speed: 1,
                trail: 100,
                opacity: .25,
                fps: 20,
                zIndex: 2e9,
                className: "spinner",
                top: "auto",
                left: "auto",
                position: "relative"
            };
        l.defaults = {}, r(l.prototype, {
            spin: function(e) {
                this.stop();
                var i, n, r = this,
                    a = r.opts,
                    l = r.el = o(t(0, {
                        className: a.className
                    }), {
                        position: a.position,
                        width: 0,
                        zIndex: a.zIndex
                    }),
                    c = a.radius + a.length + a.width;
                if (e && (e.insertBefore(l, e.firstChild || null), n = s(e), i = s(l), o(l, {
                        left: ("auto" == a.left ? n.x - i.x + (e.offsetWidth >> 1) : parseInt(a.left, 10) + c) + "px",
                        top: ("auto" == a.top ? n.y - i.y + (e.offsetHeight >> 1) : parseInt(a.top, 10) + c) + "px"
                    })), l.setAttribute("role", "progressbar"), r.lines(l, r.opts), !u) {
                    var d, p = 0,
                        h = (a.lines - 1) * (1 - a.direction) / 2,
                        f = a.fps,
                        m = f / a.speed,
                        g = (1 - a.opacity) / (m * a.trail / 100),
                        v = m / a.lines;
                    ! function t() {
                        p++;
                        for (var e = 0; e < a.lines; e++) d = Math.max(1 - (p + (a.lines - e) * v) % m * g, a.opacity), r.opacity(l, e * a.direction + h, d, a);
                        r.timeout = r.el && setTimeout(t, ~~(1e3 / f))
                    }()
                }
                return r
            },
            stop: function() {
                var t = this.el;
                return t && (clearTimeout(this.timeout), t.parentNode && t.parentNode.removeChild(t), this.el = void 0), this
            },
            lines: function(n, r) {
                function s(e, i) {
                    return o(t(), {
                        position: "absolute",
                        width: r.length + r.width + "px",
                        height: r.width + "px",
                        background: e,
                        boxShadow: i,
                        transformOrigin: "left",
                        transform: "rotate(" + ~~(360 / r.lines * c + r.rotate) + "deg) translate(" + r.radius + "px,0)",
                        borderRadius: (r.corners * r.width >> 1) + "px"
                    })
                }
                for (var l, c = 0, d = (r.lines - 1) * (1 - r.direction) / 2; c < r.lines; c++) l = o(t(), {
                    position: "absolute",
                    top: 1 + ~(r.width / 2) + "px",
                    transform: r.hwaccel ? "translate3d(0,0,0)" : "",
                    opacity: r.opacity,
                    animation: u && i(r.opacity, r.trail, d + c * r.direction, r.lines) + " " + 1 / r.speed + "s linear infinite"
                }), r.shadow && e(l, o(s("#000", "0 0 4px #000"), {
                    top: "2px"
                })), e(n, e(l, s(a(r.color, c), "0 0 1px rgba(0,0,0,.1)")));
                return n
            },
            opacity: function(t, e, i) {
                e < t.childNodes.length && (t.childNodes[e].style.opacity = i)
            }
        });
        var f = o(t("group"), {
            behavior: "url(#default#VML)"
        });
        return !n(f, "transform") && f.adj ? function() {
            function i(e, i) {
                return t("<" + e + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', i)
            }
            p.addRule(".spin-vml", "behavior:url(#default#VML)"), l.prototype.lines = function(t, n) {
                function r() {
                    return o(i("group", {
                        coordsize: c + " " + c,
                        coordorigin: -u + " " + -u
                    }), {
                        width: c,
                        height: c
                    })
                }

                function s(t, s, l) {
                    e(p, e(o(r(), {
                        rotation: 360 / n.lines * t + "deg",
                        left: ~~s
                    }), e(o(i("roundrect", {
                        arcsize: n.corners
                    }), {
                        width: u,
                        height: n.width,
                        left: n.radius,
                        top: -n.width >> 1,
                        filter: l
                    }), i("fill", {
                        color: a(n.color, t),
                        opacity: n.opacity
                    }), i("stroke", {
                        opacity: 0
                    }))))
                }
                var l, u = n.length + n.width,
                    c = 2 * u,
                    d = 2 * -(n.width + n.length) + "px",
                    p = o(r(), {
                        position: "absolute",
                        top: d,
                        left: d
                    });
                if (n.shadow)
                    for (l = 1; l <= n.lines; l++) s(l, -2, "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");
                for (l = 1; l <= n.lines; l++) s(l);
                return e(t, p)
            }, l.prototype.opacity = function(t, e, i, n) {
                var o = t.firstChild;
                n = n.shadow && n.lines || 0, o && e + n < o.childNodes.length && ((o = (o = (o = o.childNodes[e + n]) && o.firstChild) && o.firstChild) && (o.opacity = i))
            }
        }() : u = n(f, "animation"), l
    }),
    function(t) {
        if ("object" == typeof exports) t(require("jquery"), require("spin"));
        else if ("function" == typeof define && define.amd) define(["jquery", "spin"], t);
        else {
            if (!window.Spinner) throw new Error("Spin.js not present");
            t(window.jQuery, window.Spinner)
        }
    }(function(t, e) {
        t.fn.spin = function(i, n) {
            return this.each(function() {
                var o = t(this),
                    r = o.data();
                r.spinner && (r.spinner.stop(), delete r.spinner), !1 !== i && (i = t.extend({
                    color: n || o.css("color")
                }, t.fn.spin.presets[i] || i), r.spinner = new e(i).spin(this))
            })
        }, t.fn.spin.presets = {
            tiny: {
                lines: 8,
                length: 2,
                width: 2,
                radius: 3
            },
            small: {
                lines: 8,
                length: 4,
                width: 3,
                radius: 5
            },
            large: {
                lines: 10,
                length: 8,
                width: 4,
                radius: 8
            }
        }
    }),
    function() {
        var t, e, i, n, o, r, s, a, l, u, c, d, p, h, f, m, g, v, y = function(t, e) {
                return function() {
                    return t.apply(e, arguments)
                }
            },
            w = function(t, e) {
                function i() {
                    this.constructor = t
                }
                for (var n in e) b.call(e, n) && (t[n] = e[n]);
                return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
            },
            b = {}.hasOwnProperty;
        (function() {
            function t(t, e) {
                this.element = t, this.type = e, this.resizeListeners = y(this.resizeListeners, this), this.fillYSpace = y(this.fillYSpace, this), this.checkOverlap = y(this.checkOverlap, this), this.createOverlapDetectors = y(this.createOverlapDetectors, this), this.position = y(this.position, this), this.parent = this.element.parent(), this.left_side_border, this.right_element_width = null, this.position(), this.fillYSpace(), this.createOverlapDetectors(), this.resizeListeners()
            }
            t.prototype.position = function() {
                if ("center-x" === this.type) return this.element.css({
                    "margin-left": -this.element.outerWidth() / 2
                })
            }, t.prototype.createOverlapDetectors = function() {
                if (this, "right" === this.type) return this.right_element_width = this.element.outerWidth()
            }, t.prototype.checkOverlap = function() {
                var t, e;
                if ("right" === (t = this).type && (t.parent.removeClass("overlap"), (e = t.parent.children().eq(t.element.index() - 1)).position().left + e.outerWidth() >= t.parent.outerWidth() - t.right_element_width)) return t.parent.addClass("overlap")
            }, t.prototype.fillYSpace = function() {
                var t, e, i;
                if ("fill-y--dynamic" === (t = this).type) return e = t.parent.outerHeight(), i = t.parent.find(".fw--align--fill-y--fixed").outerHeight(), t.element.outerHeight(e - i)
            }, t.prototype.resizeListeners = function() {
                var t;
                return t = this, $(window).on("resize.FrameworkAlign", function() {
                    return t.checkOverlap(), t.fillYSpace()
                }), setTimeout(function() {
                    return t.checkOverlap()
                }, 1)
            }
        })(), theme.classes.FrameworkAnimation = function() {
            return function() {}
        }(), theme.classes.FrameworkArticle = function() {
            function t(t) {
                this.root = t, this.startDisqus = y(this.startDisqus, this), this.load = y(this.load, this), this.load()
            }
            return t.prototype.load = function() {
                var t, e;
                if (this, e = $(".article--root").attr("data-enable-disqus"), t = $(".article--root").attr("data-comments-enabled"), e && t) return this.startDisqus()
            }, t.prototype.startDisqus = function() {
                var t;
                return this, t = $(".article--root").attr("data-disqus-shortname"),
                    function() {
                        var e;
                        return (e = document.createElement("script")).src = "https://" + t + ".disqus.com/embed.js", e.setAttribute("data-timestamp", +new Date), (document.head || document.body).appendChild(e)
                    }()
            }, t
        }(), theme.classes.FrameworkBlog = function() {
            function t(t) {
                this.root = t, this.initMasonry = y(this.initMasonry, this), this.eventListeners = y(this.eventListeners, this), this.load = y(this.load, this), this.load()
            }
            return t.prototype.load = function() {
                var t;
                if ((t = this).eventListeners(), t.has_multi_columns = "1" !== t.root.attr("data-columns"), "small" !== theme.utils.mqs.current_window && t.has_multi_columns) return t.initMasonry(), $(window).load(function() {
                    return t.initMasonry()
                })
            }, t.prototype.eventListeners = function() {
                var t;
                return t = this, $(window).on("resize.Blog", theme.utils.debounce(100, function() {
                    return t.has_multi_columns && "small" !== theme.utils.mqs.current_window ? t.initMasonry() : $(".blog--list").masonry("destroy")
                }))
            }, t.prototype.initMasonry = function() {
                return $(".blog--list").masonry({
                    itemSelector: ".blog--list--item",
                    percentPosition: !0,
                    horizontalOrder: !0,
                    columnWidth: ".blog--list--item"
                })
            }, t
        }(), theme.classes.FrameworkCart = function() {
            function t(t) {
                var e;
                this.root = t, this.isNaN = y(this.isNaN, this), this.renderDynamicCheckoutButtons = y(this.renderDynamicCheckoutButtons, this), this.updateCurrencies = y(this.updateCurrencies, this), this.updateTotals = y(this.updateTotals, this), this.updateAllHasItems = y(this.updateAllHasItems, this), this.swapInImages = y(this.swapInImages, this), this.updateHtml = y(this.updateHtml, this), this.updateAllHtml = y(this.updateAllHtml, this), this.getHtml = y(this.getHtml, this), this.removeItem = y(this.removeItem, this), this.updateQuantity = y(this.updateQuantity, this), this.addItem = y(this.addItem, this), this.clearRequests = y(this.clearRequests, this), this.htmlListener = y(this.htmlListener, this), this.removeButtonListener = y(this.removeButtonListener, this), this.minusButtonListener = y(this.minusButtonListener, this), this.plusButtonListener = y(this.plusButtonListener, this), this.inputBoxListener = y(this.inputBoxListener, this), this.eventListeners = y(this.eventListeners, this), this.getAjaxUrl = y(this.getAjaxUrl, this), this.getOtherCarts = y(this.getOtherCarts, this), (e = this).ajaxReq = {}, e.other_carts = e.getOtherCarts(), e.total_item_count = $(".cart--external--total-items"), e.total_price = $(".cart--external--total-price"), e.updateTimer = {}, e.view = e.root.data("view"), e.getAjaxUrl(), e.updateTotals(), e.htmlListener(), e.eventListeners(), e.renderDynamicCheckoutButtons()
            }
            return t.prototype.getOtherCarts = function() {
                return this, $('[data-js-class="Cart"]').not(this.root)
            }, t.prototype.getAjaxUrl = function() {
                var t;
                // return (t = this).ajax_url = window.location.href, t.ajax_url = t.ajax_url.replace(window.location.hostname + window.location.pathname, window.location.hostname + "/cart"), t.ajax_url = t.ajax_url.replace("#", ""), t.ajax_url.indexOf("?") >= 0 ? t.ajax_url = t.ajax_url + "&" : t.ajax_url = t.ajax_url + "?", t.ajax_desktop_url = t.ajax_url + "view=ajax--desktop", t.ajax_mobile_url = t.ajax_url + "view=ajax--mobile"
            }, t.prototype.eventListeners = function() {
                var t;
                return (t = this).inputBoxListener(), t.plusButtonListener(), t.minusButtonListener(), t.removeButtonListener()
            }, t.prototype.inputBoxListener = function() {
                var t, e;
                return (e = (t = this).root.find(".cart--quantity--input")).on("keydown", function(t) {
                    if ((t.which < 48 || t.which > 57) && 8 !== t.which && 37 !== t.which && 39 !== t.which && 9 !== t.which) return t.preventDefault()
                }), e.on("keyup", function(e) {
                    var i, n;
                    if ($(this).attr("data-loading", "true"), i = $(this).closest(".cart--item").data("item-key"), t.clearRequests(i), 8 !== e.which || 0 !== $(this).val().length) return 0 !== (n = t.isNaN(parseInt($(this).val())) ? 1 : parseInt($(this).val())) ? t.updateQuantity(i, n, 700, function(e) {
                        if (e) return t.updateAllHtml(function() {})
                    }) : t.removeItem(i)
                })
            }, t.prototype.plusButtonListener = function() {
                var t;
                return (t = this).root.find(".cart--item--quantity .plus").on("click", function() {
                    var e, i, n;
                    return e = $(this).prev("input"), n = t.isNaN(parseInt(e.val())) ? 1 : parseInt(e.val()) + 1, e.val(n), e.attr("data-loading", "true"), i = $(this).closest(".cart--item").data("item-key"), t.clearRequests(i), t.updateQuantity(i, n, 700, function(e) {
                        if (e) return t.updateAllHtml(function() {})
                    }), !1
                })
            }, t.prototype.minusButtonListener = function() {
                var t;
                return (t = this).root.find(".cart--item--quantity .minus").on("click", function() {
                    var e, i, n;
                    return e = $(this).next("input"), (n = t.isNaN(parseInt(e.val())) ? 1 : parseInt(e.val()) - 1) < 1 ? (n = 1, !1) : (e.val(n), e.attr("data-loading", "true"), i = $(this).closest(".cart--item").data("item-key"), t.clearRequests(i), t.updateQuantity(i, n, 700, function(e) {
                        if (e) return t.updateAllHtml(function() {})
                    }), !1)
                })
            }, t.prototype.removeButtonListener = function() {
                var t;
                return (t = this).root.find(".cart--item--remove").on("click", function() {
                    var e, i;
                    return i = (e = $(this).closest(".cart--item")).data("item-key"), e.find("input").attr("data-loading", "true"), t.clearRequests(i), t.removeItem(i), !1
                })
            }, t.prototype.htmlListener = function() {
                var t;
                return (t = this).root.on("updateHtml", function() {
                    return t.updateHtml(function() {})
                })
            }, t.prototype.clearRequests = function(t) {
                var e;
                if ((e = this).ajaxReq.item_key && e.ajaxReq.item_key.abort(), e.updateTimer.item_key) return clearTimeout(e.updateTimer.item_key)
            }, t.prototype.addItem = function(t, e) {
                var i;
                return i = this, $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: t.serialize()
                }).done(function(t, n, o) {
                    return e(!0), i.updateAllHasItems(1, !0), i.updateTotals()
                }).fail(function(t, i) {
                    return console.log("Error - ajax update quantity", $.parseJSON(t.responseText).description), e(!1, $.parseJSON(t.responseText).description)
                })
            }, t.prototype.updateQuantity = function(t, e, i, n) {
                var o, r;
                return r = function() {
                    return o.ajaxReq.item_key = $.ajax({
                        type: "POST",
                        url: "/cart/change.js",
                        dataType: "json",
                        data: "quantity=" + e + "&id=" + t
                    }).done(function(t, e, i) {
                        return n(!0), o.updateTotals()
                    }).fail(function(t, e) {
                        return t.responseText && console.log("Error - ajax update quantity", $.parseJSON(t.responseText).description), n(!1)
                    })
                }, (o = this).updateTimer.item_key = setTimeout(r, i)
            }, t.prototype.removeItem = function(t) {
                var e;
                return (e = this).updateQuantity(t, 0, 0, function(t) {
                    if (t) return e.updateAllHtml(function() {})
                })
            }, t.prototype.getHtml = function(t, e) {
                var i;
                return this, i = this.ajax_desktop_url, "mobile" === t && (i = this.ajax_mobile_url), $.ajax({
                    url: i,
                    type: "GET",
                    dataType: "html",
                    success: function(t) {
                        var i;
                        i = $($.parseHTML(t)), e(i)
                    },
                    error: function(t, i, n) {
                        var o;
                        o = i + ", " + n, console.log("search.json Request Failed: " + o), e(!1)
                    }
                })
            }, t.prototype.updateAllHtml = function(t) {
                return this, this.updateHtml(t), this.other_carts.trigger("updateHtml")
            }, t.prototype.updateHtml = function(t) {
                var e;
                return (e = this).getHtml(e.view, function(i) {
                    var n, o;
                    return o = e.root.find(".cart--form"), n = i.find(".cart--form"), n = e.swapInImages(o, n), o.replaceWith(n), e.eventListeners(), e.updateCurrencies(), t()
                })
            }, t.prototype.swapInImages = function(t, e) {
                return e.find(".cart--item").each(function() {
                    var i, n, o, r, s;
                    if (s = $(this).data("variant-id"), i = $(this).find(".cart--item--image"), n = e.find('[data-variant-id="' + s + '"] .cart--item--image').index(i), (r = t.find('[data-variant-id="' + s + '"]').eq(n)).length > 0) return o = r.find(".cart--item--image"), i.replaceWith(o)
                }), e
            }, t.prototype.updateAllHasItems = function(t, e) {
                var i;
                return null == e && (e = !1), this, i = !1, (t > 0 || e) && (i = !0), this.root.attr("data-has-items", i), this.other_carts.attr("data-has-items", i)
            }, t.prototype.updateTotals = function() {
                var t;
                return t = this, $.ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "json"
                }).done(function(e, i, n) {
                    var o, r;
                    return r = Shopify.formatMoney(e.total_price, theme.money_format), o = e.item_count, t.updateAllHasItems(o), t.total_price.text(r), t.total_item_count.text(o), t.updateTotalsComplete(o), t.updateCurrencies()
                }).fail(function(t, e) {
                    return console.log("Error - ajax updating totals", $.parseJSON(t.responseText).description)
                })
            }, t.prototype.updateCurrencies = function() {
                if (theme.settings.currency_switcher_enabled) return Currency.convertAll(shopCurrency, $("[name=currencies]").val())
            }, t.prototype.renderDynamicCheckoutButtons = function() {
                if ("/cart" === window.location.pathname && ($(".off-canvas--right-sidebar .cart--additional-buttons").remove(), "small" === theme.utils.mqs.current_window)) return $('[data-view="desktop"] .cart--additional-buttons').remove()
            }, t.prototype.isNaN = function(t) {
                return t != t
            }, t
        }(), theme.classes.FrameworkFeaturedBlog = function() {
            function t(t) {
                var e;
                this.root = t, this.resizeListeners = y(this.resizeListeners, this), this.matchImageHeights = y(this.matchImageHeights, this), (e = this).item_container = e.root.find(".featured-blog--body"), e.items = e.root.find(".featured-blog--item"), e.matchImageHeights(), e.resizeListeners()
            }
            return t.prototype.matchImageHeights = function() {
                return this, theme.utils.matchImageHeights(this.item_container, this.items, ".featured-blog--item--image")
            }, t.prototype.resizeListeners = function() {
                var t;
                return t = this, $(window).on("resize.FeaturedGrid", theme.utils.debounce(100, function() {
                    return t.matchImageHeights()
                }))
            }, t
        }(), theme.classes.FrameworkFeaturedCollections = function() {
            function t(t) {
                var e;
                this.root = t, this.resizeListeners = y(this.resizeListeners, this), this.matchImageHeights = y(this.matchImageHeights, this), (e = this).item_container = e.root.find(".featured-collections--body"), e.items = e.root.find(".featured-collections--item"), e.matchImageHeights(), e.resizeListeners()
            }
            return t.prototype.matchImageHeights = function() {
                return this, theme.utils.matchImageHeights(this.item_container, this.items, ".featured-collections--image")
            }, t.prototype.resizeListeners = function() {
                var t;
                return t = this, $(window).on("resize.FeaturedCollections", theme.utils.debounce(100, function() {
                    return t.matchImageHeights()
                }))
            }, t
        }(), theme.classes.FrameworkFeaturedContent = function() {
            return function(t) {
                this.root = t
            }
        }(), theme.classes.FrameworkFeaturedGrid = function() {
            function t(t) {
                var e;
                this.root = t, this.resizeListeners = y(this.resizeListeners, this), this.matchImageHeights = y(this.matchImageHeights, this), (e = this).item_container = e.root.find(".featured-grid--body"), e.items = e.root.find(".featured-grid--item"), e.text_position = e.root.data("text-position"), e.matchImageHeights(), e.resizeListeners()
            }
            return t.prototype.matchImageHeights = function() {
                var t;
                if ((t = this).items.find(".featured-grid--item--image, .placeholder--root").css("height", "auto"), "center" !== t.text_position || "small" === theme.utils.mqs.current_window) return theme.utils.matchImageHeights(t.item_container, t.items, ".featured-grid--item--image")
            }, t.prototype.resizeListeners = function() {
                var t;
                return t = this, $(window).on("resize.FeaturedGrid", theme.utils.debounce(100, function() {
                    return t.matchImageHeights()
                }))
            }, t
        }(), theme.classes.FrameworkFeaturedProduct = function() {
            function t(t) {
                var e;
                this.root = t, this.addProductComplete = y(this.addProductComplete, this), this.addToCartListener = y(this.addToCartListener, this), this.updateVariantImage = y(this.updateVariantImage, this), this.sectionListeners = y(this.sectionListeners, this), this.variantSelected = y(this.variantSelected, this), this.initiateVariants = y(this.initiateVariants, this), this.load = y(this.load, this), (e = this).id = e.root.data("id"), e.add_button = e.root.find(".featured-product--add-to-cart"), e.cart_form = e.root.find(".featured-product--cart-form > form"), e.compare_price = e.root.find(".featured-product--compare-price"), e.main_images = e.root.find(".featured-product--image"), e.price = e.root.find(".featured-product--actual-price"), e.price_wrapper = e.root.find(".featured-product--price-wrapper"), e.smart_payment_buttons = e.root.find(".featured-product--smart-payment-buttons"), e.unavailable_variant = e.root.find(".featured-product--unavailable-variant"), e.variant_sold_out = e.root.find(".featured-product--sold-out--variant"), e.cart_form = e.root.find(".featured-product--cart-form > form"), e.json = $.parseJSON(e.root.find(".featured-product--json").text()), e.load()
            }
            return t.prototype.load = function() {
                return this, this.initiateVariants(), this.addToCartListener()
            }, t.prototype.initiateVariants = function() {
                var t, e;
                if ((t = this).root.find("select").length > 0) return e = "featured-product--select--" + t.id, new Shopify.OptionSelectors(e, {
                    product: t.json,
                    onVariantSelected: t.variantSelected,
                    enableHistoryState: !1
                })
            }, t.prototype.variantSelected = function(t, e, i) {
                var n, o, r, s;
                return o = !1, (n = this).root.find(".featured-product--sold-out--product").length && (o = !0), n.variant_sold_out.hide(), n.unavailable_variant.hide(), n.add_button.hide(), n.price_wrapper.hide(), t ? (t && t.available ? (n.price_wrapper.show(), n.add_button.show(), n.smart_payment_buttons.show()) : o ? (n.variant_sold_out.hide(), n.add_button.hide(), n.smart_payment_buttons.hide()) : (n.variant_sold_out.show(), n.smart_payment_buttons.hide()), s = Shopify.formatMoney(t.price, theme.money_format), n.price.replaceWith('<span class="featured-product--actual-price money font--accent">' + s + "</span>"), n.price = n.root.find(".featured-product--actual-price"), t.compare_at_price > t.price ? (r = Shopify.formatMoney(t.compare_at_price, theme.money_format), n.compare_price.replaceWith('<span class="featured-product--compare-price money font--light-accent">' + r + "</span>"), n.compare_price = n.root.find(".featured-product--compare-price"), n.compare_price.show()) : n.compare_price.hide(), theme.settings.currency_switcher_enabled && Currency.convertAll(shopCurrency, $("[name=currencies]").val()), t.featured_image ? n.updateVariantImage(t.featured_image.id) : void 0) : (n.unavailable_variant.show(), n.smart_payment_buttons.hide(), !1)
            }, t.prototype.sectionListeners = function() {
                var t;
                return (t = this).root.on("theme:section:load", function() {
                    return new Shopify.OptionSelectors("featured-product--select", {
                        product: theme.product_json,
                        onVariantSelected: t.variantSelected,
                        enableHistoryState: !0
                    })
                })
            }, t.prototype.updateVariantImage = function(t) {
                return this, this.main_images.attr("data-active", "false"), this.main_images.filter('[data-image-id="' + t + '"]').attr("data-active", "true")
            }, t.prototype.addToCartListener = function() {
                var t;
                if ((t = this).cart_form.length > 0) return t.cart_form.submit(function() {
                    return t.cart_form.find(".error").remove(), t.add_button.attr("data-loading", "true"), theme.partials.Cart.addItem($(this), function(e, i) {
                        return e ? theme.partials.Cart.updateAllHtml(function() {
                            return t.addProductComplete()
                        }) : (t.cart_form.append('<div class="featured-product--error error">' + i + "</div>"), t.add_button.attr("data-loading", "false"))
                    }), !1
                })
            }, t.prototype.addProductComplete = function() {
                return this, this.add_button.attr("data-loading", "false"), $('[data-off-canvas--open="right-sidebar"]').first().trigger("click")
            }, t
        }(), theme.classes.FrameworkFeaturedVideo = function() {
            function t(t) {
                var e;
                this.root = t, this.hideThumbnail = y(this.hideThumbnail, this), this.playButtonListener = y(this.playButtonListener, this), this.vimeoEvents = y(this.vimeoEvents, this), this.insertVimeoPlayer = y(this.insertVimeoPlayer, this), this.youtubeEvents = y(this.youtubeEvents, this), this.youtubeReady = y(this.youtubeReady, this), this.insertYoutubePlayer = y(this.insertYoutubePlayer, this), this.insertAPIScript = y(this.insertAPIScript, this), this.playerInit = y(this.playerInit, this), this.checkAPIScriptExists = y(this.checkAPIScriptExists, this), (e = this).video_type = e.root.data("videoType"), e.video_id = e.root.data("videoId"), e.thumbnail = e.root.data("thumbnail"), e.section_id = e.root.data("sectionId"), e.youtubeVars = {}, e.vimeoVars = {
                    id: e.video_id,
                    autopause: 0,
                    playsinline: 0,
                    title: 0
                }, e.thumbnail ? e.playButtonListener() : e.checkAPIScriptExists()
            }
            return t.prototype.checkAPIScriptExists = function() {
                var t;
                return "vimeo" === (t = this).video_type ? theme.utils.vimeoScriptAdded ? t.playerInit() : t.insertAPIScript("https://player.vimeo.com/api/player.js") : theme.utils.youtubeScriptAdded ? t.playerInit() : t.insertAPIScript("https://www.youtube.com/iframe_api")
            }, t.prototype.playerInit = function() {
                var t;
                return "vimeo" === (t = this).video_type ? t.thumbnail ? t.insertVimeoPlayer() : ($(window).on("load", function() {
                    return t.insertVimeoPlayer()
                }), t.root.on("theme:section:load", function() {
                    return t.insertVimeoPlayer()
                })) : t.thumbnail ? t.insertYoutubePlayer() : ($(window).on("load", function() {
                    return t.insertYoutubePlayer()
                }), t.root.on("theme:section:load", function() {
                    return t.insertYoutubePlayer()
                }))
            }, t.prototype.insertAPIScript = function(t) {
                var e, i, n;
                return e = this, (n = document.createElement("script")).src = t, "vimeo" === e.video_type ? (theme.utils.vimeoScriptAdded = !0, n.onload = function() {
                    return e.insertVimeoPlayer()
                }) : (theme.utils.youtubeScriptAdded = !0, $(window).on("theme.utils.youtubeAPIReady", function() {
                    return e.insertYoutubePlayer()
                })), (i = document.getElementsByTagName("script")[0]).parentNode.insertBefore(n, i)
            }, t.prototype.insertYoutubePlayer = function() {
                var t;
                return (t = this).thumbnail || (t.youtubeVars.playsinline = 1, t.youtubeVars.fs = 0, t.youtubeVars.loop = 1, t.youtubeVars.playlist = t.video_id), t.player = new YT.Player("player-" + t.section_id, {
                    videoId: t.video_id,
                    playerVars: t.youtubeVars,
                    events: {
                        onReady: t.youtubeReady,
                        onStateChange: t.youtubeEvents
                    }
                })
            }, t.prototype.youtubeReady = function() {
                var t;
                return (t = this).thumbnail || t.player.mute(), t.player.playVideo()
            }, t.prototype.youtubeEvents = function(t) {
                var e, i, n;
                if (i = this, e = t.target, i.thumbnail) {
                    if (0 === t.data) return e.seekTo(0), e.pauseVideo()
                } else if (1 === t.data) return n = e.getDuration() - e.getCurrentTime(), i.rewindTO && clearTimeout(i.rewindTO), i.rewindTO = setTimeout(function() {
                    e.seekTo(0)
                }, 1e3 * (n - .1))
            }, t.prototype.insertVimeoPlayer = function() {
                var t;
                return (t = this).thumbnail || (t.vimeoVars.playsinline = 1, t.vimeoVars.muted = 1, t.vimeoVars.background = 1, t.vimeoVars.loop = 1), t.player = new Vimeo.Player("player-" + t.section_id, t.vimeoVars), t.thumbnail && t.vimeoEvents(), t.player.play()
            }, t.prototype.vimeoEvents = function() {
                var t;
                return (t = this).player.getDuration().then(function(e) {
                    return t.player.addCuePoint(e - .3, {})
                }), t.player.on("cuepoint", function() {
                    return t.player.setCurrentTime(0), t.player.pause()
                })
            }, t.prototype.playButtonListener = function() {
                var t;
                return (t = this).root.find(".feature-video--play svg, .feature-video--play-mobile svg").on("click", function() {
                    return t.checkAPIScriptExists(), t.hideThumbnail()
                })
            }, t.prototype.hideThumbnail = function() {
                var t;
                return t = this, setTimeout(function() {
                    return t.root.find(".feature-video--header, .feature-video--thumbnail, .feature-video--play-mobile").hide()
                }, 350)
            }, t
        }(), theme.classes.FrameworkFeedbackBar = function() {
            function t(t) {
                var e;
                this.root = t, this.load = y(this.load, this), (e = this).messages = e.root.find(".feedback-bar--message span"), e.load()
            }
            return t.prototype.load = function() {
                var t, e, i;
                if ((t = this).messages.hide(), e = window.location.hash.substr(1).replace("feedback-bar--", ""), (i = t.messages.filter('[data-feedback-bar--message="' + e + '"]')).length) return i.show(), setTimeout(function() {
                    return t.root.attr("data-feedback-bar--open", "true")
                }, 200), setTimeout(function() {
                    return t.root.attr("data-feedback-bar--open", "false")
                }, 3e3)
            }, t
        }(), theme.classes.FrameworkInstagram = function() {
            function t(t) {
                var e;
                this.container = t, this.load = y(this.load, this), (e = this).username = e.container.data("username"), e.access_token = e.container.data("access-token"), e.body = e.container.find(".instagram--grid"), e.rows = e.container.data("rows"), e.columns = e.container.data("columns"), e.total_items = e.rows * e.columns, "small" === theme.utils.mqs.current_window && (e.total_items = 4), e.load()
            }
            return t.prototype.load = function() {
                var t;
                return !((t = this).access_token.length < 1) && $.ajax({
                    dataType: "jsonp",
                    url: "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + t.access_token + "&count=" + t.total_items,
                    success: function(e) {
                        var i, n, o, r, s, a;
                        if (200 === e.meta.code) {
                            for (i = e.data, a = [], n = r = 0, s = t.total_items - 1; 0 <= s ? r <= s : r >= s; n = 0 <= s ? ++r : --r) i[n] ? (o = (o = i[n].images.standard_resolution.url).replace("http:", "https:"), a.push(t.body.append('<a class="instagram--item" target="_blank" href="' + i[n].link + '" > <div class="instagram--item-container"> <div class="instagram--image" style="background-image: url(\'' + o + "');\" > </div> </div> </a>"))) : a.push(void 0);
                            return a
                        }
                        return t.body.append('<h4 class="error">' + e.meta.error_message + "</h4>")
                    },
                    error: function(t, e) {
                        return console.log(t), console.log(e)
                    }
                })
            }, t
        }(), theme.classes.FrameworkLoadingAnimation = function() {
            return function(t) {
                var e;
                this.root = t, (e = this).root.hasClass("tiny") ? e.root.spin("tiny") : e.root.spin("small")
            }
        }(), theme.classes.FrameworkMap = function() {
            function t(t) {
                var e;
                this.root = t, this.buildStyles = y(this.buildStyles, this), this.buildMap = y(this.buildMap, this), this.geolocate = y(this.geolocate, this), this.loadMapsApi = y(this.loadMapsApi, this), this.load = y(this.load, this), (e = this).api_status = null, e.map_instance = null, e.key = e.root.data("api-key"), e.address = e.root.data("address"), e.theme = e.root.data("theme"), e.styles = null, e.container = e.root.find(".map--google-maps"), e.center = null, e.load()
            }
            return t.prototype.load = function() {
                if (this, this.container.length > 0) return this.loadMapsApi()
            }, t.prototype.loadMapsApi = function() {
                var t, e;
                return t = this, "loading" === theme.utils.google_map_api_status ? e = setInterval(function() {
                    if ("loaded" === theme.utils.google_map_api_status) return t.geolocate(), clearInterval(e)
                }, 100) : void 0 === window.google ? (theme.utils.google_map_api_status = "loading", $.getScript("https://maps.googleapis.com/maps/api/js?key=" + t.key).then(function() {
                    return t.geolocate(), theme.utils.google_map_api_status = "loaded"
                })) : t.geolocate()
            }, t.prototype.geolocate = function() {
                var t;
                return t = this, (new google.maps.Geocoder).geocode({
                    address: t.address
                }, function(e, i) {
                    return "OK" === i ? (t.center = e[0].geometry.location, t.buildStyles(), t.buildMap()) : console.log("couldn't convert address with geocoder")
                })
            }, t.prototype.buildMap = function() {
                var t, e, i, n;
                return n = {
                    zoom: 15,
                    center: (t = this).center,
                    disableDefaultUI: !0,
                    zoomControl: !0,
                    scrollwheel: !1,
                    styles: t.styles
                }, i = new google.maps.Map(t.container[0], n), e = i.getCenter(), new google.maps.Marker({
                    map: i,
                    position: i.getCenter()
                }), t.map_instance = google.maps.event.addDomListener(window, "resize", theme.utils.debounce(500, function() {
                    google.maps.event.trigger(i, "resize"), i.setCenter(e)
                }))
            }, t.prototype.buildStyles = function() {
                var t;
                return "grayscale" === (t = this).theme ? t.styles = [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#f5f5f5"
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#f5f5f5"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dadada"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#c9c9c9"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }] : "dark" === t.theme ? t.styles = [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#212121"
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#212121"
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "administrative.country",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    featureType: "administrative.locality",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#181818"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1b1b1b"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#2c2c2c"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#8a8a8a"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{
                        color: "#373737"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#3c3c3c"
                    }]
                }, {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry",
                    stylers: [{
                        color: "#4e4e4e"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#000000"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#3d3d3d"
                    }]
                }] : void 0
            }, t
        }(), theme.classes.FrameworkMediaQueries = function() {
            function t() {
                this.screenSizeListener = y(this.screenSizeListener, this), this.getScreenSize = y(this.getScreenSize, this), this.medium_screen = 768, this.large_screen = 1024, this.current_window = null, this.getScreenSize(), this.screenSizeListener()
            }
            return t.prototype.getScreenSize = function() {
                var t;
                if (t = this, window.matchMedia("only screen and (min-width: " + t.large_screen + "px)").matches) {
                    if ("large" !== t.current_window) return $.event.trigger("largeWindow"), t.current_window = "large"
                } else if (window.matchMedia("only screen and (min-width: " + t.medium_screen + "px)").matches) {
                    if ("medium" !== t.current_window) return $.event.trigger("mediumWindow"), t.current_window = "medium"
                } else if ("small" !== t.current_window) return $.event.trigger("smallWindow"), t.current_window = "small"
            }, t.prototype.screenSizeListener = function() {
                var t;
                return t = this, $(window).resize(function() {
                    return t.getScreenSize()
                })
            }, t
        }(), theme.classes.FrameworkModal = function() {
            function t(t) {
                var e;
                this.container = t, (e = this).fullscreen = !!e.container.data("modal--fullscreen"), e.container.data("modal--custom-close") ? e.custom_close_button = e.container.data("modal--custom-close") : e.custom_close_button = "", e.force_view = e.container.data("force-view"), e.view = e.container.data("modal--view"), e.links = e.container.find(".modal--link"), e.content = e.container.find(".modal--content"), e.window = e.createModalWindow(), e.window_container = e.window.find(".modal--container"), e.mask = e.window.find(".modal--mask"), e.close_button = e.window.find(".modal--close"), e.next_button = e.window.find(".modal--next"), e.prev_button = e.window.find(".modal--prev"), e.slider = null, e.slides = null, e.main_content_window = $(".off-canvas--main-content"), e.openListeners(), e.modal_state = "closed", e.nav_lock = !1
            }
            return t.prototype.createModalWindow = function() {
                var t, e;
                return t = null, $(".modal--window").length ? t = $(".modal--window") : (e = '<div class="modal--window"> <div class="modal--mask"></div> <div class="modal--container"></div> <div class="modal--close">' + theme.utils.addSymbol("cross") + '</div> <div class="modal--prev">' + theme.utils.addSymbol("chevron-left") + '</div> <div class="modal--next">' + theme.utils.addSymbol("chevron-right") + "</div> </div>", t = $(e).appendTo("body")), t
            }, t.prototype.openListeners = function() {
                var t;
                return (t = this).links.on("keypress.FrameworkModal, click.FrameworkModal, quick-open", function(e) {
                    var i;
                    return ("keypress" !== e.type || !1 !== theme.utils.a11yClick(e)) && (i = $(this), t.links.each(function(n) {
                        if ($(this).is(i)) return "quick-open" === e.type ? t.open(n, !0) : t.open(n)
                    }), !1)
                })
            }, t.prototype.open = function(t, e) {
                var i, n;
                if (null == e && (e = !1), "closed" === (i = this).modal_state) return i.modal_state = "opened", $("html").addClass("modal-open"), i.window.attr("data-modal--fullscreen", i.fullscreen), i.window.attr("data-modal--custom-close", i.custom_close_button), i.window.attr("data-modal--view", i.view), i.closeListeners(), i.positionListeners(), n = $(window).scrollTop(), i.main_content_window.css({
                    position: "fixed",
                    top: -n
                }), i.moveContentToWindow(), i.slides.length > 1 && (i.next_button.show(), i.prev_button.show(), i.prevListeners(), i.nextListeners()), i.window.show(), i.window_container.show(), i.renderVideo(i.slides.eq(t)), e ? (i.slides.eq(t).addClass("active"), i.position()) : (i.mask.fadeIn(), i.loadModal(i.slides.eq(t), function() {
                    return setTimeout(function() {
                        return i.window_container.find('input[type="text"]').focus()
                    }, 0)
                }))
            }, t.prototype.moveContentToWindow = function(t) {
                var e, i;
                return i = (e = this).container.find(".modal--content"), e.window_container.append(i), e.slides = e.window_container.find(".modal--content")
            }, t.prototype.detectImageSlide = function(t) {
                return this
            }, t.prototype.renderVideo = function(t) {
                var e, i, n, o, r, s;
                return e = this, o = (s = t.find(".responsive-video").first()).data("video"), r = e.extractVideoType(o), i = e.extractVideoId(o, r), n = e.createIframe(r, i), "vimeo" === r && s.addClass("vimeo"), "kickstarter" === r && s.addClass("kickstarter"), s.append(n)
            }, t.prototype.extractVideoType = function(t) {
                return /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i.exec(t) ? "youtube" : /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/.exec(t) ? "vimeo" : !!/^.*(kickstarter)\.com/g.exec(t) && "kickstarter"
            }, t.prototype.extractVideoId = function(t, e) {
                var i, n;
                if ("youtube" === e) {
                    if (n = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/, (i = t.match(n)) && 11 === i[2].length) return i[2]
                } else if ("vimeo" === e) {
                    if (n = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/, i = t.match(n)) return i[2]
                } else if ("kickstarter" === e && (n = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/, i = t.match(n))) return i[1]
            }, t.prototype.createIframe = function(t, e) {
                return "youtube" === t ? '<iframe  src="//www.youtube.com/embed/' + e + '?autoplay=1" frameborder="0" allowfullwidth></iframe>' : "vimeo" === t ? '<iframe src="//player.vimeo.com/video/' + e + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' : "kickstarter" === t ? '<iframe src="//www.kickstarter.com/projects/' + e + '/widget/video.html" frameborder="0" webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>' : void 0
            }, t.prototype.removeVideos = function() {
                return this, this.slides.find(".responsive-video").each(function() {
                    if ($(this).data("video")) return $(this).find("iframe").remove()
                })
            }, t.prototype.loadModal = function(t, e) {
                return this, t.addClass("active"), this.position(), e && e(), this.nav_lock = !1
            }, t.prototype.position = function() {
                var t, e, i, n;
                if (null != (t = this).window_container) {
                    if (e = t.content.filter(".active"), t.window_container.attr("style", ""), t.positionVideoColumns(e), t.detectImageSlide(e), t.window.removeClass("fixed"), n = e.outerHeight(), e.outerWidth(), i = n + parseInt(t.window.css("padding-top")) + parseInt(t.window.css("padding-bottom")), t.fullscreen) return;
                    return e.hasClass("type--image") && (i = n), $(window).height() >= i && "absolute" !== t.force_view ? t.window.addClass("fixed") : ($("html, body").animate({
                        scrollTop: 0
                    }, "0"), $("body,html").on("DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal", function(t) {
                        if (t.which > 0 || "mousewheel" === t.type || "touchmove" === t.type) return $("html,body").stop()
                    }), t.window.removeClass("fixed"))
                }
            }, t.prototype.positionVideoColumns = function(t) {
                var e, i;
                if (t.find(".responsive-video").length > 0 && (e = t.find(".fw--blocks > div").eq(0), i = t.find(".fw--blocks > div").eq(1), e.css({
                        width: ""
                    }), i.css({
                        width: ""
                    }), e.outerHeight() < i.outerHeight())) return e.css({
                    width: "100%"
                }), i.css({
                    width: "100%"
                })
            }, t.prototype.positionListeners = function() {
                var t;
                return t = this, $(window).on("resize.FrameworkModal", function() {
                    return t.position()
                })
            }, t.prototype.nextListeners = function() {
                var t;
                return t = this, $(document).on("keydown.FrameworkModal", function(e) {
                    if (39 === e.keyCode) return t.next()
                }), t.next_button.on("click.FrameworkModal", function() {
                    return t.next()
                })
            }, t.prototype.next = function() {
                var t, e, i;
                if (!(t = this).nav_lock) return t.nav_lock = !0, i = t.slides.filter(".active").index(), t.slides.removeClass("active"), t.removeVideos(), e = i + 1 === t.slides.length ? t.slides.eq(0) : t.slides.eq(i + 1), t.renderVideo(e), t.loadModal(e)
            }, t.prototype.prevListeners = function() {
                var t;
                return t = this, $(document).on("keydown.FrameworkModal", function(e) {
                    if (37 === e.keyCode) return t.prev()
                }), t.prev_button.on("click.FrameworkModal", function() {
                    return t.prev()
                })
            }, t.prototype.prev = function() {
                var t, e, i;
                if (!(t = this).nav_lock) return t.nav_lock = !0, i = t.slides.filter(".active").index(), t.slides.removeClass("active"), t.removeVideos(), e = 0 === i ? t.slides.eq(t.slides.length - 1) : t.slides.eq(i - 1), t.renderVideo(e), t.loadModal(e)
            }, t.prototype.closeListeners = function() {
                var t;
                return (t = this).container.on("quick-close", function() {
                    return t.close(!0)
                }), $(document).on("keydown.FrameworkModal", function(e) {
                    if (27 === e.keyCode) return t.close()
                }), t.mask.on("click.FrameworkModal", function() {
                    return t.close()
                }), t.window_container.on("click.FrameworkModal", function() {
                    return t.close()
                }), t.content.on("click.FrameworkModal", function(t) {
                    return t.stopPropagation()
                }), t.close_button.on("click.FrameworkModal", function() {
                    return t.close()
                })
            }, t.prototype.close = function(t) {
                var e, i;
                return null == t && (t = !1), e = this, i = -1 * parseInt(e.main_content_window.css("top")), e.container.trigger("modalClosed"), e.main_content_window.css({
                    top: "0",
                    position: "relative"
                }), $(window).scrollTop(i), e.putBackContent(), e.next_button.hide(), e.prev_button.hide(), e.window.hide(), t ? (e.mask.hide(), this.window_container.empty(), e.modal_state = "closed") : e.mask.fadeOut(function() {
                    return e.window_container.empty(), e.modal_state = "closed"
                }), $("html").removeClass("modal-open"), e.removeListeners(), $(window).trigger("FrameworkModal.afterClose")
            }, t.prototype.putBackContent = function() {
                var t;
                return (t = this).removeVideos(), t.slides.removeClass("active").appendTo(t.container)
            }, t.prototype.removeListeners = function() {
                var t;
                return t = this, $(document).off("keydown.FrameworkModal"), $(window).off("resize.FrameworkModal"), $("body,html").off("DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal"), t.next_button.off("click.FrameworkModal"), t.prev_button.off("click.FrameworkModal"), t.close_button.off("click.FrameworkModal"), t.mask.off("click.FrameworkModal"), t.window_container.off("click.FrameworkModal")
            }, t
        }(), theme.classes.FrameworkOffCanvas = function() {
            function t(t) {
                var e;
                this.root = t, this.touchListener = y(this.touchListener, this), this.closeRight = y(this.closeRight, this), this.closeLeft = y(this.closeLeft, this), this.fadeInOverlay = y(this.fadeInOverlay, this), this.openRight = y(this.openRight, this), this.openLeft = y(this.openLeft, this), this.toggle = y(this.toggle, this), this.toggleListeners = y(this.toggleListeners, this), this.viewPortHeightListener = y(this.viewPortHeightListener, this), this.setViewPortHeight = y(this.setViewPortHeight, this), this.setState = y(this.setState, this), this.unload = y(this.unload, this), this.load = y(this.load, this), (e = this).viewport = $(".off-canvas--viewport"), e.left_sidebar = $(".off-canvas--left-sidebar"), e.right_sidebar = $(".off-canvas--right-sidebar"), e.main_content = $(".off-canvas--main-content"), e.overlay = $(".off-canvas--overlay"), e.state = "closed", e.load()
            }
            return t.prototype.load = function() {
                var t;
                return (t = this).close = $(".off-canvas--close"), t.triggers = $(".off-canvas--open"), t.setViewPortHeight(), t.viewPortHeightListener(), t.toggleListeners(), t.touchListener()
            }, t.prototype.unload = function() {
                var t;
                return (t = this).triggers.off("click"), t.overlay.add(t.close).off("click"), $(document).off("touchstart.FrameworkOffCanvas"), $(document).off("touchend.FrameworkOffCanvas")
            }, t.prototype.setState = function(t) {
                return this, this.state = t, this.root.attr("data-off-canvas--state", t)
            }, t.prototype.setViewPortHeight = function() {
                return this, this.viewport.css({
                    "min-height": $(window).height()
                })
            }, t.prototype.viewPortHeightListener = function() {
                var t;
                return t = this, $(window).resize(function() {
                    return t.setViewPortHeight()
                })
            }, t.prototype.toggleListeners = function() {
                var t;
                return (t = this).triggers.on("click", function() {
                    return "left-sidebar" === $(this).data("off-canvas--open") ? t.toggle("left-sidebar") : "right-sidebar" === $(this).data("off-canvas--open") && t.toggle("right-sidebar"), !1
                }), t.overlay.add(t.close).on("click", function() {
                    return "left-open" === t.state ? t.toggle("left-sidebar") : "right-open" === t.state ? t.toggle("right-sidebar") : void 0
                })
            }, t.prototype.toggle = function(element) {
                //alert('0000000000000000000');
                var _this;
                  _this = this;
                  if (element === 'left-sidebar' && _this.state === 'closed') {
                    //return _this.openLeft();
                    $('body').addClass('openMenu');
                    $('.off-canvas--viewport').attr('data-off-canvas--state','left-open');
                    _this.setState('left-open');
                  } else if (element === 'left-sidebar' && _this.state === 'left-open') {
                    //return _this.closeLeft();
                    $('body').removeClass('openMenu');
                    $('.off-canvas--viewport').attr('data-off-canvas--state','closed');
                    _this.setState('closed');
                  } else if (element === 'right-sidebar' && _this.state === 'closed') {
                    //alert('open right');
                    //return _this.openRight();
                    $('body').addClass('openMenu');
                    $('.off-canvas--viewport').attr('data-off-canvas--state','right-open');
                    _this.setState('right-open');
                  } else if (element === 'right-sidebar' && _this.state === 'right-open') {
                    //alert('close right');
                    $('body').removeClass('openMenu');
                    $('.off-canvas--viewport').attr('data-off-canvas--state','closed');
                    _this.setState('closed');
                    //return _this.closeRight();
                  }
                //return e = this, "left-sidebar" === t && "closed" === e.state ? e.openLeft() : "left-sidebar" === t && "left-open" === e.state ? e.closeLeft() : "right-sidebar" === t && "closed" === e.state ? e.openRight() : "right-sidebar" === t && "right-open" === e.state ? e.closeRight() : void 0
            }, t.prototype.openLeft = function() {
                var t;
                return (t = this).setState("left-open"), t.main_content.css({
                    position: "fixed",
                    top: -$(window).scrollTop()
                }), t.left_sidebar.velocity({
                    translateX: [0, "-100%"]
                }, {
                    complete: function() {
                        return t.left_sidebar.css({
                            position: "relative"
                        })
                    }
                }), t.fadeInOverlay()
            }, t.prototype.openRight = function() {
                var t;
                return (t = this).setState("right-open"), t.main_content.css({
                    position: "fixed",
                    top: -$(window).scrollTop()
                }), t.right_sidebar.velocity({
                    translateX: ["-100%", 0]
                }, {
                    complete: function() {
                        return t.right_sidebar.css({
                            position: "relative"
                        })
                    }
                }), t.fadeInOverlay()
            }, t.prototype.fadeInOverlay = function() {
                return this, this.overlay.show(), this.overlay.velocity({
                    opacity: "0.3"
                })
            }, t.prototype.closeLeft = function() {
                var t, e;
                return "left-open" === (t = this).state && (t.setState("closed"), e = -1 * parseInt(t.main_content.css("top")), t.left_sidebar.velocity({
                    translateX: ["-100%", 0]
                }, {
                    complete: function() {
                        return t.left_sidebar.css({
                            position: "absolute"
                        }), t.main_content.css({
                            position: "relative",
                            top: "initial"
                        }), $(window).scrollTop(e)
                    }
                }), t.overlay.velocity("fadeOut"))
            }, t.prototype.closeRight = function() {
                var t, e;
                return "right-open" === (t = this).state && (t.setState("closed"), e = -1 * parseInt(t.main_content.css("top")), t.right_sidebar.velocity({
                    translateX: [0, "-100%"]
                }, {
                    complete: function() {
                        return t.right_sidebar.css({
                            position: "absolute"
                        }), t.main_content.css({
                            position: "relative",
                            top: "initial"
                        }), $(window).scrollTop(e)
                    }
                }), t.overlay.velocity("fadeOut"))
            }, t.prototype.touchListener = function() {
                var t, e;
                return t = this, !!Modernizr.touchevents && (e = {
                    start: {},
                    end: {}
                }, $(document).on("touchstart.FrameworkOffCanvas", function(t) {
                    e.start.x = t.originalEvent.touches[0].clientX, e.start.y = t.originalEvent.touches[0].clientY
                }), $(document).on("touchend.FrameworkOffCanvas", function(i) {
                    return e.end.x = i.originalEvent.changedTouches[0].clientX, e.end.y = i.originalEvent.changedTouches[0].clientY, !(Math.abs(e.start.y - e.end.y) > 30) && (e.start.x > e.end.x + 5 ? t.closeLeft() : e.start.x < e.end.x - 5 ? t.closeRight() : void 0)
                }))
            }, t
        }(), theme.classes.FrameworkProductRecommendations = function() {
            function t(t) {
                this.root = t, this.loadHoverImages = y(this.loadHoverImages, this), this.checkIfEmpty = y(this.checkIfEmpty, this), this.loadProducts = y(this.loadProducts, this), this.resizeListeners = y(this.resizeListeners, this), this.matchImageHeights = y(this.matchImageHeights, this), this.loadProducts(), this.resizeListeners()
            }
            return t.prototype.matchImageHeights = function() {
                var t;
                return (t = this).item_container = t.root.find(".product-recommendations--body"), t.items = t.root.find(".product--root"), theme.utils.matchImageHeights(t.item_container, t.items, ".product--image-wrapper")
            }, t.prototype.resizeListeners = function() {
                var t;
                return t = this, $(window).on("resize", theme.utils.debounce(100, function() {
                    return t.matchImageHeights()
                }))
            }, t.prototype.loadProducts = function() {
                var t, e, i, n, o;
                return t = this, e = (i = document.getElementsByClassName("product-recommendations--root")[0]).dataset.productId, o = "/recommendations/products?section_id=framework--product-recommendations&limit=" + i.dataset.maxProducts + "&product_id=" + e, (n = new XMLHttpRequest).open("GET", o), n.onload = function() {
                    var e;
                    if (n.status >= 200 && n.status < 300) return (e = document.createElement("div")).innerHTML = n.response, i.innerHTML = e.querySelector(".product-recommendations--root").innerHTML, t.matchImageHeights(), t.checkIfEmpty(), t.loadHoverImages()
                }, n.send()
            }, t.prototype.checkIfEmpty = function() {
                var t;
                return t = !($(".product--root").length > 0), $(".product-recommendations--root").attr("data-empty", t)
            }, t.prototype.loadHoverImages = function() {
                return $('.product--root[data-hover-image="true"]').each(function() {
                    var t;
                    return t = $(this), theme.utils.imagesLoaded(t, function() {
                        return t.attr("data-hover-image", "loaded")
                    })
                })
            }, t
        }(), theme.classes.FrameworkSearch = function() {
            function t(t) {
                var e;
                this.root = t, this.resizeListeners = y(this.resizeListeners, this), this.matchImageHeights = y(this.matchImageHeights, this), this.getResults = y(this.getResults, this), this.listenForKeyEntered = y(this.listenForKeyEntered, this), this.getSearchUrl = y(this.getSearchUrl, this), this.searchLinks = y(this.searchLinks, this), this.loadSpinners = y(this.loadSpinners, this), this.onOpen = y(this.onOpen, this), (e = this).articles = e.root.find(".search--articles"), e.form = e.root.find("form"), e.icon = e.root.find(".search--icon"), e.loading = e.root.find(".search--loading"), e.no_results = e.root.find(".search--no-results"), e.products = e.root.find(".search--products"), e.results = e.root.find(".search--results"), e.text_box = e.root.find(".search--textbox"), e.toggle_link = e.root.find(".search--toggle"), e.show_articles = e.root.data("show-articles"), e.show_pages = e.root.data("show-pages"), e.view = e.root.data("view"), e.ajax_request = null, e.search_term = null, e.search_url = null, e.close_results_timer = null, e.typing_timer = null, e.article_page_combination = "", e.offCanvas = null, void 0 !== theme.partials.OffCanvas ? e.offCanvas = theme.partials.OffCanvas : e.offCanvas = theme.partials.FrameworkOffCanvas, e.show_articles && e.show_pages ? e.article_page_combination = "article,page" : e.show_articles ? e.article_page_combination = "article" : e.show_pages && (e.article_page_combination = "page"), "modal" === e.view && (e.searchLinks(), e.getSearchUrl(), e.listenForKeyEntered(), e.loadSpinners()), e.resizeListeners(), e.matchImageHeights()
            }
            return t.prototype.onOpen = function() {
                var t, e;
                return (t = this).text_box.focus(), e = t.text_box.val(), t.text_box.val(""), t.text_box.val(e), t.text_box.trigger("keyup")
            }, t.prototype.loadSpinners = function() {
                var t;
                return this, (t = this.loading.find(".animation")).hasClass("tiny") ? t.spin("tiny") : t.spin("small")
            }, t.prototype.searchLinks = function() {
                var t;
                return t = this, $('.off-canvas--main-content a[href="/search"]').on("click", function() {
                    return $('[data-trigger="search-modal"]').trigger("click"), t.onOpen(), !1
                }), $('.off-canvas--right-sidebar a[href="/search"]').on("click", function() {
                    return t.offCanvas.closeRight(), setTimeout(function() {
                        return $('[data-trigger="search-modal"]').trigger("click"), t.onOpen()
                    }, 450), !1
                }), $('.off-canvas--left-sidebar a[href="/search"]').on("click", function() {
                    return t.offCanvas.closeLeft(), setTimeout(function() {
                        return $('[data-trigger="search-modal"]').trigger("click"), t.onOpen()
                    }, 450), !1
                })
            }, t.prototype.getSearchUrl = function() {
                var t;
                return (t = this).search_url = window.location.href, t.search_url = t.search_url.replace(window.location.hostname + window.location.pathname, window.location.hostname + "/search"), t.search_url = t.search_url.replace("#", ""), t.search_url.indexOf("?") >= 0 ? t.search_url = t.search_url + "&" : t.search_url = t.search_url + "?"
            }, t.prototype.listenForKeyEntered = function() {
                var t;
                return (t = this).text_box.attr("autocomplete", "off").on("keyup paste", function(e) {
                    var i;
                    return clearTimeout(t.typing_timer), (i = $(this).val()).length < 2 && "paste" !== e.type ? (t.products.empty(), t.articles.empty(), t.loading.hide(), t.icon.show(), !1) : (t.loading.show(), t.icon.hide(), t.typing_timer = setTimeout(function() {
                        var e;
                        if (clearTimeout(t.typing_timer), e = t.search_url + "view=ajax-product&type=product&q=" + i + "*", t.getResults(e, i, "product"), t.show_articles || t.show_pages) return e = t.search_url + "view=ajax-article-page&type=" + t.article_page_combination + "&q=" + i + "*", t.getResults(e, i, "article")
                    }, 750))
                })
            }, t.prototype.getResults = function(t, e, i) {
                var n;
                (n = this).products.empty(), n.articles.empty(), $.ajax({
                    url: t,
                    type: "GET",
                    dataType: "html",
                    success: function(t) {
                        return n.loading.hide(), n.icon.show(), "product" === i ? (n.products.empty(), n.products.append(t), n.matchImageHeights()) : "article" === i ? (n.articles.empty(), n.articles.append(t)) : void 0
                    },
                    error: function(t, e, i) {
                        var n;
                        return n = e + ", " + i, console.log("search.json Request Failed: " + n)
                    }
                })
            }, t.prototype.matchImageHeights = function() {
                return this, theme.utils.matchImageHeights(this.products, this.products.find(".product--root"), ".product--image-wrapper")
            }, t.prototype.resizeListeners = function() {
                var t;
                return t = this, $(window).on("resize.Search", theme.utils.debounce(100, function() {
                    return t.matchImageHeights()
                }))
            }, t
        }(), theme.classes.Sections = function() {
            function t() {
                this.unload = y(this.unload, this), this.deselectBlock = y(this.deselectBlock, this), this.selectBlock = y(this.selectBlock, this), this.deselectSection = y(this.deselectSection, this), this.selectSection = y(this.selectSection, this), this.load = y(this.load, this), this.getActiveBlock = y(this.getActiveBlock, this), this.getActiveSection = y(this.getActiveSection, this), this.listeners = y(this.listeners, this), this.listeners()
            }
            return t.prototype.listeners = function() {
                var t;
                return (t = this).load(), t.unload(), t.selectSection(), t.deselectSection(), t.selectBlock(), t.deselectBlock()
            }, t.prototype.getActiveSection = function(t) {
                return $(t.target).find("[data-section-id]")
            }, t.prototype.getActiveBlock = function(t) {
                return $(t.target)
            }, t.prototype.load = function(t) {
                var e;
                return e = this, $(document).on("shopify:section:load", function(t) {
                    var i;
                    return theme.utils.loadJsClasses(), (i = e.getActiveSection(t)).triggerHandler("theme:section:load"), i.find("[data-js-class]").each(function() {
                        return $(this).triggerHandler("theme:section:load")
                    })
                })
            }, t.prototype.selectSection = function() {
                var t;
                return t = this, $(document).on("shopify:section:select", function(e) {
                    return t.getActiveSection(e).triggerHandler("theme:section:select")
                })
            }, t.prototype.deselectSection = function() {
                var t;
                return t = this, $(document).on("shopify:section:deselect", function(e) {
                    return t.getActiveSection(e).triggerHandler("theme:section:deselect")
                })
            }, t.prototype.selectBlock = function() {
                var t;
                return t = this, $(document).on("shopify:block:select", function(e) {
                    return t.getActiveBlock(e).triggerHandler("theme:block:select")
                })
            }, t.prototype.deselectBlock = function() {
                var t;
                return t = this, $(document).on("shopify:block:deselect", function(e) {
                    return t.getActiveBlock(e).triggerHandler("theme:block:deselect")
                })
            }, t.prototype.unload = function(t) {
                var e;
                return e = this, $(document).on("shopify:section:unload", function(t) {
                    var i;
                    return (i = e.getActiveSection(t)).triggerHandler("theme:section:unload"), i.find('[data-js-loaded="true"]').each(function() {
                        return $(this).triggerHandler("theme:section:unload")
                    })
                })
            }, t
        }(), theme.classes.FrameworkSlider = function() {
            function t(t) {
                this.container = t, this.eventListeners = y(this.eventListeners, this), this.alignPlayButton = y(this.alignPlayButton, this), this.updateContextMenu = y(this.updateContextMenu, this), this.autoplay = y(this.autoplay, this), this.formatPaginationNumbers = y(this.formatPaginationNumbers, this), this.getActiveIndex = y(this.getActiveIndex, this), this.createSlider = y(this.createSlider, this), this.autoplay_enabled = !!this.container.data("autoplay"), this.navigation = !!this.container.data("navigation"), this.pagination_numbers = !!this.container.data("pagination-numbers"), this.autoplay_frequency = 3e3, this.slide_length = this.container.children().length, this.active_index = 0, this.news_panel = !!this.container.data("news-panel"), this.createSlider(), this.eventListeners(), this.owl = this.container.data("owlCarousel")
            }
            return t.prototype.createSlider = function() {
                var t, e;
                return t = this, e = this.container.owlCarousel({
                    singleItem: !0,
                    navigation: t.navigation,
                    navigationText: !1,
                    pagination: !!t.container.data("pagination"),
                    paginationNumbers: t.pagination_numbers,
                    scrollPerPageNav: !0,
                    slideSpeed: 800,
                    autoHeight: !1,
                    autoPlay: t.autoplay(),
                    afterInit: function() {},
                    afterAction: function() {
                        return t.alignPlayButton(), t.active_index = t.getActiveIndex(), t.updateContextMenu(t.active_index), t.formatPaginationNumbers()
                    }
                }), t.navigation && (e.find(".owl-prev").html(theme.utils.addSymbol("chevron-left")), e.find(".owl-next").html(theme.utils.addSymbol("chevron-right"))), e
            }, t.prototype.getActiveIndex = function() {
                return this.container.find(".owl-pagination .owl-page.active").index()
            }, t.prototype.formatPaginationNumbers = function() {
                return this.container.find(".owl-page.active .owl-numbers").text(this.active_index + 1 + "/" + this.slide_length)
            }, t.prototype.autoplay = function() {
                return !!this.autoplay_enabled && this.autoplay_frequency
            }, t.prototype.updateContextMenu = function(t) {
                var e, i;
                if (this.news_panel) return i = "." + this.container.find(".slide").eq(t).data("feed-type"), (e = this.container.closest(".template--index--news").find(".context-navigation")).find(".item").hide(), e.find(i).show()
            }, t.prototype.alignPlayButton = function() {
                var t, e, i;
                if (0 !== (t = (e = this.container.find(".owl-item").eq(this.active_index)).find(".play-button")).length) return t.css("visibility", "hidden"), l.hasClass("transparent-menu") && "absolute" === $(".main-header").css("position") ? (i = (e.outerHeight() - t.outerHeight()) / 2, t.css({
                    "margin-top": 0,
                    top: i
                })) : t.css({
                    "margin-top": "-40px",
                    top: "50%"
                }), t.css("visibility", "visible")
            }, t.prototype.eventListeners = function() {
                var t;
                return t = this, this.container.find(".play-button").on("click", function() {
                    return new h($(this).closest(".video")).open(), t.owl.stop(), !1
                }), this.container.find(".owl-pagination .owl-page, .skip-to-next").on("click", function() {
                    return t.owl.next(), !1
                })
            }, t
        }(), theme.classes.FrameworkStickyColumn = function() {
            function t(t, e, i, n) {
                if (this.container = t, this.column_a = e, this.column_b = i, this.mq = n, this.Listeners = y(this.Listeners, this), this.setColumnPosition = y(this.setColumnPosition, this), this.getAlignment = y(this.getAlignment, this), this.getState = y(this.getState, this), this.resetLargerColumn = y(this.resetLargerColumn, this), this.getSmallerColumn = y(this.getSmallerColumn, this), this.heightsHaveChanged = y(this.heightsHaveChanged, this), this.setHeights = y(this.setHeights, this), this.loadColumns = y(this.loadColumns, this), Modernizr.touchevents) return !1;
                this.current_state = "auto", this.column_a_height = 0, this.column_b_height = 0, this.loadColumns()
            }
            return t.prototype.loadColumns = function() {
                var t;
                return t = this, theme.utils.imagesLoaded(t.container, function() {
                    return t.Listeners(), t.setColumnPosition()
                })
            }, t.prototype.setHeights = function() {
                return this.column_a_height = this.column_a.outerHeight(), this.column_b_height = this.column_b.outerHeight()
            }, t.prototype.heightsHaveChanged = function() {
                return this.column_a.outerHeight() !== this.column_a_height ? (this.setHeights(), !0) : this.column_b.outerHeight() !== this.column_b_height && (this.setHeights(), !0)
            }, t.prototype.getSmallerColumn = function() {
                return this.column_a_height < this.column_b_height ? this.column_a : this.column_b
            }, t.prototype.resetLargerColumn = function() {
                return this.column_a_height > this.column_b_height ? this.column_a.css({
                    position: "relative",
                    top: "auto",
                    bottom: "auto"
                }) : this.column_b.css({
                    position: "relative",
                    top: "auto",
                    bottom: "auto"
                })
            }, t.prototype.getState = function(t, e, i) {
                var n, o, r;
                return r = "auto", "small" === this.mq.current_window ? "auto" : (e > (n = i.outerHeight()) && (o = !0), t < this.container.offset().top && (r = "auto"), t + (o ? n : e) > this.container.offset().top + this.container.outerHeight() ? r = "absolute-bottom" : t > this.container.offset().top && o ? r = "fixed-top" : e < n && t + e > this.container.offset().top + i.outerHeight() && (r = "fixed-bottom"), r)
            }, t.prototype.getAlignment = function(t) {
                return t.hasClass("column-a") ? "left" : t.hasClass("column-b") ? "right" : void 0
            }, t.prototype.setColumnPosition = function() {
                var t, e, i, n;
                if ((t = this).setHeights(), i = t.getSmallerColumn(), n = t.getState($(window).scrollTop(), $(window).height(), i), e = t.getAlignment(i), "auto" === n && "auto" !== this.current_state ? (this.current_state = "auto", i.css({
                        position: "relative",
                        top: "auto",
                        bottom: "auto"
                    })) : "fixed-bottom" === n && "fixed-bottom" !== this.current_state ? (this.current_state = "fixed-bottom", i.css({
                        position: "fixed",
                        top: "auto",
                        bottom: 0
                    })) : "fixed-top" === n && "fixed-top" !== this.current_state ? (this.current_state = "fixed-top", i.css({
                        position: "fixed",
                        top: 0,
                        bottom: "auto"
                    })) : "absolute-bottom" === n && "absolute-bottom" !== this.current_state && (this.current_state = "absolute-bottom", i.css({
                        position: "absolute",
                        top: "auto",
                        bottom: 0
                    })), "right" === e) return i.css({
                    right: 0
                })
            }, t.prototype.Listeners = function() {
                var t;
                return t = this, $(window).scroll(function() {
                    return t.setColumnPosition()
                }), setInterval(function() {
                    if (t.heightsHaveChanged()) return t.resetLargerColumn(), t.setColumnPosition()
                }, 250), $(window).resize(function() {
                    return t.resetLargerColumn(), t.setColumnPosition()
                })
            }, t
        }(), theme.classes.FrameworkUtils = function() {
            function t() {
                this.google_map_api_status = null, cssVars()
            }
            return t.prototype.debounce = function(t, e) {
                var i;
                return i = void 0,
                    function() {
                        i && clearTimeout(i), i = setTimeout(e.bind(this), t, arguments)
                    }
            }, t.prototype.imagesLoaded = function(t, e) {
                var i, n;
                return i = 0, (n = t.find('img[data-sizes="auto"]').length) < 1 ? void e() : t.on("lazybeforeunveil", function(t) {
                    return $(t.target).one("load", function() {
                        if (++i === n) return e()
                    })
                })
            }, t.prototype.a11yClick = function(t) {
                var e;
                return "click" === t.type || "keypress" === t.type && (32 === (e = t.charCode || t.keyCode) && t.preventDefault(), 32 === e || 13 === e)
            }, t.prototype.matchImageHeights = function(t, e, i) {
                var n, o, r;
                return o = Math.round(t.width() / e.first().outerWidth()), n = 0, r = $(), e.find(i).css("height", "auto"), e.find(".placeholder--root").css("height", "auto"), e.each(function(t) {
                    var s;
                    if (s = $(this).find(".image--root").length > 0 ? $(this).find(i + " .image--root").outerHeight() : $(this).find(".placeholder--root").outerHeight(), r = r.add($(this)), s > n && (n = s), t % o == o - 1 || t + 1 === e.length) return r.find(i + ", .placeholder--root").height(n), n = 0, r = $()
                })
            }, t
        }(), theme.classes.FrameworkXMenu = function() {
            function t(t) {
                var e;
                this.root = t, this.slideUp = y(this.slideUp, this), this.slideDown = y(this.slideDown, this), this.arrangeMegaNav = y(this.arrangeMegaNav, this), this.resizeListeners = y(this.resizeListeners, this), this.checkOverlap = y(this.checkOverlap, this), this.listeners = y(this.listeners, this), this.load = y(this.load, this), (e = this).debugging = !1, e.state = "closed", e.parent_links = e.root.find(".x-menu--level-1--link > a"), e.sub_menu_links = e.root.find('.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a'), e.sub_menu_items = e.sub_menu_links.parent().find("ul a"), e.parents_with_sub_menu = e.sub_menu_links.parent(), e.overlap_parent = e.root.data("x-menu--overlap-parent"), e.load()
            }
            return t.prototype.load = function() {
                var t;
                return (t = this).arrangeMegaNav(), t.listeners(), t.checkOverlap(), t.resizeListeners()
            }, t.prototype.listeners = function() {
                var t;
                return (t = this).parents_with_sub_menu.on("mouseenter.XMenu", function(e) {
                    return t.slideDown($(this).find("> a"))
                }), t.parents_with_sub_menu.on("mouseleave.XMenu", function() {
                    return t.slideUp()
                }), t.parent_links.on("focus", function(e) {
                    return t.slideUp()
                }), t.sub_menu_links.on("focus", function(e) {
                    return t.slideDown($(this))
                }), t.sub_menu_links.on("touchstart.XMenu", function(e) {
                    return e.preventDefault(), "true" === $(this).parent().attr("data-x-menu--open") ? t.slideUp() : t.slideDown($(this))
                })
            }, t.prototype.checkOverlap = function() {
                var t, e, i, n, o, r, s, a;
                return t = this, Modernizr.touchevents && "large" !== theme.utils.mqs.current_window ? (t.root.attr("data-x-menu--overlap", "true"), !1) : (t.root.attr("data-x-menu--overlap", "false"), i = t.root, 1 === t.overlap_parent ? i = i.parent() : 2 === t.overlap_parent && (i = i.parent().parent()), o = i.parent(), s = !1, (e = i.index()) > 1 && (s = o.children().eq(e - 1)), a = !1, e + 1 < o.children().length && (a = o.children().eq(e + 1)), o.width(), t.root.outerWidth(), s && (n = i.find("> :first-child").offset().left - 1, left_edge >= n && t.root.attr("data-x-menu--overlap", "true")), a && (r = i.find("> :last-child")).outerWidth() + r.offset().left + 1 >= a.offset().left ? t.root.attr("data-x-menu--overlap", "true") : void 0)
            }, t.prototype.resizeListeners = function() {
                var t;
                return t = this, $(window).on("resize.XMenu", t.debounce(100, function() {
                    return t.checkOverlap()
                }))
            }, t.prototype.debounce = function(t, e) {
                var i;
                return i = void 0,
                    function() {
                        i && clearTimeout(i), i = setTimeout(e.bind(this), t, arguments)
                    }
            }, t.prototype.arrangeMegaNav = function() {
                return this, 0 !== this.parents_with_sub_menu.length && this.root.find('[data-x-menu--depth="3"] .x-menu--level-2--container').each(function() {
                    var t, e;
                    if ((e = (t = $(this)).find('[data-x-menu--single-parent="true"]')).length > 0) return $('<div class="x-menu--single-parents"></div>').insertAfter(t.find(".x-menu--bg")).append("<ul>").find("ul").append(e)
                })
            }, t.prototype.slideDown = function(t, e) {
                var i, n, o, r, s;
                if (null == e && (e = !1), i = this, clearTimeout(i.timer), "true" === (o = t.parent()).attr("data-x-menu--open") || "closing" === i.state) return !1;
                i.slideUp(!1), e && "complete" !== e ? i.timer = setTimeout(function() {
                    return i.slideDown(t, "complete")
                }, e) : (t.closest(".x-menu--level-1--link").find(".fw--icon--expand-less").show(), t.closest(".x-menu--level-1--link").find(".fw--icon--expand-more").hide(), t.closest(".x-menu--level-1--link").find(".fw--icon--minus").show(), t.closest(".x-menu--level-1--link").find(".fw--icon--plus").hide(), i.state = "open", o.attr("data-x-menu--open", "true"), t.attr("aria-expanded", "true"), s = t.closest(".x-menu--level-1--link").find(".x-menu--level-2--container"), n = "block", "3" === o.attr("data-x-menu--depth") && (n = "flex"), s.velocity("stop"), s.css({
                    height: "auto",
                    display: n
                }), s.find(".x-menu--level-2--list").css({
                    display: n
                }), r = s.outerHeight(), s.css({
                    height: 0,
                    opacity: 1
                }), s.velocity({
                    height: [r, 0]
                }, {
                    queue: !1,
                    duration: 600,
                    easing: "easeOutExpo"
                }))
            }, t.prototype.slideUp = function(t) {
                var e, i, n, o;
                return null == t && (t = 300), !(e = this).debugging && (i = (n = e.parents_with_sub_menu.filter('[data-x-menu--open="true"]')).find("> a"), "false" !== n.attr("data-x-menu--open") && (t ? e.timer = setTimeout(function() {
                    return e.slideUp(!1)
                }, t) : (i.closest(".x-menu--level-1--link").find(".fw--icon--expand-less").hide(), i.closest(".x-menu--level-1--link").find(".fw--icon--expand-more").show(), i.closest(".x-menu--level-1--link").find(".fw--icon--minus").hide(), i.closest(".x-menu--level-1--link").find(".fw--icon--plus").show(), o = i.closest(".x-menu--level-1--link").find(".x-menu--level-2--container"), n.attr("data-x-menu--open", "false"), i.attr("aria-expanded", "false"), o.velocity({
                    opacity: 0
                }, {
                    begin: function() {
                        return e.state = "closing"
                    },
                    complete: function() {
                        return o.css({
                            display: "none"
                        }), e.state = "closed"
                    },
                    duration: 200
                }))))
            }, t
        }(), theme.classes.FrameworkYMenu = function() {
            function t(t) {
                var e;
                this.root = t, this.slideRight = y(this.slideRight, this), this.slideLeft = y(this.slideLeft, this), this.adjustHeight = y(this.adjustHeight, this), this.listeners = y(this.listeners, this), this.load = y(this.load, this), (e = this).state = "closed", e.sub_menu_links = e.root.find(".fw--icon--chevron-right").parent(), e.back_links = e.root.find(".y-menu--back-link a"), e.regular_links = e.root.find('.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])'), e.timer = null, e.load()
            }
            return t.prototype.load = function() {
                return this, this.listeners()
            }, t.prototype.listeners = function() {
                var t;
                return (t = this).regular_links.on("click", function(t) {
                    var e; - 1 !== (e = $(this).attr("href")).indexOf("#") && ("left-open" === theme.partials.FrameworkOffCanvas.state ? theme.partials.FrameworkOffCanvas.closeLeft() : "right-open" === theme.partials.FrameworkOffCanvas.state && theme.partials.FrameworkOffCanvas.closeRight(), setTimeout(function() {
                        return window.location.href = e
                    }, 450))
                }), t.sub_menu_links.on("click", function(e) {
                    return t.slideLeft($(this)), !1
                }), t.back_links.on("click", function(e) {
                    return t.slideRight($(this)), !1
                })
            }, t.prototype.adjustHeight = function(t) {
                var e, i;
                return (e = this).root.css({
                    height: "auto"
                }), e.root.outerHeight(), i = t.outerHeight(), "absolute" === t.css("position") && (t.css("position", "relative"), i = t.outerHeight(), t.css("position", "absolute")), e.root.velocity({
                    height: i
                })
            }, t.prototype.slideLeft = function(t) {
                var e;
                return this, (e = t.closest("li").find("ul").first()).css({
                    display: "block"
                }), this.adjustHeight(e), e.velocity({
                    translateX: ["-100%", 0]
                })
            }, t.prototype.slideRight = function(t) {
                var e, i;
                return this, i = (e = t.closest("ul")).parent().closest("ul"), this.adjustHeight(i), e.velocity({
                    translateX: [0, "-100%"]
                })
            }, t
        }(), t = function() {
            return function() {
                $(".accordion.headings").each(function() {
                    return $(this).add($(this).next(".accordion.content")).wrapAll("<div class='accordion-wrapper'/>")
                }), $(".accordion.headings li").wrapInner('<div class="trigger"></div>'), $(".accordion.headings li .trigger").append('<div class="bg"></div>'), $(".accordion-wrapper").each(function() {
                    var t, e;
                    return e = $(this).find(".accordion.headings > li"), t = $(this).find(".accordion.content > li"), e.first().addClass("active"), t.each(function(t) {
                        return $('<div class="content">' + $(this).html() + "</div>").appendTo(e.eq(t))
                    }), t.remove(), $(this).find(".content").first().show(), $(this).find(".trigger").on("click", function() {
                        var t, e;
                        return t = $(this).closest(".accordion").find(".content"), e = $(this).closest("li").find(".content"), t.not(e).slideUp(200), e.slideDown(200), $(this).closest(".accordion").find("li").removeClass("active"), $(this).closest("li").addClass("active")
                    })
                })
            }
        }(), theme.classes.Article = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments)
            }
            return w(e, t), e
        }(theme.classes.FrameworkArticle), theme.classes.Cart = function(t) {
            function e() {
                return this.updateTotalsComplete = y(this.updateTotalsComplete, this), e.__super__.constructor.apply(this, arguments)
            }
            return w(e, t), e.prototype.updateTotalsComplete = function(t) {
                $('body').removeClass('ajaxLoading');
                t > 0 ? ($(".cart .show--medium-large .number-wrapper").show(), $(".header--mobile .number-wrapper").show()) : ($(".cart .show--medium-large .number-wrapper").hide(), $(".header--mobile .number-wrapper").hide())
            }, e
        }(theme.classes.FrameworkCart), theme.classes.FeaturedProduct = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments)
            }
            return w(e, t), e
        }(theme.classes.FrameworkFeaturedProduct), theme.classes.FeaturedVideo = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments)
            }
            return w(e, t), e
        }(theme.classes.FrameworkFeaturedVideo), n = function() {
            function t(t) {
                this.root = t, this.stickyFooter = y(this.stickyFooter, this), this.addListeners = y(this.addListeners, this), this.load = y(this.load, this), this.load()
            }
            return t.prototype.load = function() {
                return this, this.addListeners(), this.stickyFooter()
            }, t.prototype.addListeners = function() {
                var t;
                return t = this, f.on("resize", function() {
                    return t.stickyFooter()
                })
            }, t.prototype.stickyFooter = function() {
                var t;
                if (t = r.outerHeight() + $(".main-content").outerHeight() + $(".main-footer").outerHeight(), f.outerHeight() > t) return $(".main-content").css({
                    "min-height": f.outerHeight() - $(".main-header").outerHeight() - $(".main-footer").outerHeight()
                })
            }, t
        }(), o = function() {
            function t(t) {
                var e;
                this.eventListeners = y(this.eventListeners, this), this.alignPlayButton = y(this.alignPlayButton, this), this.alignCaption = y(this.alignCaption, this), this.isFirstSlider = y(this.isFirstSlider, this), this.getActiveIndex = y(this.getActiveIndex, this), this.autoplay = y(this.autoplay, this), this.removeDuplicateVideoModals = y(this.removeDuplicateVideoModals, this), this.createSlider = y(this.createSlider, this), this.el = t, e = this.el.closest(".slider"), this.autoplay_enabled = e.data("autoplay"), e.find(".slide").length < 2 && (this.autoplay_enabled = !1), this.autoplay_frequency = e.data("rotateFrequency"), this.transition_style = e.data("transitionStyle"), this.removeDuplicateVideoModals(), this.createSlider(), this.owl = $(".owl-carousel").data("owlCarousel")
            }
            return t.prototype.createSlider = function() {
                var t, e;
                return e = {
                    singleItem: !0,
                    navigation: !1,
                    paginationNumbers: !1,
                    scrollPerPageNav: !0,
                    slideSpeed: 800,
                    pagination: !0,
                    autoHeight: !0,
                    autoPlay: (t = this).autoplay(),
                    afterInit: function() {
                        return t.eventListeners()
                    },
                    afterAction: function() {
                        return t.alignCaption(), t.alignPlayButton()
                    }
                }, "default" !== this.transition_style && (e.transitionStyle = this.transition_style), t.el.owlCarousel(e)
            }, t.prototype.removeDuplicateVideoModals = function() {
                return $(".modal.video:gt(0)").remove()
            }, t.prototype.autoplay = function() {
                return !!this.autoplay_enabled && this.autoplay_frequency
            }, t.prototype.getActiveIndex = function() {
                return this.el.find(".owl-pagination .owl-page.active").index()
            }, t.prototype.isFirstSlider = function() {
                var t, e, i;
                return i = (e = $(".index-sections").children("div:first")).find(".slider").data("sectionId"), t = this.el.closest(".slider").data("sectionId"), !!e.hasClass("section--slideshow") && t === i
            }, t.prototype.alignCaption = function() {
                var t, e, i, n, o;
                return n = this.el.find(".owl-item").eq(this.getActiveIndex()), (t = n.find(".caption")).css("visibility", "hidden"), e = t.outerHeight(), i = t.outerWidth(), 30, o = theme.utils.transparentMenuIsEnabled() && !0 === this.isFirstSlider() ? $(".main-header").outerHeight() : 0, theme.utils.imagesLoaded(n.find("img").first(), function() {
                    var r, s, a, l;
                    return a = n.outerHeight(), l = n.outerWidth(), t.hasClass("top") ? t.css("top", o + 30) : t.hasClass("middle") && (s = o + (a - o - e) / 2, t.css("top", s)), t.hasClass("center") && (r = (l - i) / 2, t.css("left", r)), t.css("visibility", "visible")
                })
            }, t.prototype.alignPlayButton = function() {
                var t, e;
                return e = this.el.find(".owl-item").eq(this.getActiveIndex()), (t = e.find(".play-button")).css("visibility", "hidden"), theme.utils.transparentMenuIsEnabled() && "absolute" === $(".main-header").css("position") ? theme.utils.imagesLoaded(e.find("img").first(), function() {
                    var i;
                    return i = (e.outerHeight() - t.outerHeight()) / 2, t.css({
                        "margin-top": 0,
                        top: i
                    })
                }) : t.css({
                    "margin-top": "-40px",
                    top: "50%"
                }), t.css("visibility", "visible")
            }, t.prototype.eventListeners = function() {
                var t;
                return t = this, this.el.find(".play-button").on("click", function() {
                    return new h($(this).closest(".video")).open(), t.owl.stop(), !1
                }), this.el.find(".owl-pagination .owl-page").on("click", function() {
                    return t.owl.stop()
                }), i.on("header.transparentMenuIsUpdated", t.alignCaption)
            }, t
        }(), theme.classes.Header = function() {
            function t(t) {
                this.root = t, this.moveYMenu = y(this.moveYMenu, this), this.sectionListeners = y(this.sectionListeners, this), this.load = y(this.load, this), this.load()
            }
            return t.prototype.load = function() {
                var t;
                return (t = this).searchAndAccount(), t.sectionListeners(), t.moveYMenu()
            }, t.prototype.sectionListeners = function() {
                return this, this.root.on("theme:section:load", function() {
                    return theme.partials.FrameworkOffCanvas.unload(), theme.partials.FrameworkOffCanvas.load()
                })
            }, t.prototype.moveYMenu = function() {
                return $(".mobile-nav--menu").empty(), $(".y-menu").appendTo(".mobile-nav--menu")
            }, t.prototype.searchAndAccount = function() {
                return $(".account-open").click(function() {
                    return $(this).closest(".menu").fadeOut(100, function() {
                        return $(".account-container").fadeIn(200)
                    }), !1
                }), $(".account-close").click(function() {
                    return $(".account-container").fadeOut(100, function() {
                        return $(".search-account .menu").fadeIn(200)
                    }), !1
                })
            }, t
        }(), s = function() {
            return function() {
                $(".tabs-horizontal.headings").each(function() {
                    return $(this).add($(this).next(".tabs.content")).wrapAll("<div class='tabs-wrapper horizontal'/>")
                }), $(".tabs-horizontal.headings li").wrapInner('<div class="trigger"></div>'), $(".tabs-horizontal.headings li .trigger").append('<div class="bg"></div>'), $(".tabs-wrapper.horizontal").each(function() {
                    var t, e;
                    return e = $(this).find(".headings > li"), (t = $(this).find(".tabs.content > li")).first().addClass("active"), e.first().addClass("active"), e.on("click", function() {
                        return e.removeClass("active"), t.removeClass("active"), $(this).addClass("active"), t.eq($(this).index()).addClass("active")
                    })
                })
            }
        }(), a = function() {
            function t() {
                this.load = y(this.load, this), this.listeners(), this.load()
            }
            return t.prototype.load = function() {
                var t;
                if (window.matchMedia("only screen and (min-width: " + m + "px)").matches) {
                    if ("large" !== t) return $.event.trigger("largeWindow"), "large"
                } else if (window.matchMedia("only screen and (min-width: " + g + "px)").matches) {
                    if ("medium" !== t) return $.event.trigger("mediumWindow"), "medium"
                } else if ("small" !== t) return $.event.trigger("smallWindow"), "small"
            }, t.prototype.listeners = function() {
                return this, f.on("resize.section-" + this.section_id, this.load)
            }, t
        }(), u = function() {
            return function(t) {
                var e, n, o, r, s, a, u, c, d, p, h, m, g, v, y, w, b, _, x, S, k;
                this.clazz = t, y = null, w = this.clazz, g = $(".popup-modal-mask"), k = function() {
                    var t, e, i;
                    t = new Date, i = 864e5 * popup_config.days_until, e = {
                        expires: t.setTime(t.getTime() + i)
                    };
                    try {
                        return localStorage[popup_config.storage_key] = JSON.stringify(e)
                    } catch (t) {
                        return !1
                    }
                }, x = function() {
                    return localStorage.removeItem(popup_config.storage_key), k()
                }, m = function() {
                    var t, e;
                    return t = JSON.parse(localStorage[popup_config.storage_key]).expires, e = (new Date).getTime(), parseFloat(t - e) <= 0 && (x(), !0)
                }, _ = function() {
                    var t;
                    return t = !1, "undefined" === Storage || popup_config.test_mode ? t = !0 : void 0 === localStorage[popup_config.storage_key] ? (t = !0, k()) : t = m(), t
                }, v = function() {
                    return $(".popup-modal").is(":visible") || $(".modal-mask").length > 0 && $(".modal-mask").is(":visible")
                }, S = function() {
                    return g.show(), l.addClass("modal-on")
                }, h = function() {
                    return g.hide(), l.removeClass("modal-on")
                }, u = function() {
                    return !1 === popup_config.show_image_enabled ? "" : popup_config.image_link.length > 0 ? $('<div class="popup-image"> <a href="' + popup_config.image_link + '">' + popup_config.show_image_url + "</a> </div>") : $('<div class="popup-image">').append(popup_config.show_image_url)
                }, c = function() {
                    return !1 === popup_config.newsletter_enabled ? "" : $("<div id='subscribe_module'></div>").append($(".popup--root"))
                }, d = function() {
                    return !1 === popup_config.social_icons_enabled ? "" : $(".social-follow").clone()
                }, a = function() {
                    var t;
                    return t = "", t += !0 === popup_config.show_image_enabled ? " has-image" : " has-no-image", t += popup_config.page_content.length > 0 ? " has-page-content" : " has-no-page-content", (t += popup_config.newsletter_enabled ? " has-newsletter" : " has-no-newsletter") + (popup_config.social_icons_enabled ? " has-social-icons" : " has-no-social-icons")
                }, p = function() {
                    return '<dialog class="' + w + " popup-modal" + a() + '" />'
                }, s = function() {
                    var t;
                    return $(".popup-modal.size-chart").length < 1 && (t = {
                        wrapper: p()
                    }, l.append($(t.wrapper).append($(".size-chart")))), b()
                }, r = function() {
                    var t, e, i;
                    return t = {
                        wrapper: p(),
                        newsletter: c(),
                        social_icons: d(),
                        image: u()
                    }, e = function() {
                        return popup_config.page_content.length < 1 && !1 === popup_config.newsletter_enabled && !1 === popup_config.social_icons_enabled ? "" : $("<div class='inner' />").append(t.body, t.newsletter, t.social_icons)
                    }, i = function() {
                        return l.append($(t.wrapper).append(t.image, e())), b()
                    }, popup_config.page_content.length > 0 ? $.getJSON("/pages/" + popup_config.page_content + ".json", function(e, n) {
                        return t.body = "<div class='page-contents'>" + e.page.body_html + "</div>", i()
                    }) : i()
                }, e = function() {
                    return setTimeout(function() {
                        if (y.length > 0 && $(".popup-modal-mask").is(":visible")) return theme.utils.imagesLoaded(y, function() {
                            return $('dialog[class*="' + w + '"]:last-of-type').outerHeight() >= f.height() ? l.addClass("modal-unfix") : l.removeClass("modal-unfix")
                        })
                    }, 0)
                }, b = function() {
                    return y = $('dialog[class*="' + w + '"]'), o(), y.addClass("opened").removeClass("closed"), e(), S()
                }, o = function() {
                    var t;
                    return t = function(t) {
                        return "modal-close" === t.originalEvent.animationName ? "popup" === w ? y.remove() : y.removeClass("closed, completed") : y.addClass("completed").removeClass("opened")
                    }, i.on("click", ".popup-modal", function(t) {
                        if (t.stopPropagation(), t.target === this) return n()
                    }), $(".popup-modal-close").click(n), g.click(n), y.on("animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd", t), f.resize(e), i.keydown(function(t) {
                        if (y.hasClass("completed") && 27 === t.keyCode) return n()
                    }), $("dialog.popup-modal #contact_form").on("submit", function(t) {
                        return (y = $(this).closest(".popup-modal")).find(".error, .success").remove(), t.preventDefault(), 0 === y.find('input[type="email"]').val().length ? (y.find(".inner").prepend('<p class="error">' + theme.translation.newsletter_email_blank + "</p>"), !1) : (this.submit(), !1)
                    })
                }, n = function() {
                    return y.addClass("closed").removeClass("completed").removeClass("opened"), h()
                }, "popup" !== w ? s() : popup_config.enabled && _() && (popup_config.page_content.length > 0 || popup_config.newsletter_enabled || popup_config.show_image_enabled || popup_config.social_icons_enabled) && setTimeout(function() {
                    if (!(!0 === v() || $(".popup-modal-mask").length < 1)) return r()
                }, 1e3 * popup_config.seconds_until)
            }
        }(), theme.classes.ProductGrid = function() {
            function t(t) {
                var e;
                this.root = t, this.hoverImagesLoaded = y(this.hoverImagesLoaded, this), this.listeners = y(this.listeners, this), this.matchImageHeights = y(this.matchImageHeights, this), this.detectOnboarding = y(this.detectOnboarding, this), this.load = y(this.load, this), (e = this).items = e.root.find(".product--root"), e.onboarding = e.detectOnboarding(), e.in_slider = e.root.data("in-slider"), e.load()
            }
            return t.prototype.load = function() {
                var t;
                if ((t = this).listeners(), t.hoverImagesLoaded(), !t.in_slider) return t.matchImageHeights()
            }, t.prototype.detectOnboarding = function() {
                return this, !!this.items.first().find(".placeholder").length
            }, t.prototype.matchImageHeights = function() {
                return this, theme.utils.matchImageHeights(this.root, this.items, ".product--image-wrapper")
            }, t.prototype.listeners = function() {
                var t;
                if (!(t = this).in_slider) return $(window).on("resize.ProductGrid", theme.utils.debounce(100, function() {
                    return t.matchImageHeights()
                }))
            }, t.prototype.hoverImagesLoaded = function() {
                return this, this.items.filter('[data-hover-image="true"]').each(function() {
                    var t;
                    return t = $(this), theme.utils.imagesLoaded(t, function() {
                        return t.attr("data-hover-image", "loaded")
                    })
                })
            }, t
        }(), theme.classes.ProductRecommendations = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments)
            }
            return w(e, t), e
        }(theme.classes.FrameworkProductRecommendations), c = function() {
            function t(t) {
                var e;
                this.root = t, this.listeners = y(this.listeners, this), this.afterUpdate = y(this.afterUpdate, this), this.load = y(this.load, this), (e = this).product_grid = e.root.find(".product-grid--root"), e.product_item = e.root.find(".product--root"), e.load(), e.listeners()
            }
            return t.prototype.load = function() {
                var t;
                return (t = this).product_grid.owlCarousel({
                    items: 4,
                    navigation: !0,
                    scrollPerPage: !0,
                    slideSpeed: 800,
                    lazyLoad: !1,
                    pagination: !1,
                    navigationText: !1,
                    afterUpdate: t.afterUpdate()
                }), t.product_item.show()
            }, t.prototype.afterUpdate = function() {
                return $(window).trigger("ProductSlider.afterUpdate")
            }, t.prototype.listeners = function() {
                var t;
                return t = this, $(window).on("resize.ProductGrid", theme.utils.debounce(100, function() {
                    return t.loadCarousel
                }))
            }, t
        }(), d = function() {
            function t(t) {
                var e;
                this.root = t, this.load = y(this.load, this), (e = this).promo_bar = e.root, e.close_btn = e.root.find(".close"), e.load()
            }
            return t.prototype.load = function() {
                var t;
                return t = this, "undefined" != typeof Storage && null !== Storage && sessionStorage["promo-bar-closed"] ? t.promo_bar.hide() : (t.promo_bar.show(), t.close_btn.on("click", function() {
                    return t.close()
                }))
            }, t.prototype.close = function() {
                return this, "undefined" == typeof Storage || null === Storage || sessionStorage["promo-bar-closed"] || (sessionStorage["promo-bar-closed"] = !0), this.promo_bar.addClass("closed")
            }, t
        }(), p = function() {
            return function() {
                $(".tabs-vertical.headings").each(function() {
                    return $(this).add($(this).next(".tabs.content")).wrapAll("<div class='tabs-wrapper vertical'/>")
                }), $(".tabs-vertical.headings li").wrapInner('<div class="trigger"></div>'), $(".tabs-vertical.headings li .trigger").append('<div class="bg"></div>'), $(".tabs-wrapper.vertical").each(function() {
                    var t, e, i;
                    return i = $(this), e = $(this).find(".headings > li"), (t = $(this).find(".tabs.content > li")).first().addClass("active"), e.first().addClass("active"), e.on("click", function() {
                        if (e.removeClass("active"), t.removeClass("active"), $(this).addClass("active"), t.eq($(this).index()).addClass("active"), general_scroll_to_active_item) return matchMedia("only screen and (min-width: " + g + "px)").matches ? $("html, body").animate({
                            scrollTop: i.offset().top - 50
                        }, "slow") : $("html, body").animate({
                            scrollTop: i.offset().top + i.find(".headings").outerHeight() - 50
                        }, "slow")
                    })
                })
            }
        }(), h = function() {
            function t(t) {
                this.createIframe = y(this.createIframe, this), this.extractVideoId = y(this.extractVideoId, this), this.extractVideoType = y(this.extractVideoType, this), this.eventListeners = y(this.eventListeners, this), this.centerPosition = y(this.centerPosition, this), this.close = y(this.close, this), this.open = y(this.open, this), this.opened = !1, this.video = t, this.modal = $(".video.modal"), this.player_button = t.find(".player-button"), this.src_url = t.find(".play-button").attr("href"), this.type = this.extractVideoType(), this.id = this.extractVideoId(), this.iframe = this.createIframe(), this.caption = t.find(".caption")
            }
            return t.prototype.open = function() {
                return this.opened = !0, this.modal.find(".flex-video").append(this.iframe), this.caption.length > 0 ? (this.modal.find(".caption").append(this.caption.html()), this.modal.addClass("wide")) : (this.modal.find(".player").removeClass("large-8"), this.modal.find(".caption").hide(), this.modal.removeClass("wide")), this.player_button.hide(), $(".modal-mask").show(), this.modal.find(".close").show(), this.modal.fadeIn(), this.centerPosition(), $(".modal").fadeIn(0), this.eventListeners()
            }, t.prototype.close = function() {
                if (this.opened = !1, this.modal.find(".flex-video").empty(), this.modal.find(".caption").empty(), this.modal.hide(), $(".modal-mask").fadeOut(), 0 === this.caption.length) return this.modal.find(".player").addClass("large-8"), this.modal.find(".caption").show()
            }, t.prototype.centerPosition = function() {
                return f.height() < this.modal.outerHeight() ? this.modal.css({
                    position: "absolute",
                    top: "30px",
                    "margin-top": 0,
                    "margin-left": -this.modal.outerWidth() / 2
                }) : this.modal.css({
                    position: "fixed",
                    top: "50%",
                    "margin-top": -this.modal.outerHeight() / 2,
                    "margin-left": -this.modal.outerWidth() / 2
                })
            }, t.prototype.eventListeners = function() {
                var t;
                return t = this, this.modal.find(".close").on("click", function() {
                    return t.close()
                }), f.resize(function() {
                    return t.centerPosition()
                }), i.keydown(function(e) {
                    if (t.opened && 27 === e.keyCode) return t.close()
                }), $(".modal-mask").on("click", function() {
                    return t.close()
                }), this.player_button.on("click", function() {
                    return !1
                })
            }, t.prototype.extractVideoType = function() {
                return /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i.exec(this.src_url) ? "youtube" : !!/^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/.exec(this.src_url) && "vimeo"
            }, t.prototype.extractVideoId = function() {
                var t, e;
                if ("youtube" === this.type) {
                    if (e = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/, (t = this.src_url.match(e)) && 11 === t[2].length) return t[2]
                } else if ("vimeo" === this.type && (e = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/, t = this.src_url.match(e))) return t[2]
            }, t.prototype.createIframe = function() {
                return "youtube" === this.type ? '<iframe  src="//www.youtube.com/embed/' + this.id + '?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe>' : "vimeo" === this.type ? '<iframe src="//player.vimeo.com/video/' + this.id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' : void 0
            }, t
        }(), theme.classes.XMenu = function(t) {
            function e(t) {
                var i;
                this.root = t, this.slideDown = y(this.slideDown, this), this.hideHeader = y(this.hideHeader, this), this.showHeader = y(this.showHeader, this), this.headerListeners = y(this.headerListeners, this), this.isHeaderTransparent = y(this.isHeaderTransparent, this), (i = this).header = $(".main-header"), i.header_bg = i.header.find(".header--bg"), i.header_timer = null, i.transparent_header = i.isHeaderTransparent(), e.__super__.constructor.apply(this, arguments), i.headerListeners()
            }
            return w(e, t), e.prototype.isHeaderTransparent = function() {
                return "true" === $(".header").attr("data-header--menu-transparent")
            }, e.prototype.headerListeners = function() {
                var t;
                return (t = this).parents_with_sub_menu.on("mouseenter", function(e) {
                    return clearTimeout(t.header_timer)
                }), t.header.on("mouseenter touchstart", function(e) {
                    return clearTimeout(t.header_timer), t.showHeader()
                }), t.header.on("mouseleave", function(e) {
                    return t.header_timer = setTimeout(function() {
                        return t.hideHeader()
                    }, 500)
                })
            }, e.prototype.showHeader = function() {
                if (this, 0 === parseInt(this.header_bg.css("opacity"))) return this.header_bg.velocity({
                    opacity: [.95]
                }, {
                    duration: 400,
                    queue: !1
                })
            }, e.prototype.hideHeader = function() {
                var t;
                return !((t = this).parents_with_sub_menu.filter('[data-main-menu--open="true"]').length > 0) && (t.header_bg.velocity({
                    opacity: 0
                }, {
                    duration: 400
                }), t.slideUp())
            }, e.prototype.slideDown = function(t, i) {
                return null == i && (i = !1), this, "complete" !== i && Math.round(100 * parseFloat(this.header_bg.css("opacity"))) < 90 && this.transparent_header && (i = 400), e.__super__.slideDown.call(this, t, i)
            }, e
        }(theme.classes.FrameworkXMenu), theme.classes.Blog = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments)
            }
            return w(e, t), e
        }(theme.classes.FrameworkBlog), e = function() {
            return function() {
                i.on("change", ".tags-listbox", function() {
                    var t, e;
                    return t = [], $(this).each(function(e, i) {
                        if ($(this).val()) return t.push($(this).val())
                    }), t.length ? (e = t.join("+"), window.location.href = $(theme.collection.tag).attr("href").replace("tag", e)) : theme.collection.handle ? window.location.href = "/collections/" + theme.collection.handle : theme.collection.products.first_type === theme.collection.title ? window.location.href = theme.collection.url_for_type : theme.collection.products.first_vendor === theme.collection.title ? window.location.href = theme.collection.url_for_vendor : void 0
                })
            }
        }(), theme.classes.ProductPage = function() {
            function e(t) {
                var e;
                this.root = t, this.cssGridFallback = y(this.cssGridFallback, this), this.modalCloseListener = y(this.modalCloseListener, this), this.resizeListeners = y(this.resizeListeners, this), this.imageZoom = y(this.imageZoom, this), this.getActiveImageId = y(this.getActiveImageId, this), this.updateVariantImage = y(this.updateVariantImage, this), this.thumbListener = y(this.thumbListener, this), this.variantSelected = y(this.variantSelected, this), this.sizeChart = y(this.sizeChart, this), this.updateLowInStock = y(this.updateLowInStock, this), this.getVariantQuantity = y(this.getVariantQuantity, this), this.getLowInStockAmount = y(this.getLowInStockAmount, this), this.getLowInStockMessage = y(this.getLowInStockMessage, this), this.mobileModalHandler = y(this.mobileModalHandler, this), this.addProductComplete = y(this.addProductComplete, this), this.addToCartListener = y(this.addToCartListener, this), this.load = y(this.load, this), (e = this).thumbs = e.root.find(".product-page--thumb"), e.main_images = e.root.find(".product-page--image"), e.zoom_images = e.root.find(".product-page--zoom-image"), e.image_container = e.root.find(".product-page--images-container"), e.magnify = parseFloat(e.root.data("magnify")), e.size_chart_enabled = e.root.data("size-chart-enabled"), e.size_chart_option = e.root.data("size-chart-option").toLowerCase(), e.form = e.root.find(".product-page--cart-form form"), e.add_button = e.root.find("#add"), e.load()
            }
            return e.prototype.load = function() {
                var e, n;
                if ((e = this).cssGridFallback(), e.thumbListener(), e.imageZoom(), e.resizeListeners(), e.modalCloseListener(), e.mobileModalHandler(), e.addToCartListener(), e.root.on("theme:section:load", function() {
                        return new Cart, new t, new s, new p, new Shopify.OptionSelectors("variant-listbox", {
                            product: product_json,
                            onVariantSelected: e.variantSelected,
                            enableHistoryState: !0
                        })
                    }), n = $("article .photos"), i.on("click", ".size-chart-trigger", function(t) {
                        return t.preventDefault(), new u("size-chart-container")
                    }), n.on("click", function() {
                        return !1
                    }), $("article .custom.dropdown").hide(), 1 === product_options_size && "Title" !== product_options_first) return $(".selector-wrapper:eq(0)").prepend("<label class='variant-opt'>" + product_options_first + "</label>")
            }, e.prototype.addToCartListener = function() {
                var t;
                if ((t = this).form.length > 0) return t.form.submit(function() {
                    return t.form.find("p.error").remove(), t.add_button.attr("data-loading", "true"), theme.partials.Cart.addItem($(this), function(e, i) {
                        return e ? theme.partials.Cart.updateAllHtml(function() {
                            return t.addProductComplete()
                        }) : (t.form.append('<p class="error">' + i + "</p>"), t.add_button.attr("data-loading", "false"))
                    }), !1
                })
            }, e.prototype.addProductComplete = function() {
                return this, this.add_button.attr("data-loading", "false"), $('[data-off-canvas--open="right-sidebar"]').first().trigger("click")
            }, e.prototype.mobileModalHandler = function() {
                return this, this.image_container.find(".modal--link").on("click", function(t) {
                    if ("small" === theme.utils.mqs.current_window) return t.stopImmediatePropagation()
                })
            }, e.prototype.getLowInStockMessage = function(t) {
                var e;
                return e = 1 === t ? theme.products.low_in_stock.one : theme.products.low_in_stock.other, t > 1 && (e = e.replace(/\d+/, t)), e
            }, e.prototype.getLowInStockAmount = function() {
                return this, this.root.data("product-low-in-stock-amount")
            }, e.prototype.getVariantQuantity = function(t) {
                var e;
                return (e = $("#variant-listbox").find('[value="' + t.id + '"]')).length > 0 ? parseInt(e.data("inventory-quantity")) : "not available"
            }, e.prototype.updateLowInStock = function(t) {
                var e, n, o;
                return e = this, null !== t && (n = e.getVariantQuantity(t), "undefined" !== (o = e.getLowInStockAmount()) && (n > 0 && n <= o ? $(".product-low-in-stock").html("<p>" + e.getLowInStockMessage(n) + "</p>").show() : $(".product-low-in-stock").hide(), i.on(".shopify-section section--products shopify:section:select", function() {
                    return e.updateLowInStock(t)
                })))
            }, e.prototype.sizeChart = function(t) {
                var e;
                // if ((e = this).size_chart_enabled) return $(".selector-wrapper").each(function(i, n) {
                //     if (t[i].toLowerCase() === e.size_chart_option && 0 === $(n).find(".size-chart-trigger").length) return $(n).append('<div class="font--block-link"><a class="size-chart-trigger" href="#">' + theme.products.size_chart.label + "</a></div>")
                // })
            }, e.prototype.variantSelected = function(t, e, i) {
                var n, o, r;
                var vID = t.id;
                var priceHTML = $('.variantAttr [data-id="'+vID+'"] .priceHTML').html();

                //console.log('renderPrice variantSelected theme 2', t.id, priceHTML);
                var discountMod = parseFloat($('.product-page-right .prices').attr('data-custom-discount'));
                var fixedDiscountPrice = parseInt($('.product-page-right .prices').attr('data-fixed-discount-price'));

                //console.log(t);
                // console.log('t.price');
                // console.log('t.price:'+t.price);
                // console.log('xxxxxx'+t.price); 


                /*
                n = this, $(".compare-price .money").html(""), $('.product-unavailable [type="submit"]').prop("disabled", !0), t && t.available ? ($(".quanity-cart-row, .product-page--smart-payment-buttons").show(), $(".product-unavailable").hide()) : ($(".quanity-cart-row, .product-page--smart-payment-buttons").hide(), $(".product-unavailable").show(), $(".product-low-in-stock").hide(), $('.product-unavailable [type="submit"]').prop("disabled", !1), product_variant_size > 1 && t && $(".product-unavailable form .email-body").attr("value", "Please notify me when this is back in stock: " + product_title + " - " + t.title)), t && (o = Shopify.formatMoney(t.price * discountMod, shop_money_format), 
                    $(".priceBox .actual-price").replaceWith('<span data-val="'+o+'" class="actual-price money font--accent" itemprop="price">' + o + "</span>"), t.compare_at_price > t.price && (r = Shopify.formatMoney(t.compare_at_price, shop_money_format), $(".compare-price").html('<span class="money font--light-accent" data-currency="'+Currency.currentCurrency+'">' + r + "</span>")), currency_switcher_enabled && Currency.convertAll(shopCurrency, $("[name=currencies]").val()), t.featured_image && n.updateVariantImage(t.featured_image.id)), !0 === (!1 !== n.getLowInStockAmount()) && n.updateLowInStock(t), n.sizeChart(e.product.options);
                */    
                n = this;
$(".compare-price .money").html("");
$('.product-unavailable [type="submit"]').prop("disabled", true);
if (t && t.available) {
  $(".quanity-cart-row, .product-page--smart-payment-buttons").show();
  $(".product-unavailable").hide();
} else {
  $(".quanity-cart-row, .product-page--smart-payment-buttons").hide();
  $(".product-unavailable").show();
  $(".product-low-in-stock").hide();
  $('.product-unavailable [type="submit"]').prop("disabled", false);
  if (product_variant_size > 1 && t) {
    $(".product-unavailable form .email-body").attr("value", "Please notify me when this is back in stock: " + product_title + " - " + t.title);
  }
}

if (t) {

  o = Shopify.formatMoney(t.price * discountMod, shop_money_format);




  // $(".priceBox .actual-price").replaceWith('<span data-val="' + o + '" class="actual-price" itemprop="price">' + customMoney(t.price * discountMod, false) + "</span>");
  // if (t.compare_at_price > t.price) {
  //   r = Shopify.formatMoney(t.compare_at_price, shop_money_format);
  //   $(".compare-price").html(customMoney(t.compare_at_price, false));
  // }
  // if (currency_switcher_enabled) {
  //   //Currency.convertAll(shopCurrency, $("[name=currencies]").val());
  // }


  if (t.featured_image) {
    n.updateVariantImage(t.featured_image.id);
  }
}

if (n.getLowInStockAmount() !== false === true) {
  n.updateLowInStock(t);
}
n.sizeChart(e.product.options);




                console.log('o.price:'+o);


                if (fixedDiscountPrice > 0) {
                   var r =  Shopify.formatMoney(t.price, shop_money_format);
                   var dp = Shopify.formatMoney(Math.trunc(fixedDiscountPrice * parseFloat(window.Shopify.currency.rate)), shop_money_format);
                   

                   $(".product-page-right .actual-price").html(customMoney(Math.trunc(fixedDiscountPrice * parseFloat(window.Shopify.currency.rate)), false));
                   //$(".product-page-right .compare-price").html('<span class="money font--light-accent">' + r + '</span>');
                   $(".product-page-right .compare-price").html(customMoney(t.price, false));
                }    
                if (discountMod < 1) {
                   var r =  Shopify.formatMoney(t.price, shop_money_format);
                   //$(".product-page-right .compare-price").html('<span class="money font--light-accent">' + r + '</span>'); 
                   $(".product-page-right .compare-price").html(customMoney(t.price, false));
                }

                // setTimeout(function() {
                //   //Currency.convertAll(shopCurrency, defaultCurrency);
                // }, 600);
                //console.log('convertAll vvvv1111');

                if (Shopify.currency.active != defaultCurrency) {
                    //console.log('convertAll vvvv');
                    //Currency.convertAll(shopCurrency, defaultCurrency); 
                }  

            }, e.prototype.thumbListener = function() {
                var t;
                return (t = this).thumbs.on("keypress click", function(e) {
                    var i;
                    return theme.utils.a11yClick(e) && (i = $(this).data("id"), t.updateVariantImage(i)), t.imageZoom()
                })
            }, e.prototype.updateVariantImage = function(t) {
                var e;
                return (e = this).main_images.attr("data-active", "false"), e.main_images.filter('[data-id="' + t + '"]').attr("data-active", "true"), e.thumbs.attr("data-active", "false"), e.thumbs.filter('[data-id="' + t + '"]').attr("data-active", "true"), e.imageZoom()
            }, e.prototype.getActiveImageId = function() {
                return this, this.main_images.filter('[data-active="true"]').data("id")
            }, e.prototype.imageZoom = function() {
                var t, e, i, n, o, r, s, a;
                if (!(!1 === (t = this).root.data("zoom-enabled") || t.main_images.length < 1)) return t.image_container.off("mouseenter.ProductPage.imageZoom"), t.image_container.off("mouseleave.ProductPage.imageZoom"), (e = t.zoom_images.filter('[data-id="' + t.getActiveImageId() + '"]')).data("aspect-ratio"), r = t.image_container.width(), o = t.image_container.height(), e.css("width", r * t.magnify), e.find(".image--root").css("width", r * t.magnify), e.find("img").addClass("lazypreload"), n = t.image_container.offset().top, i = t.image_container.offset().left, s = (r * t.magnify - r) / r, a = (o * t.magnify - o) / o, t.image_container.on("mouseenter.ProductPage.imageZoom", function() {
                    return e.css("display", "block")
                }), t.image_container.on("mouseleave.ProductPage.imageZoom", function() {
                    return e.css("display", "none")
                }), t.image_container.on("mousemove", function(t) {
                    var o, r;
                    return o = t.pageX - i, r = t.pageY - n, e.css({
                        left: o * -s,
                        top: r * -a
                    })
                })
            }, e.prototype.resizeListeners = function() {
                var t;
                return t = this, $(window).on("resize.ProductPage", theme.utils.debounce(100, function() {
                    return t.imageZoom()
                }))
            }, e.prototype.modalCloseListener = function() {
                var t;
                return t = this, $(window).on("FrameworkModal.afterClose", function() {
                    return t.imageZoom()
                })
            }, e.prototype.cssGridFallback = function() {
                if (!Modernizr.cssgrid) return $(".product-page--title-n-vendor, .product-page--cart-form-block, .product-page--description").wrapAll('<div class="product-page--no-grid--left-column"></div>'), $(".product-page--images").wrapAll('<div class="product-page--no-grid--right-column"></div>')
            }, e
        }(), theme.classes.Utils = function(t) {
            function e() {
                e.__super__.constructor.apply(this, arguments), this.sections = new theme.classes.Sections, this.mqs = new theme.classes.FrameworkMediaQueries
            }
            return w(e, t), e.prototype.transparentMenuIsEnabled = function() {
                return l.find("[data-header--menu-transparent=true]").length > 0
            }, e.prototype.loadJsClasses = function() {
                return $("[data-js-class]").each(function() {
                    var t, e;
                    if (t = $(this).attr("data-js-class"), "true" !== $(this).attr("data-js-loaded") && void 0 !== (e = theme.classes[t])) return theme.partials[t] = new e($(this)), $(this).attr("data-js-loaded", "true")
                })
            }, e.prototype.addSymbol = function(t) {
                return '<svg class="fw--icon fw--icon--' + t + '"> <use xlink:href="#fw--icon--' + t + '" /> </svg>'
            }, e.prototype.isIE11 = function() {
                return !(!window.MSInputMethodContext || !document.documentMode)
            }, e
        }(theme.classes.FrameworkUtils), l = null, i = null, f = null, r = null, v = null, g = null, m = null, jQuery(function(h) {
            var y;
            return l = h("body"), i = h(document), f = h(window), r = h(".main-header"), v = Modernizr.touchevents, g = 768, m = 1280, 1440, theme.utils = new theme.classes.Utils, general_external_links_enabled && h('a[href^="http"]').not('a[href^="' + shop_url + '"]').attr("target", "_blank"), new u("popup"), new n(h(".footer")), new t, new s, new p, new d(h(".promo-bar")), l.hasClass("template-page") && (((y = h(".page-content .rte-content")).find(".left-side-column").length || y.find(".right-side-column").length) && (y.find(".left-side-column").length && y.find(".right-side-column").length ? (y.wrapInner("<div class='main-column with-2-sidebars'></div>"), h(".left-side-column").addClass("with-2-sidebars"), h(".right-side-column").addClass("with-2-sidebars")) : y.wrapInner("<div class='main-column'></div>"), h(".left-side-column").prependTo(y), h(".right-side-column").appendTo(y))), l.hasClass("template-index") && (h(".slider").each(function() {
                return new o(h(this).find(".slides"))
            }), h(".product-slider").each(function() {
                return new c(h(this))
            })), l.hasClass("template-collection") && new e, l.hasClass("template-password") && (h(document).on("click", ".password--login-link", function() {
                return h(this).css("visibility", "hidden"), h(".password--main").hide(), h(".password--login-form").css("visibility", "visible"), h('.password--login-form input[type="password"]').focus(), !1
            }).on("click", ".password--login-form .cancel", function() {
                return h(".password--login-link").css("visibility", "visible"), h(".password--main").fadeIn(), h(".password--login-form").css("visibility", "hidden"), !1
            }), h(".password--login-form .errors").size() && h(".password--login-link").click()), "undefined" != typeof InstallTrigger && h("img").addClass("image-scale-hack"), v && h("form.custom .hidden-field").removeClass("hidden-field"), "", new a, h(".hide-until-js").show(), i.on("shopify:section:load", function(t) {
                var e;
                return (e = h(t.target).closest(".shopify-section")).css("min-height", "2000px"), e.hasClass("section--slideshow") ? new o(h(t.target).find(".slides")) : e.hasClass("section--featured-collection") ? new c(h(t.target).find(".product-slider")) : e.hasClass("section--header") ? (setTimeout(function() {
                    if (h(".slider").length > 0) return i.trigger("header.transparentMenuIsUpdated")
                }, 0), new d(h(".promo-bar"))) : e.hasClass("section--products") && i.trigger("set-option-selectors"), e.css("min-height", "auto")
            }), i.on("shopify:section:unload", function(t) {
                var e, n;
                if ((n = h(t.target).closest(".shopify-section")).hasClass("section--featured-collection")) return setTimeout(function() {
                    if (0 === h(".section--featured-collection").length) return f.off("resize.ProductSlider")
                }, 0);
                if (n.hasClass("section--products")) {
                    if (e = h(".popup-modal-mask"), h(".size-chart").remove(), e.is(":visible")) return e.trigger("click")
                } else if (n.hasClass("section--slideshow")) return setTimeout(function() {
                    if (0 === h(".slider").length) return i.off("header.transparentMenuIsUpdated")
                }, 0)
            }), i.on("shopify:block:select", function(t) {
                var e, i;
                if ((e = h(t.target).closest(".shopify-section")).hasClass("section--slideshow")) return i = e.find(".slide").index(t.target), h(t.target).closest(".owl-carousel").trigger("owl.jumpTo", i).trigger("owl.stop")
            }), i.on("shopify:section:deselect", function(t) {
                var e;
                if ((e = h(t.target).closest(".shopify-section")).hasClass("section--slideshow") && !0 === e.find(".slider").data("autoplay")) return e.find(".slides").trigger("owl.play", e.find(".slider").data("rotateFrequency"))
            }), theme.utils.loadJsClasses(), !1
        })
    }.call(this);
$(document).ready(function() {
	$('.accordion').accordion({
	  cookieName: 'accordion_nav',
	  speed: 'fast'
	});
});
Currency.format = theme.currencySettings.format;


//var shopCurrency = theme.currencySettings.money_with_currency_format.replace('${{amount}} ', '');
//var shopCurrency = theme.currencySettings.defaultCurrency;
var shopCurrency = theme.currencySettings.shopCurrency;  
var shopCurrency = Shopify.currency.active;

/* Sometimes merchants change their shop currency, let's tell our JavaScript file */
Currency.moneyFormats[shopCurrency].money_with_currency_format = theme.currencySettings.money_with_currency_format;
Currency.moneyFormats[shopCurrency].money_format = theme.currencySettings.money_format;




console.log('selectedCurrency:'+$('[name=currencies]').val());


/* Default currency */
var defaultCurrency = theme.currencySettings.defaultCurrency;

/* Cookie currency */
var cookieCurrency = Currency.cookie.read();
// If there's no cookie.
console.log('cookieCurrency:'+cookieCurrency);
console.log('cookieCurrencyxxx:'+cookieCurrency);
if (cookieCurrency == null) {
  cookieCurrency = defaultCurrency;
  //Currency.cookie.write(shopCurrency); 
}

if (window.location.hostname == 'stylish-hound.com') {
  //alert('AUD');
  //Currency.cookie.write('AUD');
  //cookieCurrency = 'AUD';
} else if (window.location.hostname == 'stylish-hound.co.nz') {
  //alert('NZD');
  Currency.cookie.write('NZD');
  cookieCurrency = 'NZD'
} else if (window.location.hostname == 'stylish-hound.us') {
  //alert('USD');
  Currency.cookie.write('USD');
  cookieCurrency = 'USD';
}



!(function($){
  /* Fix for customer account pages */
  $('span.money span.money').each(function() {
    $(this).parents('span.money').removeClass('money');
  });

  /* Saving the current price */
  $('span.money').each(function() {
    $(this).attr('data-currency-' + shopCurrency, $(this).html());
  });




  // If there's no cookie.
  if (cookieCurrency == null) {
    if (shopCurrency !== defaultCurrency) {
      //Currency.convertAll(shopCurrency, defaultCurrency);
    }
    else {
      Currency.currentCurrency = defaultCurrency;
    }

  }
  // If the cookie value does not correspond to any value in the currency dropdown.
  else if ($('[name=currencies]').size() && $('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
    Currency.currentCurrency = shopCurrency;
    Currency.cookie.write(shopCurrency);
  }
  else if (cookieCurrency === shopCurrency) {
    Currency.currentCurrency = shopCurrency;
  }
  else {
    //Currency.convertAll(shopCurrency, cookieCurrency);
  }




  // $('[name=currencies]').val(Currency.currentCurrency).change(function() {

  //   var newCurrency = $(this).val();
  //   Currency.convertAll(Currency.currentCurrency, newCurrency);
  //   $('.selected-currency').text(Currency.currentCurrency);
  //   $('[name=currencies]').val(newCurrency); // update all others e.g. ones hidden in mobile view
  // });

  // var original_selectCallback = window.selectCallback;
  // var selectCallback = function(variant, selector) {
  //   original_selectCallback(variant, selector);
  //   Currency.convertAll(shopCurrency, $('[name=currencies]').val());
  //   $('.selected-currency').text(Currency.currentCurrency);
  // };

  // $('body').on('ajaxCart.afterCartLoad', function(cart) {
  //   Currency.convertAll(shopCurrency, $('[name=currencies]').val());
  //   $('.selected-currency').text(Currency.currentCurrency);
  // });

  // Set the Flag Image


  var setCurrencyFlag = function(){
    var flagUrl = $('[name=currencies]').find('option:selected').attr('data-flag-url');
    var currencyContainer = $('[name=currencies]').parent();
    $(currencyContainer).find('img').remove();
    $(currencyContainer).prepend('<img src="' + flagUrl + '" width="20" height="20"/>');
  };

  $('.selected-currency').text(Currency.currentCurrency);

  

  // Copy/clone new currency selector to target element
  var currencyTargetTotal = $('.currency-target');
  var newCurrencyDropdown = $('.currency-selector-to-clone .currency-selector-container');

  if (currencyTargetTotal.length > 0) {
    currencyTargetTotal.each(function(e){
      $(this).html(newCurrencyDropdown.clone());
    });
  }

  //$('[name=currencies]').val(Currency.currentCurrency);
  $('[name=currencies]').val(Currency.currentCurrency);    
  setCurrencyFlag();

  

  $(document).on('change', '[name=currencies]', function(e){
    var newCurrency = $(this).val();
    var selectedCurrencyUrl = $('[name=currencies]').find('option[value="'+newCurrency+'"]').attr('data-url');
    

    if (selectedCurrencyUrl == 'https://stylish-hound.com') {
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      Currency.cookie.write(newCurrency);
      cookieCurrency = newCurrency;
    }
    //alert(cookieCurrency+'||'+selectedCurrencyUrl);
    
    $('.selected-currency').text(Currency.currentCurrency);
    $('[name=currencies]').val(newCurrency); // update all others e.g. ones hidden in mobile view

    
    setCurrencyFlag();

    //console.log('newCurrency'+newCurrency);

    var currentURL = window.location.protocol+'//'+window.location.hostname;
    
    var currencyUrl = window.location.href.replace(currentURL, selectedCurrencyUrl);

    // console.log('currencyUrl');
    // console.log(currencyUrl);
    //Currency.cookie.write('AUD');
    //cookieCurrency = 'AUD';


    setTimeout(function() {
      //window.location.href = replaceUrlParam(currencyUrl, 'currency', newCurrency);
      window.location.href = currencyUrl;
    }, 600);
    
  });
})(jQuery);


function replaceUrlParam(url, paramName, paramValue)
{
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
    if (url.search(pattern)>=0) {
        return url.replace(pattern,'$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/,'');
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}


!(function($){
  // // Calculate the progress number, and the width of the progress bar. Compiled to ES5.
  // function calculateProgress(currentVal, targetVal) {
  //     var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
  //     var progressNum = document.querySelectorAll('.cart-shipping__num');
  //     var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
  //     var successMsg = document.querySelectorAll('.cart-shipping__success');
  //     // calculate how far progress is from the total as a percentage
  //     var result = Math.round(100 * currentVal / targetVal);
  //     progressBar.forEach(function(el){
  //       el.setAttribute('style', "width: ".concat(result, "%"));
  //     })
  //      // Update the progess text. If threshold is met, show success message
  //     var newProgressNum = (targetVal - currentVal) / 100;
  //     if(newProgressNum <= 0){
  //       successMsg.forEach(function(el){
  //         el.setAttribute('style', 'display: block;');
  //       });
  //       progressOuter.forEach(function(el){
  //         el.setAttribute('style', 'display: none;');
  //       });
  //       progressNum.forEach(function(el){
  //         el.textContent = newProgressNum;
  //       });
  //     } else {
  //       successMsg.forEach(function(el){
  //         el.setAttribute('style', 'display: none;');
  //       });
  //       progressOuter.forEach(function(el){
  //         el.setAttribute('style', 'display: block;');
  //       });
  //       progressNum.forEach(function(el){
  //         el.textContent = newProgressNum;
  //       });
  //     }
  // };

  // function calculateGiftProgress(currentVal, targetVal) {
  //     var progressBar = document.querySelectorAll('.cart-giftThreshold__progress');
  //     var progressNum = document.querySelectorAll('.cart-gift__num');
  //     var progressOuter = document.querySelectorAll('.cart-gift__numOuter');
  //     var successMsg = document.querySelectorAll('.cart-gift__success');
  //     // calculate how far progress is from the total as a percentage
  //     var result = Math.round(100 * currentVal / targetVal);
  //     progressBar.forEach(function(el){
  //       el.setAttribute('style', "width: ".concat(result, "%"));
  //     })
  //      // Update the progess text. If threshold is met, show success message
  //     var newProgressNum = (targetVal - currentVal) / 100;
  //     if(newProgressNum <= 0){
  //       successMsg.forEach(function(el){
  //         el.setAttribute('style', 'display: block;');
  //       });
  //       progressOuter.forEach(function(el){
  //         el.setAttribute('style', 'display: none;');
  //       });
  //       progressNum.forEach(function(el){
  //         el.textContent = newProgressNum;
  //       });
  //     } else {
  //       successMsg.forEach(function(el){
  //         el.setAttribute('style', 'display: none;');
  //       });
  //       progressOuter.forEach(function(el){
  //         el.setAttribute('style', 'display: block;');
  //       });
  //       progressNum.forEach(function(el){
  //         el.textContent = newProgressNum;
  //       });
  //     }
  // };



  var getCartAjaxCall = function(){
    // Most themes use jquery to make ajax requests, so that's how we'll do it. In your theme's main JS file, find each ajax call where your store adds to, deletes from, and updates the cart. Put this in the success function of each. 
    // NOTE: If you make this ajax request outside of the functions that update the cart, the calculator won't sync with the current cart state without refreshing the page. You need to specify that you want to read the current cart data AFTER the new items are added/removed.
    
    // var freeShippingThreshold = parseInt(theme.free_shipping_threshold) * 100;
    // var freeGiftThreshold = parseInt(theme.free_gift_threshold) * 100;

    // $.ajax({
    //   type: 'GET',
    //   url: '/cart.js',
    //   dataType: 'json',
    //   success: function(cart){
    //     // run the calculator with a target price of $60
    //     //calculateProgress(cart.total_price, freeShippingThreshold);
    //     //calculateGiftProgress(cart.total_price, freeGiftThreshold);
    //   }
    // });
  };


  getCartAjaxCall();
  var updateTimer;





  $( document ).ajaxSend(function( event, jqxhr, settings ) {
    //console.log('ajaxSend:'+settings.url );
    if ( settings != undefined && settings.url.indexOf('cart') > 0) {
      $('body').addClass('ajaxLoading');
    }
  });
  
  $( document ).ajaxSuccess(function(event, xhr, settings, value) {
    //console.log('ajaxSuccess:'+settings.url );
    //console.log(settings);
    //console.log(settings.url)
    var bundleFlag = false;
    if ($('.cart--item[data-bundler="true"]').length > 0) {
      bundleFlag = true;
    }  
    
    if (settings != undefined) {
      if ( settings.url.indexOf('cart') > 0 || settings.url.indexOf('update.js') > 0) {
        //$('body').removeClass('ajaxLoading');
      }
    }
    if (settings != undefined && settings.url == '/cart?view=plain_cart') {
      
      //checkFreeGift();
      if (bundleFlag == false) {
        freeGiftShipProgressBar('ajax:cart', 'normal');
      } else {
        $('body').addClass('freeGWPLoading');
        window.bndlr.updateCartDiscounts();
      }
    }
    if (settings != undefined && settings.url == '/cart?view=framework_cart') {      
      if (bundleFlag == false) {
        console.log('cart::::', 'bundleFlag:'+bundleFlag, 'freeGiftShipProgressBar', 'ajax mini cart no bundle');
        $('body').addClass('freeGWPLoading');
        clearTimeout(updateTimer);
        resizeTimer = setTimeout(function() {
          $('body').removeClass('freeGWPLoading');
          freeGiftShipProgressBar('ajax:minicart', 'normal');  
        }, 900);
      } else {
        $('body').addClass('freeGWPLoading');
        window.bndlr.updateCartDiscounts();
      }
    }
  });
  

  function selectChanged(newvalue) {$.post('/cart/add.js', {
    quantity: $(this).attr('data-quantity'),
    id: newvalue,
  });

  var singleVariantSelector = $('.cart--form select.product-single__variants');
  $(singleVariantSelector).on('change', function(){
    selectChanged(this.value);
  });

  setTimeout(function(){
    $.post('/cart/change.js', {
      quantity: 0,
      id: $(singleVariantSelector).attr('data-variant-id'),
    });
  }, 500);

  setTimeout(function(){
    window.location.reload(1);}, 1000);
  }

})(jQuery);

var currentCurrency = Currency.currentCurrency;
var currencyCode = '';
if (currentCurrency != 'AUD') {
  currencyCode = currentCurrency;
}
currentCurrency = Shopify.currency.active;
var autoAddTimer;

$(document).ready(function() {


  if ($('.cart-gift__numOuter strong').length == 0) {
    $('.cart-gift__numOuter').html($('.cart-gift__numOuter').text());
  }
  // custom upsell
  $('body').on('change', '.customUpsell select', function() {
    var xImg =  $(this).find('option:selected').attr('data-image-url');  
    $(this).closest('.nudge-offer').find('.product-image-wrapper img').attr('src', xImg);
  });

  // Cart variant Change
  $(document).on('change', '.cart--item .cart--item--info .product-single__variants, .cartTableBox .cart--item select.product-single__variants', function(e){

    e.preventDefault();
    if ($(this).val().trim() != '') {
      $('body').addClass('ajaxLoading'); 
      var itemVariant = $(this).val();
      var variantId = $(this).closest('.cart--item').attr('data-item-key');
      var itemQuantity = $(this).attr('data-quantity');
      var itemProperty = JSON.parse($(this).parent().parent().find('.line-item-property-json').text()) || [];
      var propertyFormarted = {};


      if (itemProperty.length > 0) {
        for (var x = 0; x < itemProperty.length; x++) {
          propertyFormarted[itemProperty[x][0]] = itemProperty[x][1];
        }
      }

      console.log('change variant')
      console.log($(this).closest('.cartPage').length);

      if ($(this).closest('.cartPage').length > 0) {
        // cart page
      } else {
        // mini cart
      }

      
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: variantId,
          quantity: 0
        },
        dataType: 'json',
        success: function() {
          $.post('/cart/add.js', {
            items: [
                {
                  quantity: itemQuantity,
                  id: itemVariant,
                  properties: propertyFormarted
                }
            ]
          }).always(function(data, textStatus, jqXHR) { 
            loadCart();
          });
          
        }
      });

    }
    
  });


  

  $('body').on('click', '.upsellAdd', function() {
    var upsellID = $(this).closest('.customUpsell').find('.variants-wrapper select').val();
    $.post('/cart/add.js', {
        quantity: 1,
        id: upsellID,
    }).always(function(data, textStatus, jqXHR) {
          // load cart ajax
      loadCart()
    });
  });



  $('body').on('click', '.off-canvas--close', function() {
    $('.off-canvas--viewport').attr('data-off-canvas--state', 'closed');
  });
  $('body').on('click', '.off-canvas--overlay', function() {
    $('.off-canvas--viewport').attr('data-off-canvas--state', 'closed');
  });
  // remove clicl
  $('body').on('click', '.custom--item--remove a, .cartTableBox .cart-table  .remove', function(e) { 
    var target = e.target;
    var item, item_key;
    var qty = 0;
    var data = { updates: {} };
    $('body').addClass('ajaxLoading');


    if ($(this).attr('data-bundle-timestamp')) {
      // bundle remove
      var bundleTimeStampValue = $(this).attr('data-bundle-timestamp');
      $('[data-bundle-timestamp="' + bundleTimeStampValue + '"]').each(function(btnNum){
        var removeButton = $('[data-bundle-timestamp]')[btnNum];
        item = $('[data-bundle-timestamp]')[btnNum].closest('.cart--item');
        item_key = $(item).attr('data-item-key');
        data.updates[item_key] = qty;
      });

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() {
          loadCart();
        },
        error: function (request, status, error) {
          $('body').removeClass('ajaxLoading'); 
        }
      });
    } else {
      // normal remove
      item = $(this).closest('.cart--item');
      item_key = $(item).attr('data-item-key');

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: qty,
          id: item_key
        },
        dataType: 'json',
        success: function() {
          loadCart();
        },
        error: function (request, status, error) {
          $('body').removeClass('ajaxLoading'); 
        }
      });
    }
    return false;
  });


  $('.cart--item .cart--quantity--container a').off("click");
  $('body').on('click', '.cart--item .cart--quantity--container a', function(e) {
    var qtyInput = $(this).closest('.cart--quantity--container').find('.cart--quantity--input');
    var qtyInputVal = qtyInput.val();
    var minNumber = qtyInput.attr('min');
    if ($(this).attr('class') == 'minus') {
      if (qtyInputVal ==  minNumber) {
        return false;
      } else {
        qtyInput.val(parseInt(qtyInputVal) - 1).trigger('change');
      }
    } else if ($(this).attr('class') == 'plus') {
      qtyInput.val( parseInt(qtyInputVal) + 1).trigger('change');
    }   
    return false;
  }); 
  var changeTimer;
  $('body').on('change', '.cart--item .cart--quantity--input', function(e) {
    var cartKey = $(this).closest('.cart--item').attr('data-item-key');
    var cartQty = parseInt($(this).val());

    clearTimeout(changeTimer);
    changeTimer = setTimeout(function() {

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: cartQty,
          id: cartKey
        },
        dataType: 'json',
        success: function() {
          loadCart();
        },
        error: function (request, status, error) {
          $('body').removeClass('ajaxLoading'); 
        }
      });
    }, 600);
    
  }); 
  $('body').on('click', '.upsell-toggle', function(e) {
    $('.sideUpsell').toggleClass('exp');
  });   

}); // doc ready
var cartValueFlag = false;
var bundleAppDiscount = false;

var bundlerTimer;
document.addEventListener('bundler:total_cart_values', function(e) {
  clearTimeout(bundlerTimer);
  bundlerTimer = setTimeout(function() {

    console.log('cart:::', 'bundler:total_cart_values');
            
    //console.log('bundler:total_cart_values');
    //console.log(e);
    var moneyDecimal = true;
    
    if (cartValueFlag ==  false) {
      console.log(e.detail);
      //console.log($('.savingsRow').html());

      var discountVal = e.detail.discounted_cart_object.total_discount;

      var discountPrice = e.detail.discounted_cart_object.total_price;

      console.log('discountVal:'+discountVal);
      // add discount
      var bundleFlag = false;
      if ($('.cart--item[data-bundler="true"]').length > 0) {
        bundleFlag = true;
      }  
      if (discountVal > 0 && discountVal != undefined) {
        bundleFlag = true;
      }
      if (bundleFlag) {
        console.log('bundle discount');

        var discountMoney = Shopify.formatMoney(discountVal, shop_money);
        //console.log('discountMoney:'+discountMoney);
        var totalMoney = Shopify.formatMoney(discountPrice, shop_money);
        //console.log('totalMoney:'+totalMoney);
        

        //console.log('bundler:total_cart_values:'+discountPrice);
        //console.log('bundle: totals'+$('.cart--total--price').html());

          $('.cart--total .cart--total--price').attr('data-subtotal', discountPrice);
          // console.log('totalMoney:'+discountPrice);
          $('.cartContent').addClass('loading');
          //setTimeout(function() {
          if ($('.cart-gift__numOuter strong').length == 0) {
            $('.cart-gift__numOuter').html($('.cart-gift__numOuter').text());
          }
          $('.savingsRow').attr('data-save', discountVal);
          $('.savingsRow').html('<td class="label">You Save:</td><td class="value"><span class="money">'+discountMoney+' '+Shopify.currency.active+'</span></td>');
          $('.cartTotalBox .cart--total--price').html('<span class="money">'+totalMoney+' '+Shopify.currency.active+'</span');
          $('.cartContent').removeClass('loading');
          //$('body').removeClass('ajaxLoading');  
          //console.log('bundler cart discountMoney:'+discountVal);
          //console.log('bundler cart totalMoney:'+discountPrice);
          //console.log(e.detail.discounted_cart_object);

          // free gift active
          //$('.cart--spend-more').attr('data-total', totalDecimal);
          $('body').removeClass('freeGWPLoading');
          console.log('cart:::', 'freeGiftShipProgressBar', 'bundler:total_cart_values');
          freeGiftShipProgressBar('bundler:total_cart_values', 'bundle');

          $('[data-convert]:not([data-convert="0"])').each(function() {
             var convVal = parseInt($(this).attr('data-convert'));
             var convertedPrice = Math.trunc(convVal * exchRate);
             var formatedPrice = Shopify.formatMoney(convertedPrice, shop_money);
             console.log('cart::::xxx mini page data-convert', convVal, convertedPrice, formatedPrice); 
             $(this).html(formatedPrice);
          });
          
        //}, 10);


        //Currency.convertAll(shopCurrency, cookieCurrency);
        bundleAppDiscount = true;
      }
      cartValueFlag = true;
      
    }    
    $('body').removeClass('ajaxLoading'); 
  }, 600);  
});
var ajaxTimer;
function loadCart() {
  cartValueFlag = false;
  console.log('cart:::: loadCart');

  var cartPageSize = $('#shopify-section-cart').length;


  $('body').addClass('ajaxLoading'); 
  if ($('.cart-gift__numOuter strong').length == 0) {
    $('.cart-gift__numOuter').html($('.cart-gift__numOuter').text());
  }
  if (cartPageSize > 0) {
    console.log('page cartload');
    // cart page
    $('#shopify-section-cart').load('/cart?view=plain_cart .cartPage', function() {
      var cartCount = parseInt($('.cartPage').attr('data-count'));

      var shipProtectFlag = $('.cartPage').attr('data-ship-protect');
      console.log('loadCart cart page', cartCount, shipProtectFlag);
      if (cartCount > 0) {
        if (shipProtectFlag == 'false') {
          if (getCookie('shipProtectCookie') == 'false') {

          } else {
            //addGiftProtection(parseInt(theme.cart_ship_protection_product))
          }
        }  
      } else {
        if (shipProtectFlag == 'true') {
          removeGiftProtection(parseInt(theme.cart_ship_protection_product));  
        }
      } 

      $('.cart-container .number-wrapper').attr('data-item-count', cartCount).find('.number').text(cartCount);
      $('.cart-link.font--accent .number-wrapper').attr('data-item-count', cartCount).find('.number').text(cartCount);

      if (cartCount > 0) {
        $('.cart--root').attr('data-has-items', true);
      } else {
        $('.cart--root').attr('data-has-items', false);
      }
      $('body').removeClass('ajaxLoading'); 
      /*
      $('.cartPage .sideUpsellList .product--title').matchHeight();
      $('.cartPage .sideUpsellList .price').matchHeight();
      $('.cartPage .sideUpsellList').slick({
            arrows: false,
            dots: true,
            infinite: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            //fade: true,
            responsive: [ 
              {
                breakpoint: 992, 
                settings: {
                  slidesToShow: 3 
                }
              },  
              {
                breakpoint: 768, 
                settings: {
                  slidesToShow: 2 
                }
              },
              {
                breakpoint: 480, 
                settings: {
                  slidesToShow: 1 
                }
              }    
            ]
      });
      */
      /*
      setTimeout(function() {
        console.log('updateCartDiscounts loadCart cartpage');
        checkBundler()
      }, 100);  
      */
      var exchRate = parseFloat(window.Shopify.currency.rate);
      $('[data-convert]:not([data-convert="0"])').each(function() {
       console.log('cart:::: page data-convert'); 
       var convVal = parseInt($(this).attr('data-convert'));
       var convertedPrice = Math.trunc(convVal * exchRate);
       var formatedPrice = Shopify.formatMoney(convertedPrice, shop_money);
       $(this).html(formatedPrice);
      });
    });
  } else {
    // mini cart
    //console.log('cart:::: mini cartload');


    $('.off-canvas--right-sidebar .cart--root').load('/cart?view=framework_cart .cartContent', function() {
      var cartCount = parseInt($('.cart--form').attr('data-count'));

      
      var shipProtectFlag = $('.cart--form').attr('data-ship-protect');
      console.log('loadCart', cartCount, shipProtectFlag);
      if (cartCount > 0) {
        if (shipProtectFlag == 'false') {
          if (getCookie('shipProtectCookie') == 'false') {

          } else {
            //addGiftProtection(parseInt(theme.cart_ship_protection_product))
          }
        }  
      } else {
        if (shipProtectFlag == 'true') {
          removeGiftProtection(parseInt(theme.cart_ship_protection_product));  
        }
      } 
      //console.log('mini cartCount:'+cartCount); 
      //console.log($('.off-canvas--right-sidebar .cart--root').html());

      $('.cart-container .number-wrapper').attr('data-item-count', cartCount).find('.number').text(cartCount);
      $('.cart-link.font--accent .number-wrapper').attr('data-item-count', cartCount).find('.number').text(cartCount);

      if (cartCount > 0) {
        $('.cart--root').attr('data-has-items', true);
      } else {
        $('.cart--root').attr('data-has-items', false);
      }

      var exchRate = parseFloat(window.Shopify.currency.rate);
      $('[data-convert]:not([data-convert="0"])').each(function() {
         var convVal = parseInt($(this).attr('data-convert'));
         var convertedPrice = Math.trunc(convVal * exchRate);
         var formatedPrice = Shopify.formatMoney(convertedPrice, shop_money);
         console.log('cart:::: mini page data-convert', convVal, convertedPrice, formatedPrice); 
         $(this).html(formatedPrice);
      });



      clearTimeout(ajaxTimer);
      ajaxTimer = setTimeout(function() {
        $('body').removeClass('ajaxLoading'); 
      }, 1000);

      //setTimeout(function() {
        var bundleFlag = false;
        if ($('.cart--item[data-bundler="true"]').length > 0) {
          bundleFlag = true;
        }  
        if (bundleFlag) {
          console.log('bundler');
          checkBundler()
        }
        
        
      //}, 100);
    });
  }
  
}
function freeGiftShipProgressBar(customEvent, cartType) { 
  //var currencyFormat = Currency.moneyFormats[Currency.currentCurrency].money_with_currency_format;
  //var currencyPrefix = currencyFormat.split('{{amount}}')[0];
  //var currencySuffix = currencyFormat.split('{{amount}}')[1];
  //console.log('cart:::: freeGiftShipProgressBar', customEvent, cartType);
  var cartTotal = parseFloat($('.cart--spend-more').attr('data-total'));
  var bundleFlag = false;
  if (theme.cartGamify) {
    console.log('cartGameify freeGiftShipProgressBar');
    //$('body').removeClass('freeGWPLoading');
    cartGameify(customEvent) 
  }
}
var amtArr = [];
var amtArrLength = 0;
var cartTotal = 0;
function cartGameify(customEvent) {
  
  //console.log('cart:::: cartGameify:::', customEvent);
  amtArr = [];
  
  var exchRate = parseFloat(window.Shopify.currency.rate);
  var currencySymbol = theme.currencySettings.money_format.split('{{')[0];
  cartTotal = parseInt($('.cartTotalBox .cart--total--price').attr('data-subtotal'));

  var currCurrency = Shopify.currency.active; 
  //var currCurrencyFormat = Currency.moneyFormats[currCurrency].money_format;
  var cartItemVal = $('.cartGamifyBox').attr('data-item');
  var cartProdVal = $('.cartGamifyBox').attr('data-product');
  var cartItemQty = $('.cartGamifyBox').attr('data-qty');

  var moneyDecimal = true;
  if (theme.currencySettings.money_format.indexOf('amount_no_decimals') > -1) {
    moneyDecimal = false;
  }
  //console.log('cartGameify cartTotal:'+cartTotal);

  $('.cartGamifyBox .freeGiftItems .item').removeClass('active');
  $('.cartGamifyBox .freeGiftItems .item').each(function() {
    var $this = $(this);
    var tresholdAttr = $this.attr('data-treshold');
    var convAmt = parseInt($(this).attr('data-amount')) * exchRate;
    convAmt = Math.trunc(convAmt);
    //console.log('cartGameify:', parseInt($(this).attr('data-amount')));

    if (tresholdAttr !== undefined && tresholdAttr !== '') {
      var tresholdArr = $(this).attr('data-treshold').split('; ');
      $.each(tresholdArr, function(index, threshold) {
        var thresholdArr = threshold.split(':');
        var thresholdCurrency = thresholdArr[0];
        if (currCurrency == thresholdCurrency) {
          //console.log('cartGameify::', threshold);
          convAmt = Math.trunc(thresholdArr[1] * 100);
          return false;
        }
      }); 
    }
    //console.log('cartGameify:::', currCurrency,  convAmt);
    amtArr.push(convAmt);
  });  
  //console.log('cartGameify::::', amtArr); 
  // $('.customMoney').each(function() {
  //   var convAmt = parseInt($(this).attr('data-amount')) * exchRate;
  //   convAmt = Math.trunc(convAmt);
  //   $(this).html(Shopify.formatMoney(convAmt, theme.currencySettings.money_with_currency_format))
  // });

  //var progressMSG = 'Spend <span class="moneyCustom" data-value="'+amtArr[0]+'">$'+amtArr[0]/100+'</span> more to get <span class="moneyCustom" data-value="'+amtArr[0]+'">$'+amtArr[0]/100+'</span> giveaway!';
  var remAmount = amtArr[0]/100;
  if (moneyDecimal == false) {
    remAmount = Math.round(remAmount);
  }
  var progressSucess = '';
  var progressMSG = 'Spend <span class="moneyCustom">'+currencySymbol+remAmount+'</span> more  for Free Shipping';
  var lvlHeading = 'Spend <span class="moneyCustom">'+currencySymbol+remAmount+'</span> to add next freebie in your cart';

  var lastAmt = amtArr[amtArr.length - 1];

  var progressVal = 0;
  var progressMax = 0;
  var freeShip = false;
  var freeGift = false;

  $('.cartGamifyBox .progressbox mark').remove();
  $.each(amtArr, function(k, v){
    var currentArr = v;
    var xMin = 0;
    var xMax = v;
    if (k > 0) {
      xMin = amtArr[k-1];
    }
    //   console.log(currentArr);
    //   console.log('cartTotal:'+cartTotal);
    //   console.log('xMin:'+xMin);
    //   console.log('xMax:'+xMax);
    var markLabel = $('.cartGamifyContent .freeGiftItems .item:eq('+k+')').attr('data-type');
    $('.cartGamifyBox .progressbox').append('<mark style="left: '+((v / lastAmt)*100)+'%"><span>'+markLabel+'</span></mark>');

    
    var inRangeVal = inRange(amtArr[0], cartTotal, xMin, xMax);
    amtArrLength = amtArr.length - 1;

    if (amtArr[0] <= cartTotal) {
      $('.cartGamifyBox .freeGiftItems .item').first().addClass('active');
    }
    
    if (inRangeVal.rangeActive == true) {
      console.log('currentArr', currentArr);
      var currentItem = $('.cartGamifyBox .freeGiftItems .item[data-amount="'+currentArr+'"]').prev('.item');
      currentItem.addClass('active');
      //currentItem.find('button').trigger('click');
      // console.log('rem:'+inRangeVal.rangeRem);
      // console.log('max:'+inRangeVal.rangeMax);
      // console.log('last:'+amtArr[amtArrLength]);

      var remAmt = inRangeVal.rangeRem;
      var maxAmt = inRangeVal.rangeMax;
      if (remAmt < 0 ) {
        remAmt = 0;
      }
      
      //progressMSG = 'Spend <span class="moneyCustom" data-value="'+remAmt+'">$'+remAmt/100+'</span> more to get <span class="moneyCustom" data-value="'+maxAmt+'">$'+maxAmt/100+'</span> giveaway!';
      var remAmount2 = remAmt/100;
      if (moneyDecimal == false) {
        remAmount2 = Math.round(remAmount2);
      }
      console.log('remAmt', remAmt)

      
      

      if (amtArr[k] <= cartTotal) {
        // above amount
        if (markLabel == 'Gift') {
          progressMSG = 'You have unlocked Free Gift';
      
          $('.cartGamifyBox .freeGiftItems .item').last().addClass('active');
          progressSucess = '<span>You have unlocked free gift!</span>';
          freeGift = true;
        } else {
          progressMSG = 'Spend <span class="moneyCustom">'+currencySymbol+remAmount2+'</span> more to get Free Gift!';
          progressSucess = '<span>YAY You have unlocked free shipping!</span>';
          freeShip = true;
        }
        console.log('progress:::', amtArr[k], cartTotal, markLabel);
      } else {
        // below amount
        if (markLabel == 'Gift') {
          progressMSG = 'Spend <span class="moneyCustom">'+currencySymbol+remAmount2+'</span> more for Free Gift!';   
        } else {
          progressMSG = 'Spend <span class="moneyCustom">'+currencySymbol+remAmount2+'</span> more for Free Shipping!'; 
        }  
        console.log('progress:::xxxx', amtArr[k], cartTotal, markLabel);
      }
      console.log('progress::::', progressMSG, progressSucess);
      
      var remAmount3 = maxAmt/100;
      if (moneyDecimal == false) {
        remAmount2 = Math.round(remAmount3);
      }
      
      lvlHeading = 'Spend <span class="moneyCustom">'+currencySymbol+remAmount3+'</span> to add next freebie in your cart';
      //console.log('inRangeVal.rangeMax');
      //console.log(inRangeVal.rangeMax);
      //console.log(inRangeVal.rangeRem);
      //if (amtArr[1] > 1)
  //var progressMSG = 'Spend <span class="moneyCustom" data-value="'+amtArr[0]+'">$'+amtArr[0]/100+'</span> more to get Free Gift';


      // $('.cartGamifyBox progress').val(inRangeVal.rangeMax - inRangeVal.rangeRem);
      // $('.cartGamifyBox progress').attr('max', inRangeVal.rangeMax);
 
      // $('.cartGamifyBox progress').val(cartTotal);
      // $('.cartGamifyBox progress').attr('max', amtArr[1]);

      $('.cartGamifyBox .progressAmt').html(progressMSG);
      $('.cartGamifyBox .headingLvl').html(lvlHeading);

      progressVal = cartTotal;
      progressMax = amtArr[1];
    } 
  });

  $('.cartGamifyBox progress').val(cartTotal);
  $('.cartGamifyBox progress').attr('max', amtArr[1]);
  $('.progressSuccess').html(progressSucess);
  $('.cartGamifyBox .progressAmt').html(progressMSG);

  //console.log('cart::::', 'freeShip:'+freeShip, 'freeGift:'+freeGift, progressSucess, progressVal, progressMax);
  if (freeGift) {
    //console.log('cart:::: offer free gift');
  } else {
    //console.log('cart:::: no free gift');
  }
  //console.log('ttt', cartTotal);
  validateFreeGift(customEvent, freeGift, cartItemVal, cartProdVal, cartItemQty);
  //console.log('cart:::: validateFreeGift');
  //checkCartGamify(cartItemVal, cartProdVal, cartItemQty, customEvent);

  // validate

}


function validateFreeGift(customEvent, freeGift, cartItemVal, cartProdVal, cartItemQty) {
  //console.log('cart:::: validateFreeGift', customEvent, freeGift);
  var cartItemArr = cartItemVal.split(',');
  var cartProdArr = cartProdVal.split(',');
  var cartQtyArr = cartItemQty.split(',');

  var freeGiftVariantId = $('.cartGamifyBox .freeGiftItems .item[data-type="Gift"]').attr('data-variant');
  var giftFoundIndex = $.inArray(freeGiftVariantId, cartItemArr);
  var freeGiftAvailable = $('.cartGamifyBox .freeGiftItems .item[data-type="Gift"][data-variant="' + freeGiftVariantId + '"]').attr('data-avail');

  // check free gift
  var freeGiftIds = [];
  $('.cartGamifyBox .freeGiftItems .item').each(function() {
    var variantID = $(this).attr('data-variant');
    freeGiftIds.push(variantID);
  });
  $('.cart--body .freeGiftCartItem').each(function() {
    var giftID = $(this).attr('data-variant-id');
    if ($.inArray(giftID, freeGiftIds) == -1) {
        // wrong free gift
        //console.log('not found:'+giftID);
        var xdata = { updates: {} };
        xdata.updates[giftID] = 0;
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: xdata,
          dataType: 'json',
          success: function() {     
            loadCart();
          }
        });
      }
  }); 
  $('.cart-table .freeGiftCartItem').each(function() {
    var giftID = $(this).attr('data-variant-id');
    if ($.inArray(giftID, freeGiftIds) == -1) {
      // wrong free gift
      //console.log('not found:'+giftID);
      var xdata = { updates: {} };
      xdata.updates[giftID] = 0;
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: xdata,
        dataType: 'json',
        success: function() {     
          loadCart();
        }
      });
    }
  });
  

  if (freeGift == true) {
    if (giftFoundIndex > -1) {
      // free gift found 
      $('.cart--item[data-variant-id="' + freeGiftVariantId + '"]').addClass('freeGamifyItem');
      var giftQty = parseInt(cartQtyArr[giftFoundIndex]);
      // check gift quantity ensure its 1pc only
      if (giftQty > 1) {
        //console.log('cart:::: gift is more than 1pc');
        var xdata = {
          updates: {}
        };
        xdata.updates[freeGiftVariantId] = 1;
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: xdata,
          dataType: 'json',
          success: function() {
            loadCart();
          }
        });
      }
      // remove out of stock gift
      if (freeGiftAvailable == 'false') {
        //console.log('cart:::: gift is OOS');

        var xdata = {
          updates: {}
        };
        xdata.updates[freeGiftVariantId] = 1;
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: xdata,
          dataType: 'json',
          success: function() {
            loadCart();
          }
        });

      }
    } else {
      // free gift not found add free gift
      //console.log('cart:::: free gift not found add free gift');
      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: {
          quantity: 1,
          id: freeGiftVariantId
        },
        async: false
      }).always(function(data, textStatus, jqXHR) {
        // load cart ajax

        setTimeout(function() {
          //console.log('cart:::: gamify free gift added');
          loadCart()
        }, 100);
      });


    }
  } else {
    if (giftFoundIndex > -1) {
      //console.log('cart:::: remove free gift');
      var xdata = {
        updates: {}
      };
      xdata.updates[freeGiftVariantId] = 0;
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: xdata,
        dataType: 'json',
        success: function() {
          loadCart();
        }
      });
    }
  }
}  



function checkCartGamify(cartItemVal, cartProdVal, cartItemQty, customEvent) {
  console.log('checkCartGamify');
  //console.log('checkCartGamify cartItemVal:'+cartItemVal);


  //var cartItemVal = $('.cartGamifyBox').attr('data-item');
  //var cartProdVal = $('.cartGamifyBox').attr('data-product');
  // check if gift is in cart
  var cartItemArr = cartItemVal.split(',');
  var cartProdArr = cartProdVal.split(',');
  var cartQtyArr = cartItemQty.split(',');

  var freeGiftIds = [];
    

  //$('.cartGamifyBox .freeGiftItems .item').removeClass('added');
  $('.cartGamifyBox .freeGiftItems .item').each(function() {
    var variantID = $(this).attr('data-variant');
    var productID = $(this).attr('data-product');
    var foundIndex = $.inArray(productID, cartProdArr);
    freeGiftIds.push(variantID);
    if (foundIndex > -1) {
      
      // product found 
      // check variant
      var pFoundIndex = $.inArray(productID, cartProdArr);
      $('.cart--item[data-variant-id="'+variantID+'"]').addClass('freeGamifyItem');

      //console.log('amtArr[amtArrLength]', amtArr, amtArr[amtArrLength], cartTotal);
      //if ($(this).hasClass('active') == false) {
      if (amtArr[amtArrLength] > cartTotal) {  
        //console.log('amtArr auto remove gift');
        var xdata = { updates: {} };
        xdata.updates[variantID] = 0;
        
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: xdata,
          dataType: 'json',
          success: function() {     
            loadCart();
          }
        });
        
      } else {
        // check if added is more than 1 make this 1
        var giftQty = parseInt(cartQtyArr[foundIndex]);
        if (giftQty > 1) {
          var xdata = { updates: {} };
          xdata.updates[variantID] = 1;
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: xdata,
            dataType: 'json',
            success: function() {     
              loadCart();
            }
          });
        }
        
      }
      // remove out of stock gift
      if ($(this).hasClass('added') == true && $(this).attr('data-avail') == 'false') {
        var xdata = { updates: {} };
        xdata.updates[variantID] = 0;
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: xdata,
          dataType: 'json',
          success: function() {     
            loadCart();
          }
        });
      }  

    } else {
      
    }  
  });    
  $('.cart--body .freeGiftCartItem').each(function() {
    var giftID = $(this).attr('data-variant-id');
    if ($.inArray(giftID, freeGiftIds) == -1) {
      // wrong free gift
      console.log('not found:'+giftID);
      var xdata = { updates: {} };
      xdata.updates[giftID] = 0;
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: xdata,
        dataType: 'json',
        success: function() {     
          loadCart();
        }
      });
    }
  });
  $('.cart-table .freeGiftCartItem').each(function() {
    var giftID = $(this).attr('data-variant-id');
    if ($.inArray(giftID, freeGiftIds) == -1) {
      // wrong free gift
      //console.log('not found:'+giftID);
      var xdata = { updates: {} };
      xdata.updates[giftID] = 0;
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: xdata,
        dataType: 'json',
        success: function() {     
          loadCart();
        }
      });
    }
  });
  //console.log('amtArr', amtArr)
  if (amtArr[amtArrLength] <= cartTotal) {
    //$('.cartGamifyBox .freeGiftItems .item').last().not('.added').find('button').trigger('click');
  }
  $('body').removeClass('ajaxLoading');
}


// add gamified product
var freeGiftFlag = true;
$('body').on('click', '.cartGamifyBox .freeGiftBox button', function() {
  
  if (freeGiftFlag) {
    
    var giftID = $(this).closest('.item ').attr('data-variant');
    $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: {
            quantity: 1,
            id: giftID
        },
        async: false
    }).always(function(data, textStatus, jqXHR) {
        // load cart ajax
        console.log('gamify free gift added');
        setTimeout(function() {
          freeGiftFlag = true;
          console.log('cart:::', 'add free gift');
          loadCart() 
        }, 100);
    });
    freeGiftFlag = false;
  }
  return false;
});

// set proper vaariant id
$('body').on('change', '.cartGamifyBox .variant_id', function() {
  var variantID = $(this).val(); 
  $(this).closest('.item ').attr('data-variant', variantID);
  $(this).closest('.item').find('.imgBox img').attr('src', $(this).find('option:selected').attr('data-image'));
  return false; 
});


function inRange(treshold, cartTotal, min, max) {
  var currentRange = ((cartTotal-min)*(cartTotal-max) <= 0);
  var rangeActive = cartTotal >= min;
  var rangeRem = max - cartTotal; 

  return {'currentRange': currentRange, 'rangeActive': rangeActive, 'rangeRem': rangeRem, 'rangeMax': max}
}



function checkFreeGift() {


  
  if (theme.free_gift_enable) {
    var remainingAMountForFreeGiftAttr = $('.cart-gift__wrapper').attr('data-left');
    var remainingAMountForFreeGift = parseFloat($('.cart-gift__wrapper').attr('data-left'));

    var freeGiftVariant =  $('.cart-gift__wrapper').attr('data-free-gift-variant');
    var freeGiftCount =  $('.cart--item[data-variant-id="'+freeGiftVariant+'"]').length;
    var xdata = { updates: {} };
    if ($('.cart-gift__numOuter strong').length == 0) {
      $('.cart-gift__numOuter').html($('.cart-gift__numOuter').text());
    }
    console.log('freeGift remaining:'+remainingAMountForFreeGift);
    console.log('freeGift Count:'+freeGiftCount);

    if (remainingAMountForFreeGift == 0) {
      console.log('freeGift offer free gift'); 
    } else {
      console.log('freeGift no free gift');
      if (freeGiftCount > 0) {
        xdata.updates[freeGiftVariant] = 0;
        
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: xdata,
          dataType: 'json',
          success: function() {     
            console.log('cart:::', 'freeGift remove free gift'); 
            loadCart();
          }
        });
      }  
    }
  } 
  
}


// auto open cart
var cartOpenCount = 0;
var upsellClass = '';
var domTimer;
$('.off-canvas--viewport').bind('DOMSubtreeModified', function(){
  clearTimeout(domTimer);
  var $this = $(this)
  domTimer = setTimeout(function() {
    if ($this.attr('data-off-canvas--state') == 'right-open') {
      if (cartOpenCount == 0) {
        $('.sideUpsell').addClass('exp');
        upsellClass = 'exp';
      }
      cartOpenCount += 1;
      $('.off-canvas--right-sidebar .sideUpsellList .product--title').matchHeight();
      $('.off-canvas--right-sidebar .sideUpsellList .price').matchHeight(); 
    }
  }, 300); 
  
});


$(document).ready(function() {
  // cart count
  var cartCount = $('.off-canvas--right-sidebar .cart--form').attr('data-count');
  $('.cart-container .number-wrapper').attr('data-item-count', cartCount).find('.number').text(cartCount);
  $('.cart-link.font--accent .number-wrapper').attr('data-item-count', cartCount).find('.number').text(cartCount);
  $('.cartPage .sideUpsellList .product--title').matchHeight();
  $('.cartPage .sideUpsellList').slick({
        arrows: false,
        dots: true,
        infinite: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        //fade: true,
        responsive: [ 
          {
            breakpoint: 992, 
            settings: {
              slidesToShow: 3 
            }
          },  
          {
            breakpoint: 768, 
            settings: {
              slidesToShow: 2 
            }
          },
          {
            breakpoint: 480, 
            settings: {
              slidesToShow: 1 
            }
          }    
        ]
  });
  // new custom upsell
  var upsellAddFlag = false;
  var upsellTitle = '';
  var upsellPrice = '';
  var upsellType = '';


  $('body').off('click', '.cartRelatedItem  .add-to-cart .button');
  $('body').on('click', '.cartRelatedItem  .add-to-cart .button', function() {

    upsellAddFlag = true;
    upsellTitle = $(this).closest('.cartUpsellItem').attr('data-title');
    upsellPrice = $(this).closest('.cartUpsellItem').attr('data-price');
    upsellType = $(this).closest('.cartUpsellItem').attr('data-type');

    
    var upsellID = $(this).closest('.cartRelatedItem').find('.variant-listbox').val();
    $('body').attr('data-upsell-add-flag', upsellAddFlag).attr('data-upsell-title', upsellTitle).attr('data-upsell-price', upsellPrice).attr('data-upsell-type', upsellType);

    $.post('/cart/add.js', {
        quantity: 1,
        id: upsellID,
    }).always(function(data, textStatus, jqXHR) {
          // load cart ajax
      loadCart()
    });
    return false;
  });
});




var directUpsellCloseKey = localStorage.getItem('directUpsellCloseKey');
$('body').on('click', '.upsellClose', function() {
  var directUpsellCloseKeyItem = $(this).closest('.directUpsellBox').attr('data-parent-key');    
  localStorage.setItem('directUpsellCloseKey', directUpsellCloseKeyItem); 
  $(this).closest('.directUpsellBox').hide();
});

$(document).ready(function() {
  loadCart();
});
/*
$( document ).ajaxStop(function() {
  var discountVal = parseInt($('.off-canvas--right-sidebar .savingsRow').attr('data-save'));
  if (amtArr[amtArrLength] <= cartTotal) {
    //$('.cartGamifyBox .freeGiftItems .item').last().not('.added').find('button').trigger('click');
  }
  if (bundleAppDiscount == true && discountVal == 0) {
    //cartValueFlag = false;
    //console.log('cart:::: updateCartDiscounts ajaxStop');
    //window.bndlr.updateCartDiscounts();
  }
});
*/
function loadBundler() {
  console.log('ccc loadBundler');
  $('body').addClass('freeGWPLoading');
  $('body').addClass('bundleLoading');
  // Create a new script element
  var script = document.createElement('script');

  // Set the type and source of the script
  script.type = 'text/javascript';
  script.src = 'https://cdn-bundler.nice-team.net/app/js/bundler.js?shop=stylish-hound-com.myshopify.com';

  // Append the script to the document head or body
  document.head.appendChild(script);

  // Optionally, add a callback function to run once the script is loaded
  script.onload = function() {
      console.log('ccc Bundle Script loaded successfully!');
      //$('body').removeClass('ajaxLoading');

         //window.bndlr.updateCartDiscounts(); 
         //console.log('cartGameify bundle load', window.bndlr);
         //cartGameify()   
         $('body').removeClass('bundleLoading');

  };
}

function checkBundler() {
  console.log('ccc checkBundler');
  if ($('.cart--item[data-bundler="true"]').length > 0) {
    console.log('ccc checkBundler has bundle', window.bndlr);
    if (typeof window.bndlr === 'undefined') {
      if ($('.off-canvas--viewport').attr('data-off-canvas--state') == 'right-open') {
        console.log('ccc checkBundler right open ');
        //loadBundler()
      }
      loadBundler()
    } else {
      //console.log('updateCartDiscounts bundler js present');
      console.log('cart:::: updateCartDiscounts checkBundler');
      window.bndlr.updateCartDiscounts();
      //freeGiftShipProgressBar('checkBundler');  
    }
  }  
}

// $('body').on('click', '.cart--open-right', function() {
//   console.log('click cart');
//loadBundler()  
 
// });

// Select the target element you want to observe
var targetElement = document.querySelector('[data-off-canvas--state]');
var mutateTimer;
// Create a callback function to handle mutations
var callback = function(mutationsList, observer) {
    mutationsList.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-off-canvas--state') {
            console.log('data-off-canvas--open attribute has changed!');
            // You can add your custom logic here
            var isOpen = targetElement.getAttribute('data-off-canvas--state');
            
            clearTimeout(mutateTimer);
            mutateTimer = setTimeout(function() {
              if (isOpen == 'right-open') {
                //console.log('mutate loadBundler');
                //loadBundler();
                //checkBundler()
              }            
            }, 300);

        }
    });
};

// Create a MutationObserver instance and pass the callback function
var observer = new MutationObserver(callback);

// Start observing the target element for attribute changes
observer.observe(targetElement, {
    attributes: true // Observe attribute changes
});

// Optionally, you can stop observing by calling:
// observer.disconnect();


$('body').on('change', '#cartShipProtectionToggler', function() {
  var ship_potection_id = $(this).attr('data-value');
  if ($(this).prop('checked')) {
    addGiftProtection(ship_potection_id);
    setCookie('shipProtectCookie', 'true', 365);
  } else {
    setCookie('shipProtectCookie', 'false', 365);
    removeGiftProtection(ship_potection_id)
  }   
});

function addGiftProtection(ship_potection_id) {
    $.post('/cart/add.js', {
      quantity: 1,
      id: ship_potection_id,
    }).always(function(data, textStatus, jqXHR) {
      // load cart ajax
      setCookie('shipProtectCookie', 'true', 365);
      loadCart()
    });
  
}

function removeGiftProtection(ship_potection_id) {
  var data = { updates: {} };
  data.updates[ship_potection_id] = 0;
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function() {
        loadCart();
      },
      error: function (request, status, error) {
        $('body').removeClass('ajaxLoading'); 
      }
    });
  
}
// remove if error
if (theme.cart_ship_protection == false && theme.cart_ship_protection_found == true) {
   removeGiftProtection(parseInt(theme.cart_ship_protection_product));      
}
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
}
function getCookie(name) {
  const decodedCookies = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookies.split(';');
  
  for (let i = 0; i < cookiesArray.length; i++) {
    let cookie = cookiesArray[i].trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }
  
  return null; // Return null if the cookie is not found
}
function init() {
var vidDefer = document.getElementsByTagName('iframe');
for (var i=0; i<vidDefer.length; i++) {
if(vidDefer[i].getAttribute('data-src')) {
vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
} } }
window.onload = init;
!(function($){
	Shopify.queryParams = {};
	if (location.search.length) {
	  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
	    aKeyValue = aCouples[i].split('=');
	    if (aKeyValue.length > 1) {
	      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
	    }
	  }
	}
	$('#advanceFilterSelectBox')
	  .val(theme.collection_sort_by_default)
	  .bind('change', function() {
	    Shopify.queryParams.sort_by = $(this).val();
	    location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
	  });
})(jQuery);



!(function($) {
	// Search bar opener
	$('.searchbar-open').click(function() {
		$(this).closest('.menu').fadeOut(100, function() {
		$('.main-header .searchbar-container').fadeIn(200);
			return $('.main-header .searchbar-container .search-box').focus();
		});
		return false;
	});
	$('.searchbar-close').click(function() {
		$('.main-header .searchbar-container').fadeOut(100, function() {
			return $('.search-account .menu').fadeIn(200);
		});
		return false;
	});

	if ($('.search-template-container').length != 0) {
		var field = 'smallscreen=true',
		url = window.location.href;

		if ( (~ url.indexOf('?' + field)) || (~ url.indexOf('&' + field)) ) {
		  $('input[name=q]').focus();
		}
	}
})(jQuery);
!(function($){
	var announcementBarActive = false;
	var announcementBarSliderInit = function(){
		$('.announcment-bar-container').slick({
		    slideToShow: 1,
		    arrows: false,
		    dots: false,
		    adaptiveHeight: true,
		    autoplay: true,
		    autoplaySpeed: 3000,
		    fade: true,
		    speed: 500
		});

		announcementBarActive = true;
	};

	$(document).ready(function(){
		if ($(window).width() < 768) {
			announcementBarSliderInit();
		}

		if ($('.promo-bar').length > 0) {
			$('.promo-bar').appendTo('#promoBarMain');
		}
		
		$('.announcement-bar-main').removeClass('hidden');

		var promoHt = $('#promoBarMain').height();$('#promoBarMain .promo-bar');
		if (promoHt > 0) {
			$('body').removeClass('promoBarHide');
		} else {
			$('body').addClass('promoBarHide')
		}

		$('#promoBarMain').on('click', '.promo-bar .close', function() {
  			$('#promoBarMain .promo-bar').addClass('close');      
  			$('body').addClass('promoBarHide');
		}); 
	});

	$(window).on('resize', function(){
		if ($(window).width() < 768) {
			if (announcementBarActive == true) {
				$('.announcment-bar-container').slick('destroy');
			}
			announcementBarSliderInit();
		} else {
			if (announcementBarActive == true) {
				$('.announcment-bar-container').slick('destroy');
			}
		}
	});

	$('.announcement-bar-close').on('click', function(e){
		e.preventDefault();
		$('.announcement-bar-main').remove();
	});
})(jQuery);
!(function($){	
	if ($('.Esc-returns-container .alert-success').length > 0) {
		// Hides the returns form on success page
		$('.Esc-returns-container .Esc-returns-form').hide();
		$('.Esc-returns-container > .text-center.mb20').hide();
		$('<div class="text-center alert alert-success-alt-message">' + theme.translations.return_success_alt + '</div>').insertAfter('.Esc-returns-container .alert-success');
	} else if ($('.Esc-returns-container .alert-success').length <= 0 && $('.Esc-returns-container .Esc-returns-form').length > 0) {
		// Adds message for faulty and damaged returns
		$('.Esc-returns-container > .text-center.mb20').addClass('main-text');
		$('<div class="text-center mb20 faulty-and-damaged-text"><p>' + theme.translations.faulty_and_damaged_text + '</p></div>').insertAfter('.Esc-returns-container > .text-center.mb20');
	} else if ($('.Esc-returns-container .Esc-returns-Form__InputSelection #step_three').length > 0) {
		//  Add return and credit info on option
		var returnChoicesInfo = '<div class="return-choices-info">';
		returnChoicesInfo += '<small>&#42; ' + theme.translations.refund_info + '</small>';
		returnChoicesInfo += '<small>&#42; ' + theme.translations.credit_info + '</small>';
		returnChoicesInfo += '</div>';
		$(returnChoicesInfo).insertAfter('.Esc-returns-Form__InputSelection #step_three > .form-group');
	}
})(jQuery);
!(function($){
	$('.video-accordion-main .video-accordion-title').on('click', function(e){
		e.preventDefault();
		$(this).parent().find('.accordion-panel-block').slideToggle(500);
		$(this).find('.fw--icon--expand-more, .fw--icon--expand-less').toggle();
	});
})(jQuery);
!(function($){
	if ($('.header-block-image-menu-container').length > 0) {
		$('.header-image-menu-block').each(function(e){
			var targetMenuTitle = $(this).attr('data-menu-target');
			var targetedMenuElement = $('.x-menu--level-1--link a[data-title="' + targetMenuTitle + '"]').parent();
			var xLevel2MenuOriginal = "";

			if ($(targetedMenuElement).find('.x-menu--level-3--container').length > 0) {
				xLevel2MenuOriginal = $(targetedMenuElement).find('.x-menu--level-2--container .x-menu--level-3--container').eq(0).clone();
			} else {
				xLevel2MenuOriginal = $(targetedMenuElement).find('.x-menu--level-2--container .x-menu--level-2--list').clone();
			}
			xLevel2MenuOriginal = $(targetedMenuElement).find('.x-menu--level-2--container .x-menu--level-2--list').clone();

			$(this).find('.menu-container').html(xLevel2MenuOriginal);
			$(targetedMenuElement).attr('data-x-menu--depth', 3);
			$(targetedMenuElement).find('.x-menu--level-2--container').html($(this).clone());

			if ($(targetedMenuElement).find('.x-menu--level-2--list li').length > 10) {
				$(targetedMenuElement).addClass('two-column-grid-menu');
			}

			var targetMobileImg = $(this).find('img').attr('src');
			var mobileLinkHTML = '<span>'+targetMenuTitle+'</span><span><img src="'+targetMobileImg+'" /></span>';

			$('.y-menu--level-1--link[data-y-parent="'+targetMenuTitle+'"]').addClass('menuImg').find('.linkItem').html(mobileLinkHTML);

		});
	}

	// Header Login And Search Button additional script
	$('.account-open').click(function(e){
		$('.searchbar-close.cross').click();
	});

	

	// Open Automatically the serach bar in desktop
	$('.searchbar-open').click();

	var hoverTimer;
	$('.x-menu--level-1--link').hover(function() {
		var hThis = $(this);
		clearTimeout(hoverTimer);
	  	hoverTimer = setTimeout(function() {
	  		var posRight = hThis.position().left + hThis.width();
	  		var rightSpace = $(window).width() - posRight; 
	  		var subWidth = hThis.find('.x-menu--level-2--container').width();
	    	//console.log(rightSpace);
	    	if (subWidth > rightSpace) {
	    		hThis.addClass('rightMenu');
	    	} else {
	    		hThis.removeClass('rightMenu');
	    	}
	  	}, 1);
	});
	
	$('body').on('focus', '.mobile-nav--search .search--textbox', function() {
  		var canvasStatus = $('.off-canvas--viewport').attr('data-off-canvas--state');
   		//console.log(canvasStatus);
  		if (canvasStatus == 'left-open') {
    		$('body').addClass('openMenu');
  		}
	});
	$('body').on('click', '.off-canvas--close, .off-canvas--overlay', function() {
      $('body').removeClass('openMenu');
	});


	$('body').on('click', '.account-opens', function() {
     	$('body').addClass('openAccount');
	});
	$('.account-close').click(function(e){
		$('body').removeClass('openAccount');
	});
})(jQuery);	

$(window).scroll(function() {
	scrollFunction()
});

var lastScrollTop = 0;
function scrollFunction() {
	if (document.body.scrollTop > 75 || document.documentElement.scrollTop > 75) {
	    $('body').addClass('smallHeader');
	} else {
	   $('body').removeClass('smallHeader');
	}
	var st = $(this).scrollTop();
   	if (st > lastScrollTop){
        $('body').attr('data-scroll', 'down');
   	} else {
      	// upscroll code
      	$('body').attr('data-scroll', 'up');
   	}
   	lastScrollTop = st; 

}



var resizePromo;
$(window).on('resize', function(e) {
  clearTimeout(resizePromo);
  resizePromo = setTimeout(function() {
   	var pLHt = parseInt($('.promo-bar .text').css('line-height')) + 2;
	var pHt = $('.promo-bar .text').height()

	if (pHt > pLHt) {
	  $('body').addClass('promo2Lines');
	} else {
	  $('body').removeClass('promo2Lines');
	}
  }, 300);
});
$(document).ready(function() {
	resizePromo(); 
});

function resizePromo() {
	var pLHt = parseInt($('.promo-bar .text').css('line-height')) + 2;
	var pHt = $('.promo-bar .text').height()

	if (pHt > pLHt) {
	  $('body').addClass('promo2Lines');
	} else {
	  $('body').removeClass('promo2Lines');
	}
}
!(function($){
	var isIconSliderActive = false;
	var initIconListSlider = function() {
		$('.icon-list-container .icon-blocks-main').slick({
	        arrows:         false,
	        autoplay:       true,
	        autoplaySpeed:  4500,
	        infinite:       true,
	        pauseOnFocus:   false,
	        pauseOnHover:   false,
	        slidesToShow:   2,
	        slidesToScroll: 2,
	        adaptiveHeight: true
	    });

	    isIconSliderActive = true;
	};

	$(document).ready(function(){
		if ($(window).width() < 768) {
			initIconListSlider();
		}
	});

	$(window).on('resize', function(){
		if ($(window).width() < 768) {
			if (isIconSliderActive == true) {
				$('.icon-list-container .icon-blocks-main').slick('destroy');
			}
			initIconListSlider();
		} else {
			if (isIconSliderActive == true) {
				$('.icon-list-container .icon-blocks-main').slick('destroy');
			}
		}
	});
})(jQuery);
!(function($){
	var isProductSLiderActive = false;
	var initProductSlider = function() {

		// Hide carousel controls when there are few items/slides
	    $('.product-section-new-main .product-section-new-block-container').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		    var windowWidth = $(window).width();

		    if (windowWidth >= 768 && slick.slideCount <= 5) {
		    	$('.product-section-new-main__carousel-control-left').hide();
		    	$('.product-section-new-main__carousel-control-right').hide();
		    }

		    if (windowWidth < 768 && slick.slideCount <= 2) {
		    	$('.product-section-new-main__carousel-control-left').hide();
		    	$('.product-section-new-main__carousel-control-right').hide();
		    }
		});

	    $('.product-section-new-main .product-section-new-block-container').each(function(elem){
	    	var autoplaySpeedValue = parseInt($(this).attr('data-speed'));
	    	$(this).slick({
		        arrows:         false,
		        autoplay:       true,
		        autoplaySpeed:  autoplaySpeedValue,
		        infinite:       true,
		        pauseOnFocus:   false,
		        pauseOnHover:   false,
		        slidesToShow:   5,
		        slidesToScroll: 1,
		        adaptiveHeight: true,
		        responsive: [
					{
						breakpoint: 1281,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 640,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					}
		        ]
		    });
	    });


	    isProductSLiderActive = true;

	    $(document).on('click', '.product-section-new-main__carousel-control-left', function(e){
	    	e.preventDefault();

	    	$(this).parent().find('.product-section-new-block-container').slick('slickPrev');
	    });

	    $(document).on('click', '.product-section-new-main__carousel-control-right', function(e){
	    	e.preventDefault();
	    	$(this).parent().find('.product-section-new-block-container').slick('slickNext');
	    });

	};

	$(document).ready(function(){
		initProductSlider();
		setTimeout(function() {
    		$('.single-option-selector').trigger('change');    
    	}, 600);
	});
})(jQuery);
!(function($){
	$(document).ready(function(){
		// Mobile Footer Accordion
		$('.main-footer .footer-menu-title').on('click', function(e){
			if ($(window).width() < 768) {
				e.preventDefault();

				$(this).parent().find('.content').slideToggle(500);
				$(this).toggleClass('active');
			}	
		});
	});
})(jQuery);
$(document).ready(function() {

	$('.playOverlay').click(function() {

	  var vidElem = $(this).closest('.video-wrapper').find('video');
	  if ($(this).closest('.video-wrapper').hasClass('playing')) {
	    // trigger pause
	    $(this).closest('.video-wrapper').removeClass('playing');
	    vidElem.trigger('pause');
	  } else {
	    vidElem.trigger('play');
	    $(this).closest('.video-wrapper').addClass('playing');
	  }

	});



});

// =require modules/homepage.js
$(document).ready(function() {
	$('body').on('click', '.paginationMore a', function() {
	    var xHref = $(this).attr('href') + '&view=mini .blogArticleBox';
	    $(this).closest('.blogArticleMore').addClass('loading');
	    //$('.blogArticleBox').addClass('prev');
	    $('.blogArticleWrap').append('<div class="blogArticleBox"></div>');
	    $('.blogArticleWrap > .blogArticleBox').last().load(xHref, function() {
	        $('.blogArticleWrap > .blogArticleBox').addClass('prev');
	        var nextCount = $('.blogArticleWrap > .blogArticleBox').last().find('.blogArticleMore a').length;
	        console.log('nextCount:' + nextCount);
	        if (nextCount > 0) {
	            $('.blogArticleWrap > .blogArticleBox').last().removeClass('prev');
	        } else {

	        }
	    });
	    return false;
	});

});


window.onscroll = function(e) {
  // print "false" if direction is down and "true" if up
  var scrollDown = this.oldScroll < this.scrollY;
  this.oldScroll = this.scrollY;
  if (scrollDown && $('.blogArticleMore').length > 0) {
    moreArticles();
  }
}

function moreArticles() {
  var offset = 100;
  var pPos = $('.blogArticleMore .paginationMore a').offset().top;
  var scrollPos = ($(window).scrollTop() + $(window).innerHeight()) - offset;
  var paginateLinkCount = $('.blogArticleMore .paginationMore a:visible').length;
  var paginateLoading = $('.blogArticleMore').last().hasClass('loading');
  if (pPos < scrollPos && paginateLinkCount > 0 && paginateLoading ==  false) {
    $('.blogArticleMore').last().find('.paginationMore a').trigger('click')
  }

}
!(function($, FrameworkCart, FrameworkOffCanvas){
$(document).ready(function(){
    $(document).on('click', '.product-list-container .collection-grid-product-form.with-size-variant .size-button-container a' ,function(e) {
        e.preventDefault();
        var dataValue = $(this).attr('data-value');
        var addButton = $(this).parent().parent().parent().parent().parent().find('.add-to-cart input').not('.coming-soon');

        var pRoot = $(this).closest('.product--root');
        var itemPriceHtml = $(this).find('.variant--price-wrapper').html();

        pRoot.find('.with-size-variant .variant-listbox').val(dataValue).change();
        pRoot.find('.with-size-variant .size-button-container a.selected').removeClass('selected');
        $(this).addClass('selected');
        if (itemPriceHtml != undefined)  {
            pRoot.find('.product--price-wrapper').html(itemPriceHtml); 
        }

        if ($(this).hasClass('unavailable')) {
            $(addButton).addClass('sold-out-item');
            $(addButton).prop('disabled', true);
        } else {
            $(addButton).removeClass('sold-out-item');
            $(addButton).prop('disabled', false);
        }
    });

    //  Buy Add to cart
    $(document).on('click', '.product-list-container .collection-grid-product-form .add-to-cart input[type="submit"]', function(e){
        e.preventDefault();
        var targetForm = $(e.target).parent().parent().parent();
        theme.classes.FrameworkCart.prototype.addItem($(targetForm), function(){
            $('.off-canvas--viewport').attr('data-off-canvas--state','right-open');
            $('body').removeClass('ajaxLoading');
            loadCart();
        });
        
    });
});
})(jQuery);
$(document).ready(function() {

    // New Size Selector button
    //$('.collection-grid-product-form.with-size-variant .size-button-container a.selected').removeClass('selected');
    
    //$('.collection-grid-product-form.with-size-variant .size-button-container a.selected').trigger('click');

    $(document).on('click', '.collection-grid-product-form.with-size-variant .size-button-container a' ,function(e){
      e.preventDefault();
      console.log('variant click');
      var dataValue = $(this).attr('data-value');
      var pRoot = $(this).closest('.product--root');
      var addButton = pRoot.find('.add-to-cart input').not('.coming-soon');
      var itemPriceHtml = $(this).find('.variant--price-wrapper').html();
    
      var listPrice = parseFloat($(this).find('.product--compare-price').attr('data-val'));
      var salePrice = parseFloat($(this).find('.product--price').attr('data-val'));
      if (listPrice > salePrice) {
        $(this).addClass('saleVariant')
      }

      if ($(this).hasClass('saleVariant')) {
        var discountPercent = Math.round(((listPrice - salePrice) / listPrice) * 100);
        pRoot.find('.discount-percentage-block').html(discountPercent+'% Off');
      } else {
        pRoot.find('.discount-percentage-block').html('');
      }
      //console.log(sizeImg);
      if ($(this).closest('.cart--root').attr('data-view') == 'mobile') {
        //console.log(sizeImg.indexOf('no-image'));
        // if (sizeImg.indexOf('no-image') > -1) {
        // } else {
        //   pRoot.find('.image img').attr('src', sizeImg);
        // }  
      }



      pRoot.find('.with-size-variant .variant-listbox').val(dataValue).change();
      pRoot.find('.with-size-variant .size-button-container a.selected').removeClass('selected');
      $(this).addClass('selected');
      if (itemPriceHtml != undefined)  {
        pRoot.find('.product--price-wrapper').html(itemPriceHtml); 
      }
      
      if ($(this).hasClass('unavailable')) {
        $(addButton).addClass('sold-out-item');
        $(addButton).prop('disabled', true);
        $(addButton).val(theme.translations.sold_out);
      } else {
        $(addButton).removeClass('sold-out-item');
        $(addButton).prop('disabled', false);
        $(addButton).val(theme.translations.add_to_cart);
        //$(addButton).trigger('click');
      }
      


    });
    $(document).on('click', '.collection-grid-product-form .variant-listbox' ,function(e){
      var sizeImg = $(this).find('option:selected').attr('data-image');
      var pRoot = $(this).closest('.product--root');
      if ($(this).closest('.cart--root').attr('data-view') == 'mobile') {
        if (sizeImg.indexOf('no-image') > -1) {
        } else {
          pRoot.find('.image img').attr('src', sizeImg);
        }  
      }
    });  
    //$('.collection-grid-product-form.with-size-variant .size-button-container a.selected').trigger('click');
});    


